// @ts-nocheck -- TypeScript migration in progress: bulk-renamed from .js and not
// yet typed. Remove this directive and add real types when converting this
// module. Backlog: grep -rl "@ts-nocheck" src app.ts. See docs/typescript-migration.md.
import { renderCgrTwinSyncAction } from "./src/app/cgr-twin-dialog.js";
import { createSharePreview } from "./src/app/share-preview.js";
import {
  aircraftProfilesPath,
  appConfigEndpoint,
  chtCautionThresholdF,
  chtCoolingRateMaxWindowSeconds,
  chtCoolingRateMinWindowSeconds,
  chtCoolingRateTriggerFpm,
  chtHealthReviewThresholdF,
  chtPeakReviewThresholdF,
  colors,
  contactRequestEndpoint,
  databaseAircraftFlightFlagSummariesEndpoint,
  databaseAircraftEndpoint,
  databaseAircraftUploadsEndpoint,
  databaseFlightAiSummaryEndpoint,
  databaseFlightArchiveEndpoint,
  databaseFlightReviewNotesEndpoint,
  databaseIngestJobEndpoint,
  databaseTrendSnapshotEndpoint,
  databaseUploadDeleteEndpoint,
  databaseUploadEndpoint,
  databaseUploadReprocessEndpoint,
  databaseUploadProcessShortFlightsEndpoint,
  fallbackDataPath,
  patternWorkCandidatePhases,
  patternWorkPhaseName,
  sampleDataPath,
  reviewNoteMaxLength,
  sensitivityModeOrder,
  sensitivityModes,
  seriesMeta,
  thermalAxisRanges,
  trendMetricMeta,
  valvePatternSummaryPath,
} from "./src/core/config.js";
import {
  availablePhasesForData,
  phaseSegments,
} from "./src/analysis/phase.js";
import {
  analyzeChtHealth,
  chtExposureNote,
  panelPercent,
  percentAboveThreshold,
  percentBelowThreshold,
} from "./src/analysis/cht.js";
import {
  analyzeEgtBalance,
  egtAbsoluteHighThresholdF,
  egtAbsoluteReviewThresholdF,
  egtExpectedRangeF,
} from "./src/analysis/egt.js";
import {
  analyzeMagCheck,
  candidateMagPhase,
} from "./src/analysis/mag.js";
import {
  analyzePowerChangeContext,
} from "./src/analysis/power-change-context.js";
import {
  analyzeCombustionSignatures,
  combustionEvidenceMeta,
} from "./src/analysis/combustion.js";
import {
  analyzeCarbIce,
} from "./src/analysis/carb-ice.js";
import {
  calculateAnalysisSummary,
  computeRawAnalysisMetrics,
  finalizeAnalysisSummary,
  healthMetricLabels as summaryHealthMetricLabels,
} from "./src/analysis/summary.js";
import { formatPointTime } from "./src/core/format-point-time.js";
import {
  runRawAnalysisInWorker,
  analysisWorkerAvailable,
} from "./src/app/analysis-worker-client.js";
import {
  analyzeDescentEgtDropout as extractedAnalyzeDescentEgtDropout,
  analyzeTransientDivergence as extractedAnalyzeTransientDivergence,
} from "./src/analysis/divergence.js";
import {
  analyzeChtCoolingRate,
  analyzeCoolingEfficiency,
  clusteredCoolingRateEvents,
  coolingRateNoteForRate,
  coolingRateScoreForRate,
} from "./src/analysis/cooling.js";
import {
  analyzeThermalContext,
} from "./src/analysis/thermal-context.js";
import {
  analyzeElectrical as extractedAnalyzeElectrical,
  analyzeStartChargeMetric as extractedAnalyzeStartChargeMetric,
} from "./src/analysis/electrical.js";
import {
  analyzeTurboHealth,
  turboTemperatureValues,
} from "./src/analysis/turbo.js";
import {
  analyzeMarkedGamiSweep,
  gamiEgtKeys,
  gamiFuelFlowKey,
  gamiSweepEngineIdentity,
  gamiSweepPeakDisplayRows,
  gamiSpreadReviewGph,
  gamiSpreadTargetGph,
  gamiSpreadWatchGph,
} from "./src/analysis/gami-sweep.js";
import {
  analyzeOilSystem,
  oilSummaryIssue,
} from "./src/analysis/oil-system.js";
import {
  analyzeCrossEngineComparison,
  crossEngineComparisonFinding,
} from "./src/analysis/cross-engine.js";
import {
  analyzeSensorValidity as extractedAnalyzeSensorValidity,
  augmentSensorValidityWithCoolingRate,
  sensorChannelType,
  summarizeSensorChannel,
} from "./src/analysis/sensors.js";
import {
  engineWorkPoint,
  estimatedHpMetric as estimatedHpMetricModel,
  estimatedTorqueMetric as estimatedTorqueMetricModel,
  estimatePower as estimatePowerModel,
  fuelUsedMetric as fuelUsedMetricModel,
  powerEstimateRows as powerEstimateRowsModel,
  powerEstimateSummary as powerEstimateSummaryModel,
  preferredPowerEstimateSummary as preferredPowerEstimateSummaryModel,
} from "./src/analysis/operating-context.js";
import {
  analyzeExhaustValvePattern,
  valveBandLabel,
  valveFrequencyLabel,
} from "./src/analysis/valve.js";
import {
  assignFlightPhases,
} from "./src/analysis/phase-detection.js";
import {
  aircraftActivityCardsForPanel as aircraftActivityCardsForPanelModel,
  aircraftAverageFlightDurationFromTrendRows,
  aircraftAverageFlightDurationSeconds,
  aircraftFleetRowDetail,
  aircraftFlightDateRangeLabel as aircraftFlightDateRangeLabelModel,
  aircraftFlightDurationSecondsFromTrendRows,
  aircraftProfileHealthLabel,
  aircraftRecentFlightCount as aircraftRecentFlightCountModel,
  aircraftTotalFlightDurationSeconds,
  finiteNumber,
  latestFlightFromAircraftFlights as latestFlightFromAircraftFlightsModel,
} from "./src/app/aircraft-activity-model.js";
import {
  aircraftDisplayLabel,
  aircraftFleetSortIndex as aircraftFleetSortIndexModel,
  aircraftMakeModelLabel,
  aircraftPhotoFallbackLabel,
  aircraftPhotoSource,
  aircraftProfilesLocalStorageKey,
  aircraftTypeLabel,
  databaseAircraftProfilesMap as databaseAircraftProfilesMapModel,
  databaseAircraftToProfile,
  engineLabel,
  fuelLabel,
  loadLocalAircraftProfiles as loadLocalAircraftProfilesModel,
  monitorLabel,
  normalizedAircraftType,
  normalizedPropellerEntries,
  profileValue,
  propellerEngineLabel,
  propellerLabel,
  propellerTypeLabel,
  saveLocalAircraftProfiles as saveLocalAircraftProfilesModel,
} from "./src/app/aircraft-profile-model.js";
import {
  aircraftMonitorCapability,
  aircraftProfileSupportsMultiEngineReview,
  coolingRateTriggerSettingBounds,
  coolingRateTriggerSettingForAircraft,
  disabledReviewMonitorKeyListForAircraft,
  groupedReviewMonitorDefinitionsForProfile,
  normalizeCoolingRateTriggerSetting,
  reviewMonitorCountTextForAircraft,
  reviewMonitorDefinitionsForProfile,
  reviewMonitorEnabledForAircraft,
  reviewSettingsAircraftId,
  reviewSettingsSignatureForAircraft,
} from "./src/app/aircraft-review-settings-model.js";
import {
  duplicateUploadMessage,
  formatUploadByteSize,
  monitorSelectionFromText,
  selectedMonitorFromSelectValues,
  shortUploadHash,
  splitUploadMakeModel,
  supportedUploadFile,
  shortFlightsSkippedSummary,
  noEngineDataRefusedSummary,
  uploadBatchSummary,
  uploadDisplayError,
  uploadDisplayStatus,
  uploadDuplicateSummary,
  uploadFileDisplayName,
  uploadFlightSummary,
  uploadFlightSummaryDetailClass,
  uploadCanReprocess,
  uploadHasActiveJob,
  uploadReprocessActionLabel,
  uploadIngestStatusLabel,
  uploadIsEmpty,
  uploadJobProgressLabel,
  uploadSelectionFiles,
  uploadSelectionSummary,
  uploadStatusClass,
  uploadStatusLabel,
  uploadAircraftMetadataSearchParams,
  uploadDateLabel,
  uploadFilesNewestFlightFirst,
  accountWithholdsFlights,
  uploadAtFlightLimitMessage,
} from "./src/app/aircraft-upload-model.js";
import {
  displayMonitorLabel,
  supportedMonitorFromLabel,
  supportedMonitorFromParser,
  supportedMonitorLabel,
  supportedMonitorMakes,
  supportedMonitorModelsForMake,
} from "./src/app/supported-monitors.js";
import {
  compactFlightOptionLabel,
  dashboardFlightOptionLabel,
  dateLabelFromTimestamp,
  flightDateFromText,
  flightDateLabel,
  flightDisplayTitle,
  flightOptionLabel,
  flightRouteSlug,
  flightMatchesSourcePath,
  flightReadyToView,
  flightSourcePathDisplay,
  isSupportedFlight,
  correctedFlightTimestamp,
  plausibleFlightTimestamp,
  valveFlagForFlight,
  visibleFlightEntries as visibleFlightEntriesModel,
  visibleFlightEntriesByAircraft as visibleFlightEntriesByAircraftModel,
} from "./src/app/flight-display-model.js";
import {
  dashboardFlightMenuElements,
  flightLogMenuElements,
  flightLogMenuOptionButton,
  renderDashboardFlightMenu,
  renderFlightLogMenu,
  setDashboardFlightMenuOpen,
  setFlightLogMenuOpen,
  setupDashboardFlightMenu,
  setupFlightLogMenu,
  syncFlightLogMenuButton,
} from "./src/app/flight-menus.js";
import {
  databaseAircraftLabel,
  loadDatabaseFlightManifest as loadDatabaseFlightManifestModel,
  readDatabaseNormalizedArtifactEnvelope as readDatabaseNormalizedArtifactEnvelopeModel,
} from "./src/app/flight-source.js";
import {
  isPublicShareMode,
  publicShareContext,
  publicShareBundle,
  installPublicShareFetchShim,
  initPublicShareSession,
  loadPublicShareBundle,
} from "./src/app/public-share.js";
import {
  compactSigned,
  panelNumber,
  signedPanelNumber,
} from "./src/core/display.js";
import {
  ENGINE_LABEL_MODES,
  ENGINE_LABEL_STYLES,
  aggregateKeyForSingleEngineIndexedChannel,
  engineById,
  engineDescriptorsForData,
  engineDelta,
  engineInfoForSourceNumber,
  engineLayoutAmbiguityForData,
  engineMetricValue,
  engineNarrativeCylinderLabel,
  engineScopedCylinderLabel,
  engineScopedChannelLabel,
  engineScopedProbeLabel,
  projectFlightDataForEngine,
} from "./src/core/engines.js";
import {
  formatCompactDurationLabel,
  formatCompactElapsedTime,
  formatElapsedTime,
} from "./src/core/format.js";
import {
  findingCausePresentation,
  findingDisplayClass,
  findingDisplayLabel,
  findingMetaItems,
  findingMetaMarkup,
  metricDisplayClass,
  reportFindingEvidenceItems,
  reportFindingText,
} from "./src/findings/presentation.js";
import {
  averageValues,
  clamp01,
  extentFromValues,
  lerp,
  seededNoise,
} from "./src/core/math.js";
import {
  DASHBOARD_PERF_LOG,
  perfFlush,
  perfMark,
  perfTime,
  perfTimeSync,
} from "./src/core/perf-utils.js";
import {
  trimEndpointSamples,
} from "./src/core/flight-point-selection.js";
import {
  finiteValues,
  peerAverage,
  pointCylinderValues,
} from "./src/analysis/utils.js";
import {
  elapsedDeltaBetween,
  elapsedSecondsFromClockRows,
  finalizeParsedPoints,
  hasMultipleSamplesPerSecond,
  resamplePointsToOneHz,
  sampleIntervalSeconds as sampleIntervalSecondsPure,
  suppressAuxDropoutRows,
  suppressImplausibleCarbTemp,
  suppressImplausibleOilTemps,
  timeOfDayToSeconds,
} from "./src/parsers/data-prep.js";
import {
  cloneEngineLayout,
  cloneParsedFlightEnvelope,
  cloneParsedFlightPoints,
  cloneParserMetadata,
  cloneParserWarnings,
  parsedFlightEntryCacheKey,
  parserMetadataFromEnvelope,
} from "./src/parsers/parser-metadata.js";
import {
  defaultAppConfig,
  fetchAppConfig,
} from "./src/persistence/app-config-store.js";
import {
  databaseAircraftSummaryEndpoint as databaseAircraftSummaryEndpointBuilder,
  fetchDatabaseAircraftSummary,
  fetchLocalAircraftProfilesJson,
} from "./src/persistence/aircraft-profiles-store.js";
import {
  waitForUploadIngestJob,
} from "./src/persistence/upload-ingest-poller.js";
import { escapeHtml } from "./src/core/html.js";
import {
  abnormalCombustionFinding as abnormalCombustionFindingFromContext,
  carbIceFinding,
  chtFinding as chtFindingFromContext,
  chtRhythmFinding as chtRhythmFindingFromContext,
  combustionFinding as combustionFindingFromContext,
  combustionMetaForDisplay,
  coolantMarginFinding,
  coolingFinding as coolingFindingFromContext,
  coolingRateFinding as coolingRateFindingFromContext,
  descentEgtDropoutFinding as descentEgtDropoutFindingFromContext,
  egtFinding as egtFindingFromContext,
  egtScopeSentenceLabel,
  electricalFinding,
  elevatedEgtChannels,
  evidenceClassForScore,
  findingCylinderListLabel as findingCylinderListLabelFromContext,
  inductionLeakFinding as inductionLeakFindingFromContext,
  instrumentationSuspicionFinding,
  magFinding as magFindingFromContext,
  oilSystemFinding,
  takeoffEnrichmentFinding,
  startChargeFinding,
  turboFinding as turboFindingFromContext,
  turboMetricEvidenceRows as turboMetricEvidenceRowsFromContext,
  valveFinding as valveFindingFromContext,
} from "./src/findings/metric-findings.js";
import { createSensorSummaryHelpers } from "./src/findings/sensor-summary.js";
import { createCylinderSummary } from "./src/findings/cylinder-summary.js";
import { createFindingDispatch } from "./src/findings/finding-dispatch.js";
import { createReportBuilders } from "./src/reporting/report-builders.js";
import { createFlightReportBlob } from "./src/reporting/flight-report-blob.js";
import { buildReportOverviewVisuals } from "./src/reporting/report-visuals.js";
import { createAircraftForm } from "./src/app/aircraft-form.js";
import { createAircraftPhoto } from "./src/app/aircraft-photo.js";
import { createAircraftDefaultArt } from "./src/app/aircraft-default-art.js";
import { createContactForm } from "./src/app/contact-form.js";
import { createUploadDialog } from "./src/app/upload-dialog.js";
import { downloadNormalizedCsv } from "./src/app/normalized-csv-download.js";
import { createMonitorSelects } from "./src/app/monitor-selects.js";
import { createParserDispatch } from "./src/app/parser-dispatch.js";
import {
  confirmAircraftDeleteDialog,
  confirmFlightDeleteDialog,
  confirmFlightReanalyzeDialog,
  confirmFlightsReanalyzeAllDialog,
  confirmFlightsUpdateDialog,
} from "./src/app/confirm-dialogs.js";
import { createTrendRowStorage } from "./src/app/trend-row-storage.js";
import { createDetectionGuide } from "./src/app/detection-guide.js";
import {
  createFlightFlagSummary,
  clearPersistedAircraftFlightFlagSummaries,
} from "./src/app/flight-flag-summary.js";
import { createFlightProfileRenderer } from "./src/app/flight-profile-renderer.js";
import { createEngineReviewRenderer } from "./src/app/engine-review-renderer.js";
import { createExplorerAnnunciations } from "./src/app/explorer-annunciations.js";
import { createTrendRowComputation } from "./src/app/trend-row-computation.js";
import { createFlightReportPdf } from "./src/app/flight-report-pdf.js";
import {
  rawAnalysisCacheKey,
  rawAnalysisCacheFlightId,
} from "./src/app/analysis-cache-key.js";
import {
  readCachedRawAnalysisBundle,
  writeCachedRawAnalysisBundle,
  deleteCachedRawAnalysisBundlesForFlight,
} from "./src/app/analysis-cache-store.js";
import {
  readCachedNormalizedArtifactEnvelope,
  writeCachedNormalizedArtifactEnvelope,
} from "./src/app/normalized-artifact-cache-store.js";
import {
  readCachedTrendSnapshot,
  writeCachedTrendSnapshot,
  deleteCachedTrendSnapshotsForAircraft,
} from "./src/app/trend-snapshot-cache-store.js";
import { createFlightReanalyze } from "./src/app/flight-reanalyze.js";
import { createTrendViewRenderer } from "./src/app/trend-view-renderer.js";
import { createTrendVisualWorkspace } from "./src/app/trend-visual-workspace.js";
import { createTrendSampleGraphs } from "./src/app/trend-sample-graphs.js";
import { createTrendEvidenceTable } from "./src/app/trend-evidence-table.js";
import { createAircraftFlightsPanelData } from "./src/app/aircraft-flights-panel-data.js";
import { createAircraftReviewSettingsDialog } from "./src/app/aircraft-review-settings-dialog.js";
import {
  createAircraftWorkspaceRenderer,
  flightCanReanalyze,
  flightUpdateAction,
} from "./src/app/aircraft-workspace-renderer.js";
import { createAircraftMaintenancePanel } from "./src/app/aircraft-maintenance-panel.js";
import { createMaintenanceContext } from "./src/app/maintenance-context.js";
import { createHealthSummaryRenderer } from "./src/app/health-summary-renderer.js";
import { createReviewNotePlaceholderPicker } from "./src/app/review-note-placeholders.js";
import { createEngineScopeRenderer } from "./src/app/engine-scope-renderer.js";
import { createCylinderDetailRenderer } from "./src/app/cylinder-detail-renderer.js";
import { createOverviewDetectorVisuals } from "./src/app/overview-detector-visuals.js";
import { createChartRenderers } from "./src/app/chart-renderers.js";
import { createDataQualityRenderer } from "./src/app/data-quality-renderer.js";
import { createNavigationSetup } from "./src/app/setup-navigation.js";
import { aiSummaryIsNew, markAiSummarySeen } from "./src/app/new-item-marks.js";
import { createFleetSidebar } from "./src/app/fleet-sidebar.js";
import { initTheme, setupDisplayPreferenceControls, flightSortFromPreference } from "./src/app/display-preferences.js";
import { setupUploadDropzones } from "./src/app/upload-dropzone.js";
import { loadFlightOrder, loadAircraftOrder } from "./src/core/preferences.js";
import {
  analyticsPathForAppState,
  trackAnalyticsPageView,
} from "./src/app/analytics.js";
import { mountConsentBanner } from "./src/app/consent-banner.js";
import { mountAnalyticsOverlay } from "./src/app/analytics-overlay.js";
import { wireAnalyticsInstrumentation } from "./src/app/analytics-events.js";
import { createChartScrubber } from "./src/app/chart-scrubber.js";
import { enforceUnalignedSeriesExclusivity } from "./src/app/series-alignment.js";
import { createSeriesControls } from "./src/app/series-controls.js";
import { createSeriesPaneDrag } from "./src/app/series-pane-drag.js";
import { createTrendController } from "./src/app/trend-controller.js";
import { createOperatingContextController } from "./src/app/operating-context-cards-controller.js";
import { createGamiSpecialTestsController } from "./src/app/gami-special-tests-controller.js";
import { createPilotObservationController } from "./src/app/pilot-observation-controller.js";
import { createExplorerAskController } from "./src/app/explorer-ask-controller.js";
import { createHealthNoteMarkup } from "./src/app/health-note-markup.js";
import { createMarkerReadoutRenderer } from "./src/app/marker-readout-renderer.js";
import {
  createViewNavigationController,
  flightReviewRouteFromLocationHash,
  flightReviewRouteHash,
  normalizeOverviewHealthCardRouteKey,
  normalizeRouteChannels,
  normalizeRouteFit,
  normalizeRouteZoom,
  trendRouteFromLocationHash,
  trendRouteHash,
} from "./src/app/view-navigation-controller.js";
import { createUploadFlightPipeline } from "./src/app/upload-flight-pipeline.js";
import { createAiSummaryPanelHelpers } from "./src/ai/summary-panel-helpers.js";
import {
  aiSummaryPanelMarkup,
  aiSummaryPanelModel,
  parseBriefingGraphTarget,
} from "./src/ai/summary-panel-renderer.js";
import { createEngineSnapshot } from "./src/app/engine-snapshot.js";
import {
  buildTrendRow as buildTrendRowFromContext,
  hasCarbTempChannel,
  trendDateLabel,
  trendDateValue,
  valuesForKeys,
} from "./src/trends/trend-row-builder.js";
import {
  detectionWindow,
  magCandidateWindow,
  pointDetectionWindow,
  pointInDetectionWindow,
  visibleDivergenceCylinders,
} from "./src/findings/detection-windows.js";
import {
  healthyMetricEvidence as healthyMetricEvidenceFromContext,
  healthyMetricFinding as healthyMetricFindingFromContext,
  healthyMetricTitle,
  magWindowLabel,
  metricChtPeakAboveCaution,
  metricNearChtCaution,
  metricNearCoolingRateTrigger,
  turboEngineLabels,
} from "./src/findings/healthy-metric-evidence.js";
import {
  aiSummaryAvailableSeries as aiSummaryAvailableSeriesFromContext,
  aiSummaryGraphSpec as aiSummaryGraphSpecFromContext,
  aiSummaryGraphSpecs as aiSummaryGraphSpecsFromContext,
  aiSummarySeriesForHealthKey as aiSummarySeriesForHealthKeyFromContext,
  aiSummaryTargetCylinder,
  aiSummaryThermalPeerKeys as aiSummaryThermalPeerKeysFromContext,
  aiSummaryWindowedData,
} from "./src/ai/summary-graph-specs.js";
import {
  aiSummaryErrorMessage,
  aiSummaryGeneratedLabel,
  aiSummaryPayloadJson,
} from "./src/ai/summary-markup.js";
import {
  axisRangeForData,
  rawValueExtent,
} from "./src/charts/scales.js";
import {
  auxScaleConfig,
  yLabelsForSingleSeries,
} from "./src/charts/series.js";
import {
  cachedInteractionBounds,
  chartBounds,
  chartPointerGeometry,
  explorerChartLayoutOptions,
  explorerChartPadding,
  flightChartLayoutOptions,
  flightChartPadding,
  plotLayout,
  syncCanvasDisplaySize,
  syncFlightChartCanvasHeight,
} from "./src/charts/layout.js";
import {
  phaseLabelOptions,
  phaseRailColor,
  phaseRailDisplayPlan,
  phaseRailLabelForSegment,
  phaseRailPriority,
  phaseRailSegments,
  phaseRailTransitionZones,
  rectsOverlap,
} from "./src/charts/phase-rail.js";
import {
  chartLaneRenderPlan,
  chartOverlayPlan,
  compareChartPlan,
  cylinderCompareChartPlan,
  explorerAlertTone,
  explorerConditionTimelineLayout,
  explorerIsNormalFinding,  explorerTimelineRatioForElapsed,
  explorerTimelineTicks,
  explorerTimelineWindowGeometry,
  isTitMetricKey,
  isTurboMetricKey,
  metricDisplayFor,  formatTrendValue,
} from "./src/charts/presentation.js";
import {  drawDetectionWindowLabel,
  drawEmptyChartMessage,
  drawGrid,
  drawInlineLegend,
  drawLaneLabel,
  drawLine,
  drawMarker,
  drawSelectedDetectionWindow,
  roundRect,
} from "./src/charts/rendering.js";
import {
  clearAircraftSeriesPaneOverrides,
  disabledReviewMonitorKeysForAircraft,
  loadAircraftReviewSettings,
  loadDetectionSensitivity,
  loadHiddenFlightIds,
  loadSelectedAircraftWorkspaceId,
  loadSelectedFlightId,
  loadSeriesPaneOverrides,
  loadTrendExcludedFlightIds,
  loadTrendIncludedFlightIds,
  normalizeSensitivity,
  saveAircraftReviewSettings,
  saveDetectionSensitivity,
  saveHiddenFlightIds,
  saveSelectedAircraftWorkspaceId,
  saveSelectedFlightId,
  saveSeriesPaneOverrides,
  saveTrendExcludedFlightIds,
  saveTrendIncludedFlightIds,
  seriesPaneOverridesForAircraft,
  updateAircraftReviewMonitorSettings,
  updateAircraftSeriesPaneOverride,
} from "./src/core/preferences.js";
import {
  ANALYSIS_VERSION,
  scoreCardState,
  scoreCardStateFromClass,
  scoreClass,
  scoreLabel,
} from "./src/core/score.js";
import {
  createRawMetricDescriptor,
  formatRawNumber,
  rawChannelKeysForData,
  rawMetricDescriptor,
  scoringRole,
} from "./src/core/raw-metadata.js";
import {
  flightProfileContext as flightProfileContextModel,
  groupFlightProfileSummaryItems as groupFlightProfileSummaryItemsModel,
  flightProfileSummaryItems as flightProfileSummaryItemsModel,
  formatProfileDuration,
  maxPositiveForProfileKey,
  operationalProfileCards as operationalProfileCardsModel,
  operationalProfileReportRows as operationalProfileReportRowsModel,
  phaseProfileRows as phaseProfileRowsModel,
  profileDurationBuckets as profileDurationBucketsModel,
  profileShareLabel,
} from "./src/profile/flight-profile.js";
import {
  engineFindingSnippet as engineFindingSnippetModel,
  engineForSummaryScope as engineForSummaryScopeModel,
  engineMetricCylinder as engineMetricCylinderModel,
  engineMetricLesson as engineMetricLessonModel,
  engineMetricRows as engineMetricRowsModel,
  healthMetricScopeForKey,
  metricParticipatesInScopedScore,
  normalizeHealthMetricScope,
  engineReviewActionList as engineReviewActionListModel,
  engineReviewItems as engineReviewItemsModel,
  engineSeverityRank as engineSeverityRankModel,
  engineTriageStatus as engineTriageStatusModel,
  engineWindowLabel as engineWindowLabelModel,
  metricMatchesEngineScope as metricMatchesEngineScopeModel,
  scopedSummaryFinding as scopedSummaryFindingModel,
} from "./src/engine/review-model.js";
import {
  reportDisclaimerParagraphs,
  reportFileName,
  reportWindowSummary,
  turboTitQualitySummaryText,
} from "./src/reporting/pdf-helpers.js";
import {
  buildPdfBlob,
  makePdfWriter,
  pdfPalette,
  pdfSoftColorForScore,
  pdfTruncateText,
} from "./src/reporting/pdf-document.js";
import {
  flightReportRowsModel,
  reportAtAGlanceCardsModel,
  reportAtAGlanceTurboCardModel,
  reportCylinderTableRowsModel,
  reportEngineMetricRowsModel,
  reportHealthCheckRowsModel,
  reportTraceRowsModel,
  reportTurboContextModel,
} from "./src/reporting/report-model.js";
import {
  writePrimaryFindingSections,
} from "./src/reporting/pdf-sections.js";
import {
  canonicalValueForField,
  createCanonicalParserEnvelope,
  cylinderKeys,
  cylinderNumberFromKey,
} from "./src/core/schema.js";
import {
  parseCsv,
} from "./src/parsers/utils.js";
import {
  parseEiCgrComboCsvDetailedWithDeps,
} from "./src/parsers/ei-cgr.js";
import {
  EI_CGR_COMBO_PARSER_VERSION,
} from "./src/parsers/index.js";
import {
  trendRowsRenderVersion,
} from "./src/trends/trend-contract.js";
import { createTrendSignalContext } from "./src/trends/trend-signal-definitions.js";
import { createTrendSignalSpecifics } from "./src/trends/trend-signal-specifics.js";
import { createTrendSignalSummary } from "./src/trends/trend-signal-summary.js";
import { buildGamiTrendAggregate } from "./src/trends/gami-aggregate.js";

// Bind the sensor-summary helpers once. Uses hoisted function references for
// currentEngineDescriptors and sensorEvidenceFlights, so the bound helpers
// always pick up live state at call time.
const {
  engineNarrativeProbeLabel,
  sensorChannelList,
  sensorFinding,
  sensorPairedChannelLabel,
  sensorPrimarySummaries,
  sensorPrimaryWindowSentence,
  sensorRelatedEvidenceItems,
  sensorRelatedReviewSentence,
  sensorReviewSummaries,
  sensorSummaryDisplayLabel,
  sensorSummaryEvidenceParts,
  sensorSummaryEvidenceText,
  sensorSummaryHasReviewCue,
  sensorSummaryIsPrimaryConcern,
  sensorSummaryMarkedWindows,
  sensorSummaryOutOfRangeCue,
  sensorSummaryPeerMismatchCount,
  sensorSummaryReportDetail,
  sensorSummaryWindowText,
  sensorValueText,
} = createSensorSummaryHelpers({
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  sensorEvidenceFlights: (...args) => sensorEvidenceFlights(...args),
});

// Bind the trend-signal "specifics" helpers (sensor/turbo/divergence/combustion
// Meaning/Why/Contexts/Checks). Dependencies passed as lambdas so they resolve
// at call-time against the hoisted function declarations later in the file.
const {
  trendFormatElapsed,
  trendSignedF,
  trendSensorEvidenceNote,
  trendSensorIssueEvidenceNote,
  trendSensorDominantIssue,
  trendSensorIssueEntries,
  trendSensorIssueGroups,
  trendSensorGroupDominantIssue,
  trendSensorGroupDisplayLabel,
  trendSensorGroupSummary,
  trendSensorSpecificMeaning,
  trendSensorSpecificWhy,
  trendSensorSpecificContexts,
  trendTurboValueLabel,
  trendTurboEventSummary,
  trendTurboStatusGroups,
  trendTurboPrimaryReason,
  trendTurboPeakSummary,
  trendTurboSpecificMeaning,
  trendTurboSpecificWhy,
  trendTurboSpecificContexts,
  trendDivergencePrimaryRows,
  trendDivergenceRepeatedCylinders,
  trendDivergenceLiftSummary,
  trendDivergenceWindowSummary,
  trendDivergenceSpecificMeaning,
  trendDivergenceSpecificWhy,
  trendDivergenceSpecificContexts,
  trendCombustionPrimaryRows,
  trendCombustionSignatureLabel,
  trendCombustionSignatureGroups,
  trendCombustionMovementSummary,
  trendCombustionWindowSummary,
  trendCombustionSpecificMeaning,
  trendCombustionSpecificWhy,
  trendCombustionSpecificContexts,
  trendCombustionSpecificChecks,
} = createTrendSignalSpecifics({
  trendAffectedRows: (...args) => trendAffectedRows(...args),
  trendCylinderLabel: (...args) => trendCylinderLabel(...args),
  trendCylinderListLabel: (...args) => trendCylinderListLabel(...args),
});

// Bind the trend cylinder-context helpers and the canonical
// trendSignalDefinitions catalog. The catalog references the specifics
// helpers (above) and the cylinder labels defined here. State getters
// (current trend rows/aircraft, aircraft profiles) keep this binding
// live without leaking the underlying mutable globals.
const {
  trendCylinderRowsFromContext,
  trendCylinderAircraftFromRows,
  addTrendCylinderNumber,
  trendCylinderNumbersForRows,
  trendEngineDescriptorsForCylinderContext,
  trendCylinderLabel,
  trendCylinderListLabel,
  trendSignalDefinitions,
} = createTrendSignalContext({
  trendAffectedRows: (...args) => trendAffectedRows(...args),
  getCurrentTrendRows: () => currentTrendRows,
  getCurrentTrendAircraft: () => currentTrendAircraft,
  selectedTrendAircraft: (...args) => selectedTrendAircraft(...args),
  getAircraftProfile: (aircraft) => aircraftProfiles?.[aircraft] ?? null,
  engineDescriptorsForData: (...args) => engineDescriptorsForData(...args),
  engineNarrativeCylinderLabel: (...args) => engineNarrativeCylinderLabel(...args),
  trendSensorSpecificMeaning,
  trendSensorSpecificWhy,
  trendSensorSpecificContexts,
  trendTurboSpecificMeaning,
  trendTurboSpecificWhy,
  trendTurboSpecificContexts,
  trendDivergenceSpecificMeaning,
  trendDivergenceSpecificWhy,
  trendDivergenceSpecificContexts,
  trendCombustionSpecificMeaning,
  trendCombustionSpecificWhy,
  trendCombustionSpecificContexts,
  trendCombustionSpecificChecks,
});

// Bind the trend signal summary / narrative / story helpers. Dependencies
// use lambdas/getters so they resolve at call-time against state and
// hoisted function declarations later in the file.
const {
  trendHealthKeyForSignalKey,
  trendReviewMonitorEnabledForSignalKey,
  trendSignalDefinitionsForRows,
  trendDominantAffected,
  trendAverageScore,
  trendConsecutiveFlagCount,
  trendDirection,
  trendDirectionText,
  trendSignalStatus,
  buildTrendSignalSummary,
  buildTrendSignalSummaries,
  trendCoverageLabel,
  selectedTrendSignal,
  trendStoryMetricKey,
  trendSignalRepeatText,
  trendDominantNumber,
  trendCylinderPeakCht,
  trendChtThresholdSummary,
  trendValveSpecificEvidenceText,
  trendSpecificEvidenceText,
  trendSignalTitle,
  trendSignalNoun,
  trendSignalExplanationItems,
  trendSignalContextItems,
  ownerTrendCopy,
  trendMeaningLeadText,
  trendStoryBodyText,
  trendStableStoryBodyText,
  trendStableEmptyBodyText,
  trendImprovedStoryBodyText,
  trendExplanationHtml,
  trendStoryForSignal,
  buildTrendOwnerStory,
  trendQueueNote,
  trendAffectedRows,
} = createTrendSignalSummary({
  getTrendSignalDefinitions: () => trendSignalDefinitions,
  trendMetricAvailable: (...args) => trendMetricAvailable(...args),
  trendAnchorIndex: (...args) => trendAnchorIndex(...args),
  trendWindowRows: (...args) => trendWindowRows(...args),
  reviewMonitorEnabled: (...args) => reviewMonitorEnabled(...args),
  reviewMonitorCapabilityAvailable: (...args) => reviewMonitorCapabilityAvailable(...args),
  selectedTrendAircraft: (...args) => selectedTrendAircraft(...args),
  getActiveTrendMetric: () => activeTrendMetric,
  trendMetricMeta,
  chtCautionThresholdF,
  chtHealthReviewThresholdF,
  chtCoolingRateTriggerFpm,
  trendCylinderLabel: (...args) => trendCylinderLabel(...args),
  trendTurboPrimaryReason,
  trendTurboPeakSummary,
  trendDivergencePrimaryRows,
  trendDivergenceRepeatedCylinders,
  trendDivergenceLiftSummary,
});

// Bind the per-cylinder summary computations and cylinder finding builder.
// Many deps — but all lambdas/getters so the binding always sees live
// hoisted helpers and the current flightData / healthSummary / detection
// sensitivity globals.
const {
  cylinderValveSummary,
  capCylinderScoreForLocalFlags,
  cylinderCoolingRateSummary,
  cylinderInductionLeakSummary,
  cylinderMetricSummary,
  cylinderMetricSummaryUncached,
  cylinderScoreMarkup,
  cylinderScoreText,
  cylinderFindingBody,
  cylinderFinding,
} = createCylinderSummary({
  finiteValues: (...args) => finiteValues(...args),
  peerAverage: (...args) => peerAverage(...args),
  cylinderKeys: (...args) => cylinderKeys(...args),
  extentFromValues: (...args) => extentFromValues(...args),
  quantile: (...args) => quantile(...args),
  percentAboveThreshold: (...args) => percentAboveThreshold(...args),
  percentBelowThreshold: (...args) => percentBelowThreshold(...args),
  clampScore: (...args) => clampScore(...args),
  engineWorkPoint: (...args) => engineWorkPoint(...args),
  engineInfoForCylinderNumber: (...args) => engineInfoForCylinderNumber(...args),
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  engineNarrativeProbeLabel: (...args) => engineNarrativeProbeLabel(...args),
  engineScopedProbeLabel: (...args) => engineScopedProbeLabel(...args),
  cylinderSensorSummary: (...args) => cylinderSensorSummary(...args),
  cylinderProbeNote: (...args) => cylinderProbeNote(...args),
  chtExposureNote: (...args) => chtExposureNote(...args),
  panelNumber: (...args) => panelNumber(...args),
  signedPanelNumber: (...args) => signedPanelNumber(...args),
  evidenceClassForScore: (...args) => evidenceClassForScore(...args),
  scoreClass: (...args) => scoreClass(...args),
  scoreLabel: (...args) => scoreLabel(...args),
  valveBandLabel: (...args) => valveBandLabel(...args),
  coolingRateScoreForRate: (...args) => coolingRateScoreForRate(...args),
  clusteredCoolingRateEvents: (...args) => clusteredCoolingRateEvents(...args),
  coolingRateNoteForRate: (...args) => coolingRateNoteForRate(...args),
  readableProbeLabel: (...args) => readableProbeLabel(...args),
  findingCylinderReference: (...args) => findingCylinderReference(...args),
  valveFinding: (...args) => valveFinding(...args),
  getFlightData: () => flightData,
  getHealthSummary: () => healthSummary,
  getDetectionSensitivity: () => detectionSensitivity,
  currentFlightDerivedCache: (...args) => currentFlightDerivedCache(...args),
  calculateHealthSummary: (...args) => calculateHealthSummary(...args),
  chtHealthReviewThresholdF,
  chtCautionThresholdF,
  chtCoolingRateTriggerFpm,
});

// Engine snapshot / aircraft snapshot / engine-delta overview card builders.
// All deps wrapped in lambdas/getters so the binding stays live against
// hoisted helpers and the mutable flightData/healthSummary globals.
const {
  aircraftFuelFlowAverage,
  aircraftSnapshotCard,
  aircraftSnapshotRows,
  engineMetricOverviewFloor,
  finiteMetricValuesForEngine,
  averageMetricForEngine,
  extentMetricForEngine,
  engineSnapshotStatus,
  engineSnapshotCard,
  averageEngineDelta,
  peakEngineDelta,
  engineDeltaOverviewCard,
} = createEngineSnapshot({
  getFlightData: () => flightData,
  getHealthSummary: () => healthSummary,
  scopedSummaryForEngine: (...args) => scopedHealthSummaryForEngine(...args),
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  engineMetricValue: (...args) => engineMetricValue(...args),
  engineDelta: (...args) => engineDelta(...args),
  engineDeltaLabel: (...args) => engineDeltaLabel(...args),
  finiteValues: (...args) => finiteValues(...args),
  extentFromValues: (...args) => extentFromValues(...args),
  panelNumber: (...args) => panelNumber(...args),
  signedPanelNumber: (...args) => signedPanelNumber(...args),
  formatElapsedTime: (...args) => formatElapsedTime(...args),
  flightDurationSeconds: (...args) => flightDurationSeconds(...args),
  fuelUsedMetric: (...args) => fuelUsedMetric(...args),
});

// Top-level finding dispatcher + per-metric wrappers + evidence-flight
// helpers. Lots of deps — all lambdas/getters so binding stays live against
// the hoisted helpers and the mutable detectionSensitivity / selectedFlight
// / trendCache / flightManifest globals.
const {
  buildFinding,
  findingForMetric,
  descentEgtDropoutHasCandidate,
  healthyMetricEvidenceContext,
  healthyMetricEvidence,
  healthyMetricFinding,
  metricDisplayName,
  unavailableMetricFinding,
  turboMetricEvidenceRows,
  turboFinding,
  relatedTrendRowsForSelectedAircraft,
  sortEvidenceReferences,
  sensorEvidenceNote,
  sensorEvidenceFlights,
  coolingEvidenceFlights,
  coolingRateEvidenceFlights,
  chtFinding,
  readableProbeLabel,
  egtFinding,
  combustionFinding,
  abnormalCombustionFinding,
  findingCylinderReference,
  capitalizeSentence,
  findingCylinderListLabel,
  valveFinding,
  descentEgtDropoutFinding,
  magFinding,
  valveEvidenceFlights,
  coolingFinding,
  inductionLeakFinding,
  coolingRateFinding,
} = createFindingDispatch({
  getDetectionSensitivity: () => detectionSensitivity,
  getSelectedFlight: () => selectedFlight,
  getTrendCache: () => trendCache,
  getFlightManifest: () => flightManifest,
  titleCase: (...args) => titleCase(...args),
  normalizeSensitivity: (...args) => normalizeSensitivity(...args),
  sensitivityModes,
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  engineNarrativeProbeLabel: (...args) => engineNarrativeProbeLabel(...args),
  engineScopedProbeLabel: (...args) => engineScopedProbeLabel(...args),
  engineInfoForCylinderNumber: (...args) => engineInfoForCylinderNumber(...args),
  engineScopedCylinderLabel: (...args) => engineScopedCylinderLabel(...args),
  metricDisplayClass: (...args) => metricDisplayClass(...args),
  valveBandLabel: (...args) => valveBandLabel(...args),
  sensorReviewSummaries: (...args) => sensorReviewSummaries(...args),
  trendCacheKey: (...args) => trendCacheKey(...args),
  staticValveRowsForAircraft: (...args) => staticValveRowsForAircraft(...args),
  healthyMetricEvidenceFromContext: (...args) => healthyMetricEvidenceFromContext(...args),
  healthyMetricFindingFromContext: (...args) => healthyMetricFindingFromContext(...args),
  chtFindingFromContext: (...args) => chtFindingFromContext(...args),
  chtRhythmFindingFromContext: (...args) => chtRhythmFindingFromContext(...args),
  egtFindingFromContext: (...args) => egtFindingFromContext(...args),
  combustionFindingFromContext: (...args) => combustionFindingFromContext(...args),
  abnormalCombustionFindingFromContext: (...args) => abnormalCombustionFindingFromContext(...args),
  valveFindingFromContext: (...args) => valveFindingFromContext(...args),
  descentEgtDropoutFindingFromContext: (...args) => descentEgtDropoutFindingFromContext(...args),
  magFindingFromContext: (...args) => magFindingFromContext(...args),
  coolingFindingFromContext: (...args) => coolingFindingFromContext(...args),
  inductionLeakFindingFromContext: (...args) => inductionLeakFindingFromContext(...args),
  coolingRateFindingFromContext: (...args) => coolingRateFindingFromContext(...args),
  turboFindingFromContext: (...args) => turboFindingFromContext(...args),
  turboMetricEvidenceRowsFromContext: (...args) => turboMetricEvidenceRowsFromContext(...args),
  findingCylinderListLabelFromContext: (...args) => findingCylinderListLabelFromContext(...args),
  sensorFinding: (...args) => sensorFinding(...args),
  oilSystemFinding: (...args) => oilSystemFinding(...args),
  coolantMarginFinding: (...args) => coolantMarginFinding(...args),
  takeoffEnrichmentFinding: (...args) => takeoffEnrichmentFinding(...args),
  carbIceFinding: (...args) => carbIceFinding(...args),
  startChargeFinding: (...args) => startChargeFinding(...args),
  crossEngineComparisonFinding: (...args) => crossEngineComparisonFinding(...args),
  electricalFinding: (...args) => electricalFinding(...args),
  instrumentationSuspicionFinding: (...args) => instrumentationSuspicionFinding(...args),
});

// PDF report data builders (flightReportRows, reportCylinderRows,
// reportMultiEngine*, reportFlightMap*, etc.). All deps wrapped in
// lambdas/getters so binding stays live against the hoisted helpers and
// the mutable flightData / selectedFlight / sourceMonitor / healthSummary
// globals.
const {
  flightReportRows,
  reportTurboContext,
  reportEngineMetricRows,
  reportCylinderRows,
  cylinderAverageForKeys,
  cylinderSpreadAverageForKeys,
  reportHealthCheckRows,
  reportTraceRows,
  reportAtAGlanceTurboCard,
  reportAtAGlanceCards,
  reportNormalizeEngineScopedText,
  reportNormalizeEngineFinding,
  reportEnginePdfSummary,
  reportEngineDeltaMetrics,
  engineDeltaLabel,
  reportMultiEngineCards,
  reportMultiEngineOverviewRows,
  reportMultiEnginePrimaryCues,
  reportMultiEngineTraceRows,
  reportCylinderTableRows,
  reportFlightMapImage,
  reportFlightMapCaption,
  reportFlightDistanceLabel,
  reportFlightProfileRows,
  reportFlightMapTiles,
  reportSensorChannelItems,
  sortReportActionsByPriority,
} = createReportBuilders({
  getFlightData: () => flightData,
  getSelectedFlight: () => selectedFlight,
  getSourceMonitor: () => sourceMonitor,
  getHealthSummary: () => healthSummary,
  getPlaybackMap: () => window.AeroInsightPlaybackMap,
  flightReportRowsModel: (...args) => flightReportRowsModel(...args),
  reportTurboContextModel: (...args) => reportTurboContextModel(...args),
  reportEngineMetricRowsModel: (...args) => reportEngineMetricRowsModel(...args),
  reportHealthCheckRowsModel: (...args) => reportHealthCheckRowsModel(...args),
  reportTraceRowsModel: (...args) => reportTraceRowsModel(...args),
  reportAtAGlanceTurboCardModel: (...args) => reportAtAGlanceTurboCardModel(...args),
  reportAtAGlanceCardsModel: (...args) => reportAtAGlanceCardsModel(...args),
  reportCylinderTableRowsModel: (...args) => reportCylinderTableRowsModel(...args),
  panelNumber: (...args) => panelNumber(...args),
  signedPanelNumber: (...args) => signedPanelNumber(...args),
  scoreLabel: (...args) => scoreLabel(...args),
  formatPointTime: (...args) => formatPointTime(...args),
  formatElapsedTime: (...args) => formatElapsedTime(...args),
  formatCompactElapsedTime: (...args) => formatCompactElapsedTime(...args),
  flightDateLabel: (...args) => flightDateLabel(...args),
  flightDurationSeconds: (...args) => flightDurationSeconds(...args),
  sampleRateSummary: (...args) => sampleRateSummary(...args),
  fuelUsedMetric: (...args) => fuelUsedMetric(...args),
  preferredPowerEstimateSummary: (...args) => preferredPowerEstimateSummary(...args),
  dataQualitySummary: (...args) => dataQualitySummary(...args),
  estimatedHpMetric: (...args) => estimatedHpMetric(...args),
  engineMetricRows: (...args) => engineMetricRows(...args),
  detectionWindowsForHealthKey: (...args) => detectionWindowsForHealthKey(...args),
  engineMetricCylinder: (...args) => engineMetricCylinder(...args),
  engineWorkPoint: (...args) => engineWorkPoint(...args),
  availableCylinderNumbers: (...args) => availableCylinderNumbers(...args),
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  engineInfoForCylinderNumber: (...args) => engineInfoForCylinderNumber(...args),
  enginePeerKeysForCylinderNumber: (...args) => enginePeerKeysForCylinderNumber(...args),
  cylinderMetricSummary: (...args) => cylinderMetricSummary(...args),
  finiteValues: (...args) => finiteValues(...args),
  quantile: (...args) => quantile(...args),
  peerAverage: (...args) => peerAverage(...args),
  extentFromValues: (...args) => extentFromValues(...args),
  visibleDivergenceCylinders: (...args) => visibleDivergenceCylinders(...args),
  pointCylinderValues: (...args) => pointCylinderValues(...args),
  hasCarbTempChannel: (...args) => hasCarbTempChannel(...args),
  scopedHealthSummaryForEngine: (...args) => scopedHealthSummaryForEngine(...args),
  extentMetricForEngine: (...args) => extentMetricForEngine(...args),
  averageMetricForEngine: (...args) => averageMetricForEngine(...args),
  averageEngineDelta: (...args) => averageEngineDelta(...args),
  peakEngineDelta: (...args) => peakEngineDelta(...args),
  engineMetricValue: (...args) => engineMetricValue(...args),
  engineDelta: (...args) => engineDelta(...args),
  flightProfileSummaryItems: (...args) => flightProfileSummaryItems(...args),
  phaseProfileRows: (...args) => phaseProfileRows(...args),
  reportFindingEvidenceItems: (...args) => reportFindingEvidenceItems(...args),
  reportFindingText: (...args) => reportFindingText(...args),
  sensorReviewSummaries: (...args) => sensorReviewSummaries(...args),
  sensorSummaryEvidenceParts: (...args) => sensorSummaryEvidenceParts(...args),
  sensorSummaryDisplayLabel: (...args) => sensorSummaryDisplayLabel(...args),
  sensorSummaryEvidenceText: (...args) => sensorSummaryEvidenceText(...args),
  sensorSummaryWindowText: (...args) => sensorSummaryWindowText(...args),
  sensorSummaryReportDetail: (...args) => sensorSummaryReportDetail(...args),
  getPdfPalette: () => pdfPalette,
});

// Async PDF blob assemblers (V1 + V2) plus the renderAiSummarySection
// writer helper. All deps wrapped in lambdas/getters so binding stays
// live against the hoisted helpers and mutable state.
const {
  renderAiSummarySection,
  buildFlightReportPdfBlob,
  buildFlightReportPdfBlobV1,
  buildFlightReportPdfBlobV2,
} = createFlightReportBlob({
  getHealthSummary: () => healthSummary,
  getFlightData: () => flightData,
  getSelectedFlight: () => selectedFlight,
  getSourceMonitor: () => sourceMonitor,
  getSourceName: () => sourceName,
  getSourceRows: () => sourceRows,
  getSourceRawRows: () => sourceRawRows,
  getAiSummaryState: () => aiSummaryState,
  getSavedSpecialTestResults: () => getSavedGamiSpecialTestResults(),
  gamiSweepEngineIdentity: (...args) => gamiSweepEngineIdentity(...args),
  gamiSweepPeakDisplayRows: (...args) => gamiSweepPeakDisplayRows(...args),
  buildReportOverviewVisuals: (...args) => (typeof buildReportOverviewVisuals === "function" ? buildReportOverviewVisuals(...args) : []),
  calculateHealthSummary: (...args) => calculateHealthSummary(...args),
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  engineReviewItems: (...args) => engineReviewItems(...args),
  engineMetricLesson: (...args) => engineMetricLesson(...args),
  engineTriageStatus: (...args) => engineTriageStatus(...args),
  flightDateLabel: (...args) => flightDateLabel(...args),
  formatPointTime: (...args) => formatPointTime(...args),
  formatCompactElapsedTime: (...args) => formatCompactElapsedTime(...args),
  aiSummaryPayloadJson: (...args) => aiSummaryPayloadJson(...args),
  aiSummaryGeneratedLabel: (...args) => aiSummaryGeneratedLabel(...args),
  reportFindingText: (...args) => reportFindingText(...args),
  reportFindingEvidenceItems: (...args) => reportFindingEvidenceItems(...args),
  reportWindowSummary: (...args) => reportWindowSummary(...args),
  findingDisplayLabel: (...args) => findingDisplayLabel(...args),
  findingCausePresentation: (...args) => findingCausePresentation(...args),
  phaseProfileRows: (...args) => phaseProfileRows(...args),
  operationalProfileReportRows: (...args) => operationalProfileReportRows(...args),
  dataQualityItems: (...args) => dataQualityItems(...args),
  rawChannelKeys: (...args) => rawChannelKeys(...args),
  scoringRole: (...args) => scoringRole(...args),
  writePrimaryFindingSections: (...args) => writePrimaryFindingSections(...args),
  makePdfWriter: (...args) => makePdfWriter(...args),
  buildPdfBlob: (...args) => buildPdfBlob(...args),
  reportFileName: (...args) => reportFileName(...args),
  flightReportRows: (...args) => flightReportRows(...args),
  reportFlightMapImage: (...args) => reportFlightMapImage(...args),
  reportFlightMapCaption: (...args) => reportFlightMapCaption(...args),
  reportFlightMapTiles: (...args) => reportFlightMapTiles(...args),
  reportFlightProfileRows: (...args) => reportFlightProfileRows(...args),
  reportMultiEngineCards: (...args) => reportMultiEngineCards(...args),
  reportMultiEngineOverviewRows: (...args) => reportMultiEngineOverviewRows(...args),
  reportMultiEnginePrimaryCues: (...args) => reportMultiEnginePrimaryCues(...args),
  reportMultiEngineTraceRows: (...args) => reportMultiEngineTraceRows(...args),
  reportTraceRows: (...args) => reportTraceRows(...args),
  reportTurboContext: (...args) => reportTurboContext(...args),
  reportHealthCheckRows: (...args) => reportHealthCheckRows(...args),
  reportCylinderRows: (...args) => reportCylinderRows(...args),
  reportCylinderTableRows: (...args) => reportCylinderTableRows(...args),
  reportEngineMetricRows: (...args) => reportEngineMetricRows(...args),
  reportAtAGlanceCards: (...args) => reportAtAGlanceCards(...args),
  reportSensorChannelItems: (...args) => reportSensorChannelItems(...args),
  sortReportActionsByPriority: (...args) => sortReportActionsByPriority(...args),
  getProfileDurationBuckets: () => profileDurationBuckets,
  getReportDisclaimerParagraphs: () => reportDisclaimerParagraphs,
});

const activeSeries = new Set(["egt1", "egt2", "egt3", "egt4", "cht1", "cht2", "cht3", "cht4"]);
// Per-aircraft channel→pane placement overrides (drag a channel between the
// temperature and secondary graphs); keys absent here use the default pane.
let seriesPaneOverridesByAircraft = loadSeriesPaneOverrides();
const AIRCRAFT_MODEL_MAX_LENGTH = 25;
const AIRCRAFT_FUEL_CHOICES = ["100LL Avgas", "Auto Gas", "Jet-A"];
const AIRCRAFT_FUEL_OTHER_CHOICE = "Other";
const CONTACT_MONITOR_OTHER_CHOICE = "Other";
const AIRCRAFT_PROPELLER_TYPES = ["fixed_pitch", "constant_speed"];
const aircraftFlightsHydrationBatchSize = 24;
let appConfig = defaultAppConfig();
let selectedCylinderNumber = null;
let selectedEngineScope = "aircraft";
let selectedAircraftPanel = "profile";
// Seeded from the Account > Settings "Flight order" preference. Only the
// DEFAULT is preference-driven: clicking a column header still overrides it for
// the session, so the setting decides where you start rather than fighting an
// explicit sort choice.
// Literal default, NOT flightSortFromPreference(): app.ts is evaluated in a VM
// sandbox by preferences_check, where imported bindings are not resolved, so a
// module-scope call to an import throws. The stored preference is applied
// during setup instead (see syncNewUiFeatureUi).
let aircraftFlightsSort = { key: "date", direction: "desc" };
let aircraftFlightsFilters = {
  query: "",
  dateRange: "all",
  flags: "all",
  trend: "all",
};
const aircraftUploadHistoryCache = new Map();
const aircraftUploadHistoryPending = new Map();
const aircraftUploadHistoryErrors = new Map();
const aircraftUploadReprocessPending = new Set();
const aircraftUploadReprocessActive = new Set();
const aircraftUploadReprocessQueue = [];
const aircraftUploadReprocessTasks = new Map();
const aircraftUploadReprocessConcurrency = 1;
const aircraftUploadProcessShortPending = new Set();
const aircraftUploadDeletePending = new Set();
const aircraftUploadBulkDeleteSelected = new Set();
const aircraftFlightBulkDeleteSelected = new Set();
const aircraftFlightDeletePending = new Set();
let aircraftFlightUpdateSelectedBusy = false;
const aircraftFlightFlagSummaryIndexPromises = new Map();
let flightData = null;
let referenceData = null;
let flightManifest = [];
let aircraftProfiles = {};
let localAircraftProfiles = loadLocalAircraftProfiles();
let databaseAircraftRecords = [];
let aircraftFlightManifestReady = false;
let aircraftFlightManifestLoadPromise = null;
let aircraftFormPhotoDataUrl = null;
let activeAircraftEditorFormId = "aircraftEditDialogForm";

const {
  populateMonitorSelects,
  selectedMonitorFromSelects,
} = createMonitorSelects({
  monitorOtherChoice: CONTACT_MONITOR_OTHER_CHOICE,
  escapeHtml: (...args) => escapeHtml(...args),
});

// Aircraft edit form: field readers + dynamic field renderers +
// form-to-profile conversion + validation. Placed here (after the form
// state vars are declared) so the const-array deps further up are bound
// by the time the factory is called. All function deps wrapped in
// lambdas so the binding stays live against hoisted helpers.
const {
  aircraftEditorForm,
  aircraftEditorField,
  setAircraftFormStatus,
  aircraftEditSummaryText,
  updateAircraftEditSummary,
  aircraftEditorNameForFieldId,
  setAircraftFuelFields,
  aircraftFuelFromForm,
  syncAircraftTurboLimitFields,
  resetAircraftForm,
  formEngineCount,
  aircraftEngineLabelMode,
  aircraftCylindersPerEngine,
  aircraftPropellerEntriesFromForm,
  aircraftCylinderEntriesFromForm,
  cylinderGroupsForLayout,
  syncAircraftLayoutControls,
  renderAircraftEngineLayoutFields,
  renderAircraftPropellerFields,
  aircraftProfileFromForm,
  validateAircraftEditForm,
  applyAircraftEngineMakeSelection,
  applyAircraftEngineModelSelection,
  applyAircraftRegistryPrefill,
} = createAircraftForm({
  getActiveAircraftEditorFormId: () => activeAircraftEditorFormId,
  getAircraftProfiles: () => aircraftProfiles,
  getEngineLabelModes: () => ENGINE_LABEL_MODES,
  getAircraftFuelChoices: () => AIRCRAFT_FUEL_CHOICES,
  getAircraftFuelOtherChoice: () => AIRCRAFT_FUEL_OTHER_CHOICE,
  getAircraftPropellerTypes: () => AIRCRAFT_PROPELLER_TYPES,
  escapeHtml: (...args) => escapeHtml(...args),
  normalizedAircraftType: (...args) => normalizedAircraftType(...args),
  limitedAircraftModel: (...args) => limitedAircraftModel(...args),
  propellerEngineLabel: (...args) => propellerEngineLabel(...args),
  selectedMonitorFromSelects: (...args) => selectedMonitorFromSelects(...args),
  supportedMonitorLabel: (...args) => supportedMonitorLabel(...args),
  aircraftDisplayLabel: (...args) => aircraftDisplayLabel(...args),
  monitorSelectionFromText: (...args) => monitorSelectionFromText(...args),
  populateMonitorSelects: (...args) => populateMonitorSelects(...args),
  setAircraftFormPhotoDataUrl: (...args) => setAircraftFormPhotoDataUrl(...args),
  syncReadOnlyUi: (...args) => syncReadOnlyUi(...args),
  appReadOnlyMode: (...args) => appReadOnlyMode(...args),
  readOnlyPreviewMessage: (...args) => readOnlyPreviewMessage(...args),
  readOnlyActionMessage: (...args) => readOnlyActionMessage(...args),
  aircraftProfileEditorValues: (...args) => aircraftProfileEditorValues(...args),
  aircraftFlights: (...args) => aircraftFlights(...args),
  getAircraftFormPhotoDataUrl: () => aircraftFormPhotoDataUrl,
});

const {
  setAircraftPhotoPresentation,
  updateAircraftPhotoControls,
  setAircraftFormPhotoDataUrl,
  aircraftPhotoDisplaySrc,
  readFileAsDataUrl,
  loadImageElement,
  normalizedAircraftPhotoDataUrl,
} = createAircraftPhoto({
  aircraftPhotoFallbackLabel,
  appReadOnlyMode: (...args) => appReadOnlyMode(...args),
  selectedAircraftWorkspace: (...args) => selectedAircraftWorkspace(...args),
  getAircraftFormPhotoDataUrl: () => aircraftFormPhotoDataUrl,
  setAircraftFormPhotoDataUrlValue: (value) => { aircraftFormPhotoDataUrl = value; },
  requestAircraftWorkspaceRender: () => {
    renderAircraftWorkspace();
    window.dispatchEvent(new CustomEvent("aeroinsight:aircraft-photo-ready"));
  },
});

const { applyAircraftDefaultArt, defaultArtRestUrl, defaultArtHoverUrl } = createAircraftDefaultArt({
  requestAircraftWorkspaceRender: () => renderAircraftWorkspace(),
});

const {
  setContactFormStatus,
  syncContactMonitorFields,
  initializeContactForm,
  submitContactUpdateForm,
} = createContactForm({
  contactMonitorOtherChoice: CONTACT_MONITOR_OTHER_CHOICE,
  populateMonitorSelects: (...args) => populateMonitorSelects(...args),
});

const {
  setUploadDialogError,
  setUploadDialogStatus,
  selectedUploadFiles,
  updateUploadSelectionSummary,
  syncUploadAircraftMode,
  populateUploadAircraftSelect,
  openUploadDialog,
  closeUploadDialog,
  uploadAircraftTargetValue,
  uploadAircraftTargetDatabaseId,
  chooseUploadFilesWithinCapacity,
} = createUploadDialog({
  escapeHtml: (...args) => escapeHtml(...args),
  newUiFeatureEnabled: () => newUiFeatureEnabled(),
  aircraftDisplayLabel: (...args) => aircraftDisplayLabel(...args),
  populateMonitorSelects: (...args) => populateMonitorSelects(...args),
  aircraftOptionsForUpload: (...args) => aircraftOptionsForUpload(...args),
  preferredUploadAircraft: (...args) => preferredUploadAircraft(...args),
  appReadOnlyMode: (...args) => appReadOnlyMode(...args),
  readOnlyPreviewMessage: (...args) => readOnlyPreviewMessage(...args),
  syncReadOnlyUi: (...args) => syncReadOnlyUi(...args),
  setUploadDialogPostSuccessPanel: (value) => { uploadDialogPostSuccessPanel = value; },
  aircraftDatabaseIdForUpload: (...args) => databaseAircraftIdForLabel(...args),
});

const {
  mapGarminRows,
  extractedTextParserHooks,
  extractedTextParserRegistry,
  extractedTextParserEnvelopeRegistry,
  parseGarminUserLogCsv,
  parseGarminTxiCsv,
  parseJpiCsv,
  parseJpiBinary,
  parseJpiBinaryEnvelope,
  parseFlightText,
  parseFlightTextEnvelope,
} = createParserDispatch({
  inferInsightPhase: (...args) => inferInsightPhase(...args),
});

let draggedAircraftRow = "";
let aircraftReorderInFlight = false;
let valvePatternSummary = null;
let selectedFlight = null;
let aiSummaryState = { flightId: "", status: "idle", payload: null, error: "" };
let aiSummaryRequestToken = 0;
if (typeof window.addEventListener === "function") {
  window.addEventListener("aeroinsight:ai-request-balance-updated", () => {
    if (aiSummaryState.limitInfo) {
      aiSummaryState = { ...aiSummaryState, status: "idle", error: "", limitInfo: null };
      renderAiSummaryPanel();
    }
  });
}
// Explorer Ask state and runtime live in src/app/explorer-ask-controller.js.
let aiSummaryEvidenceExpanded = false;
// Tail-number URL path (/N12345/#flights): a bookmarked tail wins over the
// remembered selection at boot; selection changes keep the path in sync.
function aircraftTailFromUrlPath(pathname = globalThis.window?.location?.pathname ?? "") {
  const match = /^\/([^/.]+)\/?$/.exec(pathname);
  // "share" and "home" are reserved client routes, not aircraft tails.
  if (!match || match[1] === "share" || match[1] === "home") return "";
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return "";
  }
}

// --- Browser history entries ------------------------------------------------
// Direct `location.hash = ...` assignments (view/panel switches) create
// history entries natively. The URL *sync* writers — the aircraft path tail
// below and syncFlightReviewRoute — historically used replaceState only,
// which left Back/Forward with nothing to traverse for path-only aircraft
// switches and in-dashboard flight hops. commitUrl() gives those writers one
// entry per user navigation: a requested push is downgraded to replace when
// the hash changed since the last commit, because a hash assignment in this
// same interaction already pushed the entry and this write is just folding
// the path/state into it. That same rule keeps Back-triggered re-renders
// (popstate/hashchange) from pushing and destroying the forward stack, and
// the boot guard keeps the very first sync from minting a spurious entry.
let lastCommittedUrlHash = globalThis.window?.location?.hash ?? "";
let urlHistoryBooted = false;
function commitUrl(nextUrl, { push = false } = {}) {
  const hashChangedSinceLastCommit = window.location.hash !== lastCommittedUrlHash;
  if (push && urlHistoryBooted && !hashChangedSinceLastCommit) {
    window.history.pushState(null, "", nextUrl);
  } else {
    window.history.replaceState(null, "", nextUrl);
  }
  urlHistoryBooted = true;
  try {
    lastCommittedUrlHash = new URL(nextUrl, window.location.href).hash;
  } catch {
    lastCommittedUrlHash = window.location.hash;
  }
}

function syncAircraftUrlPathTail() {
  if (isPublicShareMode()) return;
  // Small-mobile Home is its own route: /home, no tail, no hash.
  if (document.body?.classList?.contains("mobile-home-active")) {
    if (window.location.pathname !== "/home" || window.location.hash) {
      commitUrl(`/home${window.location.search}`);
    }
    return;
  }
  // The tail segment belongs to the aircraft workspace only; Admin, My
  // Account, and public pages keep a clean root path.
  const view = document.body?.dataset?.activeView ?? "";
  const inWorkspace = view === "aircraft" || view === "dashboard" || view === "";
  const tail = inWorkspace ? selectedAircraftWorkspaceId : "";
  const nextPath = tail ? `/${encodeURIComponent(tail)}/` : "/";
  if (window.location.pathname === nextPath) return;
  // A path change with no hash change is an aircraft switch (or a workspace
  // exit) — a real navigation, so it earns a history entry for Back.
  commitUrl(`${nextPath}${window.location.search}${window.location.hash}`, { push: true });
}

let selectedAircraftWorkspaceId = aircraftTailFromUrlPath() || loadSelectedAircraftWorkspaceId();
let selectedFlightStorageId = loadSelectedFlightId();
let lastRequestedFlightId = "";
let emptyAircraftDashboardTail = "";
let uploadDialogPostSuccessPanel = "";
let hiddenFlightIds = loadHiddenFlightIds();
let trendExcludedFlightIds = loadTrendExcludedFlightIds();
let trendIncludedFlightIds = loadTrendIncludedFlightIds();
let sourceRows = 0;
let sourceRawRows = 0;
let sourceName = "Generated fallback";
let sourceMonitor = "Generated";
let currentParserMetadata = null;
const endpointTrimSeconds = 1;
let endpointTrimInfo = { original: 0, leading: 0, trailing: 0, total: 0, seconds: endpointTrimSeconds };
let scrubRatio = 0.62;
let zoomRange = { start: 0, end: 1 };
let dragSelection = null;
let drawScheduled = false;
let chartDrawScheduled = false;
let scheduledChartCanvasId = null;
let markerUpdateScheduled = false;

function limitedAircraftModel(value) {
  const text = String(value ?? "").trim();
  return text.slice(0, AIRCRAFT_MODEL_MAX_LENGTH);
}
let scheduledMarkerCanvasId = null;
let explorerInteractionUpdateScheduled = false;
let cylinderSummaryLayoutScheduled = false;
let overviewReviewPanelHeightScheduled = false;
let overviewReviewPanelResizeObserver = null;
let healthSummary = null;
let renderedHealthSummary = null;
let scopedHealthSummaryCache = { source: null, data: null, sensitivity: "", reviewSettings: "", summaries: new Map() };
const rawAnalysisCache = new Map();
let rawScopedAnalysisCache = { data: null, signature: "", bundles: new Map() };
let detectionSensitivity = loadDetectionSensitivity();
let aircraftReviewSettings = loadAircraftReviewSettings();
let aircraftReviewSettingsCloseTimer = null;
let selectedHealthKey = null;
let overviewSelectionCleared = false;
let overviewHealthCardInteractionBound = false;
let selectedOperatingContextKey = null;
let selectedOperatingContextWindows = [];
const gamiSpecialTestsState = {
  open: false,
  selecting: false,
  window: null,
  engineId: "",
};
const pilotObservationState = {
  open: false,
  selecting: false,
  window: null,
  symptomType: "roughness",
  severity: "",
  source: "pilot",
  note: "",
};
// GAMI special-test result state now lives in the GAMI controller
// (src/app/gami-special-tests-controller.js); read it via
// getSavedGamiSpecialTestResults() / getSelectedSavedGamiSpecialTestResultId().
let gamiCursorTimeTooltip = null;
let chartCursorPosition = null;
const expandedReviewKeys = new Set();
let explorerSelectedAlertId = null;
const explorerHeightStorageKey = "aeroInsightExplorerHeight";
const explorerHeightModes = {
  normal: { label: "Normal" },
  tall: { label: "Tall" },
};
let explorerHeightMode = loadExplorerHeightMode();
const explorerFitYStorageKey = "aeroInsightExplorerFitY";
let explorerFitYAxis = loadExplorerFitYAxis();
let visibleFlightDataCacheSource = null;
const visibleFlightDataCache = new Map();
let selectedDetectionWindowCache = { summary: null, key: "", windows: [] };
let playbackDetectionWindowCache = { summary: null, windows: [] };
let explorerTimelineMarkerCache = { data: null, summary: null, markers: [] };
// Marker/scrub readout state now lives in the marker-readout renderer
// (src/app/marker-readout-renderer.js).
let trendCache = new Map();
let currentTrendRows = null;
let currentTrendAircraft = "";
let currentTrendSensitivity = "";
const trendCacheSchemaVersion = typeof trendRowsRenderVersion === "string"
  ? trendRowsRenderVersion
  : "2026-05-07-trend-analysis-dialog-v7";
const trendCacheStoragePrefix = "aeroInsight.trendRows.";
// Trends use only the last TREND_FLIGHT_CAP flights or TREND_HOURS_CAP_SECONDS of
// flight time (whichever is reached first). Declared here, ahead of the renderer
// factory injection, so its value references resolve during module evaluation.
const TREND_FLIGHT_CAP = 50;
const TREND_HOURS_CAP_SECONDS = 100 * 60 * 60;
// Hard eligibility floor: flights with a KNOWN duration under 15 minutes never contribute to
// Trends (too little warm, stable operating time to compare across flights). Exactly 15:00 is
// allowed; unknown durations are NOT gated — we don't hide what we can't measure.
const TREND_MIN_DURATION_SECONDS = 15 * 60;
const trendCappedFlightSummaryMemo = new Map();
const {
  trendHashString,
  trendStorageKey,
  trendFlightFingerprint,
  readStoredTrendRows,
  writeStoredTrendRows,
  removeStoredTrendRows,
  clearStoredTrendRowsForAircraft,
} = createTrendRowStorage({
  trendCacheStoragePrefix,
  trendCacheSchemaVersion,
});
const flightFlagSummaryCache = new Map();
const flightFlagSummaryPending = new Map();
let databaseFlightFlagIndexPromise = null;
const {
  flightFlagSummary,
  flightFlagSummaryFromAnalysisRun,
  flightFlagSummaryMarkup,
  flightFlagIdentityKeys,
  invalidateAircraftFlightFlagSummaries,
  databaseFlightFlagIndex,
  hydrateAircraftFlightFlagSummary,
  hydrateDatabaseAircraftFlightFlagSummaries,
  hydrateAircraftFlightFlagSummaries,
} = createFlightFlagSummary({
  flightFlagSummaryCache,
  flightFlagSummaryPending,
  aircraftFlightFlagSummaryIndexPromises,
  getDatabaseFlightFlagIndexPromise: () => databaseFlightFlagIndexPromise,
  setDatabaseFlightFlagIndexPromise: (value) => { databaseFlightFlagIndexPromise = value; },
  aircraftFlightsHydrationBatchSize,
  databaseAircraftEndpoint,
  databaseAircraftSummaryEndpoint: (...args) => databaseAircraftSummaryEndpoint(...args),
  databaseAircraftFlightFlagSummariesEndpoint,
  databaseAircraftLabel,
  disabledReviewMonitorKeys: (...args) => disabledReviewMonitorKeys(...args),
  selectedAircraftWorkspace: (...args) => selectedAircraftWorkspace(...args),
  escapeHtml: (...args) => escapeHtml(...args),
  isSupportedFlight,
  valveFlagForFlight,
  renderAircraftFlightsPanel: (...args) => renderAircraftFlightsPanel(...args),
  getSelectedAircraftPanel: () => selectedAircraftPanel,
});
const {
  phaseProfileRows,
  profileDurationBuckets,
  flightProfileContext,
  operationalProfileCards,
  operationalProfileReportRows,
  profileContextIcon,
  profileHighlightIcon,
  splitProfileDisplayValue,
  profileSummaryItemMap,
  flightProfileHighlightItems,
  profileSectionDisplayTitle,
  splitProfileSummarySections,
  renderOperationalMix,
  renderOperationalProfile,
  renderProfileContextRail,
  maxPositiveForKey,
  flightProfileSummaryItems,
  groupFlightProfileSummaryItems,
  flightProfileSummaryQualifier,
  renderFlightProfilePanel,
} = createFlightProfileRenderer({
  escapeHtml: (...args) => escapeHtml(...args),
  formatElapsedTime: (...args) => formatElapsedTime(...args),
  formatPointTime: (...args) => formatPointTime(...args),
  engineWorkPoint: (...args) => engineWorkPoint(...args),
  panelNumber: (...args) => panelNumber(...args),
  powerEstimateSummary: (...args) => powerEstimateSummary(...args),
  fuelUsedMetric: (...args) => fuelUsedMetric(...args),
  flightDurationSeconds: (...args) => flightDurationSeconds(...args),
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  getFlightData: () => flightData,
  getSelectedFlight: () => selectedFlight,
});
const {
  engineReviewModelContext,
  engineMetricRows,
  engineForSummaryScope,
  metricMatchesEngineScope,
  scopedSummaryFinding,
  engineSeverityRank,
  engineMetricCylinder,
  engineReviewItems,
  engineMetricLesson,
  engineLessonHtml,
  engineFindingSnippet,
  engineWindowLabel,
  engineReviewActionList,
  engineTriageStatus,
  renderEngineTriageSummary,
  renderEngineReviewList,
  renderEngineEvidencePanel,
  renderEngineSupportingChecks,
  selectEngineTimelineEvidence,
} = createEngineReviewRenderer({
  escapeHtml: (...args) => escapeHtml(...args),
  compactHealthNote: (...args) => compactHealthNote(...args),
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  engineSourceNumbers: (...args) => engineSourceNumbers(...args),
  detectionWindowsForHealthKey: (...args) => detectionWindowsForHealthKey(...args),
  findingDisplayClass,
  findingDisplayLabel,
  findingForMetric: (...args) => findingForMetric(...args),
  findingMetaMarkup,
  hasCarbTempChannel,
  healthMetricScope: (...args) => healthMetricScope(...args),
  reviewMonitorEnabled: (...args) => reviewMonitorEnabled(...args),
  scoreCardStateFromClass,
  getSelectedFlight: () => selectedFlight,
});
const {
  updateExplorerAnnunciationHeader,
  explorerAlertId,
  explorerWindowTimeLabel,
  explorerScoreText,
  explorerValveEvidenceItems,
  explorerValveAlertBody,
  explorerAlertBodyForFinding,
  explorerEgtAnnunciationLabel,
  explorerFindingAnnunciationItem,
  explorerHottestCylinder,
  explorerHotChtAnnunciationItem,
  explorerBusTone,
  explorerBusAnnunciationItem,
  explorerOilAnnunciationItem,
  explorerAnnunciationWindowPriority,
  explorerAnnunciationItems,
  syncExplorerSelectedAnnunciation,
  explorerAlertEvidenceHtml,
  explorerAlertActionsHtml,
  explorerAlertCausesHtml,
  explorerAnnunciationDetailHtml,
  renderExplorerAnnunciations,
} = createExplorerAnnunciations({
  escapeHtml: (...args) => escapeHtml(...args),
  getHealthMetricLabels: () => summaryHealthMetricLabels,
  getHealthSummary: () => healthSummary,
  getFlightData: () => flightData,
  getExplorerSelectedAlertId: () => explorerSelectedAlertId,
  setExplorerSelectedAlertId: (value) => { explorerSelectedAlertId = value; },
  findingForMetric: (...args) => findingForMetric(...args),
  calculateHealthSummary: (...args) => calculateHealthSummary(...args),
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  engineScopedCylinderLabel: (...args) => engineScopedCylinderLabel(...args),
  engineInfoForSourceNumber: (...args) => engineInfoForSourceNumber(...args),
  engineInfoForCylinderNumber: (...args) => engineInfoForCylinderNumber(...args),
  availableCylinderNumbers: (...args) => availableCylinderNumbers(...args),
  playbackDetectionWindows: (...args) => playbackDetectionWindows(...args),
  explorerFindingChip: (...args) => explorerFindingChip(...args),
  readableProbeLabel: (...args) => readableProbeLabel(...args),
  buildExplorerTimelineMarkers: (...args) => buildExplorerTimelineMarkers(...args),
});
let trendSampleGraphToken = 0;
let renderedTrendSignature = "";
let renderedTrendDataSignature = "";
let renderedTrendSampleSignature = "";
let renderedTrendFlushed = false;
let renderedTrendTableSignature = "";
const trendSampleGraphCache = new Map();
const trendSampleGraphInflight = new Map();
let trendSampleGraphPrewarmToken = 0;
const parsedFlightEntryCache = new Map();
const parsedFlightEntryPromiseCache = new Map();
// A twin trends view parses up to 5 sample flights plus prewarms, on top of the
// dashboard flight, so a 12-entry window thrashes within a single session.
const PARSED_FLIGHT_ENTRY_CACHE_MAX = 32;
const loadedFlightRuntimeStateCache = new Map();
const LOADED_FLIGHT_RUNTIME_STATE_CACHE_MAX = 8;

function rememberParsedFlightEntry(cacheKey, envelope) {
  parsedFlightEntryCache.delete(cacheKey);
  parsedFlightEntryCache.set(cacheKey, envelope);
  while (parsedFlightEntryCache.size > PARSED_FLIGHT_ENTRY_CACHE_MAX) {
    parsedFlightEntryCache.delete(parsedFlightEntryCache.keys().next().value);
  }
}

function rememberLoadedFlightRuntimeState(cacheKey, state) {
  loadedFlightRuntimeStateCache.delete(cacheKey);
  loadedFlightRuntimeStateCache.set(cacheKey, state);
  while (loadedFlightRuntimeStateCache.size > LOADED_FLIGHT_RUNTIME_STATE_CACHE_MAX) {
    loadedFlightRuntimeStateCache.delete(loadedFlightRuntimeStateCache.keys().next().value);
  }
}

let flightDerivedCache = null;
let activeTrendMetric = "overallScore";
// Default the flight log to the flights contributing to the active trend signal, as cards;
// All flights / the dense table stay one click away.
let activeTrendEvidenceMode = "contributing";
let activeTrendEvidenceSort = "date";
let activeTrendEvidenceLayout = "cards";
const {
  buildTrendRow,
  trendSelectedFlightIndex,
  trendAnchorIndex,
  trendWindowRows,
  scoreClassForValue,
  trendRenderSignature,
  trendDataRenderSignature,
  trendRowsIncludedByPreference,
  trendRowCompletenessScore,
  preferTrendRowCandidate,
  normalizeTrendRowsForDisplay,
  databaseTrendSnapshotRows,
  readDatabaseTrendSnapshotRows,
  saveDatabaseTrendSnapshotRows,
} = createTrendRowComputation({
  trendCacheSchemaVersion,
  databaseTrendSnapshotEndpoint,
  trendExcludedFlightIds,
  applyTrendRowCap: (...args) => applyTrendRowCap(...args),
  quantile: (...args) => quantile(...args),
  formatPointTime: (...args) => formatPointTime(...args),
  sensorReviewSummaries: (...args) => sensorReviewSummaries(...args),
  sensorSummaryDisplayLabel: (...args) => sensorSummaryDisplayLabel(...args),
  sensorSummaryEvidenceParts: (...args) => sensorSummaryEvidenceParts(...args),
  sensorSummaryEvidenceText: (...args) => sensorSummaryEvidenceText(...args),
  sensorSummaryPeerMismatchCount: (...args) => sensorSummaryPeerMismatchCount(...args),
  selectedTrendAircraftDatabaseId: (...args) => selectedTrendAircraftDatabaseId(...args),
  appReadOnlyMode: (...args) => appReadOnlyMode(...args),
  getSelectedFlight: () => selectedFlight,
  getDetectionSensitivity: () => detectionSensitivity,
  getActiveTrendMetric: () => activeTrendMetric,
  getActiveTrendEvidenceMode: () => activeTrendEvidenceMode,
  getActiveTrendEvidenceSort: () => activeTrendEvidenceSort,
  getActiveTrendEvidenceLayout: () => activeTrendEvidenceLayout,
});
const {
  renderTrendSummary,
  recurringTrendFocus,
  compactTrendSignalLabel,
  trendRowsHaveCarbIce,
  trendRowsHaveTurbo,
  trendRowsHaveChannel,
  trendMetricAvailable,
  overallTrendStatus,
  trendOverallTileEvidence,
  trendSignalTileEvidence,
  trendMetricTileItems,
  updateTrendMetricControls,
  trendFindingSummaryNote,
  trendBriefingSignalName,
  trendFindingsSummaryParagraphs,
  trendSummaryBriefingItems,
  renderTrendFindingsSummary,
  trendStoryEvidenceLabel,
  renderTrendOwnerStory,
} = createTrendViewRenderer({
  escapeHtml: (...args) => escapeHtml(...args),
  averageValues,
  trendDirection: (...args) => trendDirection(...args),
  trendAnchorIndex: (...args) => trendAnchorIndex(...args),
  trendWindowRows: (...args) => trendWindowRows(...args),
  trendSignalDefinitionsForRows: (...args) => trendSignalDefinitionsForRows(...args),
  buildTrendSignalSummary: (...args) => buildTrendSignalSummary(...args),
  buildTrendSignalSummaries: (...args) => buildTrendSignalSummaries(...args),
  trendSignalTitle: (...args) => trendSignalTitle(...args),
  trendQueueNote: (...args) => trendQueueNote(...args),
  trendExplanationHtml: (...args) => trendExplanationHtml(...args),
  trendStableEmptyBodyText: (...args) => trendStableEmptyBodyText(...args),
  trendSignalRepeatText: (...args) => trendSignalRepeatText(...args),
  trendDirectionText: (...args) => trendDirectionText(...args),
  trendSpecificEvidenceText: (...args) => trendSpecificEvidenceText(...args),
  buildTrendOwnerStory: (...args) => buildTrendOwnerStory(...args),
  buildGamiTrendAggregate: (...args) => buildGamiTrendAggregate(...args),
  getActiveTrendMetric: () => activeTrendMetric,
  setActiveTrendMetric: (value) => { activeTrendMetric = value; },
});
const {
  renderTrendVisualWorkspace,
  setupTrendVisualWorkspace,
} = createTrendVisualWorkspace({
  escapeHtml: (...args) => escapeHtml(...args),
  trendSignalDefinitionsForRows: (...args) => trendSignalDefinitionsForRows(...args),
  buildTrendSignalSummary: (...args) => buildTrendSignalSummary(...args),
  buildTrendSignalSummaries: (...args) => buildTrendSignalSummaries(...args),
  buildGamiTrendAggregate: (...args) => buildGamiTrendAggregate(...args),
  overallTrendStatus: (...args) => overallTrendStatus(...args),
  trendMetricReviewEnabled: (metricKey) => {
    const monitorKey = trendHealthKeyForSignalKey(metricKey);
    if (!monitorKey) return true;
    const aircraft = selectedTrendAircraft();
    if (!reviewMonitorEnabled(monitorKey, aircraft)) return false;
    const profile = aircraftProfiles?.[aircraft] ?? null;
    const capability = aircraftMonitorCapability([], profile);
    return capability.get(monitorKey)?.available !== false;
  },
  getActiveTrendMetric: () => activeTrendMetric,
  setActiveTrendMetric: (value) => { activeTrendMetric = value; },
  // Enables the gallery's lazy chart fill (skeletons first, one SVG per frame).
  // Tests construct the workspace without this dep and render fully inline.
  waitForUiFrame: (...args) => waitForUiFrame(...args),
  renderMaintenanceContext: (container, selection) => maintenanceContext.render("trends", container, selection),
});
const {
  trendSampleSignal,
  trendSampleRowsForSignal,
  trendSampleCylinderSeriesKey,
  trendSeriesKeyExists,
  trendSampleSeriesForRow,
  trendSampleCardNote,
  trendSampleScoreLabel,
  setTrendSampleEvidenceMeta,
  trendSampleDetectionWindows,
  trendSampleEventWindows,
  trendSampleStoredDetectionWindows,
  trendSampleGraphCacheKey,
  setTrendSampleGraphCache,
  hasTrendSampleGraphPayload,
  trendSampleGraphPayloadsReady,
  trendSampleGraphPayload,
  scheduleTrendSampleGraphPrewarm,
  prewarmTrendSampleGraphPayloads,
  renderTrendSampleGraphs,
  openTrendSampleInExplorer,
  drawTrendSampleGraphsAsync,
  prepareTrendSampleCanvas,
  drawTrendSampleMessage,
  drawTrendSampleGraph,
} = createTrendSampleGraphs({
  escapeHtml: (...args) => escapeHtml(...args),
  detectionWindow: (...args) => detectionWindow(...args),
  cylinderKeys: (...args) => cylinderKeys(...args),
  formatCompactElapsedTime: (...args) => formatCompactElapsedTime(...args),
  findingCylinderReference: (...args) => findingCylinderReference(...args),
  readableProbeLabel: (...args) => readableProbeLabel(...args),
  formatTrendValue: (...args) => formatTrendValue(...args),
  buildTrendSignalSummaries: (...args) => buildTrendSignalSummaries(...args),
  selectedTrendSignal: (...args) => selectedTrendSignal(...args),
  parseFlightEntry: (...args) => parseFlightEntry(...args),
  trimEndpointSamples: (...args) => trimEndpointSamples(...args),
  calculateTrendFlightSummaryOffThread: (...args) => calculateTrendFlightSummaryOffThread(...args),
  aircraftProfileForEntry: (...args) => aircraftProfileForEntry(...args),
  visibleFlightEntries: (...args) => visibleFlightEntries(...args),
  waitForBrowserIdle: (...args) => waitForBrowserIdle(...args),
  waitForUiFrame: (...args) => waitForUiFrame(...args),
  isSupportedFlight,
  trendHealthKeyForSignalKey: (...args) => trendHealthKeyForSignalKey(...args),
  detectionWindowsForHealthKey: (...args) => detectionWindowsForHealthKey(...args),
  selectCompanionSeriesForHealthCard: (...args) => selectCompanionSeriesForHealthCard(...args),
  renderHealthSummary: (...args) => renderHealthSummary(...args),
  activateView: (...args) => activateView(...args),
  selectReportPanel: (...args) => selectReportPanel(...args),
  updateHealthCardSelection: (...args) => updateHealthCardSelection(...args),
  scheduleDrawAll: (...args) => scheduleDrawAll(...args),
  loadFlightLog: (...args) => loadFlightLog(...args),
  chartBounds: (...args) => chartBounds(...args),
  drawEmptyChartMessage: (...args) => drawEmptyChartMessage(...args),
  drawGrid: (...args) => drawGrid(...args),
  drawLine: (...args) => drawLine(...args),
  drawInlineLegend: (...args) => drawInlineLegend(...args),
  drawSelectedDetectionWindow: (...args) => drawSelectedDetectionWindow(...args),
  drawDetectionWindowLabel: (...args) => drawDetectionWindowLabel(...args),
  scoreClass,
  seriesMeta,
  colors,
  trendCacheSchemaVersion,
  trendMetricMeta,
  trendSampleGraphCache,
  trendSampleGraphInflight,
  getFlightManifest: () => flightManifest,
  getActiveTrendMetric: () => activeTrendMetric,
  getDetectionSensitivity: () => detectionSensitivity,
  getSelectedFlight: () => selectedFlight,
  getHealthSummary: () => healthSummary,
  getTrendSampleGraphToken: () => trendSampleGraphToken,
  setTrendSampleGraphToken: (value) => { trendSampleGraphToken = value; return value; },
  getTrendSampleGraphPrewarmToken: () => trendSampleGraphPrewarmToken,
  setTrendSampleGraphPrewarmToken: (value) => { trendSampleGraphPrewarmToken = value; return value; },
  getRenderedTrendSampleSignature: () => renderedTrendSampleSignature,
  setRenderedTrendSampleSignature: (value) => { renderedTrendSampleSignature = value; },
  setSelectedHealthKey: (value) => {
    overviewSelectionCleared = false;
    selectedHealthKey = value;
  },
  setSelectedCylinderNumber: (value) => { selectedCylinderNumber = value; },
});
const {
  trendTableMetricColumnKey,
  trendTableCellClass,
  trendTableFocusSignal,
  setTrendEvidenceMode,
  setTrendEvidenceSort,
  setTrendEvidenceLayout,
  trendEvidenceScoreSort,
  trendEvidenceAttentionRows,
  trendEvidenceRowsForMode,
  sortTrendEvidenceRows,
  updateTrendEvidenceControlState,
  updateTrendTableFocusState,
  bindTrendTableEvents,
  updateTrendTableRowFocusInPlace,
  renderTrendTable,
} = createTrendEvidenceTable({
  escapeHtml: (...args) => escapeHtml(...args),
  scoreClass,
  formatTrendValue: (...args) => formatTrendValue(...args),
  buildTrendSignalSummaries: (...args) => buildTrendSignalSummaries(...args),
  selectedTrendSignal: (...args) => selectedTrendSignal(...args),
  trendAffectedRows: (...args) => trendAffectedRows(...args),
  trendStoryMetricKey: (...args) => trendStoryMetricKey(...args),
  trendMetricMeta,
  trendRowsHaveTurbo: (...args) => trendRowsHaveTurbo(...args),
  trendRowsHaveCarbIce: (...args) => trendRowsHaveCarbIce(...args),
  renderCurrentTrendView: (...args) => renderCurrentTrendView(...args),
  openTrendFlight: (...args) => openTrendFlight(...args),
  getActiveTrendMetric: () => activeTrendMetric,
  getActiveTrendEvidenceMode: () => activeTrendEvidenceMode,
  setActiveTrendEvidenceMode: (value) => { activeTrendEvidenceMode = value; },
  getActiveTrendEvidenceSort: () => activeTrendEvidenceSort,
  setActiveTrendEvidenceSort: (value) => { activeTrendEvidenceSort = value; },
  getActiveTrendEvidenceLayout: () => activeTrendEvidenceLayout,
  setActiveTrendEvidenceLayout: (value) => { activeTrendEvidenceLayout = value; },
  getRenderedTrendTableSignature: () => renderedTrendTableSignature,
  setRenderedTrendTableSignature: (value) => { renderedTrendTableSignature = value; },
});
const {
  renderOperatingContextCards,
  updateOperatingContextCardSelection,
  selectCompanionSeriesForOperatingContext,
  operatingContextWindows,
  selectedOperatingContextReviewCardHtml,
} = createOperatingContextController({
  escapeHtml: (...args) => escapeHtml(...args),
  formatCompactElapsedTime: (...args) => formatCompactElapsedTime(...args),
  detectionWindow: (...args) => detectionWindow(...args),
  compactCylinderLabel: (...args) => compactCylinderLabel(...args),
  compactMissingHealthNote: (...args) => compactMissingHealthNote(...args),
  reviewMonitorEnabled: (key) => reviewMonitorEnabled(key, selectedFlight?.aircraft),
  availableSeriesKeys: (...args) => availableSeriesKeys(...args),
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  activeSeries,
  syncSeriesControls: (...args) => syncSeriesControls(...args),
  renderHealthSummary: (...args) => renderHealthSummary(...args),
  updateHealthCardSelection: (...args) => updateHealthCardSelection(...args),
  scheduleDrawAll: (...args) => scheduleDrawAll(...args),
  getHealthSummary: () => healthSummary,
  getSelectedOperatingContextKey: () => selectedOperatingContextKey,
  setSelectedOperatingContextKey: (value) => { selectedOperatingContextKey = value; },
  setSelectedOperatingContextWindows: (value) => { selectedOperatingContextWindows = value; },
  setSelectedHealthKey: (value) => {
    overviewSelectionCleared = false;
    selectedHealthKey = value;
  },
  setOverviewSelectionCleared: (value) => { overviewSelectionCleared = !!value; },
  setSelectedDetectionWindowCache: (value) => { selectedDetectionWindowCache = value; },
  getDivergenceTrendRows: () => relatedTrendRowsForSelectedAircraft(),
  getSelectedFlightId: () => selectedFlight?.id,
  reviewNoteSectionHtml: (...args) => reviewNoteSectionHtml(...args),
});
// The deleted-flight retention disclosure gate (issue #405) lives with the
// permanent-delete confirmation on the account Archive tab (auth-ui);
// workspace flows only archive and never show it.
const {
  archiveFlightLogSource,
  removeFlightEntryFromList,
  removeSelectedFlightFromList,
  uploadAircraftMetadataParams,
  uploadUrlForFile,
  oversizedUploadFile,
  waitForDatabaseUploadIngest,
  uploadSelectedFiles,
} = createUploadFlightPipeline({
  appReadOnlyMode: (...args) => appReadOnlyMode(...args),
  readOnlyActionMessage: (...args) => readOnlyActionMessage(...args),
  syncReadOnlyUi: (...args) => syncReadOnlyUi(...args),
  databaseFlightArchiveEndpoint: (...args) => databaseFlightArchiveEndpoint(...args),
  databaseUploadEndpoint,
  databaseIngestJobEndpoint: (...args) => databaseIngestJobEndpoint(...args),
  flightDisplayTitle: (...args) => flightDisplayTitle(...args),
  flightSourcePathDisplay: (...args) => flightSourcePathDisplay(...args),
  confirmFlightDeleteDialog: (...args) => confirmFlightDeleteDialog(...args),
  revokeCachedFlightReport: (...args) => revokeCachedFlightReport(...args),
  hideFlightEntry: (...args) => hideFlightEntry(...args),
  saveHiddenFlightIds: (...args) => saveHiddenFlightIds(...args),
  saveTrendExcludedFlightIds: (...args) => saveTrendExcludedFlightIds(...args),
  saveTrendIncludedFlightIds: (...args) => saveTrendIncludedFlightIds(...args),
  refreshFlightManifestState: (...args) => refreshFlightManifestState(...args),
  invalidateAircraftFlightFlagSummaries: (...args) => invalidateAircraftFlightFlagSummaries(...args),
  clearStoredTrendRowsForAircraft: (...args) => clearStoredTrendRowsForAircraft(...args),
  visibleFlightEntries: (...args) => visibleFlightEntries(...args),
  isSupportedFlight: (...args) => isSupportedFlight(...args),
  flightMatchesSourcePath: (...args) => flightMatchesSourcePath(...args),
  setupFlightLogSelector: (...args) => setupFlightLogSelector(...args),
  renderAircraftWorkspace: (...args) => renderAircraftWorkspace(...args),
  populateTrendAircraftSelect: (...args) => populateTrendAircraftSelect(...args),
  loadFlightLog: (...args) => loadFlightLog(...args),
  clearLoadedFlight: (...args) => clearLoadedFlight(...args),
  updateFlightHeader: (...args) => updateFlightHeader(...args),
  uploadAircraftMetadataSearchParams: (...args) => uploadAircraftMetadataSearchParams(...args),
  uploadAircraftTargetValue: (...args) => uploadAircraftTargetValue(...args),
  selectedMonitorFromSelects: (...args) => selectedMonitorFromSelects(...args),
  limitedAircraftModel: (...args) => limitedAircraftModel(...args),
  waitForUploadIngestJob: (...args) => waitForUploadIngestJob(...args),
  uploadIngestStatusLabel: (...args) => uploadIngestStatusLabel(...args),
  setUploadDialogStatus: (...args) => setUploadDialogStatus(...args),
  setUploadDialogError: (...args) => setUploadDialogError(...args),
  showUploadProgressNotice: (...args) => showUploadProgressNotice(...args),
  uploadFileDisplayName: (...args) => uploadFileDisplayName(...args),
  uploadFilesNewestFlightFirst: (...args) => uploadFilesNewestFlightFirst(...args),
  // Upload order depends on whether the account's plan withholds flights, so
  // the pipeline asks the plan endpoint at submit time.
  async accountWithholdsFlights() {
    try {
      const response = await fetch("/api/account/plan", { cache: "no-store" });
      if (!response.ok) return false;
      return accountWithholdsFlights(await response.json());
    } catch {
      return false;
    }
  },
  // Plan admission control: how much room the plan has left for the upload
  // target. The server computes it (same math as its POST /api/uploads gate)
  // so the client picker and the backstop can never disagree.
  async fetchUploadCapacity() {
    return fetchUploadCapacityForAircraft(uploadAircraftTargetDatabaseId());
  },
  chooseUploadFilesWithinCapacity: (...args) => chooseUploadFilesWithinCapacity(...args),
  uploadAtFlightLimitMessage: (...args) => uploadAtFlightLimitMessage(...args),
  selectedUploadFiles: (...args) => selectedUploadFiles(...args),
  uploadBatchSummary: (...args) => uploadBatchSummary(...args),
  uploadDuplicateSummary: (...args) => uploadDuplicateSummary(...args),
  shortFlightsSkippedSummary: (...args) => shortFlightsSkippedSummary(...args),
  noEngineDataRefusedSummary: (...args) => noEngineDataRefusedSummary(...args),
  closeUploadDialog: (...args) => closeUploadDialog(...args),
  setAircraftPanel: (...args) => setAircraftPanel(...args),
  openAircraftUploadsPanel: (aircraft) => openUploadWorkPanel(aircraft),
  updateDataSourceLabel: (...args) => updateDataSourceLabel(...args),
  loadAircraftUploadHistory: (...args) => loadAircraftUploadHistory(...args),
  aircraftUploadHistoryCache,
  aircraftUploadHistoryErrors,
  hiddenFlightIds,
  trendExcludedFlightIds,
  trendIncludedFlightIds,
  getFlightManifest: () => flightManifest,
  setFlightManifest: (value) => { flightManifest = value; },
  getSelectedFlight: () => selectedFlight,
  getTrendCache: () => trendCache,
  setTrendCache: (value) => { trendCache = value; },
  getUploadDialogPostSuccessPanel: () => uploadDialogPostSuccessPanel,
  setUploadDialogPostSuccessPanel: (value) => { uploadDialogPostSuccessPanel = value; },
});
const {
  aircraftFlights,
  aircraftFlightsFromMap,
  compareNullableValues,
  compareAircraftFlightFallback,
  sortedAircraftFlightsForPanel,
  setAircraftFlightsSort,
  updateAircraftFlightSortHeaders,
  aircraftFlightSearchText,
  aircraftFlightFlagClass,
  aircraftFlightDateRangeStart,
  aircraftFlightMatchesFilters,
  aircraftFlightsActiveFilterCount,
  updateAircraftFlightsFilterControls,
  setAircraftFlightsFilter,
  renderAircraftFlightsPanelSummary,
} = createAircraftFlightsPanelData({
  escapeHtml: (...args) => escapeHtml(...args),
  trendDateValue: (...args) => trendDateValue(...args),
  flightDisplayTitle: (...args) => flightDisplayTitle(...args),
  flightDateLabel: (...args) => flightDateLabel(...args),
  selectedAircraftWorkspace: (...args) => selectedAircraftWorkspace(...args),
  visibleFlightEntriesByAircraft: (...args) => visibleFlightEntriesByAircraft(...args),
  aircraftTrendRowsForActivity: (...args) => aircraftTrendRowsForActivity(...args),
  aircraftFlightDurationSecondsFromTrendRows: (...args) => aircraftFlightDurationSecondsFromTrendRows(...args),
  renderAircraftFlightsPanel: (...args) => renderAircraftFlightsPanel(...args),
  flightIncludedInTrendAnalysis: (...args) => flightIncludedInTrendAnalysis(...args),
  flightAutoExcludedFromTrendAnalysis: (...args) => flightAutoExcludedFromTrendAnalysis(...args),
  flightReportAvailable: (...args) => flightReportAvailable(...args),
  flightFlagSummary: (...args) => flightFlagSummary(...args),
  aircraftFlightDateRangeLabel: (...args) => aircraftFlightDateRangeLabel(...args),
  getAircraftFlightsSort: () => aircraftFlightsSort,
  setAircraftFlightsSort: (value) => { aircraftFlightsSort = value; },
  getAircraftFlightsFilters: () => aircraftFlightsFilters,
  setAircraftFlightsFilters: (value) => { aircraftFlightsFilters = value; },
});

// Per-aircraft monitor capability for the review-settings dialog when no flight
// is loaded for that aircraft (the common case opening settings from the fleet).
// Channel availability is a property of the engine monitor and constant across
// an aircraft's logs, so the latest analyzed run's persisted score_summary is a
// reliable witness. Returns a metric-keyed summary the capability classifier can
// read, or null (non-database mode, no analyzed flight, or fetch failure -> the
// dialog then falls back to the loaded summary / profile and defaults available).
async function fetchAircraftMonitorCapabilitySummary(aircraft) {
  const entries = aircraftFlights(aircraft);
  const latest = latestFlightFromAircraftFlights(entries) ?? entries[entries.length - 1] ?? null;
  const flightId = latest?.database?.flightId ?? latest?.id ?? null;
  if (!flightId) return null;
  try {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 2500);
    const response = await fetch(`/api/flights/${encodeURIComponent(flightId)}/analysis-run`, { cache: "no-store", signal: controller.signal });
    clearTimeout(timer);
    if (!response.ok) return null;
    const payload = await response.json();
    const metrics = payload?.analysisRun?.score_summary?.metrics;
    if (!Array.isArray(metrics) || !metrics.length) return null;
    return Object.fromEntries(metrics.filter((metric) => metric?.key).map((metric) => [metric.key, metric]));
  } catch {
    return null;
  }
}

const {
  reviewSettingsProfileForAircraft,
  groupedReviewMonitorDefinitions,
  reviewMonitorDefinitions,
  reviewMonitorCountText,
  reviewMonitorGroupKey,
  reviewMonitorInputsIn,
  reviewMonitorActiveText,
  updateReviewSettingsGroupCounts,
  updateReviewSettingsDialogCount,
  updateReviewSettingsSummaryProfile,
  applyReviewSettingsGroupAction,
  setAircraftReviewSettingsStatus,
  resetAircraftReviewSettingsSaveState,
  renderAircraftReviewSettingsDialog,
  openAircraftReviewSettingsDialog,
  closeAircraftReviewSettingsDialog,
  resetReviewPreferenceCaches,
  saveAircraftReviewSettingsFromDialog,
  resetAircraftReviewSettingsInDialog,
} = createAircraftReviewSettingsDialog({
  escapeHtml: (...args) => escapeHtml(...args),
  appReadOnlyMode: (...args) => appReadOnlyMode(...args),
  readOnlyActionMessage: (...args) => readOnlyActionMessage(...args),
  readOnlyPreviewMessage: (...args) => readOnlyPreviewMessage(...args),
  syncReadOnlyUi: (...args) => syncReadOnlyUi(...args),
  aircraftDisplayLabel: (...args) => aircraftDisplayLabel(...args),
  aircraftProfileForEntry: (...args) => aircraftProfileForEntry(...args),
  aircraftProfileSupportsMultiEngineReview: (...args) => aircraftProfileSupportsMultiEngineReview(...args),
  groupedReviewMonitorDefinitionsForProfile: (...args) => groupedReviewMonitorDefinitionsForProfile(...args),
  reviewMonitorDefinitionsForProfile: (...args) => reviewMonitorDefinitionsForProfile(...args),
  reviewMonitorCountTextForAircraft: (...args) => reviewMonitorCountTextForAircraft(...args),
  coolingRateTriggerSettingForAircraft: (...args) => coolingRateTriggerSettingForAircraft(...args),
  normalizeCoolingRateTriggerSetting: (...args) => normalizeCoolingRateTriggerSetting(...args),
  coolingRateTriggerSettingBounds: (...args) => coolingRateTriggerSettingBounds(...args),
  aircraftMonitorCapability: (...args) => aircraftMonitorCapability(...args),
  disabledReviewMonitorKeys: (...args) => disabledReviewMonitorKeys(...args),
  updateAircraftReviewMonitorSettings: (...args) => updateAircraftReviewMonitorSettings(...args),
  saveAircraftReviewSettings: (...args) => saveAircraftReviewSettings(...args),
  selectedAircraftWorkspace: (...args) => selectedAircraftWorkspace(...args),
  aircraftFlights: (...args) => aircraftFlights(...args),
  flightFlagSummaryCache,
  aircraftFlightFlagSummaryIndexPromises,
  clearPersistedAircraftFlightFlagSummaries,
  rawAnalysisCache,
  clearTrendRowsForAircraft: (...args) => clearTrendRowsForAircraft(...args),
  reapplyDashboardAnalysis: (...args) => reapplyDashboardAnalysisForReviewSettings(...args),
  renderAircraftWorkspace: (...args) => renderAircraftWorkspace(...args),
  getAircraftProfiles: () => aircraftProfiles,
  getAircraftReviewSettings: () => aircraftReviewSettings,
  setAircraftReviewSettings: (value) => { aircraftReviewSettings = value; },
  getAircraftReviewSettingsCloseTimer: () => aircraftReviewSettingsCloseTimer,
  setAircraftReviewSettingsCloseTimer: (value) => { aircraftReviewSettingsCloseTimer = value; },
  setSelectedDetectionWindowCache: (value) => { selectedDetectionWindowCache = value; },
  setPlaybackDetectionWindowCache: (value) => { playbackDetectionWindowCache = value; },
  setScopedHealthSummaryCache: (value) => { scopedHealthSummaryCache = value; },
  setRawScopedAnalysisCache: (value) => { rawScopedAnalysisCache = value; },
  getSelectedFlight: () => selectedFlight,
  getFlightData: () => flightData,
  getHealthSummary: () => healthSummary,
  fetchAircraftMonitorCapabilitySummary: (...args) => fetchAircraftMonitorCapabilitySummary(...args),
  onCloseAircraftReviewSettingsDialog: () => restoreAccountAfterAircraftDialog(),
});
const maintenanceContext = createMaintenanceContext({
  enabled: () => appConfig?.maintenanceEnabled === true && !isPublicShareMode(),
  aircraftId: (aircraft) => aircraftProfiles?.[aircraft]?.databaseId ?? null,
  openMaintenance: (aircraft) => openFleetSidebarPanel(aircraft, "maintenance"),
  onRender: () => scheduleOverviewReviewPanelHeight(),
});
const { renderAircraftMaintenancePanel, confirmMaintenanceAircraftChange } = createAircraftMaintenancePanel({
  escapeHtml: (...args) => escapeHtml(...args),
  appReadOnlyMode: (...args) => appReadOnlyMode(...args),
  maintenanceFeatureEnabled: () => appConfig?.maintenanceEnabled === true,
  getAircraftProfiles: () => aircraftProfiles,
  aircraftDisplayLabel: (...args) => aircraftDisplayLabel(...args),
  aircraftMakeModelLabel: (...args) => aircraftMakeModelLabel(...args),
  onMaintenanceChanged: (aircraftId) => maintenanceContext.refresh(aircraftId),
});
const {
  renderAircraftWorkspace,
  fleetRowsFromDom,
  clearAircraftFleetDragState,
  aircraftRowDropPlacement,
  persistAircraftFleetOrderFromDom,
  reorderAircraftFleetRow,
  aircraftFlightAiSummaryIconMarkup,
  aircraftFlightPdfIconMarkup,
  renderAircraftFlightsPanel,
  renderAircraftUploadsPanel,
} = createAircraftWorkspaceRenderer({
  escapeHtml: (...args) => escapeHtml(...args),
  onWorkspaceRendered: () => renderFleetSidebar(),
  // Aircraft-page durations use the unit-bearing label so "25:25" can't be
  // misread as hours; the shared clock format stays in PDF/report layouts.
  formatCompactElapsedTime: (...args) => formatCompactDurationLabel(...args),
  isSupportedFlight,
  flightDisplayTitle: (...args) => flightDisplayTitle(...args),
  flightDateLabel: (...args) => flightDateLabel(...args),
  appReadOnlyMode: (...args) => appReadOnlyMode(...args),
  readOnlyActionMessage: (...args) => readOnlyActionMessage(...args),
  flightsReanalyzeAllStatus: () => reanalyzeAllFlightsStatus(),
  flightsUpdateSelectedBusy: () => aircraftFlightUpdateSelectedBusy,
  aircraftDisplayLabel: (...args) => aircraftDisplayLabel(...args),
  aircraftMakeModelLabel: (...args) => aircraftMakeModelLabel(...args),
  aircraftTypeLabel: (...args) => aircraftTypeLabel(...args),
  aircraftPhotoSource: (...args) => aircraftPhotoSource(...args),
  aircraftPhotoDisplaySrc: (...args) => aircraftPhotoDisplaySrc(...args),
  aircraftPhotoFallbackLabel: (...args) => aircraftPhotoFallbackLabel(...args),
  applyAircraftDefaultArt: (...args) => applyAircraftDefaultArt(...args),
  defaultArtRestUrl: (...args) => defaultArtRestUrl(...args),
  aircraftProfileHealthLabel: (...args) => aircraftProfileHealthLabel(...args),
  aircraftProfileForEntry: (...args) => aircraftProfileForEntry(...args),
  aircraftFleetRowDetail: (...args) => aircraftFleetRowDetail(...args),
  aircraftRecentFlightCount: (...args) => aircraftRecentFlightCount(...args),
  aircraftActivityCardsForPanel: (...args) => aircraftActivityCardsForPanel(...args),
  allAircraftOptionsFromFlightMap: (...args) => allAircraftOptionsFromFlightMap(...args),
  engineLabel: (...args) => engineLabel(...args),
  propellerTypeLabel: (...args) => propellerTypeLabel(...args),
  propellerLabel: (...args) => propellerLabel(...args),
  monitorLabel: (...args) => monitorLabel(...args),
  selectedAircraftWorkspace: (...args) => selectedAircraftWorkspace(...args),
  visibleFlightEntriesByAircraft: (...args) => visibleFlightEntriesByAircraft(...args),
  aircraftFlights: (...args) => aircraftFlights(...args),
  aircraftFlightsFromMap: (...args) => aircraftFlightsFromMap(...args),
  latestFlightFromAircraftFlights: (...args) => latestFlightFromAircraftFlights(...args),
  cachedAircraftAverageFlightDurationSeconds: (...args) => cachedAircraftAverageFlightDurationSeconds(...args),
  reviewMonitorCountText: (...args) => reviewMonitorCountText(...args),
  setAircraftPhotoPresentation: (...args) => setAircraftPhotoPresentation(...args),
  updateAircraftPhotoControls: (...args) => updateAircraftPhotoControls(...args),
  resetAircraftForm: (...args) => resetAircraftForm(...args),
  updateAircraftSidebarCard: (...args) => updateAircraftSidebarCard(...args),
  databaseAircraftSummaryFlightCount: (...args) => databaseAircraftSummaryFlightCount(...args),
  setAircraftFormStatus: (...args) => setAircraftFormStatus(...args),
  renderAircraftMaintenancePanel: (...args) => renderAircraftMaintenancePanel(...args),
  aircraftFlightsFilters: () => aircraftFlightsFilters,
  aircraftFlightDateRangeStart: (...args) => aircraftFlightDateRangeStart(...args),
  sortedAircraftFlightsForPanel: (...args) => sortedAircraftFlightsForPanel(...args),
  aircraftFlightDurationSecondsFromTrendRows: (...args) => aircraftFlightDurationSecondsFromTrendRows(...args),
  aircraftTrendRowsForActivity: (...args) => aircraftTrendRowsForActivity(...args),
  flightFlagSummary: (...args) => flightFlagSummary(...args),
  aircraftFlightMatchesFilters: (...args) => aircraftFlightMatchesFilters(...args),
  updateAircraftFlightSortHeaders: (...args) => updateAircraftFlightSortHeaders(...args),
  updateAircraftFlightsFilterControls: (...args) => updateAircraftFlightsFilterControls(...args),
  renderAircraftFlightsPanelSummary: (...args) => renderAircraftFlightsPanelSummary(...args),
  flightReportAvailable: (...args) => flightReportAvailable(...args),
  flightReportStale: (...args) => flightReportStale(...args),
  flightAiSummaryAvailable: (...args) => flightAiSummaryAvailable(...args),
  flightAiSummaryStale: (...args) => flightAiSummaryStale(...args),
  aiSummaryAvailableForEntry: (...args) => aiSummaryAvailableForEntry(...args),
  flightAiSummaryUnviewed: (entry) => aiSummaryIsNew(entry?.id, entry?.database?.aiSummaryId, entry?.database?.aiSummaryGeneratedAt),
  flightAutoExcludedFromTrendAnalysis: (...args) => flightAutoExcludedFromTrendAnalysis(...args),
  flightIncludedInTrendAnalysis: (...args) => flightIncludedInTrendAnalysis(...args),
  flightTooShortForTrendAnalysis: (...args) => flightTooShortForTrendAnalysis(...args),
  flightConsumedByTrends: (...args) => flightConsumedByTrends(...args),
  trendCappedFlightSummary: (...args) => trendCappedFlightSummary(...args),
  trendFlightCap: TREND_FLIGHT_CAP,
  trendHoursCapSeconds: TREND_HOURS_CAP_SECONDS,
  flightFlagSummaryMarkup: (...args) => flightFlagSummaryMarkup(...args),
  hydrateAircraftFlightFlagSummaries: (...args) => hydrateAircraftFlightFlagSummaries(...args),
  hydrateAircraftFlightReportMetadata: (...args) => hydrateAircraftFlightReportMetadata(...args),
  aircraftFlightBulkDeleteSelected,
  aircraftFlightDeletePending,
  uploadStatusClass: (...args) => uploadStatusClass(...args),
  uploadStatusLabel: (...args) => uploadStatusLabel(...args),
  formatUploadByteSize: (...args) => formatUploadByteSize(...args),
  uploadDisplayStatus: (...args) => uploadDisplayStatus(...args),
  uploadDisplayError: (...args) => uploadDisplayError(...args),
  uploadCanReprocess: (...args) => uploadCanReprocess(...args),
  uploadHasActiveJob: (...args) => uploadHasActiveJob(...args),
  uploadReprocessActionLabel: (...args) => uploadReprocessActionLabel(...args),
  uploadIsEmpty: (...args) => uploadIsEmpty(...args),
  uploadFlightSummary: (...args) => uploadFlightSummary(...args),
  uploadFlightSummaryDetailClass: (...args) => uploadFlightSummaryDetailClass(...args),
  uploadJobProgressLabel: (...args) => uploadJobProgressLabel(...args),
  uploadDateLabel: (...args) => uploadDateLabel(...args),
  shortUploadHash: (...args) => shortUploadHash(...args),
  loadAircraftUploadHistory: (...args) => loadAircraftUploadHistory(...args),
  aircraftUploadHistoryCache,
  aircraftUploadHistoryPending,
  aircraftUploadHistoryErrors,
  aircraftUploadReprocessPending,
  aircraftUploadReprocessActive,
  aircraftUploadProcessShortPending,
  aircraftUploadDeletePending,
  aircraftUploadBulkDeleteSelected,
  // The aircraft's last ingest job just settled: pull its new flights into the
  // manifest and repaint, so the Flights list updates on its own rather than
  // needing a page refresh.
  onUploadIngestSettled: async (aircraft) => {
    await refreshFlightManifestState(selectedFlight?.id ?? "");
    const aircraftId = databaseAircraftIdForLabel(aircraft);
    if (aircraftId) {
      invalidateAircraftFlightFlagSummaries(
        aircraftId,
        flightManifest.filter((entry) => entry?.database?.aircraftId === aircraftId),
      );
    }
    setupFlightLogSelector();
    renderAircraftWorkspace();
    renderFleetSidebar();
    populateTrendAircraftSelect(selectedFlight?.aircraft ?? aircraft);
  },
  databaseAircraftEndpoint,
  databaseAircraftProfilesMap: (...args) => databaseAircraftProfilesMap(...args),
  aircraftProfilesLocalStorageKey,
  getAircraftProfiles: () => aircraftProfiles,
  setAircraftProfiles: (value) => { aircraftProfiles = value; },
  getLocalAircraftProfiles: () => localAircraftProfiles,
  setLocalAircraftProfiles: (value) => { localAircraftProfiles = value; },
  setDatabaseAircraftRecords: (value) => { databaseAircraftRecords = value; },
  getDatabaseAircraftRecords: () => databaseAircraftRecords,
  getAircraftFlightManifestReady: () => aircraftFlightManifestReady,
  getSelectedAircraftPanel: () => selectedAircraftPanel,
  getAircraftReorderInFlight: () => aircraftReorderInFlight,
  setAircraftReorderInFlight: (value) => { aircraftReorderInFlight = value; },
});
const {
  renderFleetSidebar,
  wireFleetSidebar,
} = createFleetSidebar({
  escapeHtml: (...args) => escapeHtml(...args),
  // "Date added" ordering reads the raw aircraft row, NOT the profile: the
  // profile is a curated shape (make/model, engine layout, propellers) that
  // never carried created_at, so every aircraft resolved to null and the sort
  // silently fell through to its tail-number tiebreak — which is exactly what
  // "date added" looked like on screen.
  aircraftCreatedAt: (aircraft) => {
    const record = databaseAircraftRecords.find((row) => databaseAircraftLabel(row) === aircraft);
    return record?.created_at ?? record?.createdAt ?? null;
  },
  newUiFeatureEnabled: () => newUiFeatureEnabled(),
  aircraftFlightManifestReady: () => aircraftFlightManifestReady,
  ensureAircraftFlightManifestLoaded: (...args) => ensureAircraftFlightManifestLoaded(...args),
  allAircraftOptions: (...args) => allAircraftOptions(...args),
  aircraftWorkspacePlanLocked: (...args) => aircraftWorkspacePlanLocked(...args),
  selectedAircraftWorkspace: (...args) => selectedAircraftWorkspace(...args),
  getSelectedFlight: () => selectedFlight,
  getSelectedAircraftPanel: () => selectedAircraftPanel,
  aircraftFlights: (...args) => aircraftFlights(...args),
  latestFirstComparator: (...args) => compareAircraftFlightFallback(...args),
  isSupportedFlight,
  flightDisplayTitle: (...args) => flightDisplayTitle(...args),
  flightDateLabel: (entry) => flightDateLabel(null, entry),
  aircraftDisplayLabel: (...args) => aircraftDisplayLabel(...args),
  getAircraftProfiles: () => aircraftProfiles,
  aircraftMakeModelLabel: (...args) => aircraftMakeModelLabel(...args),
  // Photo endpoints need the bearer header a bare <img src> cannot send;
  // aircraftPhotoDisplaySrc serves an authed blob URL (and re-renders when
  // the fetch lands), so the rail never shows a broken-image icon.
  aircraftPhotoSource: (profile) => aircraftPhotoDisplaySrc(aircraftPhotoSource(profile)),
  defaultArtRestUrl: (...args) => defaultArtRestUrl(...args),
  defaultArtHoverUrl: (...args) => defaultArtHoverUrl(...args),
  aircraftPhotoFallbackLabel: (...args) => aircraftPhotoFallbackLabel(...args),
  openFleetSidebarFlight: (...args) => openFleetSidebarFlight(...args),
  openFleetSidebarAircraft: (...args) => openFleetSidebarAircraft(...args),
  openFleetSidebarPanel: (...args) => openFleetSidebarPanel(...args),
  showAppToast: (...args) => showAppToast(...args),
});
const {
  cylinderSummaryRows,
  updateCylinderSummaryLayout,
  scheduleCylinderSummaryLayout,
  clearOverviewReviewPanelHeight,
  updateOverviewReviewPanelHeight,
  scheduleOverviewReviewPanelHeight,
  setupOverviewReviewPanelHeightSync,
  currentEngineDescriptors,
  activateEngineScopeCard,
  bindEngineScopeCards,
  renderMultiEngineOverview,
  renderCylinderScopeSummary,
  setDetectionSensitivity,
  renderSensitivityControl,
} = createEngineScopeRenderer({
  escapeHtml: (...args) => escapeHtml(...args),
  scoreClass: (...args) => scoreClass(...args),
  sensitivityModes,
  engineDescriptorsForData: (...args) => engineDescriptorsForData(...args),
  aircraftProfileForEntry: (...args) => aircraftProfileForEntry(...args),
  normalizeSensitivity: (...args) => normalizeSensitivity(...args),
  engineSnapshotCard: (...args) => engineSnapshotCard(...args),
  aircraftSnapshotCard: (...args) => aircraftSnapshotCard(...args),
  engineDeltaOverviewCard: (...args) => engineDeltaOverviewCard(...args),
  normalizeSelectedEngineScope: (...args) => normalizeSelectedEngineScope(...args),
  engineInfoForCylinderNumber: (...args) => engineInfoForCylinderNumber(...args),
  cylinderMetricSummary: (...args) => cylinderMetricSummary(...args),
  cylinderScoreMarkup: (...args) => cylinderScoreMarkup(...args),
  setEngineScope: (...args) => setEngineScope(...args),
  clearCylinderFocus: (...args) => clearCylinderFocus(...args),
  selectCompanionSeriesForHealthCard: (...args) => selectCompanionSeriesForHealthCard(...args),
  renderHealthSummary: (...args) => renderHealthSummary(...args),
  scheduleDrawAll: (...args) => scheduleDrawAll(...args),
  reviewMonitorEnabled: (...args) => reviewMonitorEnabled(...args),
  saveDetectionSensitivity: (...args) => saveDetectionSensitivity(...args),
  updateHealthSummary: (...args) => updateHealthSummary(...args),
  renderTrendsForSelection: (...args) => renderTrendsForSelection(...args),
  getCylinderSummaryLayoutScheduled: () => cylinderSummaryLayoutScheduled,
  setCylinderSummaryLayoutScheduled: (value) => { cylinderSummaryLayoutScheduled = value; },
  getOverviewReviewPanelHeightScheduled: () => overviewReviewPanelHeightScheduled,
  setOverviewReviewPanelHeightScheduled: (value) => { overviewReviewPanelHeightScheduled = value; },
  getOverviewReviewPanelResizeObserver: () => overviewReviewPanelResizeObserver,
  setOverviewReviewPanelResizeObserver: (value) => { overviewReviewPanelResizeObserver = value; },
  getSelectedCylinderNumber: () => selectedCylinderNumber,
  getSelectedHealthKey: () => selectedHealthKey,
  setSelectedHealthKey: (value) => {
    overviewSelectionCleared = false;
    selectedHealthKey = value;
  },
  setOverviewSelectionCleared: (value) => { overviewSelectionCleared = !!value; },
  getSelectedFlight: () => selectedFlight,
  getFlightData: () => flightData,
  getHealthSummary: () => healthSummary,
  getDetectionSensitivity: () => detectionSensitivity,
  setDetectionSensitivity: (value) => { detectionSensitivity = value; },
  getCurrentParserMetadata: () => currentParserMetadata,
  setExplorerSelectedAlertId: (value) => { explorerSelectedAlertId = value; },
});
const {
  cylinderDetailHtml,
  renderCylinderDetailSection,
} = createCylinderDetailRenderer({
  escapeHtml: (...args) => escapeHtml(...args),
  scoreClass: (...args) => scoreClass(...args),
  cylinderScoreMarkup: (...args) => cylinderScoreMarkup(...args),
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  engineInfoForCylinderNumber: (...args) => engineInfoForCylinderNumber(...args),
  engineScopedProbeLabel: (...args) => engineScopedProbeLabel(...args),
  enginePeerKeysForCylinderNumber: (...args) => enginePeerKeysForCylinderNumber(...args),
  cylinderMetricSummary: (...args) => cylinderMetricSummary(...args),
  cylinderSensorSummary: (...args) => cylinderSensorSummary(...args),
  cylinderProbeNote: (...args) => cylinderProbeNote(...args),
  engineWorkPoint: (...args) => engineWorkPoint(...args),
  engineScopeCylinderNumbers: (...args) => engineScopeCylinderNumbers(...args),
  engineScopeVisibleEngines: (...args) => engineScopeVisibleEngines(...args),
  engineSourceNumbers: (...args) => engineSourceNumbers(...args),
  visibleDivergenceCylinders: (...args) => visibleDivergenceCylinders(...args),
  cylinderAverageForKeys: (...args) => cylinderAverageForKeys(...args),
  cylinderSpreadAverageForKeys: (...args) => cylinderSpreadAverageForKeys(...args),
  healthSummaryForCurrentEngineScope: (...args) => healthSummaryForCurrentEngineScope(...args),
  setCylinderFocus: (...args) => setCylinderFocus(...args),
  clearCylinderFocus: (...args) => clearCylinderFocus(...args),
  finiteValues: (...args) => finiteValues(...args),
  peerAverage: (...args) => peerAverage(...args),
  panelNumber: (...args) => panelNumber(...args),
  signedPanelNumber: (...args) => signedPanelNumber(...args),
  quantile: (...args) => quantile(...args),
  extentFromValues: (...args) => extentFromValues(...args),
  getFlightData: () => flightData,
  getSelectedCylinderNumber: () => selectedCylinderNumber,
  setSelectedCylinderNumber: (value) => { selectedCylinderNumber = value; },
});
const {
  explorerFindingChip,
  explorerMarkerButton,
  explorerConditionBandButton,
  buildExplorerTimelineMarkers,
  drawExplorerTimelineCanvas,
  renderExplorerTimeline,
  updateExplorerTimelineCursor,
  renderExplorerContext,
  drawFlightChart,
  drawExplorerChart,
  drawChartLanes,
  updateExplorerChannelReadout,
  setExplorerReadoutHover,
  drawCompareChart,
  drawCylinderCompareChart,
} = createChartRenderers({
  escapeHtml: (...args) => escapeHtml(...args),
  clamp01: (...args) => clamp01(...args),
  colors,
  seriesMeta,
  flightChartPadding,
  explorerChartPadding,
  flightChartLayoutOptions,
  explorerChartLayoutOptions,
  explorerIsNormalFinding: (...args) => explorerIsNormalFinding(...args),
  findingCylinderReference: (...args) => findingCylinderReference(...args),
  explorerEgtAnnunciationLabel: (...args) => explorerEgtAnnunciationLabel(...args),
  compactHealthNote: (...args) => compactHealthNote(...args),
  explorerAlertTone: (...args) => explorerAlertTone(...args),
  explorerTimelineWindowGeometry: (...args) => explorerTimelineWindowGeometry(...args),
  explorerConditionTimelineLayout: (...args) => explorerConditionTimelineLayout(...args),
  explorerTimelineTicks: (...args) => explorerTimelineTicks(...args),
  explorerTimelineControlIcon: (...args) => explorerTimelineControlIcon(...args),
  playbackDetectionWindows: (...args) => playbackDetectionWindows(...args),
  visibleScrubRatio: (...args) => visibleScrubRatio(...args),
  formatElapsedTime: (...args) => formatElapsedTime(...args),
  nearestPoint: (...args) => nearestPoint(...args),
  explorerPhaseFilteredData: (...args) => explorerPhaseFilteredData(...args),
  phaseFilteredData: (...args) => phaseFilteredData(...args),
  renderExplorerAnnunciations: (...args) => renderExplorerAnnunciations(...args),
  phaseSegments: (...args) => phaseSegments(...args),
  phaseRailColor: (...args) => phaseRailColor(...args),
  phaseLabelOptions: (...args) => phaseLabelOptions(...args),
  syncFlightChartCanvasHeight: (...args) => syncFlightChartCanvasHeight(...args),
  hasSplitChartLanes: (...args) => hasSplitChartLanes(...args),
  syncCanvasDisplaySize: (...args) => syncCanvasDisplaySize(...args),
  syncExplorerChartHeightState: (...args) => syncExplorerChartHeightState(...args),
  plotLayout: (...args) => plotLayout(...args),
  splitSeriesKeys: (...args) => splitSeriesKeys(...args),
  drawDetectionWindowLabel: (...args) => drawDetectionWindowLabel(...args),
  selectedDetectionWindows: (...args) => selectedDetectionWindows(...args),
  specialTestDetectionWindows: () => explorerSpecialTestDetectionWindows(),
  drawPhaseLabels: (...args) => drawPhaseLabels(...args),
  updateScrubReadout: (...args) => updateScrubReadout(...args),
  updateChartOverlays: (...args) => updateChartOverlays(...args),
  cachedInteractionBounds: (...args) => cachedInteractionBounds(...args),
  thermalAxisTypesForKeys: (...args) => thermalAxisTypesForKeys(...args),
  thermalAxisRangeForType: (...args) => thermalAxisRangeForType(...args),
  thermalAxisTypeForKey: (...args) => thermalAxisTypeForKey(...args),
  getExplorerFitYAxis: () => explorerFitYAxis,
  explorerFitThermalRange: (...args) => explorerFitThermalRange(...args),
  auxScaleConfig: (...args) => auxScaleConfig(...args),
  chartLaneRenderPlan: (...args) => chartLaneRenderPlan(...args),
  drawGrid: (...args) => drawGrid(...args),
  drawLine: (...args) => drawLine(...args),
  drawLaneLabel: (...args) => drawLaneLabel(...args),
  drawSelectedDetectionWindow: (...args) => drawSelectedDetectionWindow(...args),
  compareChartPlan: (...args) => compareChartPlan(...args),
  chartBounds: (...args) => chartBounds(...args),
  formatPointTime: (...args) => formatPointTime(...args),
  drawInlineLegend: (...args) => drawInlineLegend(...args),
  drawMarker: (...args) => drawMarker(...args),
  cylinderCompareChartPlan: (...args) => cylinderCompareChartPlan(...args),
  getHealthSummary: () => healthSummary,
  getFlightData: () => flightData,
  getReferenceData: () => referenceData,
  getExplorerTimelineMarkerCache: () => explorerTimelineMarkerCache,
  setExplorerTimelineMarkerCache: (value) => { explorerTimelineMarkerCache = value; },
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  engineScopedChannelLabel: (...args) => engineScopedChannelLabel(...args),
});
const {
  elapsedDiffs,
  parserWarningDisplay,
  parserMetadataQualityItems,
  engineLayoutOptionLabel,
  engineLayoutOptionConfig,
  engineLayoutQualityItem,
  dataQualityItems,
  dataQualitySummary,
  renderRawDataPanel,
} = createDataQualityRenderer({
  escapeHtml: (...args) => escapeHtml(...args),
  colors,
  seriesMeta,
  titleCase: (...args) => titleCase(...args),
  quantile: (...args) => quantile(...args),
  extentFromValues: (...args) => extentFromValues(...args),
  currentFlightDerivedCache: (...args) => currentFlightDerivedCache(...args),
  rawChannelKeys: (...args) => rawChannelKeys(...args),
  rawChannelStats: (...args) => rawChannelStats(...args),
  createRawMetricDescriptor: (...args) => createRawMetricDescriptor(...args),
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  aircraftProfileForEntry: (...args) => aircraftProfileForEntry(...args),
  engineLayoutAmbiguityForData: (...args) => engineLayoutAmbiguityForData(...args),
  formatElapsedTime: (...args) => formatElapsedTime(...args),
  flightDurationSeconds: (...args) => flightDurationSeconds(...args),
  sampleRateSummary: (...args) => sampleRateSummary(...args),
  formatPointTime: (...args) => formatPointTime(...args),
  formatRawNumber: (...args) => formatRawNumber(...args),
  scoringRole: (...args) => scoringRole(...args),
  getFlightData: () => flightData,
  getCurrentParserMetadata: () => currentParserMetadata,
  getSelectedFlight: () => selectedFlight,
  getSourceMonitor: () => sourceMonitor,
  getSourceRows: () => sourceRows,
  getSourceRawRows: () => sourceRawRows,
  getEndpointTrimInfo: () => endpointTrimInfo,
  appReadOnlyMode: (...args) => appReadOnlyMode(...args),
  readOnlyActionMessage: (...args) => readOnlyActionMessage(...args),
});
const { setupNavigation } = createNavigationSetup({
  syncExplorerHeightControls: (...args) => syncExplorerHeightControls(...args),
  syncExplorerFitYControls: (...args) => syncExplorerFitYControls(...args),
  saveExplorerFitYAxis: (...args) => saveExplorerFitYAxis(...args),
  getExplorerFitYAxis: () => explorerFitYAxis,
  setExplorerFitYAxis: (value) => { explorerFitYAxis = value; },
  syncChartRouteState: () => syncFlightReviewRoute(activeReportPanel()),
  appReadOnlyMode: (...args) => appReadOnlyMode(...args),
  setUploadDialogStatus: (...args) => setUploadDialogStatus(...args),
  setUploadDialogError: (...args) => setUploadDialogError(...args),
  readOnlyPreviewMessage: (...args) => readOnlyPreviewMessage(...args),
  readOnlyActionMessage: (...args) => readOnlyActionMessage(...args),
  showAppToast: (...args) => showAppToast(...args),
  syncReadOnlyUi: (...args) => syncReadOnlyUi(...args),
  openUploadDialog: (...args) => openUploadDialog(...args),
  closeUploadDialog: (...args) => closeUploadDialog(...args),
  fetchUploadCapacityForAircraft: (...args) => fetchUploadCapacityForAircraft(...args),
  databaseAircraftIdForLabel: (...args) => databaseAircraftIdForLabel(...args),
  selectedAircraftWorkspace: (...args) => selectedAircraftWorkspace(...args),
  removeSelectedFlightFromList: (...args) => removeSelectedFlightFromList(...args),
  downloadFlightReportPdf: (...args) => downloadFlightReportPdf(...args),
  hideAiWorkNotice: (...args) => hideAiWorkNotice(...args),
  aiSummaryWorkActionRef: (...args) => aiSummaryWorkActionRef(...args),
  hideUploadWorkNotice: (...args) => hideUploadWorkNotice(...args),
  dismissUploadWorkNotice: (...args) => dismissUploadWorkNotice(...args),
  restoreUploadWorkNotice: (...args) => restoreUploadWorkNotice(...args),
  uploadWorkActionRef: (...args) => uploadWorkActionRef(...args),
  downloadNormalizedCsv: (...args) => downloadNormalizedCsv(...args),
  readNormalizedFlightEnvelope: (entry) => parseFlightEntryEnvelope(entry),
  drawFlightChart: (...args) => drawFlightChart(...args),
  drawExplorerChart: (...args) => drawExplorerChart(...args),
  saveExplorerHeightMode: (...args) => saveExplorerHeightMode(...args),
  scheduleDrawAll: (...args) => scheduleDrawAll(...args),
  cancelTrendAnalysis: (...args) => cancelTrendAnalysis(...args),
  closeAircraftEditDialog: (...args) => closeAircraftEditDialog(...args),
  saveAircraftEditDialogForm: (...args) => saveAircraftEditDialogForm(...args),
  openAircraftEditDialog: (...args) => openAircraftEditDialog(...args),
  removeAircraftFromFleet: (...args) => removeAircraftFromFleet(...args),
  openAircraftReviewSettingsDialog: (...args) => openAircraftReviewSettingsDialog(...args),
  closeAircraftReviewSettingsDialog: (...args) => closeAircraftReviewSettingsDialog(...args),
  resetAircraftReviewSettingsInDialog: (...args) => resetAircraftReviewSettingsInDialog(...args),
  updateReviewSettingsDialogCount: (...args) => updateReviewSettingsDialogCount(...args),
  applyReviewSettingsGroupAction: (...args) => applyReviewSettingsGroupAction(...args),
  saveAircraftReviewSettingsFromDialog: (...args) => saveAircraftReviewSettingsFromDialog(...args),
  syncUploadAircraftMode: (...args) => syncUploadAircraftMode(...args),
  populateMonitorSelects: (...args) => populateMonitorSelects(...args),
  updateUploadSelectionSummary: (...args) => updateUploadSelectionSummary(...args),
  uploadSelectedFiles: (...args) => uploadSelectedFiles(...args),
  initializeContactForm: (...args) => initializeContactForm(...args),
  syncContactMonitorFields: (...args) => syncContactMonitorFields(...args),
  submitContactUpdateForm: (...args) => submitContactUpdateForm(...args),
  openAircraftCreateDialog: (...args) => openAircraftCreateDialog(...args),
  aircraftEditorField: (...args) => aircraftEditorField(...args),
  aircraftEditorNameForFieldId: (...args) => aircraftEditorNameForFieldId(...args),
  setAircraftFormStatus: (...args) => setAircraftFormStatus(...args),
  lookupFaaAircraftRegistry: (...args) => lookupFaaAircraftRegistry(...args),
  applyAircraftRegistryPrefill: (...args) => applyAircraftRegistryPrefill(...args),
  normalizedAircraftPhotoDataUrl: (...args) => normalizedAircraftPhotoDataUrl(...args),
  setAircraftFormPhotoDataUrl: (...args) => setAircraftFormPhotoDataUrl(...args),
  persistAircraftProfileFromForm: (...args) => persistAircraftProfileFromForm(...args),
  resetAircraftForm: (...args) => resetAircraftForm(...args),
  setAircraftWorkspaceSelection: (...args) => setAircraftWorkspaceSelection(...args),
  renderAircraftWorkspace: (...args) => renderAircraftWorkspace(...args),
  aircraftRowDropPlacement: (...args) => aircraftRowDropPlacement(...args),
  clearAircraftFleetDragState: (...args) => clearAircraftFleetDragState(...args),
  reorderAircraftFleetRow: (...args) => reorderAircraftFleetRow(...args),
  visibleFlightEntries: (...args) => visibleFlightEntries(...args),
  setFlightTrendAnalysisIncluded: (...args) => setFlightTrendAnalysisIncluded(...args),
  setAircraftFlightsFilter: (...args) => setAircraftFlightsFilter(...args),
  setAircraftFlightsTrendAnalysisIncluded: (...args) => setAircraftFlightsTrendAnalysisIncluded(...args),
  setAircraftFlightsSort: (...args) => setAircraftFlightsSort(...args),
  openOrGenerateFlightAiSummary: (...args) => openOrGenerateFlightAiSummary(...args),
  openOrGenerateFlightReport: (...args) => openOrGenerateFlightReport(...args),
  regenerateFlightReport: (...args) => regenerateFlightReport(...args),
  reanalyzeFlight: (...args) => reanalyzeFlight(...args),
  reanalyzeAllFlights: (...args) => reanalyzeAllFlights(...args),
  editFlightRouteInline: (...args) => editFlightRouteInline(...args),
  submitFlightRouteEdit: (...args) => submitFlightRouteEdit(...args),
  closeFlightRouteEdit: (...args) => closeFlightRouteEdit(...args),
  editFlightNameInline: (...args) => editFlightNameInline(...args),
  submitFlightNameEdit: (...args) => submitFlightNameEdit(...args),
  closeFlightNameEdit: (...args) => closeFlightNameEdit(...args),
  updateSelectedAircraftFlights: (...args) => updateSelectedAircraftFlights(...args),
  reanalyzeAvailableAircraftFlights: (...args) => reanalyzeAvailableAircraftFlights(...args),
  setAircraftFlightBulkDeleteSelection: (...args) => setAircraftFlightBulkDeleteSelection(...args),
  setAircraftFlightBulkDeleteSelectionForIds: (...args) => setAircraftFlightBulkDeleteSelectionForIds(...args),
  archiveSelectedAircraftFlights: (...args) => archiveSelectedAircraftFlights(...args),
  markSelectedAircraftFlightsSeen: (...args) => markSelectedAircraftFlightsSeen(...args),
  activateView: (...args) => activateView(...args),
  loadFlightLog: (...args) => loadFlightLog(...args),
  removeFlightEntryFromList: (...args) => removeFlightEntryFromList(...args),
  aircraftUploadHistoryErrors,
  renderAircraftUploadsPanel: (...args) => renderAircraftUploadsPanel(...args),
  reprocessDatabaseUpload: (...args) => reprocessDatabaseUpload(...args),
  reprocessAllDatabaseUploads: (...args) => reprocessAllDatabaseUploads(...args),
  reprocessSelectedDatabaseUploads: (...args) => reprocessSelectedDatabaseUploads(...args),
  processShortFlightsForDatabaseUpload: (...args) => processShortFlightsForDatabaseUpload(...args),
  deleteDatabaseUpload: (...args) => deleteDatabaseUpload(...args),
  setAircraftUploadBulkDeleteSelection: (...args) => setAircraftUploadBulkDeleteSelection(...args),
  setAircraftUploadBulkDeleteSelectionForIds: (...args) => setAircraftUploadBulkDeleteSelectionForIds(...args),
  deleteSelectedDatabaseUploads: (...args) => deleteSelectedDatabaseUploads(...args),
  syncAircraftLayoutControls: (...args) => syncAircraftLayoutControls(...args),
  applyAircraftEngineMakeSelection: (...args) => applyAircraftEngineMakeSelection(...args),
  applyAircraftEngineModelSelection: (...args) => applyAircraftEngineModelSelection(...args),
  setAircraftFuelFields: (...args) => setAircraftFuelFields(...args),
  syncAircraftTurboLimitFields: (...args) => syncAircraftTurboLimitFields(...args),
  updateAircraftEditSummary: (...args) => updateAircraftEditSummary(...args),
  updateDataSourceLabel: (...args) => updateDataSourceLabel(...args),
  setAircraftPanel: (...args) => setAircraftPanel(...args),
  selectReportPanel: (...args) => selectReportPanel(...args),
  preferredUploadAircraft: (...args) => preferredUploadAircraft(...args),
  explorerHeightModes,
  getZoomRange: () => zoomRange,
  setScrubRatio: (value) => { scrubRatio = value; },
  setExplorerSelectedAlertId: (value) => { explorerSelectedAlertId = value; },
  getExplorerHeightMode: () => explorerHeightMode,
  setExplorerHeightMode: (value) => { explorerHeightMode = value; },
  getDraggedAircraftRow: () => draggedAircraftRow,
  setDraggedAircraftRow: (value) => { draggedAircraftRow = value; },
  getAircraftProfiles: () => aircraftProfiles,
  getFlightData: () => flightData,
  getSelectedFlight: () => selectedFlight,
  getSelectedAircraftPanel: () => selectedAircraftPanel,
});
const {
  setupChartScrubber,
  finishZoomDrag,
  setExplorerCursorRatio,
  scheduleExplorerInteractionUpdate,
  setExplorerCursorElapsed,
  explorerTimelineControlIcon,
  explorerFindingMarkers,
  explorerFindingMarkerPosition,
  jumpExplorerFindingMarker,
  setupExplorerContextInteractions,
  chartGestureHintBaseText,
} = createChartScrubber({
  clamp01: (...args) => clamp01(...args),
  flightChartPadding,
  explorerChartPadding,
  flightChartLayoutOptions,
  explorerChartLayoutOptions,
  chartPointerGeometry: (...args) => chartPointerGeometry(...args),
  scheduleMarkerUpdate: (...args) => scheduleMarkerUpdate(...args),
  scheduleDrawAll: (...args) => scheduleDrawAll(...args),
  updateExplorerChartInteraction: (...args) => updateExplorerChartInteraction(...args),
  explorerPhaseFilteredData: (...args) => explorerPhaseFilteredData(...args),
  nearestPoint: (...args) => nearestPoint(...args),
  updateScrubReadout: (...args) => updateScrubReadout(...args),
  drawExplorerChart: (...args) => drawExplorerChart(...args),
  explorerTimelineRatioForElapsed: (...args) => explorerTimelineRatioForElapsed(...args),
  buildExplorerTimelineMarkers: (...args) => buildExplorerTimelineMarkers(...args),
  visibleScrubRatio: (...args) => visibleScrubRatio(...args),
  renderExplorerContext: (...args) => renderExplorerContext(...args),
  getZoomRange: () => zoomRange,
  setZoomRange: (value) => {
    zoomRange = value;
    syncFlightReviewRoute(activeReportPanel());
  },
  getScrubRatio: () => scrubRatio,
  setScrubRatio: (value) => { scrubRatio = value; },
  getDragSelection: () => dragSelection,
  setDragSelection: (value) => { dragSelection = value; },
  getExplorerPilotObservationPanelOpen: () => pilotObservationState.open,
  getExplorerPilotObservationSelectionActive: () => pilotObservationState.open && pilotObservationState.selecting,
  commitExplorerPilotObservationSelection: (...args) => commitExplorerPilotObservationSelection(...args),
  getExplorerGamiSweepPanelOpen: () => gamiSpecialTestsState.open,
  getExplorerGamiSweepSelectionActive: () => gamiSpecialTestsState.open && gamiSpecialTestsState.selecting,
  commitExplorerGamiSweepSelection: (...args) => commitExplorerGamiSweepSelection(...args),
  showExplorerGamiCursorTime: (...args) => showExplorerGamiCursorTime(...args),
  hideExplorerGamiCursorTime: (...args) => hideExplorerGamiCursorTime(...args),
  updateChartCursorPosition: (value) => { chartCursorPosition = value; },
  getExplorerSelectedAlertId: () => explorerSelectedAlertId,
  setExplorerSelectedAlertId: (value) => { explorerSelectedAlertId = value; },
  getExplorerInteractionUpdateScheduled: () => explorerInteractionUpdateScheduled,
  setExplorerInteractionUpdateScheduled: (value) => { explorerInteractionUpdateScheduled = value; },
});
const {
  bindSeriesPaneDrag,
} = createSeriesPaneDrag({
  // Chip drags carry a comma-separated key list; the zones say "Show on" only
  // when every channel in the bank already lives on that pane — a bank that
  // straddles panes reads "Move to" on both zones, because either drop moves
  // at least one channel.
  seriesPaneForKey: (key) => {
    const panes = String(key ?? "").split(",").filter(Boolean).map((seriesKey) => seriesPaneForKey(seriesKey));
    return panes.length && panes.every((pane) => pane === panes[0]) ? panes[0] : null;
  },
  moveSeriesToPane: (...args) => moveSeriesToPane(...args),
});
const {
  setupSeriesControls,
  isolateSeries,
  seriesControlGroupHtml,
  temperatureSeriesControlGroupHtml,
  seriesControlSubgroupHtml,
  engineTemperatureSeriesLabel,
  seriesUnitSuffix,
  engineAwareSeriesLabel,
  seriesControlHtml,
  availablePhases,
  phaseOptionLabel,
  phaseSampleCounts,
  updatePhaseFilters,
  syncSeriesControls,
} = createSeriesControls({
  escapeHtml: (...args) => escapeHtml(...args),
  seriesMeta,
  titleCase: (...args) => titleCase(...args),
  scheduleDrawAll: (...args) => scheduleDrawAll(...args),
  syncChartRouteState: () => syncFlightReviewRoute(activeReportPanel()),
  unalignedAuxSeriesKeys: () => unalignedAuxSeriesKeys(),
  notifySeriesExclusion: (keptGroup) => notifySeriesExclusion(keptGroup),
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  engineScopedChannelLabel: (...args) => engineScopedChannelLabel(...args),
  availableSeriesKeys: (...args) => availableSeriesKeys(...args),
  isPrimaryTemperatureSeries: (...args) => isPrimaryTemperatureSeries(...args),
  isPrimaryPaneSeries: (...args) => isPrimaryPaneSeries(...args),
  moveSeriesToPane: (...args) => moveSeriesToPane(...args),
  hasSeriesPaneOverrides: (...args) => hasSeriesPaneOverrides(...args),
  resetSeriesPaneOverrides: (...args) => resetSeriesPaneOverrides(...args),
  bindSeriesPaneDrag: (...args) => bindSeriesPaneDrag(...args),
  availablePhasesForData: (...args) => availablePhasesForData(...args),
  currentFlightDerivedCache: (...args) => currentFlightDerivedCache(...args),
  sampleIntervalSeconds: (...args) => sampleIntervalSeconds(...args),
  formatElapsedTime: (...args) => formatElapsedTime(...args),
  activeSeries,
  getFlightData: () => flightData,
});
const {
  trendAircraftOptions,
  setupTrendControls,
  renderCurrentTrendView,
  populateTrendAircraftSelect,
  selectedTrendAircraft,
  selectedTrendAircraftDatabaseId,
  trendCacheKey,
  clearTrendRowsForAircraft,
  buildAircraftTrends,
  maybeLoadDatabaseTrendRows,
  prefetchTrendSnapshot,
  scheduleTrendSnapshotRefresh,
  renderCachedTrendView,
  setTrendAnalysisBusy,
  renderTrendCanceledView,
  renderTrendUnavailableView,
  cancelTrendAnalysis,
  renderTrendsForSelection,
  renderTrendView,
  trendEvidenceReturnContext,
  updateTrendReturnControls,
  trendEvidenceTopReviewItem,
  focusTrendEvidenceFlightReview,
  markReturnedTrendEvidenceRow,
  returnToTrendEvidence,
  openTrendFlight,
} = createTrendController({
  escapeHtml: (...args) => escapeHtml(...args),
  trendMetricMeta,
  trendCacheSchemaVersion,
  trendFlightFingerprint: (...args) => trendFlightFingerprint(...args),
  trendHashString: (...args) => trendHashString(...args),
  visibleFlightEntries: (...args) => visibleFlightEntries(...args),
  trendExclusionCounts: (aircraft) => {
    const counts = {};
    for (const entry of visibleFlightEntries().filter((item) => item.aircraft === aircraft)) {
      const reason = !isSupportedFlight(entry) ? "unsupported logs"
        : flightTooShortForTrendAnalysis(entry) ? "flights under 15 minutes"
        : trendExcludedFlightIds.has(entry.id) ? "flights excluded by you"
        : flightAutoExcludedFromTrendAnalysis(entry) ? "flights without enough engine-run evidence"
        : !flightConsumedByTrends(entry) ? "flights outside the recency window" : null;
      if (reason) counts[reason] = (counts[reason] ?? 0) + 1;
    }
    return counts;
  },
  isSupportedFlight: (...args) => isSupportedFlight(...args),
  selectedAircraftWorkspace: (...args) => selectedAircraftWorkspace(...args),
  reviewSettingsSignature: (...args) => reviewSettingsSignature(...args),
  // The trend builder + cache key consume the capped recency window (last 50
  // flights / 100 hours), not the raw user-intent inclusion set.
  flightIncludedInTrendAnalysis: (...args) => flightConsumedByTrends(...args),
  parseFlightEntry: (...args) => parseFlightEntry(...args),
  trimEndpointSamples: (...args) => trimEndpointSamples(...args),
  calculateHealthSummary: (...args) => calculateHealthSummary(...args),
  analyzeTrendFlight: (...args) => calculateTrendFlightSummaryOffThread(...args),
  aircraftProfileForEntry: (...args) => aircraftProfileForEntry(...args),
  buildTrendRow: (...args) => buildTrendRow(...args),
  flightDisplayTitle: (...args) => flightDisplayTitle(...args),
  trendDateValue: (...args) => trendDateValue(...args),
  trendDateLabel: (...args) => trendDateLabel(...args),
  normalizeTrendRowsForDisplay: (...args) => normalizeTrendRowsForDisplay(...args),
  readDatabaseTrendSnapshotRows: (...args) => readDatabaseTrendSnapshotRows(...args),
  saveDatabaseTrendSnapshotRows: (...args) => saveDatabaseTrendSnapshotRows(...args),
  // Phase 3i: persistent (IndexedDB) trend-snapshot cache so a reload revalidates with a
  // conditional GET (304) instead of re-downloading the multi-MB snapshot body.
  readCachedTrendSnapshot: (...args) => readCachedTrendSnapshot(...args),
  writeCachedTrendSnapshot: (...args) => writeCachedTrendSnapshot(...args),
  deleteCachedTrendSnapshotsForAircraft: (...args) => deleteCachedTrendSnapshotsForAircraft(...args),
  readStoredTrendRows: (...args) => readStoredTrendRows(...args),
  writeStoredTrendRows: (...args) => writeStoredTrendRows(...args),
  removeStoredTrendRows: (...args) => removeStoredTrendRows(...args),
  clearStoredTrendRowsForAircraft: (...args) => clearStoredTrendRowsForAircraft(...args),
  waitForUiFrame: (...args) => waitForUiFrame(...args),
  engineReviewItems: (...args) => engineReviewItems(...args),
  selectedDetectionWindows: (...args) => selectedDetectionWindows(...args),
  selectCompanionSeriesForHealthCard: (...args) => selectCompanionSeriesForHealthCard(...args),
  renderHealthSummary: (...args) => renderHealthSummary(...args),
  setPlaybackScrubElapsed: (...args) => setPlaybackScrubElapsed(...args),
  updateHealthCardSelection: (...args) => updateHealthCardSelection(...args),
  scheduleDrawAll: (...args) => scheduleDrawAll(...args),
  setAircraftPanel: (...args) => setAircraftPanel(...args),
  reanalyzeAllFlights: (...args) => reanalyzeAllFlights(...args),
  renderAircraftWorkspace: (...args) => renderAircraftWorkspace(...args),
  trendRowsIncludedByPreference: (...args) => trendRowsIncludedByPreference(...args),
  trendRenderSignature: (...args) => trendRenderSignature(...args),
  trendDataRenderSignature: (...args) => trendDataRenderSignature(...args),
  updateTrendMetricControls: (...args) => updateTrendMetricControls(...args),
  renderTrendOwnerStory: (...args) => renderTrendOwnerStory(...args),
  renderTrendVisualWorkspace: (...args) => renderTrendVisualWorkspace(...args),
  renderTrendSummary: (...args) => renderTrendSummary(...args),
  renderTrendTable: (...args) => renderTrendTable(...args),
  renderTrendSampleGraphs: (...args) => renderTrendSampleGraphs(...args),
  scheduleTrendSampleGraphPrewarm: (...args) => scheduleTrendSampleGraphPrewarm(...args),
  syncTrendRoute: (...args) => syncTrendRoute(...args),
  setTrendEvidenceMode: (...args) => setTrendEvidenceMode(...args),
  setTrendEvidenceSort: (...args) => setTrendEvidenceSort(...args),
  setTrendEvidenceLayout: (...args) => setTrendEvidenceLayout(...args),
  loadFlightLog: (...args) => loadFlightLog(...args),
  activateView: (...args) => activateView(...args),
  selectReportPanel: (...args) => selectReportPanel(...args),
  scrollFlightChartPanelIntoView: (...args) => scrollFlightChartPanelIntoView(...args),
  trendCache,
  trendExcludedFlightIds,
  trendIncludedFlightIds,
  getFlightManifest: () => flightManifest,
  getAircraftProfiles: () => aircraftProfiles,
  getSelectedFlight: () => selectedFlight,
  getSelectedAircraftPanel: () => selectedAircraftPanel,
  getActiveTrendMetric: () => activeTrendMetric,
  setActiveTrendMetric: (value) => { activeTrendMetric = value; },
  getDetectionSensitivity: () => detectionSensitivity,
  getHealthSummary: () => healthSummary,
  getCurrentTrendRows: () => currentTrendRows,
  setCurrentTrendRows: (value) => { currentTrendRows = value; },
  getCurrentTrendAircraft: () => currentTrendAircraft,
  setCurrentTrendAircraft: (value) => { currentTrendAircraft = value; },
  getCurrentTrendSensitivity: () => currentTrendSensitivity,
  setCurrentTrendSensitivity: (value) => { currentTrendSensitivity = value; },
  setSelectedCylinderNumber: (value) => { selectedCylinderNumber = value; },
  setSelectedEngineScope: (value) => { selectedEngineScope = value; },
  getSelectedHealthKey: () => selectedHealthKey,
  setSelectedHealthKey: (value) => {
    overviewSelectionCleared = false;
    selectedHealthKey = value;
  },
  getTrendRequestToken: () => trendRequestToken,
  incrementTrendRequestToken: () => ++trendRequestToken,
  getTrendReturnContext: () => trendReturnContext,
  setTrendReturnContext: (value) => { trendReturnContext = value; },
  getRenderedTrendSignature: () => renderedTrendSignature,
  setRenderedTrendSignature: (value) => { renderedTrendSignature = value; },
  getRenderedTrendDataSignature: () => renderedTrendDataSignature,
  setRenderedTrendDataSignature: (value) => { renderedTrendDataSignature = value; },
  setRenderedTrendFlushed: (value) => { renderedTrendFlushed = value; },
  getRenderedTrendFlushed: () => renderedTrendFlushed,
  setRenderedTrendSampleSignature: (value) => { renderedTrendSampleSignature = value; },
  incrementTrendSampleGraphToken: () => { trendSampleGraphToken += 1; },
  setRenderedTrendTableSignature: (value) => { renderedTrendTableSignature = value; },
});
const {
  renderOverviewDetectorVisual,
  resetOverviewDetectorVisual,
} = createOverviewDetectorVisuals({
  escapeHtml: (...args) => escapeHtml(...args),
  getFlightData: () => flightData,
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  getSelectedHealthKey: () => selectedHealthKey,
  getSelectedFlight: () => selectedFlight,
  getSelectedCylinderNumber: () => selectedCylinderNumber,
  getSelectedEngineScope: () => selectedEngineScope,
  getCoolingRateThresholdFpm: (...args) => coolingRateTriggerFpm(...args),
  onChtEgtPairingCardSelect: (...args) => selectChtEgtPairingCardWindow(...args),
});
const {
  healthCardKeysForSummary,
  reviewCardSortItems,
  renderHealthSummary,
  findingBodyHtml,
  reviewCardStateKey,
  reviewCardDetailsHtml,
  reviewCardHtml,
  renderFindingReviewCards,
  scrollReviewCardIntoView,
} = createHealthSummaryRenderer({
  escapeHtml: (...args) => escapeHtml(...args),
  hasCarbTempChannel,
  findingDisplayClass,
  findingDisplayLabel,
  findingMetaItems: (...args) => findingMetaItems(...args),
  findingMetaMarkup,
  findingCausePresentation: (...args) => findingCausePresentation(...args),
  metricDisplayClass: (...args) => metricDisplayClass(...args),
  scoreMarkup: (...args) => scoreMarkup(...args),
  reviewMonitorEnabled: (...args) => reviewMonitorEnabled(...args),
  healthSummaryForCurrentEngineScope: (...args) => healthSummaryForCurrentEngineScope(...args),
  renderSensitivityControl: (...args) => renderSensitivityControl(...args),
  renderScopeSwitch: (...args) => renderScopeSwitch(...args),
  renderMultiEngineOverview: (...args) => renderMultiEngineOverview(...args),
  renderCylinderScopeSummary: (...args) => renderCylinderScopeSummary(...args),
  renderOverviewDetectorVisual: (...args) => renderOverviewDetectorVisual(...args),
  renderOperatingContextCards: (...args) => renderOperatingContextCards(...args),
  selectedOperatingContextReviewCardHtml: (...args) => selectedOperatingContextReviewCardHtml(...args),
  updateHealthCardSelection: (...args) => updateHealthCardSelection(...args),
  scheduleOverviewReviewPanelHeight: (...args) => scheduleOverviewReviewPanelHeight(...args),
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  engineReviewItems: (...args) => engineReviewItems(...args),
  engineForSummaryScope: (...args) => engineForSummaryScope(...args),
  metricMatchesEngineScope: (...args) => metricMatchesEngineScope(...args),
  scopedSummaryFinding: (...args) => scopedSummaryFinding(...args),
  findingForMetric: (...args) => findingForMetric(...args),
  cylinderMetricSummary: (...args) => cylinderMetricSummary(...args),
  cylinderFinding: (...args) => cylinderFinding(...args),
  healthCardNoteMarkup: (...args) => healthCardNoteMarkup(...args),
  openTrendFlight: (...args) => openTrendFlight(...args),
  appReadOnlyMode: (...args) => appReadOnlyMode(...args),
  getSelectedFlight: () => selectedFlight,
  getSelectedHealthKey: () => selectedHealthKey,
  setSelectedHealthKey: (value) => { selectedHealthKey = value; },
  getSelectedCylinderNumber: () => selectedCylinderNumber,
  getSelectedEngineScope: () => selectedEngineScope,
  getOverviewSelectionCleared: () => overviewSelectionCleared,
  setRenderedHealthSummary: (value) => { renderedHealthSummary = value; },
  reviewNoteSectionHtml: (...args) => reviewNoteSectionHtml(...args),
  saveReviewNote: (...args) => saveReviewNote(...args),
  renderMaintenanceContext: (container, selection) => maintenanceContext.render("finding", container, selection),
});
let trendReturnContext = null;
let trendRequestToken = 0;
let evidenceRequestToken = 0;
let reportDownloadUrl = null;

function loadExplorerHeightMode() {
  try {
    const saved = localStorage.getItem(explorerHeightStorageKey);
    return Object.hasOwn(explorerHeightModes, saved) ? saved : "normal";
  } catch {
    return "normal";
  }
}

function saveExplorerHeightMode(mode) {
  try {
    localStorage.setItem(explorerHeightStorageKey, mode);
  } catch {
    // Ignore storage failures; the in-memory choice still applies for this session.
  }
}

function syncExplorerHeightControls() {
  document.querySelectorAll("[data-explorer-height]").forEach((button) => {
    const active = button.dataset.explorerHeight === explorerHeightMode;
    button.classList.toggle("is-active", active);
    button.setAttribute("aria-pressed", active ? "true" : "false");
  });
}

function loadExplorerFitYAxis() {
  try {
    return localStorage.getItem(explorerFitYStorageKey) === "true";
  } catch {
    return false;
  }
}

function saveExplorerFitYAxis(on) {
  try {
    localStorage.setItem(explorerFitYStorageKey, on ? "true" : "false");
  } catch {
    // Ignore storage failures; the in-memory choice still applies for this session.
  }
}

function syncExplorerFitYControls() {
  const button = document.querySelector("#explorerFitYToggle");
  if (!button) return;
  button.classList.toggle("is-active", explorerFitYAxis);
  button.setAttribute("aria-pressed", explorerFitYAxis ? "true" : "false");
}

function syncExplorerChartHeightState(data = explorerPhaseFilteredData()) {
  const chartWrap = document.querySelector(".explorer-chart-wrap");
  if (!chartWrap) return;
  chartWrap.dataset.heightMode = explorerHeightMode;
  chartWrap.dataset.hasSplit = hasSplitChartLanes(data) ? "true" : "false";
}
let reportDownloadBlob = null;
let detectionGuideCache = null;
let detectionGuidePromise = null;
const detectionGuidePath = "data/detection-guide.json";
let detectionGuideSearchQuery = "";
let detectionGuideFamilyFilter = "all";
const {
  detectionGuideList,
  detectionGuideFamilySlug,
  detectionGuideFamilyIcon,
  detectionGuideDetectorIcon,
  detectionGuideSearchText,
  detectionGuideVisibleDetectors,
  detectionGuideActiveSlug,
  detectionGuideThresholdSummary,
  detectionGuideDateLabel,
  detectionGuideFamilyDisplayLabel,
  detectionGuideRenderControls,
  detectionGuideThresholdValue,
  detectionGuideThresholdLabel,
  detectionGuideThresholds,
  detectionGuideArticle,
  renderDetectionGuide,
  loadDetectionGuide,
  ensureDetectionGuideRendered,
} = createDetectionGuide({
  escapeHtml: (...args) => escapeHtml(...args),
  detectionGuidePath,
  getDetectionGuideCache: () => detectionGuideCache,
  setDetectionGuideCache: (value) => { detectionGuideCache = value; },
  getDetectionGuidePromise: () => detectionGuidePromise,
  setDetectionGuidePromise: (value) => { detectionGuidePromise = value; },
  getDetectionGuideSearchQuery: () => detectionGuideSearchQuery,
  setDetectionGuideSearchQuery: (value) => { detectionGuideSearchQuery = value; },
  getDetectionGuideFamilyFilter: () => detectionGuideFamilyFilter,
  setDetectionGuideFamilyFilter: (value) => { detectionGuideFamilyFilter = value; },
});
let reportDownloadFileName = "";
let reportDownloadFlightId = "";
const flightReportCache = new Map();
const flightReportMetadataChecked = new Set();
const flightReportMetadataPending = new Set();
const flightReportStoredMetadata = new Map();
const flightReportStoreDbName = "aeroInsightFlightReports";
const flightReportStoreName = "reports";

const {
  setReportStatus,
  releaseReportDownloadUrl,
  revokeCachedFlightReport,
  flightReportAvailable,
  flightReportStale,
  flightReportMetadataKey,
  openFlightReportStore,
  withFlightReportStore,
  readStoredFlightReportRecord,
  writeStoredFlightReport,
  cacheStoredFlightReport,
  hydrateStoredFlightReportMetadata,
  hydrateAircraftFlightReportMetadata,
  updateReportButtonState,
  resetGeneratedReport,
  stageReportDownload,
  openCachedFlightReport,
  openDatabaseFlightReport,
  openExistingFlightReport,
  blobToBase64,
  updateManifestReportMetadata,
  persistDatabaseFlightReport,
  openOrGenerateFlightReport,
  regenerateFlightReport,
  triggerPreparedReportDownload,
  waitForButtonPaint,
  waitForMinimumReportFeedback,
  downloadFlightReportPdf,
} = createFlightReportPdf({
  buildFlightReportPdfBlob: (...args) => buildFlightReportPdfBlob(...args),
  ensureAiSummaryLoadedForPdf: async () => {
    if (!flightAiSummaryAvailable(selectedFlight)) return;
    const flightId = selectedDatabaseFlightId();
    if (
      aiSummaryState.flightId === flightId
      && aiSummaryState.status === "ready"
      && aiSummaryState.payload
    ) return;
    await loadAiSummaryForSelectedFlight({ showProgressNotice: false });
  },
  flightReportStoreDbName,
  flightReportStoreName,
  aircraftFlightsHydrationBatchSize,
  flightReportCache,
  flightReportStoredMetadata,
  flightReportMetadataPending,
  flightReportMetadataChecked,
  flightDisplayTitle: (...args) => flightDisplayTitle(...args),
  appReadOnlyMode: (...args) => appReadOnlyMode(...args),
  readOnlyActionMessage: (...args) => readOnlyActionMessage(...args),
  renderAircraftFlightsPanel: (...args) => renderAircraftFlightsPanel(...args),
  aircraftFlightPdfIconMarkup: (...args) => aircraftFlightPdfIconMarkup(...args),
  flightMetadataHydrationTargets: (...args) => flightMetadataHydrationTargets(...args),
  loadFlightLog: (...args) => loadFlightLog(...args),
  getSelectedFlight: () => selectedFlight,
  getFlightData: () => flightData,
  getFlightManifest: () => flightManifest,
  getReportDownloadUrl: () => reportDownloadUrl,
  setReportDownloadUrl: (value) => { reportDownloadUrl = value; },
  getReportDownloadBlob: () => reportDownloadBlob,
  setReportDownloadBlob: (value) => { reportDownloadBlob = value; },
  getReportDownloadFileName: () => reportDownloadFileName,
  setReportDownloadFileName: (value) => { reportDownloadFileName = value; },
  getReportDownloadFlightId: () => reportDownloadFlightId,
  setReportDownloadFlightId: (value) => { reportDownloadFlightId = value; },
});

const {
  reanalyzeFlight,
  reanalyzeAllFlights,
  reanalyzeAllFlightsStatus,
} = createFlightReanalyze({
  flightDisplayTitle: (...args) => flightDisplayTitle(...args),
  renderAircraftFlightsPanel: (...args) => renderAircraftFlightsPanel(...args),
  // A batch keeps running after the owner switches aircraft. Do not let a
  // completion render for the original aircraft replace the newly selected
  // aircraft's Flights table.
  isAircraftSelected: (aircraft) => aircraft === selectedAircraftWorkspace(),
  confirmReanalyzeFlight: (...args) => confirmFlightReanalyzeDialog(...args),
  confirmReanalyzeAllFlights: (...args) => confirmFlightsReanalyzeAllDialog(...args),
  isSupportedFlight: (...args) => isSupportedFlight(...args),
  appReadOnlyMode: (...args) => appReadOnlyMode(...args),
  readOnlyActionMessage: (...args) => readOnlyActionMessage(...args),
  showReanalyzeProgressNotice: (...args) => showUploadProgressNotice(...args),
  onFlightReanalyzed: async (entry) => syncFlightAfterBackgroundUpgrade(entry),
  // Dialog opt-in ("Generate AI summary after the update"): runs the normal
  // generate-and-open flow once the re-analysis lands.
  openFlightAiSummary: (entry) => openOrGenerateFlightAiSummary(entry),
  invalidateFlightCaches: (entry) => {
    if (entry?.id) {
      flightReportCache.delete(entry.id);
      // Drop tier-1 in-memory analysis bundles for this flight. The signature
      // embeds entry.id as a "|"-delimited segment (index 2), so a stale bundle
      // would otherwise keep pinning the overview tiles after a re-analyze.
      for (const signature of rawAnalysisCache.keys()) {
        if (signature.split("|").includes(entry.id)) rawAnalysisCache.delete(signature);
      }
    }
    // Drop the persistent (IndexedDB) tier-2 bundles too; fire-and-forget since
    // overview tiles recompute on next open and the delete is best-effort.
    const flightId = rawAnalysisCacheFlightId(entry);
    if (flightId) {
      Promise.resolve()
        .then(() => deleteCachedRawAnalysisBundlesForFlight(flightId))
        .catch(() => {});
    }
    const aircraftId = entry?.database?.aircraftId;
    if (aircraftId) {
      invalidateAircraftFlightFlagSummaries(aircraftId, [entry]);
    }
  },
});

function makeFlightDerivedCache(data) {
  return {
    data,
    availableSeriesKeys: null,
    dataQualitySummary: null,
    durationSeconds: null,
    elapsedDiffs: null,
    fuelUsedMetric: null,
    maxFiniteByKey: new Map(),
    phaseCounts: null,
    powerEstimateSummary: new Map(),
    rawChannelKeys: null,
    rawChannelStats: new Map(),
    rawValueExtents: new Map(),
    sampleIntervalSeconds: null,
    cylinderMetricSummaries: new WeakMap(),
    thermalAxisRanges: new Map(),
  };
}

function currentFlightDerivedCache() {
  if (!flightDerivedCache || flightDerivedCache.data !== flightData) {
    flightDerivedCache = makeFlightDerivedCache(flightData);
  }
  return flightDerivedCache;
}

function generateFlightData() {
  return assignFlightPhases(Array.from({ length: 101 }, (_, i) => {
    const t = i;
    const climb = t >= 23 && t < 38;
    const cruise = t >= 38 && t < 76;
    const descent = t >= 76 && t < 91;
    const basePower = t < 16 ? lerp(0.25, 0.55, t / 16) : t < 23 ? 0.95 : climb ? 0.88 : cruise ? 0.74 : descent ? lerp(0.74, 0.48, Math.min(1, (t - 76) / 8)) : 0.32;
    const egt = 720 + basePower * 780 + Math.sin(t / 4) * 35 + seededNoise(i, 24);
    const cht = 150 + basePower * 230 + Math.sin(t / 7) * 14 + (cruise && t < 58 ? 35 : 0) + seededNoise(i + 4, 10);
    return {
      t,
      elapsedSeconds: t * 60,
      egt,
      cht,
      oilTemp: 82 + Math.min(t, 70) * 1.8 + Math.sin(t / 10) * 8,
      oilPressure: 82 - Math.min(t, 60) * 0.42 + Math.sin(t / 5) * 4,
      fuelFlow: t < 17 ? 1 + t * 0.5 : t < 23 ? 20 : climb ? 16 + Math.sin(t / 3) * 1.4 : cruise ? 13.6 + Math.sin(t / 8) * 0.7 : descent ? 8 + Math.sin(t / 3) : 4,
      rpm: t < 14 ? 850 + t * 80 : t < 23 ? 2450 : cruise ? 2440 + Math.sin(t / 5) * 25 : 2050 + Math.sin(t / 3) * 55,
      map: t < 14 ? 14 + t * 0.45 : t < 23 ? 25 : cruise ? 22 + Math.sin(t / 9) * 0.5 : 17 + Math.sin(t / 4),
      ias: t < 16 ? 0 : t < 23 ? lerp(35, 78, (t - 16) / 7) : climb ? 88 + Math.sin(t / 5) * 4 : cruise ? 118 + Math.sin(t / 9) * 5 : descent ? 125 + Math.sin(t / 6) * 8 : 62,
      groundSpeed: t < 16 ? 0 : t < 23 ? lerp(30, 74, (t - 16) / 7) : climb ? 82 + Math.sin(t / 6) * 5 : cruise ? 122 + Math.sin(t / 8) * 7 : descent ? 130 + Math.sin(t / 5) * 8 : 45,
      altitude: t < 23 ? 1200 : climb ? 1200 + (t - 23) * 135 : cruise ? 3225 + Math.sin(t / 12) * 80 : descent ? 3225 - (t - 76) * 140 : 1125,
      verticalSpeed: climb ? 780 + Math.sin(t / 4) * 80 : descent ? -650 + Math.sin(t / 5) * 100 : cruise ? Math.sin(t / 7) * 45 : 0,
    };
  }));
}

function makeReferenceData(data) {
  const adjust = (value, amount) => Number.isFinite(value) ? value + amount : null;
  return data.map((d, i) => ({
    ...d,
    egt: adjust(d.egt, -35 - Math.sin(i / 14) * 12),
    cht: adjust(d.cht, -(d.t > 48 && d.t < 72 ? 30 : 15)),
    rpm: adjust(d.rpm, -30),
    map: adjust(d.map, -0.8),
  }));
}

flightData = generateFlightData();
referenceData = makeReferenceData(flightData);
flightDerivedCache = makeFlightDerivedCache(flightData);

function sampleIntervalSeconds(points) {
  if (points === flightData) {
    const cache = currentFlightDerivedCache();
    if (Number.isFinite(cache.sampleIntervalSeconds)) return cache.sampleIntervalSeconds;
    const interval = sampleIntervalSecondsPure(points);
    cache.sampleIntervalSeconds = interval;
    return interval;
  }
  return sampleIntervalSecondsPure(points);
}

async function parseFlightEntry(entry) {
  return (await parseFlightEntryEnvelope(entry)).points;
}

function refreshedFlightEntryForOpen(entry) {
  if (!entry?.id) return null;
  const exact = flightManifest.find((candidate) => candidate.id === entry.id && flightSelectableForReview(candidate));
  if (exact) return exact;
  const databaseFlightId = String(entry?.database?.flightId ?? "").trim();
  if (databaseFlightId) {
    const matchingFlightId = flightManifest.find((candidate) => (
      candidate?.database?.flightId === databaseFlightId && flightSelectableForReview(candidate)
    ));
    if (matchingFlightId) return matchingFlightId;
  }
  if (!entry.path) return null;
  return [...flightManifest].reverse().find((candidate) => (
    flightSelectableForReview(candidate) && flightMatchesSourcePath(candidate, entry.path)
  )) ?? null;
}

const flightRouteRefreshTasks = new Map();

function flightNeedsRouteRefreshOnOpen(entry) {
  const flightId = entry?.database?.flightId;
  const normalizedArtifactId = entry?.database?.normalizedArtifactId;
  const missingOrigin = !entry?.origin_ident && entry?.origin_kind !== "manual";
  const missingDestination = !entry?.destination_ident && entry?.destination_kind !== "manual";
  return Boolean(
    !appReadOnlyMode()
    && isSupportedFlight(entry)
    && flightId
    && normalizedArtifactId
    && (missingOrigin || missingDestination)
  );
}

function applyRefreshedFlightRoute(entry, flight) {
  if (!entry || !flight) return;
  const apply = (target) => {
    if (!target) return;
    target.origin_ident = flight.origin_ident ?? null;
    target.origin_kind = flight.origin_kind ?? null;
    target.destination_ident = flight.destination_ident ?? null;
    target.destination_kind = flight.destination_kind ?? null;
  };
  apply(entry);
  const entryId = String(entry.id ?? "");
  const databaseFlightId = String(entry?.database?.flightId ?? "");
  (Array.isArray(flightManifest) ? flightManifest : []).forEach((candidate) => {
    if (!candidate || candidate === entry) return;
    if ((entryId && candidate.id === entryId) || (databaseFlightId && candidate?.database?.flightId === databaseFlightId)) {
      apply(candidate);
    }
  });
  if (selectedFlight && (
    (entryId && selectedFlight.id === entryId)
    || (databaseFlightId && selectedFlight?.database?.flightId === databaseFlightId)
  )) {
    apply(selectedFlight);
  }
}

// Flights whose route refresh already came back unresolved this session:
// re-firing the POST on every open costs a server round trip and can never
// succeed until new data arrives, so it is attempted once per flight.
const flightRouteRefreshUnresolved = new Set();

async function refreshFlightRouteForOpen(entry) {
  if (!flightNeedsRouteRefreshOnOpen(entry)) return entry;
  const flightId = entry?.database?.flightId;
  if (flightRouteRefreshUnresolved.has(flightId)) return entry;
  const active = flightRouteRefreshTasks.get(flightId);
  if (active) return active;
  const task = fetch(`/api/flights/${encodeURIComponent(flightId)}/route/refresh`, {
    method: "POST",
  }).then(async (response) => {
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const payload = await response.json().catch(() => ({}));
    applyRefreshedFlightRoute(entry, payload?.flight ?? null);
    if (flightNeedsRouteRefreshOnOpen(entry)) flightRouteRefreshUnresolved.add(flightId);
    return refreshedFlightEntryForOpen(entry) ?? entry;
  }).catch((error) => {
    console.warn("Could not refresh saved flight route on open", error);
    return entry;
  }).finally(() => {
    flightRouteRefreshTasks.delete(flightId);
  });
  flightRouteRefreshTasks.set(flightId, task);
  return task;
}

async function resolveFlightEntryForLoad(entry) {
  // The route refresh only affects route labels, so it must not block the
  // open: awaiting it here cost a ~200ms server round trip on every load,
  // which pushed even fully cached loads past the loading overlay's show
  // threshold. Fire it in the background and repaint labels when it lands.
  void refreshFlightRouteForOpen(entry).then(() => {
    // applyRefreshedFlightRoute mutates the entry in place; repaint the
    // header/breadcrumb if this flight is still the one on screen. Skip on
    // non-workspace views (updateFlightHeader would stomp their titles).
    const activeView = document.body.dataset.activeView;
    if (selectedFlight?.id === entry.id && (activeView === "aircraft" || activeView === "dashboard")) {
      updateFlightHeader();
    }
  }).catch(() => {});
  return entry;
}

async function parseFlightEntryEnvelope(entry) {
  const cacheKey = parsedFlightEntryCacheKey(entry);
  if (cacheKey && parsedFlightEntryCache.has(cacheKey)) {
    perfMark("parse(hit)", 0);
    const envelope = parsedFlightEntryCache.get(cacheKey);
    rememberParsedFlightEntry(cacheKey, envelope);
    return cloneParsedFlightEnvelope(envelope);
  }
  if (cacheKey && parsedFlightEntryPromiseCache.has(cacheKey)) {
    return cloneParsedFlightEnvelope(
      await perfTime("parse(inflight)", () => parsedFlightEntryPromiseCache.get(cacheKey)),
    );
  }
  const parsePromise = resolveParsedFlightEntryEnvelope(entry);
  if (cacheKey) parsedFlightEntryPromiseCache.set(cacheKey, parsePromise);
  try {
    const envelope = await parsePromise;
    if (cacheKey) rememberParsedFlightEntry(cacheKey, envelope);
    return cloneParsedFlightEnvelope(envelope);
  } finally {
    if (cacheKey) parsedFlightEntryPromiseCache.delete(cacheKey);
  }
}

// Resolve a flight's parsed envelope, preferring the persistent (IndexedDB)
// tier-2 cache over the network. In database mode the normalized artifact is
// immutable (a re-ingest mints a new normalizedArtifactId), so an envelope keyed
// by that id is always safe to serve and avoids an HTTP fetch + JSON parse of
// the (large, for a twin) artifact on every reload. Cold misses fall through to
// the network and write back to the persistent cache. The parse(idb-hit) /
// parse(miss) perf marks surface in the DASHBOARD_PERF_LOG console output.
async function resolveParsedFlightEntryEnvelope(entry) {
  const artifactId = entry?.database?.normalizedArtifactId ?? "";
  if (artifactId) {
    const cached = await readCachedNormalizedArtifactEnvelope(artifactId);
    if (cached) {
      perfMark("parse(idb-hit)", 0);
      return cached;
    }
  }
  const envelope = await perfTime("parse(miss)", () => parseFlightEntryEnvelopeUncached(entry));
  if (artifactId) {
    // Write-through is fire-and-forget so a slow IndexedDB put never delays the
    // render; tier-1 already holds this envelope for the rest of the session.
    writeCachedNormalizedArtifactEnvelope(artifactId, entry?.database?.flightId ?? "", envelope).catch(() => {});
  }
  return envelope;
}

function prefetchDashboardFlightEnvelope() {
  if (selectedAircraftPanel !== "dashboard") return;
  const aircraft = selectedAircraftWorkspace();
  if (!aircraft) return;
  const latestFlight = latestFlightForAircraft(aircraft);
  if (!latestFlight || !isSupportedFlight(latestFlight)) return;
  parseFlightEntryEnvelope(latestFlight).catch(() => {});
}

async function readDatabaseNormalizedArtifactEnvelope(entry) {
  return readDatabaseNormalizedArtifactEnvelopeModel(entry);
}

async function parseFlightEntryUncached(entry) {
  return (await parseFlightEntryEnvelopeUncached(entry)).points;
}

function flightRuntimeStateCacheKey(entry) {
  return parsedFlightEntryCacheKey(entry);
}

function buildFlightRuntimeState(entry, parsedEnvelope) {
  const trimmed = trimEndpointSamples(parsedEnvelope.points);
  const points = trimmed.points;
  return {
    points,
    parserMetadata: parserMetadataFromEnvelope(parsedEnvelope),
    sourceRows: parsedEnvelope.points.length,
    sourceRawRows: parsedEnvelope.points.reduce((total, point) => total + (point.rawSampleCount ?? 1), 0),
    endpointTrimInfo: trimmed.info,
    sourceName: flightDisplayTitle(entry),
    sourceMonitor: entry.monitor,
    referenceData: makeReferenceData(points),
    derivedCache: makeFlightDerivedCache(points),
  };
}

function flightRuntimeStateForParsedEnvelope(entry, parsedEnvelope) {
  const cacheKey = flightRuntimeStateCacheKey(entry);
  if (cacheKey && loadedFlightRuntimeStateCache.has(cacheKey)) {
    const cached = loadedFlightRuntimeStateCache.get(cacheKey);
    rememberLoadedFlightRuntimeState(cacheKey, cached);
    perfMark("flightRuntimeState(hit)", 0);
    return cached;
  }
  const state = perfTimeSync("flightRuntimeState(miss)", () => buildFlightRuntimeState(entry, parsedEnvelope));
  if (cacheKey) rememberLoadedFlightRuntimeState(cacheKey, state);
  return state;
}

async function parseFlightEntryEnvelopeUncached(entry) {
  const persistedEnvelope = await readDatabaseNormalizedArtifactEnvelope(entry);
  if (persistedEnvelope) return persistedEnvelope;
  if (entry.parser === "jpi-binary") {
    const response = await fetch(entry.path);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return parseJpiBinaryEnvelope(await response.arrayBuffer(), entry);
  }
  const { text, entry: parseEntry } = await fetchFlightEntryText(entry);
  if (entry.parser !== "ei-cgr-combo") return parseFlightTextEnvelope(parseEntry, text);
  if (!entry.auxPath) throw new Error("Combined CGR entry is missing its CGR-30C file");
  const auxResponse = await fetch(entry.auxPath);
  if (!auxResponse.ok) throw new Error(`HTTP ${auxResponse.status}`);
  const combo = parseEiCgrComboCsvDetailedWithDeps(text, await auxResponse.text(), {
    finalizeParsedPoints,
    resamplePointsToOneHz,
  }, {
    pairingMode: entry.pairing === "loose" ? "loose" : "overlap",
  });
  return createCanonicalParserEnvelope(combo.points, {
    parserId: entry.parser,
    parserVersion: EI_CGR_COMBO_PARSER_VERSION,
    parserConfidence: "Medium",
    parserWarnings: combo.parserWarnings,
    comboAlignment: combo.comboAlignment,
    comboOffsetSeconds: combo.comboOffsetSeconds,
    sourceData: combo.sourceData,
    auxSeriesKeys: combo.auxSeriesKeys,
  });
}

async function fetchFlightEntryText(entry) {
  const response = await fetch(entry.path);
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return {
    text: await response.text(),
    entry,
  };
}

function reportPanelIsActive(panel) {
  return document.querySelector(`.tab[data-panel="${panel}"]`)?.classList.contains("is-active") ?? panel === "overview";
}

function activeReportPanel() {
  return document.querySelector(".tab.is-active")?.dataset?.panel || "overview";
}

function dashboardReviewRouteVisible() {
  return document.querySelector("#view-dashboard")?.classList.contains("is-active")
    && document.querySelector("#aircraftDashboardPanel")?.classList.contains("is-active");
}

// --- Trial-promo "engaged viewing" gate --------------------------------------
// Accrue wall-clock time the user spends viewing their OWN uploaded flights on
// the dashboard. Viewing an empty dashboard or the sample/example flight does
// not count. Once it reaches 2 minutes, arm the promo; it then fires on the
// next deliberate UI action. auth-ui.ts owns the eligibility check + the modal
// (it listens for the aeroinsight:trial-promo-armed event).
const TRIAL_PROMO_VIEW_MS_REQUIRED = 2 * 60 * 1000;
let trialPromoViewedMs = 0;
let trialPromoLastTickAt = 0;
let trialPromoArmed = false;
let trialPromoDispatched = false;

function trialPromoViewingOwnFlight() {
  if (typeof document !== "undefined" && document.visibilityState === "hidden") return false;
  if (!dashboardReviewRouteVisible()) return false;
  const flight = selectedFlight;
  if (!flight?.database?.flightId) return false;             // real, persisted upload only
  if (isExampleAircraftOption(flight.aircraft)) return false; // never the sample flight
  return true;
}

function trialPromoTick() {
  if (trialPromoDispatched) return;
  const now = Date.now();
  if (trialPromoViewingOwnFlight()) {
    if (trialPromoLastTickAt) trialPromoViewedMs += now - trialPromoLastTickAt;
    trialPromoLastTickAt = now;
    if (trialPromoViewedMs >= TRIAL_PROMO_VIEW_MS_REQUIRED) trialPromoArmed = true;
  } else {
    trialPromoLastTickAt = 0; // pause accrual while not actively viewing
  }
}

function trialPromoMaybeFireOnAction() {
  trialPromoTick();
  if (trialPromoArmed && !trialPromoDispatched) {
    trialPromoDispatched = true;
    try { window.dispatchEvent(new CustomEvent("aeroinsight:trial-promo-armed")); } catch { /* ignore */ }
  }
}

function startTrialPromoViewGate() {
  // Guard every browser API: app.js is also evaluated in a bare Node vm sandbox
  // (app-safety + several tests) where `window` exists but timers/listeners
  // don't — this must be an inert no-op there, not throw at module load.
  if (typeof window === "undefined" || typeof window.setInterval !== "function") return;
  window.setInterval(trialPromoTick, 1000);
  if (typeof document !== "undefined" && typeof document.addEventListener === "function") {
    document.addEventListener("visibilitychange", trialPromoTick);
  }
  if (typeof window.addEventListener === "function") {
    // "Next UI action" once the 2-minute viewing gate passes.
    ["click", "keydown", "hashchange"].forEach((evt) =>
      window.addEventListener(evt, trialPromoMaybeFireOnAction, true));
  }
}
startTrialPromoViewGate();

function activeOverviewRouteHealthKey(panel = activeReportPanel()) {
  if (panel !== "overview" || selectedOperatingContextKey) return "";
  return selectedHealthKey || "";
}

function flightReviewPanelSupportsChartRouteState(panel = activeReportPanel()) {
  return panel === "overview" || panel === "explorer";
}

function sameRouteStringList(left = [], right = []) {
  return left.length === right.length && left.every((value, index) => value === right[index]);
}

function defaultRouteSeriesKeys() {
  const available = availableSeriesKeys();
  const defaultKeys = [...cylinderKeys("egt"), ...cylinderKeys("cht")]
    .filter((key) => available.includes(key));
  return defaultKeys.length ? defaultKeys : available.slice(0, 5);
}

function activeRouteSeriesKeys() {
  return availableSeriesKeys().filter((key) => activeSeries.has(key));
}

function flightReviewRouteState(panel = activeReportPanel()) {
  // Sensitivity stays a local (per-browser) preference: written URLs never
  // carry it, though incoming links that still have it are honored.
  const state = {};
  if (!flightReviewPanelSupportsChartRouteState(panel)) return state;
  if (chartZoomedIn()) state.zoom = zoomRange;
  const channels = activeRouteSeriesKeys();
  if (!sameRouteStringList(channels, defaultRouteSeriesKeys())) state.channels = channels;
  if (panel === "explorer") state.fit = explorerFitYAxis;
  return state;
}

// replaceState resolves bare "#..." URLs against <base href="/">, which would
// strip the tail-number path segment; always re-anchor on the current path.
function replaceUrlHash(nextHash) {
  window.history.replaceState(null, "", `${window.location.pathname}${window.location.search}${nextHash}`);
}

let lastFlightReviewRouteFlightId = "";
function syncFlightReviewRoute(panel = activeReportPanel()) {
  // Never rewrite the URL in read-only share mode — the /share/<id>#<secret>
  // hash carries the capability secret needed to re-open on reload.
  if (isPublicShareMode()) return;
  if (!selectedFlight?.id || !dashboardReviewRouteVisible()) return;
  const routeFlightId = flightRouteIdForEntry(selectedFlight);
  // Hopping to a DIFFERENT flight is a navigation and earns a history entry;
  // zoom/channel/panel tweaks on the same flight only refresh the current one.
  // commitUrl still folds the push away when a hash assignment in this same
  // interaction (e.g. entering the dashboard) already created the entry.
  const flightChanged = routeFlightId !== lastFlightReviewRouteFlightId;
  lastFlightReviewRouteFlightId = routeFlightId;
  const nextHash = flightReviewRouteHash(routeFlightId, panel, activeOverviewRouteHealthKey(panel), flightReviewRouteState(panel));
  if (!nextHash || window.location.hash === nextHash) return;
  commitUrl(`${window.location.pathname}${window.location.search}${nextHash}`, { push: flightChanged });
}

function trendRouteIdentifierForAircraft(aircraft) {
  const selectedAircraftId = selectedTrendAircraftDatabaseId(aircraft);
  return selectedAircraftId || aircraft || "";
}

function trendRouteVisible() {
  return document.querySelector("#view-aircraft")?.classList.contains("is-active")
    && document.querySelector("#view-trends")?.classList.contains("is-active");
}

function syncTrendRoute(aircraft = selectedTrendAircraft()) {
  if (isPublicShareMode()) return;
  if (!aircraft || !trendRouteVisible()) return;
  const nextHash = trendRouteHash(trendRouteIdentifierForAircraft(aircraft));
  if (!nextHash || window.location.hash === nextHash) return;
  replaceUrlHash(nextHash);
}

function syncSensitivityRoute() {
  if (isPublicShareMode()) return;
  if (dashboardReviewRouteVisible() && selectedFlight?.id) {
    syncFlightReviewRoute(activeReportPanel());
    return;
  }
  if (trendRouteVisible()) {
    syncTrendRoute(selectedTrendAircraft());
  }
}

function selectedFlightMatchesReviewRoute(route) {
  const flightId = String(route?.flightId ?? "").trim();
  if (!flightId || !selectedFlight) return false;
  return selectedFlight.id === flightId || selectedFlight?.database?.flightId === flightId;
}

function applyFlightReviewRouteZoom(route) {
  if (!flightReviewPanelSupportsChartRouteState(route?.panel)) return false;
  const nextZoom = normalizeRouteZoom(route?.zoom);
  if (!nextZoom) return false;
  if (Math.abs(zoomRange.start - nextZoom.start) < 0.000001 && Math.abs(zoomRange.end - nextZoom.end) < 0.000001) return false;
  zoomRange = nextZoom;
  scrubRatio = clamp01((nextZoom.start + nextZoom.end) / 2);
  return true;
}

function applyFlightReviewRouteChannels(route) {
  if (!flightReviewPanelSupportsChartRouteState(route?.panel) || !Object.hasOwn(route ?? {}, "channels")) return false;
  const routeChannels = normalizeRouteChannels(route.channels);
  if (!routeChannels) return false;
  const available = new Set(availableSeriesKeys());
  const channels = routeChannels.filter((key) => available.has(key));
  if (routeChannels.length && !channels.length) return false;
  if (sameRouteStringList(activeRouteSeriesKeys(), channels)) return false;
  activeSeries.clear();
  channels.forEach((key) => activeSeries.add(key));
  // A saved route may predate the unaligned-combo rule (or mix groups): keep
  // whichever unit's group the route favors, silently — no toast on restore.
  enforceUnalignedSeriesExclusivity(activeSeries, unalignedAuxSeriesKeys());
  syncSeriesControls();
  return true;
}

function applyFlightReviewRouteFit(route) {
  if (route?.panel !== "explorer" || !Object.hasOwn(route ?? {}, "fit")) return false;
  const next = normalizeRouteFit(route.fit);
  if (next === null || next === explorerFitYAxis) return false;
  explorerFitYAxis = next;
  syncExplorerFitYControls();
  return true;
}

function applyFlightReviewRouteChartState(route) {
  if (!selectedFlightMatchesReviewRoute(route)) return false;
  const zoomChanged = applyFlightReviewRouteZoom(route);
  const channelsChanged = applyFlightReviewRouteChannels(route);
  const fitChanged = applyFlightReviewRouteFit(route);
  const changed = zoomChanged || channelsChanged || fitChanged;
  if (changed) scheduleDrawAll();
  return changed;
}

function applyFlightReviewRouteFocus(route) {
  if (route?.panel === "overview") {
    const routeHealthKey = normalizeOverviewHealthCardRouteKey(route?.overviewHealthKey);
    const nextHealthKey = routeHealthKey && routeHealthKey !== "overall" ? routeHealthKey : null;
    overviewSelectionCleared = false;
    selectedHealthKey = nextHealthKey;
    selectedOperatingContextKey = null;
    selectedOperatingContextWindows = [];
    selectCompanionSeriesForHealthCard(selectedHealthKey);
    if (healthSummary && selectedFlightMatchesReviewRoute(route)) {
      preserveScrollDuring(() => renderHealthSummary(healthSummary));
      scheduleDrawAll();
    }
  }
  applyFlightReviewRouteChartState(route);
}

function showFlightReviewRouteError(route, error = null) {
  const flightId = String(route?.flightId ?? route ?? "").trim();
  const baseMessage = flightId
    ? `Flight link unavailable: ${flightId}`
    : "Flight link unavailable";
  const detail = error?.message ? ` (${error.message})` : "";
  const routeError = new Error(`${baseMessage}. The flight could not be found or is not available to this account.${detail}`);
  clearLoadedFlight(routeError);
  applyEmptyAircraftDashboardState("", {
    title: "Flight link unavailable",
    copy: "The linked flight could not be found or is not available to this account.",
    hideAction: true,
  });
}

// Shareable flight route id: the human-readable date slug when the entry has
// one (unique within its aircraft; a short id suffix breaks rare collisions),
// otherwise the raw flight id.
function flightRouteIdForEntry(entry) {
  const slug = flightRouteSlug(entry);
  if (!slug) return entry?.id ?? "";
  const twins = flightManifest.filter((other) => other.aircraft === entry.aircraft && flightRouteSlug(other) === slug);
  if (twins.length > 1) return `${slug}-${String(entry.id).slice(0, 6)}`;
  return slug;
}

function findFlightReviewEntry(flightId) {
  const id = String(flightId ?? "").trim();
  if (!id) return null;
  const byId = flightManifest.find((entry) => entry.id === id || entry?.database?.flightId === id);
  if (byId) return byId;
  // Date-slug routes: prefer the active workspace's aircraft, then anywhere,
  // so cross-aircraft same-minute collisions resolve predictably.
  const lower = id.toLowerCase();
  const bySlug = (entries) => entries.find((entry) => flightRouteIdForEntry(entry).toLowerCase() === lower) ?? null;
  return bySlug(flightManifest.filter((entry) => entry.aircraft === selectedAircraftWorkspace()))
    ?? bySlug(flightManifest);
}

function findTrendRouteAircraft(identifier) {
  const id = String(identifier ?? "").trim();
  if (!id) return "";
  return allAircraftOptions().find((aircraft) => aircraft === id)
    ?? visibleFlightEntries().find((entry) => entry?.database?.aircraftId === id)?.aircraft
    ?? "";
}

function applyRouteSensitivity(route) {
  if (!route?.sensitivity) return false;
  const next = normalizeSensitivity(route.sensitivity);
  if (next === detectionSensitivity) return false;
  detectionSensitivity = next;
  renderSensitivityControl(healthSummary);
  return true;
}

function showTrendRouteError(route, error = null) {
  const aircraft = String(route?.aircraft ?? route ?? "").trim();
  const routeError = new Error(error?.message || "The linked aircraft trend could not be found or is not available to this account.");
  renderTrendUnavailableView({
    aircraft,
    reason: "not_found",
    error: routeError,
  });
}

async function activateTrendRoute(route) {
  applyRouteSensitivity(route);
  await ensureAircraftFlightManifestLoaded();
  const aircraft = findTrendRouteAircraft(route?.aircraft);
  if (!aircraft) {
    const requestedHash = trendRouteHash(route?.aircraft, route?.sensitivity);
    await setAircraftPanel("trends");
    if (requestedHash) replaceUrlHash(requestedHash);
    showTrendRouteError(route);
    return;
  }
  setAircraftWorkspaceSelection(aircraft, { render: false });
  await setAircraftPanel("trends");
  syncTrendRoute(aircraft);
}

function renderEnginePanelIfActive() {
  if (document.querySelector("#enginePanel")?.classList.contains("is-active")) renderEnginePanel();
}

function inferInsightPhase(elapsedSeconds, maxElapsed, fuelFlow, egt) {
  const ratio = elapsedSeconds / maxElapsed;
  if (ratio < 0.06) return "Startup";
  if (ratio < 0.15) return "Taxi";
  if (ratio < 0.2) return "Runup";
  if (ratio < 0.24) return "Takeoff";
  if (ratio < 0.42) return "Climb";
  if (ratio < 0.78) return "Cruise";
  if (ratio < 0.9) return "Descent";
  if ((fuelFlow ?? 0) < 1 && (egt ?? 0) < 900) return "Shutdown";
  return "Landing";
}

function availableSeriesKeys() {
  const cache = currentFlightDerivedCache();
  if (cache.availableSeriesKeys) return cache.availableSeriesKeys;
  const order = [
    ...cylinderKeys("egt"),
    ...cylinderKeys("cht"),
    "egt", "cht",
    "fuelFlow1", "fuelFlow2", "fuelFlow", "fuelUsed1", "fuelUsed2", "fuelUsed",
    "rpm1", "rpm2", "rpm", "map1", "map2", "map", "percentPower",
    "powerRopHp", "percentPowerRop", "powerLopHp", "percentPowerLop",
    "oilTemp1", "oilTemp2", "oilTemp", "coolantTemp", "oilPressure1", "oilPressure2", "oilPressure",
    "buss", "amps1", "amps2", "amps", "oat", "carbTemp",
    "tit", "tit1", "tit2", "upperDeckPressure", "fuelPressure", "inductionTemp", "compressorDischargeTemp",
    "ias", "tas", "groundSpeed", "altitude", "verticalSpeed", "pitch", "roll",
  ];
  cache.availableSeriesKeys = order.filter((key) => seriesMeta[key] && hasGraphableSeriesData(flightData, key) && !isRedundantSeriesKey(key, flightData));
  return cache.availableSeriesKeys;
}

function isRedundantSeriesKey(key, data = flightData) {
  if (key === "tit1" && seriesValuesMatch(data, "tit", "tit1")) return true;
  const aggregateKey = aggregateKeyForSingleEngineIndexedChannel(key, currentEngineDescriptors(data));
  if (aggregateKey && seriesValuesMatch(data, aggregateKey, key)) return true;
  return false;
}

function seriesValuesMatch(data, primaryKey, duplicateKey, tolerance = 0.000001) {
  let compared = 0;
  let primaryOnly = 0;
  let duplicateOnly = 0;
  for (const point of data) {
    const primaryValue = point[primaryKey];
    const duplicateValue = point[duplicateKey];
    const hasPrimary = Number.isFinite(primaryValue);
    const hasDuplicate = Number.isFinite(duplicateValue);
    if (hasPrimary && hasDuplicate) {
      compared += 1;
      if (Math.abs(primaryValue - duplicateValue) > tolerance) return false;
    } else if (hasPrimary) {
      primaryOnly += 1;
    } else if (hasDuplicate) {
      duplicateOnly += 1;
    }
  }
  return compared > 0 && primaryOnly === 0 && duplicateOnly === 0;
}

function setDefaultActiveSeries(preferredKeys) {
  const available = new Set(availableSeriesKeys());
  activeSeries.clear();
  preferredKeys.filter((key) => available.has(key)).forEach((key) => activeSeries.add(key));
  if (!activeSeries.size) {
    availableSeriesKeys().slice(0, 5).forEach((key) => activeSeries.add(key));
  }
}

// Marketing/public views were removed; the set is kept empty so existing
// `PUBLIC_VIEWS.has(view)` checks fall through to the normal app paths.
const PUBLIC_VIEWS = new Set();

// Views that render flight data, and therefore need the flight manifest/analysis loaded.
// Public marketing pages and the account screen render without any flight processing.
function viewNeedsFlightData(view) {
  return Boolean(view) && !PUBLIC_VIEWS.has(view) && view !== "account";
}

// loadSampleFlightData() parses + analyzes + renders a default flight, which is heavy and
// runs synchronously once the data arrives. Wrap it so it executes at most once and can be
// triggered lazily on navigation (or preloaded during idle time) instead of blocking the
// initial public page load (e.g. Home).
let flightDataBootstrapPromise = null;
function ensureFlightDataLoaded() {
  if (!flightDataBootstrapPromise) {
    flightDataBootstrapPromise = Promise.resolve()
      .then(() => loadSampleFlightData())
      .then((result) => {
        // Covers both boot-with-session and the post-login first load.
        schedulePrewarmLikelyFlights();
        return result;
      })
      .catch((error) => {
        flightDataBootstrapPromise = null; // allow a later navigation to retry after a failure
        throw error;
      });
  }
  return flightDataBootstrapPromise;
}

async function loadSampleFlightData() {
  try {
    // Bare URL (no hash) also lands on the aircraft workspace — see
    // view-navigation-controller.activateHashView — so route it through the
    // same workspace-only loader so the fleet populates without falling into
    // the sample-flight fallback path.
    const trendRoute = trendRouteFromLocationHash();
    if (trendRoute) {
      applyRouteSensitivity(trendRoute);
      await ensureAircraftFlightManifestLoaded();
      activateHashView();
      drawAll();
      notifyPlaybackDataChanged();
      return;
    }
    const rawHash = window.location.hash.replace(/^#/, "").trim();
    // #account/... and #admin/... are real routes but not FLIGHT routes, and
    // nothing below handles them: the flight-review parse finds no flightId and
    // the function falls through to "load the default flight". That is why
    // reloading on /#account/settings landed on the aircraft flights page
    // instead of the settings tab. Hand these to the hash router, which owns
    // account and admin activation, and stop.
    if (/^(account|admin)(\/|$)/.test(rawHash)) {
      await ensureAircraftFlightManifestLoaded();
      activateHashView();
      drawAll();
      notifyPlaybackDataChanged();
      return;
    }
    if (aircraftPanelFromLocationHash() || !rawHash) {
      await loadAircraftWorkspaceOnly();
      preserveInitialAircraftView();
      drawAll();
      notifyPlaybackDataChanged();
      return;
    }
    const flightReviewRoute = flightReviewRouteFromLocationHash();
    applyRouteSensitivity(flightReviewRoute);
    const defaultFlight = await refreshFlightManifestState(flightReviewRoute?.flightId ?? "");
    if (flightReviewRoute?.flightId) {
      const routeFlight = findFlightReviewEntry(flightReviewRoute.flightId);
      if (!routeFlight) {
        showFlightReviewRouteError(flightReviewRoute);
        return;
      }
      await loadFlightLog(routeFlight, { preserveRoute: true, activateTrial: true });
      populateTrendAircraftSelect(routeFlight.aircraft);
      activateHashView();
      return;
    }
    if (!defaultFlight) throw new Error("No supported flight logs found");
    await loadFlightLog(defaultFlight, { markSeen: false });
    populateTrendAircraftSelect(defaultFlight.aircraft);
  } catch (error) {
    try {
      const response = await fetch(fallbackDataPath);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const rows = parseCsv(await response.text());
      sourceRows = rows.length;
      sourceRawRows = rows.length;
      sourceName = "Sample flight (synthetic Garmin-style log)";
      sourceMonitor = "Generated Garmin-style sample";
      selectedFlight = null;
      resetGeneratedReport();
      clearPilotObservationPersistenceState();
      resetPilotObservationSelectionState();
      clearGamiSpecialTestPersistenceState();
      resetGamiSpecialTestSelectionState();
      const trimmed = trimEndpointSamples(mapGarminRows(rows));
      flightData = trimmed.points;
      currentParserMetadata = parserMetadataFromEnvelope(createCanonicalParserEnvelope(flightData, {
        parserId: "generated-garmin-sample",
        parserVersion: "generated-garmin-sample/v1",
        parserConfidence: "Medium",
        parserWarnings: [],
      }));
      endpointTrimInfo = trimmed.info;
      referenceData = makeReferenceData(flightData);
      overviewSelectionCleared = false;
      selectedCylinderNumber = null;
      selectedEngineScope = "aircraft";
      setDefaultActiveSeries([...cylinderKeys("egt"), ...cylinderKeys("cht")]);
      setupSeriesControls();
      // Prime the analysis cache off the main thread before the synchronous
      // render, exactly like flight load and the review-settings reapply: a
      // bare updateHealthSummary() here ran the full detector pass on the
      // main thread for the generated sample (the one remaining sync path).
      // The {id:""} stub resolves every rawAnalysisSignature field identically
      // to the selectedFlight=null sync lookup below (id "", aircraft via
      // selectedAircraftWorkspace(), parser via currentParserMetadata), so the
      // sync pass lands a tier-1 hit — and later tile interactions hit too.
      // With no worker (unit harnesses, old browsers) the primes no-op and the
      // sync pass runs exactly as before.
      await primeRawAnalysisCacheFromStore({ id: "" }, flightData, currentParserMetadata);
      await primeRawAnalysisCacheFromWorker({ id: "" }, flightData, currentParserMetadata);
      updateHealthSummary();
      updateFlightHeader();
      updateDataSourceLabel(true);
      preserveInitialAircraftView();
      drawAll();
      notifyPlaybackDataChanged();
    } catch (fallbackError) {
      updateDataSourceLabel(false, fallbackError);
      preserveInitialAircraftView();
      drawAll();
      notifyPlaybackDataChanged();
    }
  }
  preserveInitialAircraftView();
  if (flightReviewRouteFromLocationHash()) {
    activateHashView();
    return;
  }
  const hashView = viewFromLocationHash();
  if (hashView) activateView(hashView);
}

async function loadAircraftWorkspaceOnly() {
  const response = await fetch(databaseAircraftSummaryEndpoint(), { cache: "no-store" });
  if (!response.ok) throw new Error(`Database aircraft API HTTP ${response.status}`);
  const payload = await response.json();
  databaseAircraftRecords = Array.isArray(payload.aircraft) ? payload.aircraft : [];
  await loadAircraftProfiles();
}

function databaseAircraftSummaryEndpoint(options = {}) {
  return databaseAircraftSummaryEndpointBuilder(databaseAircraftEndpoint, options);
}

function appReadOnlyMode() {
  return Boolean(appConfig?.readOnly || appConfig?.demoMode);
}

async function loadAppConfig() {
  appConfig = await fetchAppConfig(appConfigEndpoint);
  syncReadOnlyUi();
  syncAskGraphFeatureUi();
  syncMaintenanceFeatureUi();
  syncNewUiFeatureUi();
  syncLocalMailShortcut();
  return appConfig;
}

const newUiOptInStorageKey = "aeroInsightNewUiOptIn";

function newUiOptInEnabled() {
  try {
    return localStorage.getItem(newUiOptInStorageKey) === "1";
  } catch {
    return false;
  }
}

function newUiFeatureEnabled() {
  // Public share pages never use the shell, regardless of any opt-in.
  if (appConfig?.publicShare) return false;
  if (appConfig?.newUiEnabled !== false) return true;
  // Site flag off: members can still opt in per browser from My Account.
  return newUiOptInEnabled();
}

// "New UI" flag (Admin -> Site Settings): the redesigned navigation shell.
// body[data-new-ui] drives the CSS swap between the fleet-sidebar shell and
// the old six-tab navigation; renderFleetSidebar() no-ops while the flag is
// off. Default on; the old UI remains as an admin-toggleable fallback until
// the redesign is accepted and the flag is removed.
let newUiOptInWired = false;
function syncNewUiFeatureUi() {
  document.body?.toggleAttribute("data-new-ui", newUiFeatureEnabled());
  // The My Account opt-in section only exists while the site flag is off.
  document.querySelector(".account-newui-optin-panel")
    ?.toggleAttribute("data-newui-optin-hidden", appConfig?.newUiEnabled !== false);
  const optIn = document.querySelector("#accountNewUiOptIn");
  if (optIn) {
    optIn.checked = newUiOptInEnabled();
    if (!newUiOptInWired) {
      newUiOptInWired = true;
      optIn.addEventListener("change", () => {
        try {
          localStorage.setItem(newUiOptInStorageKey, optIn.checked ? "1" : "0");
        } catch {}
        // The two shells wire different chrome at boot; a reload is the
        // clean switch.
        window.location.reload();
      });
    }
  }
  // Re-assert the theme and subscribe to OS changes. The first stamp already
  // happened in the index.html head script (before first paint, so there is no
  // dark flash); this is what keeps a "Match system" user in step when they
  // flip their OS while the tab is open.
  initTheme();
  // Drag-and-drop upload targets. Idempotent per element, so re-binding on
  // every sync is safe and covers the Flights dropzone being re-rendered.
  setupUploadDropzones({
    openUploadDialog: (aircraft) => openUploadDialog(aircraft),
    selectedAircraftWorkspace: () => selectedAircraftWorkspace(),
    showAppToast: (message, tone) => showAppToast(message, tone),
    appReadOnlyMode: () => appReadOnlyMode(),
  });
  // Seed the flights sort from the stored preference. Done here rather than at
  // module scope because imports are not resolved in the VM sandbox that
  // preferences_check evaluates app.js in.
  aircraftFlightsSort = flightSortFromPreference();
  // Account > Settings display controls live in the same account shell, so they
  // are (re)bound whenever it syncs. Binding is idempotent; the selects are
  // re-seeded from storage each time so they cannot drift from what is applied.
  setupDisplayPreferenceControls({
    onRepaint: (controlId) => {
      // The flights table keeps its sort in module state, seeded at boot, so a
      // preference change has to write through to it — otherwise the setting
      // would only take effect on the next reload. Column clicks still override
      // it afterwards; this just moves the baseline.
      if (controlId === "accountFlightOrder") aircraftFlightsSort = flightSortFromPreference();
      renderFleetSidebar();
      renderAircraftWorkspace();
    },
  });
  renderFleetSidebar();
}

// Local-dev mail shortcut: reveal the floating mail icon only when the server
// reports the local Mailpit inbox URL (loopback SMTP host). Clicking opens the
// inbox in a new tab.
function syncLocalMailShortcut() {
  const fab = document.getElementById("localMailFab");
  if (!fab) return;
  const url = typeof appConfig?.localMailUiUrl === "string" ? appConfig.localMailUiUrl : "";
  fab.hidden = !url;
  fab.onclick = url ? () => { window.open(url, "_blank", "noopener"); } : null;
}

function syncMaintenanceFeatureUi() {
  document.body?.toggleAttribute("data-maintenance-enabled", appConfig?.maintenanceEnabled === true);
  maintenanceContext.refresh();
  // If the Maintenance tab is already active when the config resolves (e.g.
  // direct #maintenance navigation), re-render so the gate applies without a
  // tab switch.
  if (selectedAircraftPanel === "maintenance") {
    renderAircraftMaintenancePanel(selectedAircraftWorkspace());
  }
}

function syncReadOnlyUi() {
  const readOnly = appReadOnlyMode();
  document.body?.classList.toggle("is-demo-mode", readOnly);
  document.body?.toggleAttribute("data-read-only", readOnly);
  document.querySelectorAll("[data-demo-mode-note]").forEach((element) => {
    element.hidden = !readOnly;
  });
  document.querySelectorAll("[data-readonly-hidden]").forEach((element) => {
    element.hidden = readOnly;
  });
  document.querySelectorAll([
    "[data-readonly-disabled]",
    "#action-remove-flight",
    "#aircraftUploadButton",
    "#uploadChooseFilesButton",
    "#uploadChooseFolderButton",
    "#uploadFileInput",
    "#uploadFolderInput",
    "#uploadIncludeShortFlights",
    "#uploadDialogSubmit",
    "[data-upload-process-short]",
    "#dashboardEmptyAircraftUpload",
    "#aircraftHeaderAddButton",
    "#aircraftEditDialogSave",
    "#aircraftEditDialogDelete",
    "#aircraftReviewSettingsReset",
    "#aircraftReviewSettingsSave",
    "[data-aircraft-archive]",
    "[data-aircraft-flight-archive]",
    "[data-upload-reprocess]",
  ].join(",")).forEach((element) => {
    element.disabled = readOnly;
    element.toggleAttribute("aria-disabled", readOnly);
    element.toggleAttribute("data-demo-locked", readOnly);
    if (readOnly && !element.dataset.readonlyOriginalTitle) {
      element.dataset.readonlyOriginalTitle = element.getAttribute("title") ?? "";
      element.setAttribute("title", readOnlyActionMessage());
    } else if (!readOnly && element.dataset.readonlyOriginalTitle !== undefined) {
      const original = element.dataset.readonlyOriginalTitle;
      if (original) element.setAttribute("title", original);
      else element.removeAttribute("title");
      delete element.dataset.readonlyOriginalTitle;
    }
  });
}

function readOnlyActionMessage(action = "This action") {
  return `${action} is disabled in demo mode.`;
}

function readOnlyPreviewMessage() {
  return "Demo mode is read-only. You can preview this workflow, but uploads, deletes, and saved changes are unavailable in demo mode.";
}

function flightSelectableForReview(entry) {
  return isSupportedFlight(entry) && flightReadyToView(entry) && entry?.database?.planAccess?.locked !== true;
}

function preserveInitialAircraftView() {
  const hashPanel = aircraftPanelFromLocationHash();
  if (hashPanel && hashPanel !== "profile") {
    if (hashPanel !== "dashboard") activateAircraftWorkspaceShell();
    setAircraftPanel(hashPanel).catch((error) => updateDataSourceLabel(false, error));
    return;
  }
  if (hashPanel || document.querySelector("#view-aircraft")?.classList.contains("is-active")) {
    activateView("aircraft");
  }
}

async function refreshFlightManifestState(preferredFlightId = "", preferredPath = "") {
  const databaseManifest = await loadDatabaseFlightManifest();
  databaseAircraftRecords = databaseManifest.aircraft;
  flightManifest = databaseManifest.flights;
  aircraftFlightManifestReady = true;
  prefetchDashboardFlightEnvelope();
  await Promise.all([
    loadAircraftProfiles({ force: true }),
    loadValvePatternSummary(),
  ]);
  await backfillMissingAircraftMonitorProfiles();
  const savedFlightId = !preferredFlightId && !preferredPath ? selectedFlightStorageId : "";
  const preferred = preferredFlightId
    ? flightManifest.find((entry) => entry.id === preferredFlightId && flightSelectableForReview(entry))
    : null;
  const preferredByPath = !preferred && preferredPath
    ? [...flightManifest].reverse().find((entry) => flightMatchesSourcePath(entry, preferredPath) && flightSelectableForReview(entry))
    : null;
  const savedFlight = !preferred && !preferredByPath && savedFlightId
    ? flightManifest.find((entry) => entry.id === savedFlightId && flightSelectableForReview(entry))
    : null;
  const defaultFlight = preferred
    ?? preferredByPath
    ?? savedFlight
    ?? flightManifest.find((entry) => entry.path === sampleDataPath && flightReadyToView(entry))
    ?? flightManifest.find((entry) => flightSelectableForReview(entry))
    ?? null;
  setupFlightLogSelector(defaultFlight?.id);
  if (defaultFlight?.aircraft) populateTrendAircraftSelect(defaultFlight.aircraft);
  return defaultFlight;
}

async function loadDatabaseFlightManifest() {
  return loadDatabaseFlightManifestModel();
}

async function ensureAircraftFlightManifestLoaded() {
  if (aircraftFlightManifestReady) return;
  if (!aircraftFlightManifestLoadPromise) {
    aircraftFlightManifestLoadPromise = refreshFlightManifestState(selectedFlight?.id ?? "")
      .finally(() => {
        aircraftFlightManifestLoadPromise = null;
      });
  }
  await aircraftFlightManifestLoadPromise;
}

function databaseAircraftProfilesMap() {
  return databaseAircraftProfilesMapModel(databaseAircraftRecords);
}

function inferredMonitorForAircraftFlights(aircraft) {
  const flights = aircraftFlightsFromMap(visibleFlightEntriesByAircraft(), aircraft);
  for (const flight of flights) {
    const monitor = supportedMonitorFromLabel(flight?.monitor) ?? supportedMonitorFromParser(flight?.parser);
    if (monitor?.make || monitor?.model) return monitor;
  }
  return null;
}

async function backfillMissingAircraftMonitorProfiles() {
  if (appReadOnlyMode()) return;
  if (!databaseAircraftRecords.length || !flightManifest.length) return;
  const updates = [];
  for (const record of databaseAircraftRecords) {
    if (profileValue(record.monitor_make) && profileValue(record.monitor_model)) continue;
    const aircraft = databaseAircraftLabel(record);
    const inferred = inferredMonitorForAircraftFlights(aircraft);
    if (!inferred?.make && !inferred?.model) continue;
    const nextMake = profileValue(record.monitor_make) ?? profileValue(inferred.make);
    const nextModel = profileValue(record.monitor_model) ?? profileValue(inferred.model);
    if (!nextMake && !nextModel) continue;
    updates.push({
      ...databaseAircraftToProfile(record),
      monitor: {
        ...(databaseAircraftToProfile(record).monitor ?? {}),
        make: nextMake,
        model: nextModel,
        type: supportedMonitorLabel({ make: nextMake, model: nextModel }) || null,
        installations: nextModel ? [{ make: nextMake, model: nextModel }] : [],
      },
    });
  }
  for (const profile of updates) {
    try {
      await saveAircraftProfileToDatabase(profile);
    } catch (error) {
      console.warn(`Could not backfill monitor profile for ${profile.tailNumber}: ${error.message}`);
    }
  }
}

function aircraftFleetSortIndex(aircraft) {
  return aircraftFleetSortIndexModel(aircraft, {
    databaseAircraftRecords,
    localAircraftProfiles,
  });
}

async function loadAircraftProfiles({ force = false } = {}) {
  try {
    if (force || !databaseAircraftRecords.length) {
      // Photos arrive as photoUrl descriptors in the summary; the inline
      // photos=1 variant is multi-MB and no longer requested.
      databaseAircraftRecords = await fetchDatabaseAircraftSummary(databaseAircraftEndpoint);
    }
    aircraftProfiles = databaseAircraftProfilesMap();
  } catch {
    aircraftProfiles = databaseAircraftProfilesMap();
  }
}

function loadLocalAircraftProfiles() {
  return loadLocalAircraftProfilesModel();
}

function saveLocalAircraftProfiles() {
  saveLocalAircraftProfilesModel(localAircraftProfiles);
}

function reconcileAircraftLabelReferences(options) {
  options = options ?? {};
  const {
    previousAircraft = "",
    nextAircraft = "",
    databaseAircraftId = "",
  } = options;
  const previous = String(previousAircraft ?? "").trim();
  const next = String(nextAircraft ?? "").trim();
  const databaseId = String(databaseAircraftId ?? "").trim();
  if (!next || (!previous && !databaseId)) return;
  const shouldRenameEntry = (entry) => {
    if (!entry) return false;
    if (databaseId) return String(entry?.database?.aircraftId ?? "").trim() === databaseId;
    return Boolean(previous && entry.aircraft === previous);
  };
  flightManifest = flightManifest.map((entry) => (
    shouldRenameEntry(entry) && entry.aircraft !== next
      ? { ...entry, aircraft: next }
      : entry
  ));
  if (shouldRenameEntry(selectedFlight) && selectedFlight.aircraft !== next) {
    selectedFlight = { ...selectedFlight, aircraft: next };
  }
}

function upsertAircraftProfile(profile, options) {
  if (!profile?.tailNumber) return;
  options = options ?? {};
  const { previousTail = "" } = options;
  const previous = String(previousTail ?? "").trim().toUpperCase();
  const nextLocalAircraftProfiles = { ...localAircraftProfiles };
  const nextAircraftProfiles = { ...aircraftProfiles };
  if (previous && previous !== profile.tailNumber) {
    delete nextLocalAircraftProfiles[previous];
    delete nextAircraftProfiles[previous];
  }
  nextLocalAircraftProfiles[profile.tailNumber] = profile;
  nextAircraftProfiles[profile.tailNumber] = profile;
  reconcileAircraftLabelReferences({
    previousAircraft: previous,
    nextAircraft: profile.tailNumber,
  });
  localAircraftProfiles = {
    ...nextLocalAircraftProfiles,
  };
  aircraftProfiles = {
    ...nextAircraftProfiles,
  };
  saveLocalAircraftProfiles();
}

function deleteLocalAircraftProfile(aircraft) {
  if (!aircraft) return;
  const { [aircraft]: _removed, ...remainingLocalProfiles } = localAircraftProfiles;
  const { [aircraft]: _removedProfile, ...remainingProfiles } = aircraftProfiles;
  localAircraftProfiles = remainingLocalProfiles;
  aircraftProfiles = remainingProfiles;
  saveLocalAircraftProfiles();
}

async function loadValvePatternSummary() {
  try {
    const response = await fetch(valvePatternSummaryPath);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    valvePatternSummary = await response.json();
  } catch {
    valvePatternSummary = null;
  }
}

function visibleFlightEntries() {
  return visibleFlightEntriesModel(flightManifest, { hiddenFlightIds });
}

function visibleFlightEntriesByAircraft() {
  return visibleFlightEntriesByAircraftModel(flightManifest, { hiddenFlightIds, trendDateValue });
}

function aircraftOptionsForUpload() {
  return allAircraftOptions();
}

function allAircraftOptions() {
  return allAircraftOptionsFromFlightMap(visibleFlightEntriesByAircraft());
}

function isExampleAircraftOption(aircraft) {
  return /^_EXAMPLE_/i.test(String(aircraft ?? ""));
}

function allAircraftOptionsFromFlightMap(entriesByAircraft) {
  const names = new Set();
  databaseAircraftRecords.map(databaseAircraftLabel).filter(Boolean).forEach((aircraft) => {
    if (!isExampleAircraftOption(aircraft)) names.add(aircraft);
  });
  entriesByAircraft.forEach((entries, aircraft) => {
    if (aircraft && !isExampleAircraftOption(aircraft)) names.add(aircraft);
  });
  Object.entries(aircraftProfiles ?? {}).forEach(([aircraft, profile]) => {
    if (!aircraft || profile?.profileStatus === "example" || isExampleAircraftOption(aircraft)) return;
    names.add(aircraft);
  });
  if (selectedFlight?.aircraft) names.add(selectedFlight.aircraft);
  return [...names].sort((a, b) => {
    const orderDifference = aircraftFleetSortIndex(a) - aircraftFleetSortIndex(b);
    if (Number.isFinite(orderDifference) && orderDifference !== 0) return orderDifference;
    return a.localeCompare(b, undefined, { sensitivity: "base" });
  });
}

function preferredUploadAircraft() {
  return selectedFlight?.aircraft
    ?? visibleFlightEntries().find((entry) => entry?.aircraft)?.aircraft
    ?? aircraftOptionsForUpload()[0]
    ?? "";
}

let accountAircraftDialogReturnPending = false;
let accountAircraftDialogReturnScroll = { x: 0, y: 0 };

function markAccountAircraftDialogReturn() {
  accountAircraftDialogReturnPending = true;
  accountAircraftDialogReturnScroll = {
    x: window.scrollX || 0,
    y: window.scrollY || 0,
  };
}

function restoreAccountAfterAircraftDialog() {
  if (!accountAircraftDialogReturnPending) return;
  accountAircraftDialogReturnPending = false;
  const returnScroll = { ...accountAircraftDialogReturnScroll };
  activateView("account");
  if (window.location.hash !== "#account") {
    window.location.hash = "account";
  }
  window.scrollTo({ top: returnScroll.y, left: returnScroll.x, behavior: "auto" });
  requestAnimationFrame(() => {
    window.scrollTo({ top: returnScroll.y, left: returnScroll.x, behavior: "auto" });
  });
}

async function accountAircraftRows() {
  await ensureAircraftFlightManifestLoaded();
  const entriesByAircraft = visibleFlightEntriesByAircraft();
  return allAircraftOptionsFromFlightMap(entriesByAircraft).map((aircraft) => {
    const profile = aircraftProfiles?.[aircraft] ?? aircraftProfileForEntry({ aircraft }) ?? null;
    const flights = aircraftFlightsFromMap(entriesByAircraft, aircraft);
    const latestFlight = latestFlightFromAircraftFlights(flights);
    const makeModel = aircraftMakeModelLabel(profile) ?? "Make/model not set";
    const monitor = aircraftFleetRowDetail(profile, flights, latestFlight).monitor;
    const flightCount = flights.length;
    const latestFlightDate = latestFlight ? flightDateLabel(null, latestFlight) : "No flights yet";
    const photoSrc = aircraftPhotoDisplaySrc(aircraftPhotoSource(profile));
    return {
      aircraft,
      label: aircraftDisplayLabel(aircraft),
      makeModel,
      monitor,
      flightCount,
      latestFlightDate,
      photoSrc,
      photoFallbackLabel: aircraftPhotoFallbackLabel(aircraft),
    };
  });
}

function openAccountAircraftEditor(aircraft) {
  if (!aircraft) return;
  if (setAircraftWorkspaceSelection(aircraft, { render: false }) === false) return;
  markAccountAircraftDialogReturn();
  activateView("aircraft");
  if (window.location.hash !== "#aircraft") {
    window.location.hash = "aircraft";
  }
  renderAircraftWorkspace();
  openAircraftEditDialog({ aircraft, focusName: aircraftProfiles?.[aircraft] ? "make" : "tailNumber" });
}

function openAccountAircraftReviewSettings(aircraft) {
  if (!aircraft) return;
  if (setAircraftWorkspaceSelection(aircraft, { render: false }) === false) return;
  markAccountAircraftDialogReturn();
  activateView("aircraft");
  if (window.location.hash !== "#aircraft") {
    window.location.hash = "aircraft";
  }
  renderAircraftWorkspace();
  openAircraftReviewSettingsDialog(aircraft);
}

function staticValveRowsForAircraft(entry) {
  const aircraft = entry?.aircraft;
  if (!aircraft || !valvePatternSummary?.flaggedFlights) return [];
  return Object.entries(valvePatternSummary.flaggedFlights)
    .map(([id, flag]) => {
      const manifestEntry = flightManifest.find((flight) => flight.id === id);
      if ((flag?.aircraft ?? manifestEntry?.aircraft) !== aircraft) return null;
      const cylinder = Number(String(flag?.note ?? "").match(/\bCyl\s+(\d+)\b/i)?.[1]);
      return {
        id,
        aircraft,
        dateValue: manifestEntry ? trendDateValue(manifestEntry, []) : null,
        valveScore: Number.isFinite(flag?.score) ? flag.score : null,
        valveNote: flag?.note ?? "",
        valveCylinder: Number.isFinite(cylinder) ? cylinder : null,
      };
    })
    .filter(Boolean);
}

function refreshLoadedFlightOption(entry, summary) {
  const select = document.querySelector("#flightLogSelect");
  if (!select || !entry || !summary) return;
  const option = [...select.options].find((item) => item.value === entry.id);
  if (!option) return;
  const valve = summary.valve;
  const title = flightDisplayTitle(entry);
  if (Number.isFinite(valve?.score) && valve.score < 88) {
    option.textContent = `${title} - EGT rhythm ${valve.score}: ${valve.note}`;
    option.dataset.valveFlag = "true";
    return;
  }
  option.textContent = `${title}${isSupportedFlight(entry) ? "" : " (unsupported)"}`;
  delete option.dataset.valveFlag;
  renderFlightLogMenu();
}

const dashboardFlightSelectorsBound = new WeakSet();

function setupDashboardFlightSelector(selectedId = selectedFlight?.id ?? lastRequestedFlightId) {
  const select = document.querySelector("#dashboardFlightSelect");
  if (!select) return;
  setupDashboardFlightMenu();

  const aircraft = selectedAircraftWorkspace() || selectedFlight?.aircraft;
  const flights = aircraft
    ? aircraftFlights(aircraft)
    : [];

  if (!aircraft || !flights.length) {
    select.innerHTML = '<option value="">No aircraft flights</option>';
    select.disabled = true;
    renderDashboardFlightMenu();
    return;
  }

  select.disabled = false;
  select.innerHTML = flights.map((entry) => `
    <option value="${escapeHtml(entry.id)}" ${isSupportedFlight(entry) ? "" : "disabled"}>
      ${escapeHtml(dashboardFlightOptionLabel(entry))}
    </option>
  `).join("");

  if (selectedId && [...select.options].some((option) => option.value === selectedId)) {
    select.value = selectedId;
  }
  renderDashboardFlightMenu();

  if (!dashboardFlightSelectorsBound.has(select)) {
    const handleSelection = async () => {
      renderDashboardFlightMenu();
      if (!select.value || select.value === lastRequestedFlightId) return;
      lastRequestedFlightId = select.value;
      const entry = visibleFlightEntries().find((flight) => flight.id === select.value);
      if (entry) {
        try {
          await loadFlightLog(entry, { activateTrial: true });
        } catch (error) {
          updateDataSourceLabel(false, error);
        }
      }
    };
    select.addEventListener("change", handleSelection);
    dashboardFlightSelectorsBound.add(select);
  }
}

const flightLogSelectorsBound = new WeakSet();

function setupFlightLogSelector(selectedId = selectedFlight?.id ?? lastRequestedFlightId) {
  const select = document.querySelector("#flightLogSelect");
  if (!select) return;
  setupFlightLogMenu();
  const groups = new Map();
  const visibleFlights = visibleFlightEntries();
  if (!visibleFlights.length) {
    select.innerHTML = '<option value="">No flight logs visible</option>';
    select.disabled = true;
    renderFlightLogMenu();
    return;
  }
  select.disabled = false;
  visibleFlights.forEach((entry) => {
    if (!groups.has(entry.aircraft)) groups.set(entry.aircraft, []);
    groups.get(entry.aircraft).push(entry);
  });
  select.innerHTML = [...groups.entries()].map(([aircraft, flights]) => `
    <optgroup label="${escapeHtml(aircraftDisplayLabel(aircraft))}">
      ${flights.map((entry) => `
        <option value="${escapeHtml(entry.id)}" ${isSupportedFlight(entry) ? "" : "disabled"} ${valveFlagForFlight(entry, valvePatternSummary) ? 'data-valve-flag="true"' : ""}>
          ${escapeHtml(flightOptionLabel(entry, { valveFlag: valveFlagForFlight(entry, valvePatternSummary) }))}
        </option>
      `).join("")}
    </optgroup>
  `).join("");
  if (selectedId && [...select.options].some((option) => option.value === selectedId)) {
    select.value = selectedId;
  }
  renderFlightLogMenu();
  if (!flightLogSelectorsBound.has(select)) {
    const handleSelection = async () => {
      renderFlightLogMenu();
      if (!select.value || select.value === lastRequestedFlightId) return;
      lastRequestedFlightId = select.value;
      const entry = visibleFlightEntries().find((flight) => flight.id === select.value);
      if (entry) {
        try {
          await loadFlightLog(entry, { activateTrial: true });
        } catch (error) {
          updateDataSourceLabel(false, error);
        }
      }
    };
    select.addEventListener("input", handleSelection);
    select.addEventListener("change", handleSelection);
    flightLogSelectorsBound.add(select);
  }
  setupDashboardFlightSelector(selectedId);
}

function removeFlightEntriesForPath(path) {
  const ids = flightManifest.filter((entry) => entry.path === path).map((entry) => entry.id);
  flightManifest = flightManifest.filter((entry) => entry.path !== path);
  ids.forEach((id) => hiddenFlightIds.delete(id));
  ids.forEach((id) => trendExcludedFlightIds.delete(id));
  ids.forEach((id) => trendIncludedFlightIds.delete(id));
  saveHiddenFlightIds(hiddenFlightIds);
  saveTrendExcludedFlightIds(trendExcludedFlightIds);
  saveTrendIncludedFlightIds(trendIncludedFlightIds);
}

function hideFlightEntry(entry) {
  if (!entry?.id) return;
  hiddenFlightIds.add(entry.id);
  trendExcludedFlightIds.delete(entry.id);
  trendIncludedFlightIds.delete(entry.id);
  saveHiddenFlightIds(hiddenFlightIds);
  saveTrendExcludedFlightIds(trendExcludedFlightIds);
  saveTrendIncludedFlightIds(trendIncludedFlightIds);
}

function trendRowsForPreference(aircraft) {
  if (!aircraft) return [];
  const token = `|${aircraft}|`;
  const cachedRows = [...trendCache.entries()]
    .filter(([key]) => key.includes(token))
    .flatMap(([, rows]) => Array.isArray(rows) ? rows : []);
  if (cachedRows.length) return cachedRows;
  try {
    return Object.keys(localStorage)
      .filter((key) => key.startsWith(trendCacheStoragePrefix))
      .map((storageKey) => {
        const decoded = decodeURIComponent(storageKey.slice(trendCacheStoragePrefix.length));
        if (!decoded.includes(token)) return [];
        const payload = JSON.parse(localStorage.getItem(storageKey) ?? "{}");
        return payload?.version === trendCacheSchemaVersion && Array.isArray(payload?.rows) ? payload.rows : [];
      })
      .flat();
  } catch {
    return [];
  }
}

function trendRowForFlightEntry(entry) {
  if (!entry?.id) return null;
  const titles = new Set([entry.title, entry.displayTitle, flightDisplayTitle(entry)]
    .filter((value) => typeof value === "string" && value.trim()));
  return trendRowsForPreference(entry.aircraft).find((row) => {
    if (!row || typeof row !== "object") return false;
    if (String(row.id ?? "") === String(entry.id)) return true;
    return [row.title, row.displayTitle, row.flightTitle]
      .some((value) => typeof value === "string" && titles.has(value));
  }) ?? null;
}

function flightLooksLikeNoEngineRunTrendRow(row) {
  if (!row || row.error) return false;
  const sampleCount = finiteNumber(row.sampleCount);
  const fuelZeroCount = finiteNumber(row.sensorZeroCount) ?? 0;
  const fuelDropout = row.sensorKey === "fuelFlow"
    && Number.isFinite(sampleCount)
    && sampleCount >= 120
    && fuelZeroCount >= sampleCount * 0.8;
  const peakCht = finiteNumber(row.peakCht) ?? finiteNumber(row.p95Cht);
  const coldCht = Number.isFinite(peakCht) && peakCht < 160;
  return fuelDropout && coldCht;
}

function flightAutoExcludedFromTrendAnalysis(entry) {
  return Boolean(entry?.id)
    && isSupportedFlight(entry)
    && !trendIncludedFlightIds.has(entry.id)
    && flightLooksLikeNoEngineRunTrendRow(trendRowForFlightEntry(entry));
}

// --- Trend flight cap -------------------------------------------------------
// Trends use only the LAST TREND_FLIGHT_CAP flights or TREND_HOURS_CAP_SECONDS
// of flight time (whichever limit is reached first), per aircraft across all
// engines. flightIncludedInTrendAnalysis stays the user-intent layer that drives
// the Flights-page checkboxes / filters / search (include, exclude, auto-exclude).
// flightConsumedByTrends is the capped recency window the trend builder + cache
// key actually consume. The window is automatic: older eligible flights simply
// fall outside it. (TREND_FLIGHT_CAP / TREND_HOURS_CAP_SECONDS / the memo are
// declared earlier, near trendCacheSchemaVersion, so the factory injection can
// read them during module evaluation.)

// The 15-minute floor is a HARD lock, not a preference: it wins even over an explicit include
// (unlike auto-exclude, which a user can re-check), so short flights are non-selectable. The
// flight stays fully usable otherwise — open, re-analyze, PDF, AI summary.
function flightTooShortForTrendAnalysis(entry) {
  const duration = aircraftFlightDurationSecondsFromTrendRows(entry, []);
  return Number.isFinite(duration) && duration < TREND_MIN_DURATION_SECONDS;
}

function flightIncludedInTrendAnalysis(entry) {
  return Boolean(entry?.id)
    && isSupportedFlight(entry)
    && !flightTooShortForTrendAnalysis(entry)
    && (trendIncludedFlightIds.has(entry.id) || (!trendExcludedFlightIds.has(entry.id) && !flightAutoExcludedFromTrendAnalysis(entry)));
}

function trendCapSignature() {
  return `${flightManifest.length}|${hiddenFlightIds.size}|${trendExcludedFlightIds.size}|${trendIncludedFlightIds.size}`;
}

// Manifest-only duration (empty rows arg) keeps the cap independent of trend
// rows, avoiding a cycle through trendCacheKey -> flightConsumedByTrends.
// Flights without a known manifest duration count toward the flight cap but
// contribute 0 to the hours budget.
function trendCapDurationSeconds(entry) {
  const duration = aircraftFlightDurationSecondsFromTrendRows(entry, []);
  return Number.isFinite(duration) ? Math.max(0, duration) : null;
}

// The most-recent included flights that fit within the cap, for one aircraft.
// Always admits at least the single most-recent flight (never an empty Trends
// page, even if one log's duration alone exceeds the hours budget).
function trendCappedFlightSummary(aircraft) {
  if (!aircraft) return { idSet: new Set(), count: 0, seconds: 0, hoursKnown: true, total: 0 };
  const signature = trendCapSignature();
  const cached = trendCappedFlightSummaryMemo.get(aircraft);
  // Upload completion can replace pending entries without changing the count.
  // Recompute on manifest refresh so readiness, dates, and durations stay current.
  if (cached && cached.manifestRef === flightManifest && cached.signature === signature) return cached.value;
  const candidates = visibleFlightEntries()
    .filter((entry) => entry.aircraft === aircraft && flightIncludedInTrendAnalysis(entry))
    .sort(compareAircraftFlightFallback);
  const idSet = new Set();
  let seconds = 0;
  let hoursKnown = true;
  for (const entry of candidates) {
    if (idSet.size >= TREND_FLIGHT_CAP) break;
    const duration = trendCapDurationSeconds(entry);
    const add = Number.isFinite(duration) ? duration : 0;
    if (idSet.size > 0 && seconds + add > TREND_HOURS_CAP_SECONDS) break;
    idSet.add(entry.id);
    seconds += add;
    if (!Number.isFinite(duration)) hoursKnown = false;
  }
  const value = { idSet, count: idSet.size, seconds, hoursKnown, total: candidates.length };
  trendCappedFlightSummaryMemo.set(aircraft, { manifestRef: flightManifest, signature, value });
  return value;
}

// Capped recency-window membership: what the Trends builder actually consumes.
function flightConsumedByTrends(entry) {
  if (!entry?.id) return false;
  return trendCappedFlightSummary(entry.aircraft).idSet.has(entry.id);
}

// Cap a normalized trend-row set (DB-snapshot path) using each row's own date +
// duration, mirroring the entry-level cap so DB-mode trends never exceed it.
function trendRowDurationSeconds(row) {
  const seconds = finiteNumber(row?.durationSeconds);
  if (Number.isFinite(seconds)) return Math.max(0, seconds);
  const minutes = finiteNumber(row?.durationMinutes);
  if (Number.isFinite(minutes)) return Math.max(0, minutes * 60);
  return null;
}

function applyTrendRowCap(rows = []) {
  if (!Array.isArray(rows) || !rows.length) return Array.isArray(rows) ? rows : [];
  const ordered = [...rows].sort((left, right) => {
    const leftDate = finiteNumber(left?.dateValue) ?? 0;
    const rightDate = finiteNumber(right?.dateValue) ?? 0;
    if (rightDate !== leftDate) return rightDate - leftDate;
    return String(left?.id ?? "").localeCompare(String(right?.id ?? ""));
  });
  const keptIds = new Set();
  let seconds = 0;
  for (const row of ordered) {
    if (!row?.id) continue;
    const duration = trendRowDurationSeconds(row);
    // Twin of the entry-level 15-minute floor for the DB-snapshot path: known-short rows are
    // skipped entirely (they don't consume cap slots either).
    if (Number.isFinite(duration) && duration < TREND_MIN_DURATION_SECONDS) continue;
    if (keptIds.size >= TREND_FLIGHT_CAP) break;
    const add = Number.isFinite(duration) ? duration : 0;
    if (keptIds.size > 0 && seconds + add > TREND_HOURS_CAP_SECONDS) break;
    keptIds.add(row.id);
    seconds += add;
  }
  return rows.filter((row) => row?.id && keptIds.has(row.id));
}

function setFlightTrendAnalysisIncluded(entry, included) {
  if (!entry?.id || !isSupportedFlight(entry)) return;
  if (included && flightTooShortForTrendAnalysis(entry)) return;
  if (included) {
    trendExcludedFlightIds.delete(entry.id);
    if (flightAutoExcludedFromTrendAnalysis(entry)) trendIncludedFlightIds.add(entry.id);
  } else {
    trendExcludedFlightIds.add(entry.id);
    trendIncludedFlightIds.delete(entry.id);
  }
  saveTrendExclusionPreferenceForAircraft(entry.aircraft);
}

function setAircraftFlightsTrendAnalysisIncluded(aircraft, included) {
  const supportedFlights = aircraftFlights(aircraft).filter(isSupportedFlight);
  supportedFlights.forEach((entry) => {
    // Bulk "Include all" must not re-add flights under the 15-minute floor.
    if (included && flightTooShortForTrendAnalysis(entry)) return;
    if (included) {
      trendExcludedFlightIds.delete(entry.id);
      if (flightAutoExcludedFromTrendAnalysis(entry)) trendIncludedFlightIds.add(entry.id);
    } else {
      trendExcludedFlightIds.add(entry.id);
      trendIncludedFlightIds.delete(entry.id);
    }
  });
  saveTrendExclusionPreferenceForAircraft(aircraft);
}

function saveTrendExclusionPreferenceForAircraft(aircraft) {
  trendCappedFlightSummaryMemo.clear();
  saveTrendExcludedFlightIds(trendExcludedFlightIds);
  saveTrendIncludedFlightIds(trendIncludedFlightIds);
  clearTrendRowsForAircraft(aircraft);
  renderAircraftFlightsPanel(aircraft);
  if (selectedAircraftPanel === "trends" || document.querySelector("#view-trends")?.classList.contains("is-active")) {
    renderTrendsForSelection({ force: true });
  }
}

// options.background: hydrate the flight without the full-dashboard loading
// overlay and without clearing an already-shown AI summary. Used when opening a
// cached AI summary, so the summary is readable immediately while the flight's
// data (for inline charts + finding links) loads quietly behind it.
async function loadFlightLog(entry, options = {}) {
  if (!options.preserveTrendReturn) trendReturnContext = null;
  lastRequestedFlightId = entry.id;
  const loadingToken = options.background ? null : setFlightLogLoading(entry);
  let loaded = false;
  let errorMessage = "";
  try {
    const resolvedEntry = await resolveFlightEntryForLoad(entry);
    if (!resolvedEntry) return;
    entry = resolvedEntry;
    lastRequestedFlightId = entry.id;
    // Retired: trials no longer auto-start when a flight is opened. A trial now
    // begins only when the account owner picks a plan (selectAccountPlan). The
    // options.activateTrial flag on call sites is inert and kept only to avoid a
    // wide, unrelated diff. See feature/trial-signup-onboarding-flow.
    await loadFlightLogData(entry, options);
    if (lastRequestedFlightId !== entry.id) return;
    applyEmptyAircraftDashboardState(null);
    loaded = true;
  } catch (error) {
    errorMessage = error?.message || "";
    if (lastRequestedFlightId === entry.id) {
      clearLoadedFlight(`Could not load ${flightDisplayTitle(entry)}: ${error.message}`);
      applyEmptyAircraftDashboardState(null);
    }
    throw error;
  } finally {
    if (!options.background) await clearFlightLogLoading({ token: loadingToken, entry, loaded, message: errorMessage });
    if (lastRequestedFlightId === entry.id) {
      // Overlay has cleared (or never showed): let the AI review panel load its
      // cached summary / hydrate its charts now that flight data is available.
      if (loaded) {
        renderAiSummaryPanel();
        if (!options.background && !options.preserveRoute) syncFlightReviewRoute();
        // Opening a flight's dashboard is what marks it reviewed, clearing its
        // NEW tag and (once the last one goes) the Flights tab dot. Skipped for
        // background prewarms and for automatic opens the user did not ask for
        // (post-upload "opening the newest flight", boot defaults, the
        // replacement picked after a delete) - those pass markSeen: false, so
        // only a deliberate open clears the tag.
        if (!options.background && options.markSeen !== false) markFlightReviewed(entry);
      }
    }
  }
}

function waitForDelay(ms = 0) {
  return new Promise((resolve) => window.setTimeout(resolve, Math.max(0, ms)));
}

function waitForUiFrame(delayMs = 0) {
  return new Promise((resolve) => {
    // requestAnimationFrame never fires while the tab is hidden, so anything awaiting a UI frame
    // (flight loads, the lazy gallery fill) would stall until the tab is next visible. Fall back
    // to a timer so work started in a hidden/occluded tab still completes.
    if (document.visibilityState === "hidden") {
      window.setTimeout(resolve, Math.max(16, delayMs));
      return;
    }
    requestAnimationFrame(() => {
      window.setTimeout(resolve, delayMs);
    });
  });
}

function waitForBrowserIdle(timeout = 1000) {
  return new Promise((resolve) => {
    if (typeof requestIdleCallback === "function") {
      requestIdleCallback(resolve, { timeout });
      return;
    }
    window.setTimeout(resolve, Math.min(timeout, 250));
  });
}

// Background flight prewarm: once the fleet manifest is ready (and again on
// every aircraft switch), warm BOTH load tiers for the flights at the top of
// the rail, in rail order (newest first, exactly what the sidebar lists), so
// the "Loading Flight" overlay is rarely seen:
//   1. the parsed-envelope caches (memory + IndexedDB), and
//   2. the persistent raw-analysis bundle cache, computed in the Web Worker
//      under the same signature the dashboard load looks up.
// Best effort and state-free; one flight at a time, each waiting for browser
// idle first, so real interaction always wins the network and CPU. No
// synchronous analysis fallback here, ever: a prewarm must not block the
// main thread.
const FLIGHT_PREWARM_LIMIT = 6;
let flightPrewarmAircraft = null;

async function prewarmFlightAnalysisBundle(entry, points, aircraft) {
  let parserMetadata = null;
  try {
    parserMetadata = parserMetadataFromEnvelope(await parseFlightEntryEnvelope(entry));
  } catch {
    return;
  }
  // Mirror primeRawAnalysisCacheFromWorker's option recipe so the signature
  // (and with it the persistent cache key) matches what the dashboard's cold
  // load looks up.
  const resolvedOptions = {
    ...healthSummaryOptions(),
    selectedEntry: entry,
    aircraftProfile: aircraftProfileForEntry(entry),
    parserMetadata,
    parserId: parserMetadata?.parserId ?? entry.parser,
    disabledMetricKeys: disabledReviewMonitorKeyList(aircraft),
    coolingRateThresholdFpm: coolingRateTriggerFpm(aircraft),
  };
  const signature = rawAnalysisSignature(aircraft, parserMetadata, resolvedOptions);
  const persistKey = persistentRawAnalysisCacheKey(entry, signature);
  try {
    if (await readCachedRawAnalysisBundle(persistKey)) return;
  } catch {
    // Unreadable cache: fall through and recompute.
  }
  if (!analysisWorkerAvailable()) return;
  const bundle = await computeRawAnalysisBundleInWorker(points, resolvedOptions).catch(() => null);
  if (!bundle) return;
  await writeCachedRawAnalysisBundle(persistKey, rawAnalysisCacheFlightId(entry), bundle).catch(() => {});
}

function schedulePrewarmLikelyFlights() {
  if (isPublicShareMode()) return;
  const aircraft = selectedAircraftWorkspaceId;
  if (!aircraft || flightPrewarmAircraft === aircraft) return;
  flightPrewarmAircraft = aircraft;
  (async () => {
    await waitForBrowserIdle(1500);
    const flights = [...aircraftFlights(aircraft)]
      .filter((entry) => isSupportedFlight(entry))
      .sort(compareAircraftFlightFallback)
      .slice(0, FLIGHT_PREWARM_LIMIT);
    if (!flights.length) {
      // Manifest not ready yet (or empty aircraft): let a later call retry.
      if (flightPrewarmAircraft === aircraft) flightPrewarmAircraft = null;
      return;
    }
    for (const entry of flights) {
      // An aircraft switch hands prewarm ownership to the new run.
      if (flightPrewarmAircraft !== aircraft) return;
      if (selectedFlight?.id === entry.id) continue;
      await waitForBrowserIdle(1000);
      if (flightPrewarmAircraft !== aircraft) return;
      try {
        const points = await parseFlightEntry(entry);
        if (flightPrewarmAircraft !== aircraft) return;
        if (points?.length) await prewarmFlightAnalysisBundle(entry, points, aircraft);
      } catch {
        // Prewarm is best effort; a real open reports its own errors.
      }
    }
  })().catch(() => {});
}

async function loadFlightLogData(entry, options = {}) {
  if (!options.background) setFlightLogLoadingPhase("parse", entry, "Loading the selected flight's engine data.");
  const parsedEnvelope = await perfTime("parseEnvelope", () => parseFlightEntryEnvelope(entry));
  if (lastRequestedFlightId !== entry.id) return;
  const runtimeState = flightRuntimeStateForParsedEnvelope(entry, parsedEnvelope);
  const points = runtimeState.points;
  if (!points.length) throw new Error("No usable engine data in selected log");
  if (!options.background) setFlightLogLoadingPhase("analysis", entry, `${points.length.toLocaleString()} samples loaded. Preparing the flight review.`);
  selectedFlight = entry;
  selectedFlightStorageId = entry.id;
  overviewSelectionCleared = false;
  saveSelectedFlightId(entry.id);
  flightData = points;
  resetOverviewDetectorVisual();
  currentParserMetadata = cloneParserMetadata(runtimeState.parserMetadata);
  sourceRows = runtimeState.sourceRows;
  sourceRawRows = runtimeState.sourceRawRows;
  endpointTrimInfo = runtimeState.endpointTrimInfo;
  sourceName = runtimeState.sourceName;
  sourceMonitor = runtimeState.sourceMonitor;
  referenceData = runtimeState.referenceData;
  flightDerivedCache = runtimeState.derivedCache;
  resetGeneratedReport();
  // A background hydrate (opening a cached AI summary) keeps the summary that's
  // already on screen; a normal load clears any stale summary from the prior flight.
  if (!options.background) aiSummaryState = { flightId: "", status: "idle", payload: null, error: "" };
  resetExplorerAskState();
  selectedCylinderNumber = null;
  selectedEngineScope = "aircraft";
  zoomRange = { start: 0, end: 1 };
  scrubRatio = 0.62;
  resetPilotObservationSelectionState();
  clearPilotObservationPersistenceState();
  resetGamiSpecialTestSelectionState();
  clearGamiSpecialTestPersistenceState();
  setGamiQuestionState({});
  await loadSavedPilotObservations(entry);
  await loadSavedGamiSpecialTests(entry);
  await loadSavedExplorerAskAnswers(entry);
  setDefaultActiveSeries([...cylinderKeys("egt"), ...cylinderKeys("cht")]);
  document.querySelector("#flightLogSelect").value = entry.id;
  if (document.querySelector("#dashboardFlightSelect")) document.querySelector("#dashboardFlightSelect").value = entry.id;
  renderFlightLogMenu();
  renderDashboardFlightMenu();
  setupSeriesControls();
  updateFlightHeader();
  if (!selectedAircraftWorkspaceId && entry?.aircraft) selectedAircraftWorkspaceId = entry.aircraft;
  updateDataSourceLabel(true);
  await perfTime("primeAnalysisCache", () => primeRawAnalysisCacheFromStore(entry, flightData, currentParserMetadata));
  if (lastRequestedFlightId !== entry.id) return;
  // Cold-load fallback: if neither cache tier had the bundle, compute it in a
  // Web Worker so the synchronous render below is a cache hit instead of a
  // ~main-thread-freezing detector pass. No-op (and harmless) on a cache hit
  // or when the worker is unavailable.
  await perfTime("primeAnalysisWorker", () => primeRawAnalysisCacheFromWorker(entry, flightData, currentParserMetadata));
  if (lastRequestedFlightId !== entry.id) return;
  if (!options.background) setFlightLogLoadingPhase("render", entry, "Drawing charts and review cards.");
  await waitForUiFrame();
  perfTimeSync("updateHealthSummary", () => updateHealthSummary());
  refreshLoadedFlightOption(entry, healthSummary);
  // Warm the per-engine scoped bundles off the main thread so selecting Left/
  // Right Engine later is a cache hit, not a multi-second synchronous freeze.
  void primeScopedAnalysisCacheFromWorker(entry, flightData);
  if (selectedAircraftPanel !== "dashboard") {
    perfTimeSync("renderAircraftWorkspace", () => renderAircraftWorkspace());
  }
  if (document.querySelector("#view-trends")?.classList.contains("is-active")) {
    populateTrendAircraftSelect(entry.aircraft);
    renderTrendsForSelection();
  }
  scheduleDrawAll();
  notifyPlaybackDataChanged();
  // Keep the loading state until the scheduled charts have had a frame to draw.
  await waitForUiFrame();
}

function flightLoadingSourceLabel(entry) {
  if (entry?.database || entry?.source === "database") return "Saved flight record";
  const sourcePath = flightSourcePathDisplay(entry);
  const fileName = sourcePath.split(/[\\/]/).filter(Boolean).at(-1) ?? sourcePath;
  return fileName || "Selected log";
}

function flightLoadingMonitorLabel(entry) {
  return displayMonitorLabelForEntry(entry, sourceMonitor)
    || supportedMonitorLabel(supportedMonitorFromParser(entry?.parser ?? entry?.detected_parser))
    || entry?.monitor
    || "Engine monitor";
}

// Fast cache hits avoid a flash. Slower opens show progress, including saved
// flights whose data and review still need to load into the browser.
const flightLoadingShowDelayMs = 150;
const flightLoadingMinimumVisibleMs = 300;
const flightLoadingReadyDwellMs = 100;
const flightLoadingErrorDwellMs = 900;
const flightLoadingFadeMs = 150;
let flightLoadingState = {
  token: 0,
  startedAt: 0,
  shownAt: 0,
  showTimer: 0,
  entry: null,
};

// True while the full-dashboard flight-loading overlay is on screen. The AI
// summary auto-load defers on this so its gauge never stacks with / trails the
// flight loader — it kicks off once the overlay has cleared.
function isFlightOverlayActive() {
  return Boolean(document.querySelector("#view-dashboard")?.classList.contains("is-flight-loading"));
}

function setFlightLogLoadingPhase(phase, entry, detail) {
  const title = document.querySelector("#dashboardLoadingTitle");
  if (title) title.textContent = flightDisplayTitle(entry);
  const detailEl = document.querySelector("#dashboardLoadingDetail");
  if (detailEl) detailEl.textContent = detail || "Preparing the selected flight for review.";
  const aircraft = document.querySelector("#dashboardLoadingAircraft");
  if (aircraft) aircraft.textContent = aircraftDisplayLabel(entry?.aircraft) || "Unknown";
  const monitor = document.querySelector("#dashboardLoadingMonitor");
  if (monitor) monitor.textContent = flightLoadingMonitorLabel(entry);
  const source = document.querySelector("#dashboardLoadingSource");
  if (source) source.textContent = flightLoadingSourceLabel(entry);

  const eyebrow = document.querySelector(".dashboard-loading-copy .eyebrow");
  if (eyebrow) eyebrow.textContent = "Loading Flight";

  const order = ["parse", "analysis", "render"];
  const activeIndex = phase === "ready" ? order.length : Math.max(0, order.indexOf(phase));
  document.querySelectorAll("[data-flight-load-step]").forEach((item) => {
    const stepIndex = order.indexOf(item.dataset.flightLoadStep);
    item.classList.remove("is-error");
    item.classList.toggle("is-active", stepIndex === activeIndex);
    item.classList.toggle("is-complete", stepIndex >= 0 && stepIndex < activeIndex);
  });
}

function setFlightLogLoadingErrorPhase(entry, message) {
  const detailEl = document.querySelector("#dashboardLoadingDetail");
  if (detailEl) {
    detailEl.textContent = message
      ? `Couldn't load this flight — ${message}`
      : "Couldn't load this flight.";
  }
  const eyebrow = document.querySelector(".dashboard-loading-copy .eyebrow");
  if (eyebrow) eyebrow.textContent = "Load failed";
  // Mark whatever step was in flight as the failure point.
  document.querySelectorAll("[data-flight-load-step].is-active").forEach((item) => {
    item.classList.add("is-error");
  });
}

function clearFlightLogLoadingBusy() {
  document.querySelector("#flightLogSelect")?.removeAttribute("aria-busy");
  document.querySelector("#dashboardFlightSelect")?.removeAttribute("aria-busy");
  const view = document.querySelector("#view-dashboard");
  view?.removeAttribute("aria-busy");
  view?.removeAttribute("inert");
}

// Reveal the overlay now, cancelling the pending show timer. Used by the show
// timer itself and to force-surface errors that resolve before the delay.
function showFlightLogLoadingOverlay() {
  if (flightLoadingState.showTimer) {
    window.clearTimeout(flightLoadingState.showTimer);
    flightLoadingState.showTimer = 0;
  }
  if (!flightLoadingState.shownAt) flightLoadingState.shownAt = performance.now();
  document.querySelector("#view-dashboard")?.classList.add("is-flight-loading");
}

function setFlightLogLoading(entry) {
  if (flightLoadingState.showTimer) window.clearTimeout(flightLoadingState.showTimer);
  const token = flightLoadingState.token + 1;
  flightLoadingState = {
    token,
    startedAt: performance.now(),
    shownAt: 0,
    showTimer: 0,
    entry,
  };
  const label = document.querySelector("#dataSourceLabel");
  if (label) label.textContent = `Data Source: loading ${flightDisplayTitle(entry)}...`;
  const rate = document.querySelector("#dataSourceRate");
  if (rate) rate.textContent = "Loading selected flight";
  setFlightLogLoadingPhase("parse", entry, "Loading the selected flight's engine data.");
  document.querySelector("#flightLogSelect")?.setAttribute("aria-busy", "true");
  document.querySelector("#dashboardFlightSelect")?.setAttribute("aria-busy", "true");
  const view = document.querySelector("#view-dashboard");
  view?.setAttribute("aria-busy", "true");
  view?.setAttribute("inert", "");
  view?.classList.remove("is-flight-loading-exiting", "is-flight-loading-error");
  // Block stale flight controls immediately, then reveal progress if needed.
  flightLoadingState.showTimer = window.setTimeout(() => {
    if (flightLoadingState.token !== token) return;
    showFlightLogLoadingOverlay();
  }, flightLoadingShowDelayMs);
  return token;
}

async function clearFlightLogLoading({ token = flightLoadingState.token, entry = flightLoadingState.entry, loaded = true, message = "" } = {}) {
  if (token !== flightLoadingState.token) return;
  const view = document.querySelector("#view-dashboard");

  // Failures must never be silent — surface the overlay even on a fast error.
  if (!loaded) showFlightLogLoadingOverlay();

  // Fast success: the overlay never appeared. Tear down with no dwell/fade/flash.
  if (!flightLoadingState.shownAt) {
    if (flightLoadingState.showTimer) {
      window.clearTimeout(flightLoadingState.showTimer);
      flightLoadingState.showTimer = 0;
    }
    clearFlightLogLoadingBusy();
    view?.classList.remove("is-flight-loading", "is-flight-loading-exiting", "is-flight-loading-error");
    return;
  }

  // Idempotency guard: a second clear (e.g. the setAircraftPanel finally, whose
  // inner loadFlightLog already cleared) finds the overlay gone and no-ops.
  if (!view?.classList.contains("is-flight-loading") || view.classList.contains("is-flight-loading-exiting")) {
    return;
  }

  if (loaded && entry) {
    setFlightLogLoadingPhase("ready", entry, "Dashboard ready.");
  } else if (!loaded) {
    view?.classList.add("is-flight-loading-error");
    setFlightLogLoadingErrorPhase(entry, message);
  }

  const elapsed = performance.now() - flightLoadingState.shownAt;
  const remainingVisibleMs = Math.max(0, flightLoadingMinimumVisibleMs - elapsed);
  await waitForDelay(remainingVisibleMs + (loaded ? flightLoadingReadyDwellMs : flightLoadingErrorDwellMs));
  if (token !== flightLoadingState.token) return;

  view?.classList.add("is-flight-loading-exiting");
  await waitForDelay(flightLoadingFadeMs);
  if (token !== flightLoadingState.token) return;
  clearFlightLogLoadingBusy();
  view?.classList.remove("is-flight-loading", "is-flight-loading-exiting", "is-flight-loading-error");
}

function scheduleRelatedEvidenceRefresh(entry) {
  if (!entry?.aircraft || !isSupportedFlight(entry)) return;
  const cacheKey = trendCacheKey(entry.aircraft);
  if (trendCache.has(cacheKey)) return;
  const token = ++evidenceRequestToken;
  buildAircraftTrends(entry.aircraft).then(() => {
    if (token !== evidenceRequestToken) return;
    if (selectedFlight?.aircraft !== entry.aircraft || !healthSummary) return;
    healthSummary = calculateHealthSummary(flightData, healthSummaryOptions());
    renderHealthSummary(healthSummary);
  }).catch(() => {});
}

function aircraftProfileForEntry(entry) {
  const tailNumber = entry?.aircraft;
  return tailNumber ? aircraftProfiles?.[tailNumber] ?? null : null;
}

function displayMonitorLabelForEntry(entry = selectedFlight, fallbackMonitor = sourceMonitor) {
  const profile = aircraftProfileForEntry(entry);
  return displayMonitorLabel(monitorLabel(profile, entry?.monitor ?? fallbackMonitor));
}

function updateAircraftSidebarCard() {
  const card = document.querySelector(".aircraft-card");
  if (!card) return;

  const activeView = document.querySelector(".nav-item[data-view].is-active")?.dataset.view;
  const aircraft = activeView === "aircraft"
    ? selectedAircraftWorkspace()
    : (selectedFlight?.aircraft ?? emptyAircraftDashboardTail ?? "Sample") || "Sample";
  const profile = aircraft
    ? (aircraftProfileForEntry(activeView === "aircraft" ? { aircraft } : selectedFlight) ?? aircraftProfiles?.[aircraft] ?? null)
    : null;
  const monitor = activeView === "aircraft"
    ? (latestFlightForAircraft(aircraft)?.monitor ?? selectedFlight?.monitor ?? sourceMonitor)
    : (selectedFlight?.monitor ?? sourceMonitor);

  card.querySelector("h2").textContent = aircraft || "Sample";
  const values = card.querySelectorAll("dd");
  if (values[0]) values[0].textContent = aircraftMakeModelLabel(profile) ?? "Unknown";
  if (values[1]) values[1].textContent = displayMonitorLabel(monitorLabel(profile, monitor));
}

function updateFlightHeader() {
  renderCgrTwinSyncAction(selectedFlight, currentParserMetadata, async () => {
    const id = selectedFlight?.database?.flightId;
    await refreshFlightManifestState();
    const next = flightManifest.find(entry => entry.database?.flightId === id);
    if (next) await loadFlightLog(next);
  });
  const first = flightData[0];
  const last = flightData.at(-1);
  const aircraft = selectedFlight?.aircraft ?? "Sample";
  const emptyTail = !selectedFlight ? emptyAircraftDashboardTail : "";
  const title = emptyTail
    ? `${emptyTail} - No flights yet`
    : selectedFlight ? `${aircraft} Flight` : "Sample Flight";
  const timeRange = first && last ? `${formatPointTime(first)} - ${formatPointTime(last)}` : "Loaded flight";
  const dateLabel = flightDateLabel(first, selectedFlight);
  document.querySelector("#page-title").textContent = title;
  document.querySelector(".subhead").textContent = emptyTail
    ? "Upload a flight log to populate the dashboard"
    : `${dateLabel} · ${timeRange}`;
  updateDashboardFlightContext();
  renderAiSummaryPanel();
  setupDashboardFlightSelector(selectedFlight?.id);
  const removeButton = document.querySelector("#action-remove-flight");
  if (removeButton) {
    // The trash button archives the selected flight (nothing is deleted), so its label says so.
    removeButton.disabled = !selectedFlight;
    removeButton.title = !selectedFlight
      ? "No flight selected"
      : "Archive this flight (moves it to the Archive tab in My Account)";
  }
  updateAircraftSidebarCard();
  renderFleetSidebar();
}

function updateDashboardFlightContext() {
  const container = document.querySelector("#dashboardReviewContext");
  if (!container) return;

  const first = flightData[0];
  const last = flightData.at(-1);
  const aircraft = selectedFlight?.aircraft ?? "Sample";
  const monitor = displayMonitorLabelForEntry(selectedFlight, sourceMonitor);
  const title = selectedFlight ? compactFlightOptionLabel(flightDisplayTitle(selectedFlight)) : "Sample flight";
  const dateLabel = flightDateLabel(first, selectedFlight);
  const timeRange = first && last ? `${formatPointTime(first)} - ${formatPointTime(last)}` : "Time unavailable";
  updateTrendReturnControls();

  container.innerHTML = `
    <div class="dashboard-review-primary">
      <span>Reviewing</span>
      <strong>${escapeHtml(title)}</strong>
    </div>
    <dl class="dashboard-review-details">
      <div>
        <dt>Aircraft</dt>
        <dd>${escapeHtml(aircraftDisplayLabel(aircraft))}</dd>
      </div>
      <div>
        <dt>Date</dt>
        <dd>${escapeHtml(dateLabel)}</dd>
      </div>
      <div>
        <dt>Time</dt>
        <dd>${escapeHtml(timeRange)}</dd>
      </div>
      <div>
        <dt>Monitor</dt>
        <dd>${escapeHtml(monitor || "Unknown")}</dd>
      </div>
    </dl>
  `;
}

function reviewSensitivityControlMarkup() {
  return `
    <div class="sensitivity-field" title="Controls how readily review cues are surfaced. Balanced is recommended for normal review.">
      <span class="sensitivity-field-label" id="reviewSensitivityLabel">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M4 7h10" />
          <path d="M18 7h2" />
          <path d="M14 5v4" />
          <path d="M4 17h3" />
          <path d="M11 17h9" />
          <path d="M7 15v4" />
        </svg>
        <span>Sensitivity</span>
      </span>
      <div class="sensitivity-inline review-sensitivity" role="radiogroup" aria-labelledby="reviewSensitivityLabel">
        <button class="sensitivity-option" data-sensitivity="conservative" type="button" role="radio" aria-label="Low sensitivity">Low</button>
        <button class="sensitivity-option" data-sensitivity="balanced" type="button" role="radio">Balanced</button>
        <button class="sensitivity-option" data-sensitivity="sensitive" type="button" role="radio" aria-label="High sensitivity">High</button>
      </div>
    </div>
  `;
}

function selectedDatabaseFlightId(entry = selectedFlight) {
  return String(entry?.database?.flightId ?? "").trim();
}

// AI summary panel support: metadata helpers, graph-spec wrappers, canvas
// drawing, scroll-into-view, work-notice toasts, and progress-indicator
// state. The panel render function and the network loader stay in app.js
// because they mutate global UI state and recursively re-render. All
// deps wrapped in lambdas/getters so binding stays live against the
// hoisted helpers and mutable state.
const {
  aiSummaryAvailableForEntry,
  flightAiSummaryAvailable,
  flightAiSummaryStale,
  maybeLoadCachedAiSummaryForSelectedFlight,
  syncAiSummaryStateWithSelectedFlight,
  updateManifestAiSummaryMetadata,
  aiSummaryGraphSpecsContext,
  aiSummaryAvailableSeries,
  aiSummaryThermalPeerKeys,
  aiSummarySeriesForHealthKey,
  aiSummaryGraphSpec,
  aiSummaryGraphSpecs,
  prepareAiSummaryGraphCanvas,
  drawAiSummaryEvidenceGraph,
  drawAiSummaryGraphs,
  scrollAiSummaryPanelIntoView,
  aiSummaryElapsedLabel,
  aiWorkIconMarkup,
  showAiWorkNotice,
  hideAiWorkNotice,
  aiSummaryWorkActionRef,
  renderAiSummaryWorkIndicator,
  startAiSummaryProgressNotice,
  stopAiSummaryProgressNotice,
  finishAiSummaryProgressNotice,
  updateAiSummaryButtonState,
  aiSummaryLoadingMarkup,
  waitForVisibleAiSummaryPreparingStep,
} = createAiSummaryPanelHelpers({
  getAiSummaryState: () => aiSummaryState,
  setAiSummaryState: (v) => { aiSummaryState = v; },
  getAiSummaryEvidenceExpanded: () => aiSummaryEvidenceExpanded,
  setAiSummaryEvidenceExpanded: (v) => { aiSummaryEvidenceExpanded = v; },
  getSelectedFlight: () => selectedFlight,
  getFlightData: () => flightData,
  getHealthSummary: () => healthSummary,
  getFlightManifest: () => flightManifest,
  escapeHtml: (...args) => escapeHtml(...args),
  selectedDatabaseFlightId: (...args) => selectedDatabaseFlightId(...args),
  reportPanelIsActive: (...args) => reportPanelIsActive(...args),
  activateDashboardAiReviewPanel: (...args) => activateDashboardAiReviewPanel(...args),
  renderAiSummaryPanel: (...args) => renderAiSummaryPanel(...args),
  loadAiSummaryForSelectedFlight: (...args) => loadAiSummaryForSelectedFlight(...args),
  cylinderKeys: (...args) => cylinderKeys(...args),
  availableSeriesKeys: (...args) => availableSeriesKeys(...args),
  calculateHealthSummary: (...args) => calculateHealthSummary(...args),
  detectionWindowsForHealthKey: (...args) => detectionWindowsForHealthKey(...args),
  compactHealthNote: (...args) => compactHealthNote(...args),
  getHealthMetricLabels: () => summaryHealthMetricLabels,
  healthSummaryOptions: (...args) => healthSummaryOptions(...args),
  aiSummaryAvailableSeriesFromContext: (...args) => aiSummaryAvailableSeriesFromContext(...args),
  aiSummaryThermalPeerKeysFromContext: (...args) => aiSummaryThermalPeerKeysFromContext(...args),
  aiSummarySeriesForHealthKeyFromContext: (...args) => aiSummarySeriesForHealthKeyFromContext(...args),
  aiSummaryGraphSpecFromContext: (...args) => aiSummaryGraphSpecFromContext(...args),
  aiSummaryGraphSpecsFromContext: (...args) => aiSummaryGraphSpecsFromContext(...args),
  chartBounds: (...args) => chartBounds(...args),
  seriesMeta,
  colors,
  drawEmptyChartMessage: (...args) => drawEmptyChartMessage(...args),
  drawGrid: (...args) => drawGrid(...args),
  drawSelectedDetectionWindow: (...args) => drawSelectedDetectionWindow(...args),
  drawLine: (...args) => drawLine(...args),
  drawInlineLegend: (...args) => drawInlineLegend(...args),
  drawDetectionWindowLabel: (...args) => drawDetectionWindowLabel(...args),
});

function renderAiSummaryPanel() {
  const panel = document.querySelector("#aiSummaryPanel");
  if (!panel) return;
  syncAiSummaryStateWithSelectedFlight();
  const flightId = selectedDatabaseFlightId();
  const aiReviewActive = reportPanelIsActive("ai-review");
  const visible = Boolean(
    flightId
      && document.querySelector("#view-dashboard")?.classList.contains("is-active")
      && aiReviewActive,
  );
  if (!visible) {
    panel.hidden = true;
    panel.innerHTML = "";
    updateAiSummaryButtonState();
    return;
  }

  panel.hidden = false;
  const summary = aiSummaryPayloadJson(aiSummaryState.payload, healthSummary);
  const loading = aiSummaryState.status === "loading" || aiSummaryState.status === "preparing";
  const error = aiSummaryState.status === "error";
  const idle = aiSummaryState.status === "idle";
  panel.classList.toggle("is-ai-review-intro", idle || loading);
  const available = flightAiSummaryAvailable(selectedFlight) || aiSummaryAvailableForEntry();
  const hasCachedSummary = flightAiSummaryAvailable(selectedFlight);
  if (idle && hasCachedSummary && !isFlightOverlayActive()) {
    void loadAiSummaryForSelectedFlight({ showProgressNotice: false });
    return;
  }
  const isBriefingSummary = summary?.schemaVersion === "flight-ai-summary/v2";
  const graphSpecs = summary && !isBriefingSummary ? aiSummaryGraphSpecs(summary) : {};
  panel.innerHTML = aiSummaryPanelMarkup(aiSummaryPanelModel({
    aiSummaryState,
    aiSummaryEvidenceExpanded,
    aiSummaryAvailableForEntry,
    aiSummaryLoadingMarkup,
    available,
    hasCachedSummary,
    graphSpecs,
    readOnly: appReadOnlyMode(),
    readOnlyActionMessage: (...args) => readOnlyActionMessage(...args),
    summaryContext: healthSummary,
    availableSeriesKeys: isBriefingSummary ? availableSeriesKeys() : null,
  }));
  if (isBriefingSummary) {
    // V2 briefing interactions: review-phase and rail references focus their
    // story card; Open-evidence buttons select the story's series and window
    // in the Graph Explorer via the existing pane machinery.
    panel.querySelectorAll("[data-fb-focus-story]").forEach((ref) => {
      const focus = () => {
        const card = panel.querySelector(`[data-fb-story="${ref.getAttribute("data-fb-focus-story")}"]`);
        if (!card) return;
        card.scrollIntoView({ behavior: "smooth", block: "center" });
        card.focus({ preventScroll: true });
        card.classList.remove("fb-story-flash");
        card.classList.add("fb-story-flash");
        window.setTimeout(() => card.classList.remove("fb-story-flash"), 1600);
      };
      ref.addEventListener("click", focus);
    });
    panel.querySelectorAll("[data-fb-graph-target]").forEach((button) => {
      button.addEventListener("click", () => {
        const descriptor = parseBriefingGraphTarget(button.getAttribute("data-fb-graph-target"));
        if (!descriptor) return;
        const available = new Set(availableSeriesKeys());
        const channels = descriptor.series.filter((key) => available.has(key));
        if (!channels.length) return;
        activeSeries.clear();
        channels.slice(0, 4).forEach((key) => activeSeries.add(key));
        enforceUnalignedSeriesExclusivity(activeSeries, unalignedAuxSeriesKeys());
        overviewSelectionCleared = true;
        selectedHealthKey = null;
        selectedCylinderNumber = null;
        const nextRange = chartZoomRangeForElapsedWindow(descriptor.startTime, descriptor.endTime);
        if (nextRange) {
          zoomRange = nextRange;
          scrubRatio = clamp01((nextRange.start + nextRange.end) / 2);
        }
        selectReportPanel("explorer");
        updateHealthCardSelection();
        scheduleDrawAll();
        scrollFlightChartPanelIntoView();
      });
    });
  }
  panel.querySelectorAll(".ai-summary-disclosure").forEach((details) => {
    const label = details.querySelector("summary b");
    details.addEventListener("toggle", () => {
      if (label) label.textContent = details.open ? "Show less" : "Show more";
      window.requestAnimationFrame(() => drawAiSummaryGraphs(graphSpecs));
    });
  });
  panel.querySelectorAll(".ai-summary-phase-disclosure").forEach((details) => {
    const label = details.querySelector("summary b");
    details.addEventListener("toggle", () => {
      if (label) label.textContent = details.open ? "Hide" : "Show";
    });
  });
  const openAiSummaryHealthKey = (key) => {
    if (!key) return;
    overviewSelectionCleared = false;
    selectedHealthKey = key;
    selectedCylinderNumber = null;
    selectCompanionSeriesForHealthCard(key);
    if (healthSummary) renderHealthSummary(healthSummary);
    selectReportPanel("explorer");
    updateHealthCardSelection();
    scheduleDrawAll();
    scrollFlightChartPanelIntoView();
  };
  const scrollGamiSpecialTestsPanelIntoView = () => {
    const specialPanel = document.querySelector("#explorerSpecialTestsPanel");
    if (!specialPanel) return;
    const scroll = () => {
      const topbarHeight = Math.ceil(document.querySelector(".topbar")?.getBoundingClientRect().height ?? 0);
      const targetTop = window.scrollY + specialPanel.getBoundingClientRect().top - topbarHeight - 10;
      window.scrollTo({ top: Math.max(0, targetTop), left: window.scrollX, behavior: "auto" });
    };
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        scroll();
        window.setTimeout(scroll, 120);
      });
    });
  };
  const openAiSummaryGamiSweep = async () => {
    selectReportPanel("explorer");
    dismissExplorerAskAnnotations({ closePanel: true, render: false });
    renderExplorerAskPanel();
    dismissPilotObservationPanel({ clear: false });
    gamiSpecialTestsState.open = true;
    if (!getSavedGamiSpecialTestResults().length) {
      await loadSavedGamiSpecialTests(selectedFlight);
    }
    const selectedSavedId = getSelectedSavedGamiSpecialTestResultId();
    const selected = selectedSavedId
      ? savedGamiSpecialTestResultById(selectedSavedId)
      : null;
    const saved = selected ?? getSavedGamiSpecialTestResults()[0] ?? null;
    if (saved?.id) {
      selectSavedGamiSpecialTestResult(saved.id);
    } else {
      selectGamiSweepGraphSeries();
      renderGamiSpecialTestsPanel({ syncInputs: true });
      scheduleChartDraw("explorerChart");
    }
    scrollGamiSpecialTestsPanelIntoView();
  };
  panel.querySelectorAll("[data-ai-summary-graph-open]").forEach((button) => {
    button.addEventListener("click", () => {
      openAiSummaryHealthKey(button.dataset.aiSummaryGraphOpen);
    });
  });
  panel.querySelectorAll("[data-ai-summary-health-key]").forEach((row) => {
    row.addEventListener("click", (event) => {
      if (event.target.closest("button, a, summary")) return;
      openAiSummaryHealthKey(row.dataset.aiSummaryHealthKey);
    });
    row.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      openAiSummaryHealthKey(row.dataset.aiSummaryHealthKey);
    });
  });
  panel.querySelectorAll("[data-ai-summary-special-test=\"gami-sweep\"]").forEach((row) => {
    row.addEventListener("click", (event) => {
      if (event.target.closest("button, a, summary")) return;
      void openAiSummaryGamiSweep();
    });
    row.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      void openAiSummaryGamiSweep();
    });
  });
  panel.querySelectorAll("[data-ai-summary-exploratory-open]").forEach((button) => {
    button.addEventListener("click", () => {
      const available = new Set(availableSeriesKeys());
      const channels = String(button.dataset.aiSummaryChannelKeys ?? "")
        .split(/\s+/)
        .filter((key) => available.has(key));
      if (!channels.length) return;
      activeSeries.clear();
      channels.slice(0, 4).forEach((key) => activeSeries.add(key));
      enforceUnalignedSeriesExclusivity(activeSeries, unalignedAuxSeriesKeys());
      const engineId = String(button.dataset.aiSummaryEngineId ?? "").trim();
      if (engineId && currentEngineDescriptors().some((engine) => engine.id === engineId)) selectedEngineScope = engineId;
      overviewSelectionCleared = true;
      selectedHealthKey = null;
      selectedCylinderNumber = null;
      const nextRange = chartZoomRangeForElapsedWindow(
        Number(button.dataset.aiSummaryStartTime),
        Number(button.dataset.aiSummaryEndTime),
      );
      if (nextRange) {
        zoomRange = nextRange;
        scrubRatio = clamp01((nextRange.start + nextRange.end) / 2);
      }
      selectReportPanel("explorer");
      updateHealthCardSelection();
      scheduleDrawAll();
      scrollFlightChartPanelIntoView();
    });
  });
  panel.querySelector("[data-ai-summary-regenerate]")?.addEventListener("click", () => {
    if (appReadOnlyMode()) {
      window.alert(readOnlyActionMessage("Generating AI summaries"));
      syncReadOnlyUi();
      renderAiSummaryPanel();
      return;
    }
    loadAiSummaryForSelectedFlight({ force: true, scrollIntoView: true });
  });
  panel.querySelector("[data-ai-summary-empty-action]")?.addEventListener("click", () => {
    if (appReadOnlyMode()) {
      window.alert(readOnlyActionMessage("Generating AI summaries"));
      syncReadOnlyUi();
      renderAiSummaryPanel();
      return;
    }
    loadAiSummaryForSelectedFlight({ force: true, scrollIntoView: true });
  });
  panel.querySelector("[data-ai-summary-evidence-toggle]")?.addEventListener("click", () => {
    aiSummaryEvidenceExpanded = !aiSummaryEvidenceExpanded;
    renderAiSummaryPanel();
  });
  if (summary && !loading && !error) window.requestAnimationFrame(() => drawAiSummaryGraphs(graphSpecs));
  updateAiSummaryButtonState();
}

function aiRequestLimitInfoFromPayload(payload) {
  if (payload?.reason !== "ai_request_limit") return null;
  const limit = Math.max(0, Math.floor(Number(payload?.limit ?? 0)));
  const current = Math.max(0, Math.floor(Number(payload?.current ?? 0)));
  if (!limit || current < limit) return null;
  return {
    plan: String(payload?.plan ?? "").trim().toLowerCase(),
    limit,
    current,
    packPurchasesEnabled: payload?.packPurchasesEnabled === true,
    purchaseUrl: payload?.packPurchasesEnabled === true
      ? String(payload?.purchaseUrl ?? "/#account/plan")
      : null,
  };
}

// --- Review-cue notes (issue #240) ------------------------------------------
// Owner notes attached to a detector review card, loaded per persisted DB
// flight and rendered at the bottom of each review card by the health-summary
// and operating-context renderers. Editing is gated to persisted DB flights.
// `dirty` tracks cue keys the user edited this session so a slow/racing GET
// cannot clobber a fresh local edit.
let reviewNotesState = { flightId: "", status: "idle", notesByCueKey: new Map(), dirty: new Set() };
let reviewNotePlaceholderForCue = null;

function reviewNotePlaceholder(cueKey) {
  reviewNotePlaceholderForCue ??= createReviewNotePlaceholderPicker();
  return reviewNotePlaceholderForCue(cueKey);
}

function reviewNotesEditableFlightId() {
  if (appReadOnlyMode()) return "";
  return selectedDatabaseFlightId();
}

function reviewNoteBodyForCue(cueKey) {
  const flightId = selectedDatabaseFlightId();
  if (!flightId || reviewNotesState.flightId !== flightId) return "";
  return reviewNotesState.notesByCueKey.get(String(cueKey)) ?? "";
}

// Rendered at the bottom of every review card (see reviewCardHtml /
// operatingContextReviewCardHtml). Returns empty for demo/sample/read-only so
// the note UI only appears where it can actually be saved.
function reviewNoteSectionHtml(cueKey) {
  const flightId = reviewNotesEditableFlightId();
  if (!flightId) return "";
  const key = String(cueKey ?? "");
  if (!key) return "";
  // Only editable once THIS flight's notes have loaded; otherwise the textarea
  // would paint empty over an as-yet-unfetched saved note, and a fast typist
  // could overwrite it before the GET resolves. Render it disabled until ready.
  const loaded = reviewNotesState.flightId === flightId && reviewNotesState.status === "ready";
  const value = loaded ? reviewNoteBodyForCue(key) : "";
  const inputId = `reviewNoteInput-${key.replace(/[^a-zA-Z0-9_-]/g, "-")}`;
  const editorId = `${inputId}-editor`;
  const placeholder = loaded
    ? reviewNotePlaceholder(key)
    : "Loading your note…";
  return `
    <section class="review-note${value ? " has-saved-note" : ""}" data-review-note="${escapeHtml(key)}" data-review-note-mode="${value ? "saved" : "editing"}">
      <div class="review-note-saved" data-review-note-saved="${escapeHtml(key)}"${value ? "" : " hidden"}>
        <div class="review-note-saved-heading">
          <p class="review-note-label">Your note</p>
          <span class="review-note-saved-status" role="status" aria-live="polite"><span aria-hidden="true">✓</span> Saved</span>
        </div>
        <div class="review-note-saved-content">
          <button class="review-note-edit" type="button" data-review-note-edit="${escapeHtml(key)}" aria-label="Edit note" title="Edit note" aria-controls="${escapeHtml(editorId)}"><span class="review-note-edit-pencil" aria-hidden="true">✎</span></button>
          <p class="review-note-body" data-review-note-body="${escapeHtml(key)}">${escapeHtml(value)}</p>
        </div>
      </div>
      <div id="${escapeHtml(editorId)}" class="review-note-editor" data-review-note-editor="${escapeHtml(key)}"${value ? " hidden" : ""}>
        <label class="review-note-label" for="${escapeHtml(inputId)}">Your note</label>
        <p class="review-note-help">Add context in your own words — it is shared with your account and included in the AI summary.</p>
        <textarea id="${escapeHtml(inputId)}" class="review-note-input" data-review-note-input="${escapeHtml(key)}" maxlength="${reviewNoteMaxLength}" rows="4"${loaded ? "" : " disabled"} placeholder="${escapeHtml(placeholder)}">${escapeHtml(value)}</textarea>
        <div class="review-note-footer">
          <span class="review-note-save-state" data-review-note-save-state="${escapeHtml(key)}" role="status" aria-live="polite"></span>
          <span class="review-note-count" data-review-note-count="${escapeHtml(key)}">${reviewNoteMaxLength - value.length}</span>
        </div>
      </div>
    </section>
  `;
}

// True once the selected flight changed out from under an in-flight request,
// so a late-resolving GET for the old flight can bail instead of clobbering the
// now-current flight's state.
function reviewNotesRequestStale(flightId) {
  return selectedDatabaseFlightId() !== flightId || reviewNotesState.flightId !== flightId;
}

async function loadReviewNotesForSelectedFlight() {
  const flightId = selectedDatabaseFlightId();
  if (!flightId) {
    if (reviewNotesState.flightId) reviewNotesState = { flightId: "", status: "idle", notesByCueKey: new Map(), dirty: new Set() };
    return;
  }
  // Skip while a load is in flight or already succeeded; a prior 'error' (or
  // 'idle') is allowed to retry on the next render.
  if (reviewNotesState.flightId === flightId && (reviewNotesState.status === "loading" || reviewNotesState.status === "ready")) return;
  // Carry forward any edits already made for this flight (e.g. during a failed
  // earlier load) so the retry does not lose them.
  const dirty = reviewNotesState.flightId === flightId ? reviewNotesState.dirty : new Set();
  const carried = reviewNotesState.flightId === flightId ? reviewNotesState.notesByCueKey : new Map();
  reviewNotesState = { flightId, status: "loading", notesByCueKey: carried, dirty };
  try {
    const response = await fetch(databaseFlightReviewNotesEndpoint(flightId), { method: "GET", cache: "no-store" });
    if (reviewNotesRequestStale(flightId)) return;
    if (!response.ok) {
      reviewNotesState = { ...reviewNotesState, status: "error" };
      return;
    }
    const payload = await response.json().catch(() => ({}));
    if (reviewNotesRequestStale(flightId)) return;
    const notesByCueKey = new Map();
    for (const note of Array.isArray(payload.reviewNotes) ? payload.reviewNotes : []) {
      const key = String(note?.cueKey ?? "").trim();
      if (key) notesByCueKey.set(key, String(note?.body ?? ""));
    }
    // Keep local edits made during the load window; the server response
    // predates them.
    for (const key of reviewNotesState.dirty) {
      const localValue = reviewNotesState.notesByCueKey.get(key) ?? "";
      if (localValue) notesByCueKey.set(key, localValue);
      else notesByCueKey.delete(key);
    }
    reviewNotesState = { flightId, status: "ready", notesByCueKey, dirty: reviewNotesState.dirty };
    // Don't rebuild the panel out from under a note the user is actively
    // editing (that would drop focus and their cursor).
    const active = document.activeElement;
    const editing = active && typeof active.matches === "function" && active.matches("[data-review-note-input]");
    if (healthSummary && !editing) renderHealthSummary(healthSummary);
  } catch (error) {
    console.error("Review notes request failed", error);
    if (!reviewNotesRequestStale(flightId)) reviewNotesState = { ...reviewNotesState, status: "error" };
  }
}

async function saveReviewNote(cueKey, rawText) {
  const flightId = selectedDatabaseFlightId();
  const key = String(cueKey ?? "").trim();
  if (!flightId || !key || appReadOnlyMode()) return { ok: false };
  // Never persist before this flight's notes have loaded — otherwise `previous`
  // would read empty and a save could overwrite an unfetched saved note. The
  // textarea is rendered disabled until ready, so this is defense-in-depth.
  if (reviewNotesState.flightId !== flightId || reviewNotesState.status !== "ready") return { ok: false };
  const text = String(rawText ?? "").trim().slice(0, reviewNoteMaxLength);
  const previous = reviewNotesState.notesByCueKey.get(key) ?? "";
  if (text === previous) return { ok: true, body: text };
  // Optimistically update the in-memory map so a re-render preserves the edit,
  // and mark the cue dirty so a concurrent GET can't clobber it.
  reviewNotesState.dirty.add(key);
  if (text) reviewNotesState.notesByCueKey.set(key, text);
  else reviewNotesState.notesByCueKey.delete(key);
  const revert = () => {
    if (selectedDatabaseFlightId() !== flightId) return;
    if (previous) reviewNotesState.notesByCueKey.set(key, previous);
    else reviewNotesState.notesByCueKey.delete(key);
  };
  try {
    const endpoint = databaseFlightReviewNotesEndpoint(flightId, key);
    const response = text
      ? await fetch(endpoint, {
        method: "PUT",
        cache: "no-store",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ body: text }),
      })
      : await fetch(endpoint, { method: "DELETE", cache: "no-store" });
    const payload = await response.json().catch(() => ({}));
    if (selectedDatabaseFlightId() !== flightId) return;
    // Deleting a note that never existed (404) is a no-op success to the user.
    if (!response.ok && !(response.status === 404 && !text)) {
      revert();
      window.alert(payload?.error ?? "Could not save the note. Please try again.");
      return { ok: false };
    }
    // A note change rebuilds the evidence packet server-side, so any cached AI
    // summary is now stale. Reflect that only when a summary is already shown.
    if (payload?.aiSummaryStale && aiSummaryState.flightId === flightId && aiSummaryState.status === "ready") {
      void loadAiSummaryForSelectedFlight({ showProgressNotice: false });
    }
    return { ok: true, body: text };
  } catch (error) {
    console.error("Review note save failed", error);
    revert();
    if (selectedDatabaseFlightId() === flightId) window.alert("Could not save the note. Please try again.");
    return { ok: false };
  }
}

async function loadAiSummaryForSelectedFlight({ force = false, scrollIntoView = false, showProgressNotice = true } = {}) {
  const flightId = selectedDatabaseFlightId();
  if (appReadOnlyMode() && force) {
    window.alert(readOnlyActionMessage("Generating AI summaries"));
    syncReadOnlyUi();
    return;
  }
  if (!flightAiSummaryAvailable(selectedFlight) && !aiSummaryAvailableForEntry()) {
    window.alert("Load a persisted flight with a completed analysis run before requesting an AI summary.");
    return;
  }
  if (
    aiSummaryState.flightId === flightId
    && (aiSummaryState.status === "loading" || aiSummaryState.status === "preparing")
  ) {
    return;
  }
  const requestToken = ++aiSummaryRequestToken;
  const entry = selectedFlight;
  const isCurrentRequest = () => requestToken === aiSummaryRequestToken
    && selectedDatabaseFlightId() === flightId && aiSummaryState.flightId === flightId;
  aiSummaryEvidenceExpanded = false;
  aiSummaryState = { flightId, status: "loading", payload: null, error: "" };
  if (showProgressNotice) startAiSummaryProgressNotice(flightId);
  renderAiSummaryPanel();
  if (scrollIntoView) scrollAiSummaryPanelIntoView();
  try {
    const baseUrl = databaseFlightAiSummaryEndpoint(flightId);
    // No user-facing staleness (issue #364 decision 14): always accept a
    // stored summary on GET and render it normally. The stale flag the server
    // may attach is an internal cache-identity signal, not display state.
    let response = await fetch(force ? baseUrl : `${baseUrl}?allowStale=1`, {
      method: force ? "POST" : "GET",
      cache: "no-store",
    });
    let payload = await response.json().catch(() => ({}));
    if (!response.ok) {
      const requestError = new Error(payload?.error ?? `AI summary API HTTP ${response.status}`);
      requestError.payload = payload;
      requestError.status = response.status;
      throw requestError;
    }
    if (!isCurrentRequest()) return;
    updateManifestAiSummaryMetadata(entry, payload.aiSummary, { stale: payload.stale === true });
    aiSummaryState = { flightId, status: "preparing", payload: null, error: "" };
    renderAiSummaryPanel();
    await waitForVisibleAiSummaryPreparingStep();
    if (!isCurrentRequest()) return;
    aiSummaryState = { flightId, status: "ready", payload, error: "" };
    // The summary is on screen: clear the "New" pill for this device.
    if (entry?.database?.aiSummaryId) {
      markAiSummarySeen(entry.id, entry.database.aiSummaryId);
    }
    if (showProgressNotice) finishAiSummaryProgressNotice("ready");
    else stopAiSummaryProgressNotice();
  } catch (error) {
    console.error("AI summary request failed", error);
    if (!isCurrentRequest()) return;
    const errorMessage = aiSummaryErrorMessage(error);
    aiSummaryState = {
      flightId,
      status: "error",
      payload: null,
      error: errorMessage,
      limitInfo: aiRequestLimitInfoFromPayload(error?.payload),
    };
    if (showProgressNotice) finishAiSummaryProgressNotice("error", errorMessage);
    else stopAiSummaryProgressNotice();
  } finally {
    if (isCurrentRequest()) {
      if (entry?.aircraft) renderAircraftFlightsPanel(entry.aircraft);
      renderAiSummaryPanel();
      if (scrollIntoView) scrollAiSummaryPanelIntoView();
    }
  }
}

function aircraftWorkspacePlanLocked(aircraft) {
  return Boolean(aircraft && aircraftProfiles?.[aircraft]?.planAccess?.locked === true);
}

function availableAircraftWorkspaceOptions() {
  const options = allAircraftOptions();
  const available = options.filter((aircraft) => !aircraftWorkspacePlanLocked(aircraft));
  return available.length ? available : options;
}

function selectedAircraftWorkspace() {
  const options = allAircraftOptions();
  if (
    selectedAircraftWorkspaceId
    && options.includes(selectedAircraftWorkspaceId)
    && !aircraftWorkspacePlanLocked(selectedAircraftWorkspaceId)
  ) {
    return selectedAircraftWorkspaceId;
  }
  return availableAircraftWorkspaceOptions()[0] || "";
}

function setAircraftWorkspaceSelection(aircraft, options = {}) {
  const explicit = aircraft && !isExampleAircraftOption(aircraft) && !aircraftWorkspacePlanLocked(aircraft)
    ? aircraft
    : "";
  const next = explicit || availableAircraftWorkspaceOptions()[0] || "";
  const changed = next !== selectedAircraftWorkspaceId;
  if (changed && !confirmMaintenanceAircraftChange(next)) return false;
  selectedAircraftWorkspaceId = next;
  saveSelectedAircraftWorkspaceId(next);
  syncAircraftUrlPathTail();
  if (changed) {
    aircraftFlightsFilters = { query: "", dateRange: "all", flags: "all", trend: "all" };
  }
  if (options.render !== false) renderAircraftWorkspace();
  renderFleetSidebar();
  // Warm the new aircraft's top rail flights in the background.
  schedulePrewarmLikelyFlights();
  // skipDashboardActivation: the fleet-sidebar flight click switches aircraft
  // and then activates the dashboard itself; a second activation here would
  // race it with a concurrent flight load.
  if (selectedAircraftPanel === "dashboard" && options.skipDashboardActivation !== true) {
    activateAircraftDashboardFlight().catch((error) => updateDataSourceLabel(false, error));
  }
  scheduleTrendSnapshotPrefetch(next);
  return true;
}

// Warm the Trends snapshot caches in the background once an aircraft is the
// active workspace, so the first Trends-tab click paints from cache. Deferred
// to browser idle so it never competes with the dashboard flight load; skipped
// on the Trends panel itself, where the real load path owns the fetch.
function scheduleTrendSnapshotPrefetch(aircraft) {
  if (!aircraft) return;
  if (selectedAircraftPanel === "trends") return;
  void waitForBrowserIdle(2000).then(() => {
    if (aircraft !== selectedAircraftWorkspaceId) return;
    if (selectedAircraftPanel === "trends") return;
    return prefetchTrendSnapshot(aircraft);
  }).catch(() => {});
}

function aircraftProfileEditorValues(profile) {
  const normalizedType = normalizedAircraftType(profile?.aircraft?.type, profile);
  const engineCount = Number.isFinite(profile?.engineLayout?.count) ? Number(profile.engineLayout.count) : 1;
  const turbo = profile?.turbo ?? {};
  const operatingLimits = profile?.operatingLimits ?? {};
  const propellerType = profileValue(profile?.propellerType ?? profile?.engine?.propellerType) ?? "";
  return {
    databaseId: profile?.databaseId ?? null,
    tailNumber: profileValue(profile?.tailNumber) ?? "",
    make: profileValue(profile?.aircraft?.make) ?? "",
    model: limitedAircraftModel(profileValue(profile?.aircraft?.model) ?? ""),
    type: normalizedType ?? "",
    engineMake: profileValue(profile?.engine?.make) ?? "",
    engineModel: profileValue(profile?.engine?.model) ?? "",
    fuel: fuelLabel(profile) ?? "",
    monitor: monitorLabel(profile, "") ?? "",
    propellerType: AIRCRAFT_PROPELLER_TYPES.includes(propellerType) ? propellerType : "",
    engineCount: engineCount > 0 ? String(engineCount) : "",
    engineLabelMode: aircraftEngineLabelMode(profile, normalizedType, engineCount),
    cylindersPerEngine: aircraftCylindersPerEngine(profile, engineCount),
    propellers: normalizedPropellerEntries(profile),
    photoDataUrl: aircraftPhotoSource(profile),
    isTurbo: turbo.isTurbo === true,
    maxTitF: Number.isFinite(Number(turbo.maxTitF)) ? String(Number(turbo.maxTitF)) : "",
    maxMapInHg: Number.isFinite(Number(turbo.maxMapInHg)) ? String(Number(turbo.maxMapInHg)) : "",
    oilTempMax: Number(operatingLimits.oilTempMax) > 0 ? String(Number(operatingLimits.oilTempMax)) : "",
    oilPressureMax: Number(operatingLimits.oilPressureMax) > 0 ? String(Number(operatingLimits.oilPressureMax)) : "",
    oilPressureSettings: operatingLimits.oilPressure ?? {},
  };
}

let appToastTimer = null;
let uploadWorkNoticeTimer = null;
let uploadWorkAction = null;

// Manual From/To entry (issue #214). Replace the route cell with a two-field
// inline editor; save posts to /api/flights/:id/route and re-renders.
function editFlightRouteInline(entry, cell) {
  if (!cell || cell.querySelector("[data-aircraft-flight-route-editor]")) return;
  const value = (raw) => escapeHtml(raw ?? "");
  cell.innerHTML = `
    <span class="aircraft-flight-route-editor" data-aircraft-flight-route-editor>
      <input class="aircraft-flight-route-input" data-aircraft-flight-route-origin type="text" maxlength="8" placeholder="From" aria-label="Origin airport ident" value="${value(entry?.origin_ident)}" />
      <span class="aircraft-flight-route-sep" aria-hidden="true">→</span>
      <input class="aircraft-flight-route-input" data-aircraft-flight-route-destination type="text" maxlength="8" placeholder="To" aria-label="Arrival airport ident" value="${value(entry?.destination_ident)}" />
      <button class="aircraft-flight-route-editor-save" data-aircraft-flight-route-save="${value(entry?.id)}" type="button">Save</button>
      <button class="aircraft-flight-route-editor-cancel" data-aircraft-flight-route-cancel="${value(entry?.id)}" type="button" title="Cancel" aria-label="Cancel">✕</button>
    </span>`;
  cell.querySelectorAll("[data-aircraft-flight-route-origin], [data-aircraft-flight-route-destination]").forEach((input) => {
    input.addEventListener("keydown", (keyEvent) => {
      if (keyEvent.key === "Enter") { keyEvent.preventDefault(); cell.querySelector("[data-aircraft-flight-route-save]")?.click(); }
      else if (keyEvent.key === "Escape") { keyEvent.preventDefault(); cell.querySelector("[data-aircraft-flight-route-cancel]")?.click(); }
    });
  });
  const first = cell.querySelector("[data-aircraft-flight-route-origin]");
  first?.focus();
  first?.select?.();
}

async function submitFlightRouteEdit(entry, cell, triggerButton) {
  if (!entry || !cell) return;
  const origin = cell.querySelector("[data-aircraft-flight-route-origin]")?.value ?? "";
  const destination = cell.querySelector("[data-aircraft-flight-route-destination]")?.value ?? "";
  const flightId = entry?.database?.flightId ?? entry?.id;
  if (triggerButton) triggerButton.disabled = true;
  try {
    const response = await fetch(`/api/flights/${encodeURIComponent(flightId)}/route`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ origin, destination }),
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const payload = await response.json();
    const flight = payload?.flight ?? {};
    entry.origin_ident = flight.origin_ident ?? null;
    entry.origin_kind = flight.origin_kind ?? null;
    entry.destination_ident = flight.destination_ident ?? null;
    entry.destination_kind = flight.destination_kind ?? null;
    const unlisted = [payload?.origin, payload?.destination].some((end) => end?.ident && end.inDatabase === false);
    renderAircraftFlightsPanel(entry.aircraft);
    showAppToast(unlisted ? "From/To saved (an ident isn't in the airport database)." : "From/To saved.", unlisted ? "info" : "success");
  } catch (error) {
    if (triggerButton) triggerButton.disabled = false;
    showAppToast(`Could not save From/To: ${error.message}`, "error");
  }
}

function closeFlightRouteEdit(entry) {
  renderAircraftFlightsPanel(entry?.aircraft);
}

// Flight-name editor (Flights table pencil): opens a small modal instead of
// swapping the cell inline — the pencil can live in the Date or the Name cell
// depending on the column layout, and a modal leaves the row untouched while
// editing. Enter saves (form submit), Esc cancels (native dialog cancel).
let flightNameDialogEntry = null;
function editFlightNameInline(entry, _container) {
  const dialog = document.querySelector("#flightNameDialog");
  if (!dialog || typeof dialog.showModal !== "function") return;
  const input = dialog.querySelector("#flightNameDialogInput");
  flightNameDialogEntry = entry;
  if (input) input.value = String(entry?.custom_name ?? "");
  if (dialog.dataset.flightNameDialogBound !== "1") {
    dialog.dataset.flightNameDialogBound = "1";
    dialog.querySelector("#flightNameDialogForm")?.addEventListener("submit", (event) => {
      event.preventDefault();
      const current = flightNameDialogEntry;
      if (current) void submitFlightNameEdit(current, dialog, dialog.querySelector("#flightNameDialogSave"));
    });
    const dismiss = () => {
      flightNameDialogEntry = null;
      if (dialog.open) { try { dialog.close(); } catch { /* ignore */ } }
    };
    dialog.querySelector("#flightNameDialogCancel")?.addEventListener("click", dismiss);
    dialog.querySelector("#flightNameDialogClose")?.addEventListener("click", dismiss);
  }
  try { dialog.showModal(); } catch { /* already open */ }
  input?.focus();
  input?.select?.();
}

async function submitFlightNameEdit(entry, container, triggerButton) {
  if (!entry || !container) return;
  const name = container.querySelector("[data-aircraft-flight-name-input]")?.value ?? "";
  const flightId = entry?.database?.flightId ?? entry?.id;
  if (triggerButton) triggerButton.disabled = true;
  try {
    const response = await fetch(`/api/flights/${encodeURIComponent(flightId)}/name`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name }),
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const payload = await response.json();
    entry.custom_name = payload?.flight?.custom_name ?? null;
    // Modal caller: close the dialog on success. (Inline callers passed the
    // table cell here, which has no close().)
    if (typeof container.close === "function" && container.open) {
      flightNameDialogEntry = null;
      try { container.close(); } catch { /* ignore */ }
    }
    renderAircraftFlightsPanel(entry.aircraft);
    renderFleetSidebar();
    showAppToast(entry.custom_name ? "Flight name saved." : "Flight name cleared.", "success");
  } catch (error) {
    showAppToast(`Could not save flight name: ${error.message}`, "error");
  } finally {
    if (triggerButton) triggerButton.disabled = false;
  }
}

function closeFlightNameEdit(entry) {
  renderAircraftFlightsPanel(entry?.aircraft);
}

function showAppToast(message, statusType = "info") {
  const toast = document.querySelector("#appToast");
  if (!toast) return;
  if (appToastTimer) {
    clearTimeout(appToastTimer);
    appToastTimer = null;
  }
  toast.textContent = message;
  toast.hidden = !message;
  toast.classList.toggle("is-success", statusType === "success");
  toast.classList.toggle("is-error", statusType === "error");
  if (message) {
    appToastTimer = setTimeout(() => {
      toast.hidden = true;
      toast.textContent = "";
      toast.classList.remove("is-success", "is-error");
      appToastTimer = null;
    }, 4200);
  }
}

function uploadWorkIconMarkup(status = "loading") {
  if (status === "ready") {
    return `
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M20 6L9 17l-5-5" />
      </svg>
    `;
  }
  if (status === "error") {
    return `
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M12 8v5" />
        <path d="M12 17h.01" />
        <path d="M10.3 4.6 2.7 18a2 2 0 0 0 1.7 3h15.2a2 2 0 0 0 1.7-3L13.7 4.6a2 2 0 0 0-3.4 0z" />
      </svg>
    `;
  }
  return `
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 3v12" />
      <path d="m7 8 5-5 5 5" />
      <path d="M5 21h14" />
      <path d="M6 17h12" />
    </svg>
  `;
}

function uploadQueueRowStatusClass(status = "") {
  const normalized = String(status || "queued")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return normalized || "queued";
}

let uploadWorkNoticeMinimized = false;
let uploadWorkNoticeLastPayload = null;
// Set when the user closes the notice while the queue is still settling:
// routine progress updates must NOT resurrect it; only a forceOpen render
// (new batch, failure that needs attention) clears the suppression.
let uploadWorkNoticeClosedByUser = false;

function createUploadQueueRowElement(job) {
  const li = document.createElement("li");
  li.dataset.uploadJobId = String(job.id ?? "");
  li.innerHTML = `
    <span class="upload-queue-dot" aria-hidden="true"></span>
    <div class="upload-queue-row-copy">
      <strong></strong>
      <span></span>
      <p hidden></p>
    </div>
    <span class="upload-queue-status"></span>
    <div class="upload-queue-actions" hidden>
      <button type="button" data-upload-work-notice-retry="">Retry</button>
    </div>
  `;
  return li;
}

function patchUploadQueueRowElement(li, job) {
  const statusClass = uploadQueueRowStatusClass(job.status);
  const statusLabel = job.statusLabel || job.status || "Queued";
  const className = `upload-queue-row is-${statusClass}`;
  if (li.className !== className) li.className = className;
  const name = li.querySelector(".upload-queue-row-copy strong");
  const message = li.querySelector(".upload-queue-row-copy > span");
  const errorLine = li.querySelector(".upload-queue-row-copy p");
  const statusBadge = li.querySelector(".upload-queue-status");
  const actions = li.querySelector(".upload-queue-actions");
  const retryButton = actions?.querySelector("[data-upload-work-notice-retry]");
  const nameText = job.fileName || "Upload";
  if (name && name.textContent !== nameText) name.textContent = nameText;
  const messageText = job.message || statusLabel;
  if (message && message.textContent !== messageText) message.textContent = messageText;
  // Skip the error line when it would just repeat the row message
  // ("Failed to fetch" twice in a row helps nobody).
  const errorText = job.error && job.error !== messageText ? job.error : "";
  if (errorLine) {
    errorLine.hidden = !errorText;
    if (errorLine.textContent !== errorText) errorLine.textContent = errorText;
  }
  if (statusBadge && statusBadge.textContent !== statusLabel) statusBadge.textContent = statusLabel;
  if (actions) actions.hidden = statusClass !== "error";
  if (retryButton) retryButton.dataset.uploadWorkNoticeRetry = String(job.id ?? "");
}

// Patch the queue rows in place, keyed by job id. The <ul> and any row that
// persists between updates are never recreated, so the user's scroll
// position — and an in-progress scroll gesture — survive the once-a-second
// refreshes that a running batch produces.
function patchUploadQueueList(list, visibleJobs) {
  list.hidden = visibleJobs.length === 0;
  const existing = new Map();
  for (const li of [...list.children]) existing.set(li.dataset.uploadJobId, li);
  let cursor = list.firstElementChild;
  for (const job of visibleJobs) {
    const key = String(job.id ?? "");
    let li = existing.get(key);
    if (li) {
      existing.delete(key);
    } else {
      li = createUploadQueueRowElement(job);
    }
    if (li === cursor) {
      cursor = cursor.nextElementSibling;
    } else {
      list.insertBefore(li, cursor);
    }
    patchUploadQueueRowElement(li, job);
  }
  for (const leftover of existing.values()) leftover.remove();
}

// The notice renders in one of two skeletons: the full progress window, or a
// minimized bottom-right bar with just overall progress + Show. The skeleton
// is only (re)built when the mode changes; everything else is patched in
// place.
function ensureUploadNoticeSkeleton(notice, mode) {
  if (notice.dataset.uploadNoticeMode === mode) return;
  notice.dataset.uploadNoticeMode = mode;
  notice.dataset.uploadNoticeStatus = "";
  if (mode === "mini") {
    notice.innerHTML = `
      <div class="upload-mini">
        <div class="upload-mini-bar" role="progressbar" aria-label="Upload and analysis progress"><div class="upload-mini-fill"></div></div>
        <span class="upload-mini-label"></span>
      </div>
      <button class="ai-work-notice-action" type="button" data-upload-work-notice-show>Show</button>
      <button class="ai-work-notice-dismiss" type="button" data-upload-work-notice-dismiss aria-label="Close upload progress" hidden>Close</button>
    `;
  } else {
    notice.innerHTML = `
      <span class="ai-work-notice-icon" aria-hidden="true"></span>
      <div class="ai-work-notice-copy">
        <strong></strong>
        <p><span data-upload-notice-message></span><a class="ai-work-notice-link" href="#uploads" hidden></a></p>
      </div>
      <ul class="upload-queue-list" aria-label="Upload queue status" hidden></ul>
      <button class="ai-work-notice-action" type="button" data-upload-work-notice-action hidden></button>
      <button class="ai-work-notice-dismiss" type="button" data-upload-work-notice-dismiss aria-label="Hide this notice — uploads keep running in the background">Hide</button>
    `;
  }
}

function viewingUploadsPanel(targetAircraft = "") {
  if (selectedAircraftPanel !== "uploads") return false;
  if (!document.querySelector("#view-aircraft")?.classList.contains("is-active")) return false;
  // A notice about a DIFFERENT aircraft still has somewhere useful to go, so
  // only treat the uploads panel as "already open" when it is the panel this
  // notice would navigate to. Without the aircraft check, uploading to one
  // aircraft and then opening another aircraft's Uploads tab hid the button
  // even though it was the only way back to the upload in progress.
  if (targetAircraft && selectedAircraftWorkspace() !== targetAircraft) return false;
  return true;
}

async function openUploadWorkPanel(aircraft = "") {
  const targetAircraft = aircraft || selectedAircraftWorkspace();
  if (targetAircraft) setAircraftWorkspaceSelection(targetAircraft, { render: false });
  activateView("aircraft");
  window.location.hash = "uploads";
  await setAircraftPanel("uploads");
}

function showUploadWorkNotice({
  status = "loading",
  title = "",
  message = "",
  linkHref = "",
  linkLabel = "",
  jobs = [],
  actionLabel = "",
  action = null,
  autoDismissMs = 0,
  progress = null,
  working = false,
  forceOpen = false,
} = {}) {
  const notice = document.querySelector("#uploadWorkNotice");
  if (!notice) return;
  if (uploadWorkNoticeTimer) {
    clearTimeout(uploadWorkNoticeTimer);
    uploadWorkNoticeTimer = null;
  }
  uploadWorkAction = typeof action === "function" ? action : null;
  // Remember the latest full payload so Hide/Show can re-render either mode
  // without waiting for the next queue update. autoDismiss is intentionally
  // not replayed.
  uploadWorkNoticeLastPayload = { status, title, message, linkHref, linkLabel, jobs, actionLabel, action, progress, working };
  if (forceOpen) uploadWorkNoticeClosedByUser = false;
  if (uploadWorkNoticeClosedByUser) return;
  const visibleJobs = (Array.isArray(jobs) ? jobs : []).filter(Boolean);
  notice.hidden = !title && !message && !visibleJobs.length;
  notice.classList.toggle("is-ready", status === "ready");
  notice.classList.toggle("is-error", status === "error");
  notice.setAttribute("role", status === "error" ? "alert" : "status");
  const minimized = uploadWorkNoticeMinimized;
  notice.classList.toggle("is-minimized", minimized);
  ensureUploadNoticeSkeleton(notice, minimized ? "mini" : "full");
  if (minimized) {
    notice.classList.remove("has-upload-queue");
    const total = Number(progress?.total ?? 0);
    const settled = Number(progress?.settled ?? 0);
    const uploaded = Number(progress?.uploaded ?? settled);
    const processing = Number(progress?.processing ?? 0);
    const percent = total > 0 ? Math.round((settled / total) * 100) : (working ? 0 : 100);
    const fill = notice.querySelector(".upload-mini-fill");
    if (fill) fill.style.width = `${Math.max(0, Math.min(100, percent))}%`;
    // While files are still being sent, show upload progress. Once every file
    // is on the server, switch the compact copy to analysis progress so a
    // dismissed full notice still leaves an unmistakable "work is ongoing"
    // signal.
    const label = notice.querySelector(".upload-mini-label");
    const labelText = total > 0
      ? processing > 0 && uploaded >= total
        ? `${processing} processing`
        : `${uploaded}/${total} uploaded`
      : (title || "Uploads");
    if (label && label.textContent !== labelText) label.textContent = labelText;
    // While upload or analysis work is running the bar cannot be closed (Hide
    // collapses back here instead); once everything settles it becomes
    // closable.
    const dismiss = notice.querySelector("[data-upload-work-notice-dismiss]");
    if (dismiss) dismiss.hidden = Boolean(working);
  } else {
    notice.classList.toggle("has-upload-queue", visibleJobs.length > 0);
    if (notice.dataset.uploadNoticeStatus !== status) {
      notice.dataset.uploadNoticeStatus = status;
      const icon = notice.querySelector(".ai-work-notice-icon");
      if (icon) icon.innerHTML = uploadWorkIconMarkup(status);
    }
    const titleNode = notice.querySelector(".ai-work-notice-copy strong");
    if (titleNode && titleNode.textContent !== title) titleNode.textContent = title;
    const messageNode = notice.querySelector("[data-upload-notice-message]");
    if (messageNode && messageNode.textContent !== message) messageNode.textContent = message;
    const link = notice.querySelector(".ai-work-notice-link");
    if (link) {
      const showLink = Boolean(linkHref && linkLabel);
      link.hidden = !showLink;
      if (showLink) {
        if (link.getAttribute("href") !== linkHref) link.setAttribute("href", linkHref);
        if (link.textContent !== linkLabel) link.textContent = linkLabel;
      }
    }
    const actionButton = notice.querySelector("[data-upload-work-notice-action]");
    if (actionButton) {
      const showAction = Boolean(actionLabel && uploadWorkAction);
      actionButton.hidden = !showAction;
      if (showAction && actionButton.textContent !== actionLabel) actionButton.textContent = actionLabel;
    }
    const list = notice.querySelector(".upload-queue-list");
    if (list) patchUploadQueueList(list, visibleJobs);
  }
  if (autoDismissMs > 0) {
    uploadWorkNoticeTimer = setTimeout(() => {
      hideUploadWorkNotice();
    }, autoDismissMs);
  }
}

function hideUploadWorkNotice() {
  const notice = document.querySelector("#uploadWorkNotice");
  if (uploadWorkNoticeTimer) {
    clearTimeout(uploadWorkNoticeTimer);
    uploadWorkNoticeTimer = null;
  }
  uploadWorkAction = null;
  uploadWorkNoticeMinimized = false;
  uploadWorkNoticeLastPayload = null;
  if (!notice) return;
  notice.hidden = true;
  notice.innerHTML = "";
  delete notice.dataset.uploadNoticeMode;
  delete notice.dataset.uploadNoticeStatus;
  notice.classList.remove("is-ready", "is-error", "has-upload-queue", "is-minimized");
}

// Hide button: while files are still being uploaded, collapse to the
// minimized bottom-right progress bar (unsent work must stay visible
// somewhere); once every file is on the server, actually close the notice —
// and keep it closed against routine progress updates.
function dismissUploadWorkNotice() {
  const payload = uploadWorkNoticeLastPayload;
  if (payload?.working) {
    uploadWorkNoticeMinimized = true;
    showUploadWorkNotice(payload);
    return;
  }
  const lastPayload = uploadWorkNoticeLastPayload;
  hideUploadWorkNotice();
  uploadWorkNoticeLastPayload = lastPayload;
  uploadWorkNoticeClosedByUser = true;
}

function restoreUploadWorkNotice() {
  uploadWorkNoticeMinimized = false;
  uploadWorkNoticeClosedByUser = false;
  if (uploadWorkNoticeLastPayload) showUploadWorkNotice(uploadWorkNoticeLastPayload);
}

function uploadWorkActionRef() {
  return uploadWorkAction;
}

function showUploadProgressNotice({
  status = "loading",
  title = "Uploading logs",
  message = "",
  linkHref = "",
  linkLabel = "",
  targetAircraft = "",
  autoDismissMs = 0,
  actionLabel = "View uploads",
  jobs = [],
  progress = null,
  working = false,
  forceOpen = false,
  onRetryJob = null,
} = {}) {
  // Suppress the "View uploads" button when the uploads panel is already open —
  // it would just re-open the page the user is looking at. The action callback
  // itself is kept (gated on onRetryJob) so per-job Retry buttons still work.
  const alreadyThere = viewingUploadsPanel(targetAircraft);
  const resolvedActionLabel = alreadyThere ? "" : actionLabel;
  showUploadWorkNotice({
    status,
    title,
    message,
    linkHref: alreadyThere ? "" : linkHref,
    linkLabel: alreadyThere ? "" : linkLabel,
    jobs,
    progress,
    working,
    forceOpen,
    actionLabel: resolvedActionLabel,
    action: resolvedActionLabel || typeof onRetryJob === "function"
      ? (event = {}) => {
        if (event.type === "retry" && typeof onRetryJob === "function") {
          void onRetryJob(event.jobId);
          return;
        }
        void openUploadWorkPanel(targetAircraft);
      }
      : null,
    autoDismissMs,
  });
}

function focusAircraftFormField(fieldId, statusMessage = "") {
  openAircraftEditDialog({ focusName: aircraftEditorNameForFieldId(fieldId) });
  setAircraftFormStatus(statusMessage, "info", document.querySelector("#aircraftEditDialogForm"));
}

// --- Inline dialog mounting (Info / Settings aircraft page tabs) ------------
// The Info and Settings tabs render the existing edit and review-settings
// dialogs inline: the <dialog> element is reparented into the tab's panel and
// shown with the non-modal open attribute. Modal flows (create-aircraft
// wizard, old UI header buttons) unmount the inline state first, so both
// modes share one DOM tree and one set of handlers.
const inlineAircraftDialogHomes = new Map();

function mountAircraftDialogInline(dialogSelector, panelSelector) {
  const dialog = document.querySelector(dialogSelector);
  const panel = document.querySelector(panelSelector);
  if (!dialog || !panel) return null;
  if (dialog.open) dialog.close();
  if (dialog.parentElement !== panel) {
    if (!inlineAircraftDialogHomes.has(dialogSelector)) {
      inlineAircraftDialogHomes.set(dialogSelector, { parent: dialog.parentElement, next: dialog.nextSibling });
    }
    panel.append(dialog);
  }
  dialog.classList.add("is-inline-panel");
  return dialog;
}

function unmountAircraftDialogInline(dialogSelector) {
  const dialog = document.querySelector(dialogSelector);
  if (!dialog?.classList.contains("is-inline-panel")) return;
  dialog.classList.remove("is-inline-panel");
  dialog.removeAttribute("open");
  const home = inlineAircraftDialogHomes.get(dialogSelector);
  if (home?.parent) home.parent.insertBefore(dialog, home.next);
}

function aircraftDialogIsInline(dialogSelector) {
  return Boolean(document.querySelector(dialogSelector)?.classList.contains("is-inline-panel"));
}

// Info tab: field changes autosave after a short debounce.
// The modal Save / Cancel buttons stay hidden here.
let aircraftInfoAutosaveTimer = null;

function scheduleAircraftInfoAutosave() {
  if (!aircraftDialogIsInline("#aircraftEditDialog")) return;
  window.clearTimeout(aircraftInfoAutosaveTimer);
  setAircraftFormStatus("Changes pending...", "info", document.querySelector("#aircraftEditDialogForm"));
  aircraftInfoAutosaveTimer = window.setTimeout(() => {
    saveAircraftEditDialogForm().catch(() => {});
  }, 600);
}

function mountAircraftInfoPanelInline() {
  const dialog = mountAircraftDialogInline("#aircraftEditDialog", "#aircraftInfoPanel");
  const form = document.querySelector("#aircraftEditDialogForm");
  if (!dialog || !form) return;
  const aircraft = selectedAircraftWorkspace();
  const profile = aircraft ? aircraftProfiles?.[aircraft] ?? null : null;
  resetAircraftForm(profile ? { ...profile, tailNumber: aircraft } : aircraft ? { tailNumber: aircraft } : null, form);
  activeAircraftEditorFormId = "aircraftEditDialogForm";
  const title = document.querySelector("#aircraftEditDialogTitle");
  if (title) title.textContent = aircraft ? aircraftDisplayLabel(aircraft) : "Add aircraft";
  if (appReadOnlyMode()) setAircraftFormStatus(readOnlyPreviewMessage(), "info", form);
  syncReadOnlyUi();
  dialog.setAttribute("open", "");
}

// Settings tab: the review monitors form, inline. The module's open function
// detects the is-inline-panel class and uses the open attribute itself.
function mountAircraftSettingsPanelInline() {
  const dialog = mountAircraftDialogInline("#aircraftReviewSettingsDialog", "#aircraftSettingsPanel");
  if (!dialog) return;
  openAircraftReviewSettingsDialog(selectedAircraftWorkspace());
}

function openAircraftEditDialog({ aircraft = selectedAircraftWorkspace(), focusName = "make" } = {}) {
  // A modal open (wizard, old UI) while the form is mounted on the Info tab
  // must reclaim it first; showModal throws on an already-open dialog.
  unmountAircraftDialogInline("#aircraftEditDialog");
  const dialog = document.querySelector("#aircraftEditDialog");
  const form = document.querySelector("#aircraftEditDialogForm");
  if (!dialog || !form) return;
  const profile = aircraft ? aircraftProfiles?.[aircraft] ?? null : null;
  resetAircraftForm(profile ? { ...profile, tailNumber: aircraft } : aircraft ? { tailNumber: aircraft } : null, form);
  activeAircraftEditorFormId = "aircraftEditDialogForm";
  const title = document.querySelector("#aircraftEditDialogTitle");
  if (title) title.textContent = aircraft ? `Edit ${aircraftDisplayLabel(aircraft)}` : "Add aircraft";
  if (appReadOnlyMode()) setAircraftFormStatus(readOnlyPreviewMessage(), "info", form);
  syncReadOnlyUi();
  if (typeof dialog.showModal === "function") {
    dialog.showModal();
  } else {
    dialog.setAttribute("open", "");
  }
  requestAnimationFrame(() => {
    const target = focusName === "propeller"
      ? form.querySelector("[data-aircraft-propeller-input]")
      : aircraftEditorField(form, focusName) ?? aircraftEditorField(form, "tailNumber");
    target?.focus();
    if (target && typeof target.select === "function" && String(target.value ?? "").trim()) target.select();
  });
}

function openAircraftCreateDialog() {
  openAircraftEditDialog({ aircraft: "", focusName: "tailNumber" });
  setAircraftFormStatus(appReadOnlyMode() ? readOnlyPreviewMessage() : "", "info", document.querySelector("#aircraftEditDialogForm"));
}

function closeAircraftEditDialog() {
  const dialog = document.querySelector("#aircraftEditDialog");
  if (!dialog) return;
  if (dialog.classList.contains("is-inline-panel")) {
    // Inline (Info tab): autosave completion lands here; leave the form
    // exactly as the user typed it (repopulating would steal focus mid-form).
    return;
  }
  if (typeof dialog.close === "function") {
    dialog.close();
  } else {
    dialog.removeAttribute("open");
  }
  activeAircraftEditorFormId = "aircraftEditDialogForm";
  restoreAccountAfterAircraftDialog();
}

async function saveAircraftProfileToDatabase(profile) {
  if (appReadOnlyMode()) throw new Error(readOnlyActionMessage("Saving aircraft profiles"));
  // Photos are no longer inlined in aircraft summaries, so the profile's photo
  // value is one of: a fresh data URL (user picked a new photo), the
  // /api/aircraft/:id/photo display URL (untouched), or empty (cleared). Only
  // the first and last are written back; omitting the key preserves the stored
  // photo server-side.
  const photoValue = aircraftPhotoSource(profile);
  const photoMetadataPatch = photoValue && !/^data:/i.test(photoValue)
    ? {}
    : { photoDataUrl: photoValue ?? "" };
  const response = await fetch(databaseAircraftEndpoint, {
    method: "POST",
    headers: { "content-type": "application/json; charset=utf-8" },
    body: JSON.stringify({
      id: profile.databaseId ?? null,
      tailNumber: profile.tailNumber,
      make: profileValue(profile.aircraft?.make),
      model: profileValue(profile.aircraft?.model),
      engine_make: profileValue(profile.engine?.make),
      engine_model: profileValue(profile.engine?.model),
      monitor_type: profileValue(profile.monitor?.type) ?? supportedMonitorLabel(profile.monitor),
      monitor_make: profileValue(profile.monitor?.make),
      monitor_model: profileValue(profile.monitor?.model),
      profile_metadata: {
        source: "aircraft-workspace",
        cgrTwin: profile.monitor?.cgrTwin ?? { enabled: false },
        aircraftType: normalizedAircraftType(profile.aircraft?.type, profile),
        propellerType: profileValue(profile.propellerType ?? profile.engine?.propellerType),
        fuelPrimary: profileValue(profile.fuel?.primary),
        engineFuelSystem: profileValue(profile.engine?.fuelSystem),
        engineCount: Number.isFinite(profile.engineLayout?.count) ? profile.engineLayout.count : null,
        engineLayout: profile.engineLayout ?? null,
        propellers: normalizedPropellerEntries(profile),
        ...photoMetadataPatch,
        turbo: profile.turbo ?? null,
        operatingLimits: profile.operatingLimits ?? null,
      },
    }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload?.error || `Database aircraft API HTTP ${response.status}`);
  }
  const savedAircraft = payload?.aircraft ?? null;
  if (!savedAircraft) {
    throw new Error("Database aircraft API did not return the saved aircraft record.");
  }
  const nextProfile = databaseAircraftToProfile(savedAircraft);
  const previousRecord = databaseAircraftRecords.find((entry) => entry.id === savedAircraft.id);
  const previousAircraft = previousRecord ? databaseAircraftLabel(previousRecord) : "";
  databaseAircraftRecords = [
    ...databaseAircraftRecords.filter((entry) => entry.id !== savedAircraft.id),
    savedAircraft,
  ].sort((left, right) => {
    const leftOrder = Number(left?.display_order);
    const rightOrder = Number(right?.display_order);
    if (Number.isFinite(leftOrder) && Number.isFinite(rightOrder) && leftOrder !== rightOrder) return leftOrder - rightOrder;
    if (Number.isFinite(leftOrder)) return -1;
    if (Number.isFinite(rightOrder)) return 1;
    return databaseAircraftLabel(left).localeCompare(databaseAircraftLabel(right));
  });
  reconcileAircraftLabelReferences({
    previousAircraft,
    nextAircraft: databaseAircraftLabel(savedAircraft),
    databaseAircraftId: savedAircraft.id,
  });
  aircraftProfiles = databaseAircraftProfilesMap();
  return nextProfile;
}

async function lookupFaaAircraftRegistry(tailNumber, options = {}) {
  const params = new URLSearchParams({ tailNumber: String(tailNumber ?? "").trim() });
  const response = await fetch(`/api/aircraft/faa-registry?${params.toString()}`, {
    cache: "no-store",
    signal: options.signal,
  });
  const payload = await response.json().catch(() => ({}));
  if (response.status === 404) return null;
  if (!response.ok) {
    throw new Error(payload?.error || `FAA registry API HTTP ${response.status}`);
  }
  return payload?.aircraft ?? null;
}

// Tell the account page (Archive tab visibility, open archive listing,
// aircraft stats) that the workspace just archived something, so it stays
// current without a manual reload.
function notifyWorkspaceArchiveChanged() {
  try {
    window.dispatchEvent(new CustomEvent("aeroinsight:archive-changed", { detail: { source: "workspace" } }));
  } catch { /* ignore */ }
}

async function archiveAircraftProfileInDatabase(profile) {
  if (appReadOnlyMode()) throw new Error(readOnlyActionMessage("Archiving aircraft profiles"));
  const databaseId = profile?.databaseId;
  if (!databaseId) {
    throw new Error("This database aircraft profile cannot be archived because it does not have a database id.");
  }
  const response = await fetch(`${databaseAircraftEndpoint}/${encodeURIComponent(databaseId)}/archive`, {
    method: "POST",
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload?.error || `Database aircraft API HTTP ${response.status}`);
  }
  databaseAircraftRecords = databaseAircraftRecords.filter((entry) => entry.id !== databaseId);
  aircraftProfiles = databaseAircraftProfilesMap();
  return payload;
}

async function persistAircraftProfileFromForm({
  savingMessage,
  successMessage,
  saveButton,
  saveButtonLabel = "Save Aircraft",
  form = null,
  // Explicit "Save Aircraft" actions require a propeller type, but incidental
  // saves (e.g. adding/removing a photo) must not be blocked by an unrelated
  // profile-completeness gate — they preserve whatever propeller type is stored.
  requirePropellerType = true,
} = {}) {
  form = aircraftEditorForm(form);
  const profile = aircraftProfileFromForm(form);
  const previousTail = String(form?.dataset?.aircraftOriginalTail ?? "").trim().toUpperCase();
  if (!profile.tailNumber) {
    throw new Error("Tail number is required.");
  }
  if (requirePropellerType && !AIRCRAFT_PROPELLER_TYPES.includes(profile.propellerType)) {
    throw new Error("Choose Fixed Pitch or Constant Speed before saving.");
  }
  try {
    if (saveButton) {
      saveButton.disabled = true;
      saveButton.textContent = "Saving...";
    }
    if (savingMessage) {
      setAircraftFormStatus(savingMessage, "info", form);
    }
    const savedProfile = await saveAircraftProfileToDatabase(profile);
    populateUploadAircraftSelect(savedProfile.tailNumber);
    populateTrendAircraftSelect(savedProfile.tailNumber);
    setAircraftWorkspaceSelection(savedProfile.tailNumber, { render: false });
    renderAircraftWorkspace();
    updateFlightHeader();
    // The saved profile re-keys rawAnalysisSignature (profileHash), so the
    // loaded flight's next health-summary lookup would miss the cache and
    // rerun the detector pass synchronously. Re-prime off the main thread,
    // exactly like a review-settings change.
    if (savedProfile.tailNumber === selectedFlight?.aircraft) {
      void reapplyDashboardAnalysisForReviewSettings();
    }
    setAircraftFormStatus(
      successMessage ?? `Saved ${savedProfile.tailNumber} to the database.`,
      "success",
      form,
    );
    return savedProfile;
  } finally {
    if (saveButton) {
      saveButton.disabled = false;
      saveButton.textContent = saveButtonLabel;
    }
  }
}

async function saveAircraftEditDialogForm(form = document.querySelector("#aircraftEditDialogForm")) {
  form = aircraftEditorForm(form);
  const saveButton = form?.querySelector("#aircraftEditDialogSave");
  if (appReadOnlyMode()) {
    setAircraftFormStatus(readOnlyActionMessage("Saving aircraft profiles"), "info", form);
    syncReadOnlyUi();
    return;
  }
  if (!validateAircraftEditForm(form)) return;
  try {
    const tailNumber = String(aircraftEditorField(form, "tailNumber")?.value ?? "").trim().toUpperCase();
    const savedProfile = await persistAircraftProfileFromForm({
      savingMessage: `Saving ${tailNumber || "this aircraft"}...`,
      successMessage: `Saved ${tailNumber || "this aircraft"} to the database.`,
      saveButton,
      form,
    });
    const savedLabel = savedProfile?.tailNumber || tailNumber || "this aircraft";
    // Inline autosaves report through the footer status line; a toast per
    // field edit would be noise.
    if (!aircraftDialogIsInline("#aircraftEditDialog")) showAppToast(`Saved ${savedLabel}.`, "success");
    closeAircraftEditDialog();
  } catch (error) {
    setAircraftFormStatus(error.message, "error", form);
    showAppToast(error.message, "error");
  }
}

async function removeAircraftFromFleet(aircraft, { triggerButton = null } = {}) {
  const profile = aircraftProfiles?.[aircraft] ?? null;
  const flights = aircraftFlights(aircraft);
  const label = aircraftDisplayLabel(aircraft);
  if (!aircraft) return false;
  if (appReadOnlyMode()) {
    setAircraftFormStatus(readOnlyActionMessage("Archiving aircraft"), "info");
    showAppToast(readOnlyActionMessage("Archiving aircraft"), "info");
    syncReadOnlyUi();
    return false;
  }
  const confirmed = await confirmAircraftDeleteDialog({ label, flightCount: flights.length, archive: true });
  if (!confirmed) return false;
  try {
    if (triggerButton) triggerButton.disabled = true;
    if (profile?.profileStatus === "database") {
      await archiveAircraftProfileInDatabase(profile);
    }
    flightManifest = flightManifest.filter((entry) => entry.aircraft !== aircraft);
    hiddenFlightIds = new Set([...hiddenFlightIds].filter((id) => flightManifest.some((entry) => entry.id === id)));
    trendExcludedFlightIds = new Set([...trendExcludedFlightIds].filter((id) => flightManifest.some((entry) => entry.id === id)));
    trendIncludedFlightIds = new Set([...trendIncludedFlightIds].filter((id) => flightManifest.some((entry) => entry.id === id)));
    saveHiddenFlightIds(hiddenFlightIds);
    saveTrendExcludedFlightIds(trendExcludedFlightIds);
    saveTrendIncludedFlightIds(trendIncludedFlightIds);
    clearStoredTrendRowsForAircraft(aircraft);
    trendCache = new Map();
    // allAircraftOptions() unions THREE sources: databaseAircraftRecords, the
    // flight manifest, and aircraftProfiles. The manifest is filtered above and
    // archiveAircraftProfileInDatabase() prunes the first two — but only for a
    // database-backed profile, so a profile-only aircraft stayed in the list
    // after archiving. Drop it here so every source agrees.
    if (aircraftProfiles?.[aircraft]) {
      const remainingProfiles = { ...aircraftProfiles };
      delete remainingProfiles[aircraft];
      aircraftProfiles = remainingProfiles;
    }
    selectedAircraftWorkspaceId = allAircraftOptions()[0] ?? "";
    // Persist the new selection. Without this the archived tail stayed in
    // localStorage, so the next reload restored the aircraft that was just
    // archived — and with nothing left it restored the last one added.
    saveSelectedAircraftWorkspaceId(selectedAircraftWorkspaceId);
    populateUploadAircraftSelect(selectedAircraftWorkspaceId);
    populateTrendAircraftSelect(selectedAircraftWorkspaceId);
    setupFlightLogSelector();
    renderAircraftWorkspace();
    updateFlightHeader();
    // The URL still described the aircraft that was just archived —
    // /N12345/#info survived the archive and, with an empty fleet, pointed at a
    // workspace that no longer exists. Reloading it resurrected a dead route.
    // Drop the panel hash first: syncAircraftUrlPathTail preserves whatever
    // hash is present, so clearing the tail alone would leave "/#info" behind.
    if (!selectedAircraftWorkspaceId && window.location.hash) {
      window.history.replaceState(null, "", `${window.location.pathname}${window.location.search}`);
    }
    syncAircraftUrlPathTail();
    const archivedFlights = flights.length;
    setAircraftFormStatus(`Archived ${label}${archivedFlights ? ` and its ${archivedFlights} flight${archivedFlights === 1 ? "" : "s"}` : ""}. Restore it anytime from the Archive tab in My Account.`, "success");
    notifyWorkspaceArchiveChanged();
    return true;
  } catch (error) {
    setAircraftFormStatus(error.message, "error");
    window.alert(error.message);
    return false;
  } finally {
    if (triggerButton) triggerButton.disabled = false;
  }
}

function latestFlightForAircraft(aircraft = selectedAircraftWorkspace()) {
  return latestFlightFromAircraftFlights(aircraftFlights(aircraft));
}

function latestFlightFromAircraftFlights(flights = []) {
  return latestFlightFromAircraftFlightsModel(flights, { isSupportedFlight });
}

function clearLoadedFlight(reason) {
  selectedFlight = null;
  lastRequestedFlightId = "";
  healthSummary = null;
  flightData = [];
  referenceData = makeReferenceData(flightData);
  flightDerivedCache = makeFlightDerivedCache(flightData);
  currentParserMetadata = null;
  endpointTrimInfo = { original: 0, leading: 0, trailing: 0, total: 0, seconds: endpointTrimSeconds };
  sourceRows = 0;
  sourceRawRows = 0;
  resetExplorerAskState();
  resetGeneratedReport();
  clearPilotObservationPersistenceState();
  resetPilotObservationSelectionState();
  clearGamiSpecialTestPersistenceState();
  resetGamiSpecialTestSelectionState();
  updateFlightHeader();
  if (reason) updateDataSourceLabel(false, reason);
  drawAll();
  notifyPlaybackDataChanged();
}

function applyEmptyAircraftDashboardState(aircraft, options = {}) {
  emptyAircraftDashboardTail = aircraft || "";
  const view = document.querySelector("#view-dashboard");
  if (!view) return;
  const stateEl = document.querySelector("#dashboardEmptyAircraftState");
  const titleEl = document.querySelector("#dashboardEmptyAircraftTitle");
  const copyEl = document.querySelector("#dashboardEmptyAircraftCopy");
  const actionEl = document.querySelector("#dashboardEmptyAircraftUpload");
  if (aircraft || options.title || options.copy) {
    view.classList.add("is-empty-aircraft");
    if (titleEl) titleEl.textContent = options.title || `No flights yet for ${aircraft}`;
    if (copyEl) copyEl.textContent = options.copy || "Upload a flight log to populate this aircraft's dashboard.";
    if (actionEl) actionEl.hidden = options.hideAction === true;
    if (stateEl) stateEl.hidden = false;
  } else {
    view.classList.remove("is-empty-aircraft");
    if (titleEl) titleEl.textContent = "No flights yet for this aircraft";
    if (copyEl) copyEl.textContent = "Upload a flight log to populate this aircraft's dashboard.";
    if (actionEl) actionEl.hidden = false;
    if (stateEl) stateEl.hidden = true;
  }
  updateFlightHeader();
}

async function activateAircraftDashboardFlight() {
  const aircraft = selectedAircraftWorkspace();
  const flights = aircraftFlights(aircraft);
  const savedFlight = selectedFlightStorageId
    ? flights.find((entry) => entry.id === selectedFlightStorageId && isSupportedFlight(entry))
    : null;
  const dashboardFlight = savedFlight ?? latestFlightFromAircraftFlights(flights);
  if (!dashboardFlight || !isSupportedFlight(dashboardFlight)) {
    if (selectedFlight) clearLoadedFlight();
    applyEmptyAircraftDashboardState(aircraft);
    return false;
  }
  applyEmptyAircraftDashboardState(null);
  if (selectedFlight?.id !== dashboardFlight.id) {
    await perfTime("loadFlightLog", () => loadFlightLog(dashboardFlight, { activateTrial: true }));
  } else {
    perfMark("loadFlightLog(skip:same-flight)", 0);
    syncFlightReviewRoute();
  }
  return true;
}

// --- New UI fleet sidebar actions (new_ui_enabled flag) ---------------------
// The sidebar's click handlers delegate here so aircraft/flight selection and
// panel activation reuse the existing single-source flows above.

async function openFleetSidebarFlight(entry) {
  if (!entry?.id) return;
  exitMobileHome();
  // Hopping flights from the sidebar keeps the current dashboard tab: pass it
  // through the activation so the panel never flashes back to Overview.
  const previousPanel = document.body.dataset.activeView === "dashboard"
    ? activeReportPanel()
    : "overview";
  // Pre-store the selection so the dashboard activation below resolves to this
  // flight instead of the aircraft's latest.
  if (entry.aircraft && entry.aircraft !== selectedAircraftWorkspace()) {
    if (setAircraftWorkspaceSelection(entry.aircraft, { skipDashboardActivation: true }) === false) return;
  }
  selectedFlightStorageId = entry.id;
  saveSelectedFlightId(entry.id);
  window.scrollTo({ top: 0, behavior: "smooth" });
  await setAircraftPanel("dashboard", { reportPanel: previousPanel });
  // Clicking a flight in the rail IS a deliberate open, so it clears the NEW
  // tag. loadFlightLog cannot do it for us here: this path reaches the
  // dashboard through setAircraftPanel's default-flight resolution, which
  // passes markSeen: false because it also covers boot defaults and
  // post-delete replacements. Marking here keeps that distinction intact.
  await markFlightsReviewedForEntry(entry);
  renderFleetSidebar();
}

function openFleetSidebarAircraft(aircraft) {
  exitMobileHome();
  const activeView = document.body.dataset.activeView;
  if (activeView !== "aircraft" && activeView !== "dashboard") {
    // From Account/Admin an aircraft tap must navigate back into the
    // workspace; selecting in place would repaint headers under the wrong
    // view (the "Sample Flight" title stomping the My Account page).
    openFleetSidebarPanel(aircraft, "flights");
    return;
  }
  const changed = Boolean(aircraft && aircraft !== selectedAircraftWorkspace());
  if (changed && setAircraftWorkspaceSelection(aircraft) === false) return;
  // The selection setter repaints the workspace panels; Trends renders from
  // its own controller, so re-enter the panel for the new aircraft.
  if (changed && selectedAircraftPanel === "trends") {
    setAircraftPanel("trends").catch((error) => updateDataSourceLabel(false, error));
  }
  renderFleetSidebar();
}

function exitMobileHome() {
  if (document.body.classList.contains("mobile-home-active")) {
    document.body.classList.remove("mobile-home-active");
  }
}

function openFleetSidebarPanel(aircraft, panel) {
  // The New UI has no profile panel: the aircraft page is its Flights page.
  const nextPanel = panel === "profile" && newUiFeatureEnabled() ? "flights" : panel;
  if (aircraft && aircraft !== selectedAircraftWorkspace()) {
    if (setAircraftWorkspaceSelection(aircraft, { render: false }) === false) return false;
  }
  exitMobileHome();
  setAircraftPanel(nextPanel).catch((error) => updateDataSourceLabel(false, error));
  // Match the section-tab hash behavior: dashboard and trends own their own
  // routes; every other panel writes its plain panel hash.
  if (nextPanel !== "dashboard" && nextPanel !== "trends") {
    window.location.hash = nextPanel === "profile" ? "aircraft" : nextPanel;
  }
  renderFleetSidebar();
  return true;
}

// --- Small-mobile bottom tab bar (New UI, <=900px) --------------------------
// Home shows the full-page fleet sidebar; the other tabs open workspace
// sections. The active tab is derived from the current view/panel so the
// highlight stays in sync with breadcrumb / deep-link navigation too.
function mobileHomeActive() {
  return document.body.classList.contains("mobile-home-active");
}

function activeMobileTab() {
  if (mobileHomeActive()) return "home";
  const view = document.body.dataset.activeView;
  // My Account / Admin own no bottom tab (and selectedAircraftPanel may still be
  // a stale workspace panel), so no tab is active on those views.
  if (view === "account" || view === "admin") return "";
  const panel = selectedAircraftPanel;
  if (view === "dashboard" || panel === "dashboard") return "dashboard";
  if (panel === "maintenance") return "maintenance";
  if (view === "aircraft") return "aircraft";
  return "";
}

function syncMobileTabbar() {
  const bar = document.querySelector("#mobileTabbar");
  if (!bar) return;
  const active = activeMobileTab();
  bar.querySelectorAll("[data-mobile-tab]").forEach((tab) => {
    tab.classList.toggle("is-active", tab.dataset.mobileTab === active);
  });
  positionMobileTabIndicator();
}

let mobileTabIndicatorPlaced = false;
// Move the active-tab oval. Tab-to-tab it slides. When no tab is active (My
// Account / Admin) it fades out in place; when it next reappears it jumps to the
// active tab without sliding and fades back in.
function positionMobileTabIndicator() {
  const bar = document.querySelector("#mobileTabbar");
  const indicator = bar?.querySelector(".mobile-tab-indicator");
  if (!bar || !indicator) return;
  const activeTab = bar.querySelector("[data-mobile-tab].is-active");
  const icon = activeTab?.querySelector(".mobile-tab-icon");
  if (!activeTab || !icon) {
    // No active tab: fade the oval out where it is (don't move it).
    indicator.classList.remove("is-visible");
    mobileTabIndicatorPlaced = false;
    return;
  }
  const barRect = bar.getBoundingClientRect();
  const iconRect = icon.getBoundingClientRect();
  if (!iconRect.width) return; // bar not laid out yet (hidden)
  const setBox = () => {
    indicator.style.width = `${iconRect.width}px`;
    indicator.style.height = `${iconRect.height}px`;
    indicator.style.top = `${Math.round(iconRect.top - barRect.top)}px`;
    indicator.style.transform = `translateX(${Math.round(iconRect.left - barRect.left)}px)`;
  };
  if (!mobileTabIndicatorPlaced) {
    // Reappearing (first placement, or after Account/Admin): jump to the active
    // tab with transitions off so it doesn't slide from a stale spot, then fade
    // the opacity back in.
    indicator.classList.add("no-anim");
    indicator.classList.remove("is-visible");
    setBox();
    void indicator.offsetWidth;
    indicator.classList.remove("no-anim");
    indicator.classList.add("is-visible"); // opacity 0 -> 1 fade-in
    mobileTabIndicatorPlaced = true;
  } else {
    setBox();
    indicator.classList.add("is-visible");
  }
}

function showMobileHome() {
  document.body.classList.add("mobile-home-active");
  document.body.classList.remove("fleet-drawer-open");
  window.scrollTo({ top: 0 });
  syncAircraftUrlPathTail(); // reflect Home in the URL as /home
  renderFleetSidebar();
  syncMobileTabbar();
}

// Left-to-right order of the bottom tab bar; drives swipe direction and the
// slide-in animation (forward = deeper in this list).
const MOBILE_TAB_ORDER = ["home", "dashboard", "aircraft", "maintenance"];

// A frozen, fixed-position clone of the screen we're leaving, so it can slide
// OUT while the real page swaps content and slides IN. Dashboard/Aircraft/
// Maintenance all reuse the one .workspace element, so without this snapshot the
// outgoing content is simply overwritten and appears to vanish instead of
// sliding away. Must be called BEFORE the panel switch.
function snapshotMobileScreen() {
  const source = mobileHomeActive()
    ? document.querySelector(".fleet-sidebar")
    : document.querySelector(".workspace");
  if (!source) return null;
  const rect = source.getBoundingClientRect();
  const clone = source.cloneNode(true);
  // cloneNode doesn't copy <canvas> bitmaps (charts) — repaint them by hand.
  const srcCanvases = source.querySelectorAll("canvas");
  const cloneCanvases = clone.querySelectorAll("canvas");
  srcCanvases.forEach((canvas, index) => {
    const target = cloneCanvases[index];
    if (target && canvas.width && canvas.height) {
      try { target.getContext("2d")?.drawImage(canvas, 0, 0); } catch { /* tainted / no ctx */ }
    }
  });
  // Freeze visibility: which view/panel shows is driven by body[data-active-view]
  // rules, so once we switch pages the body attribute changes and the clone's
  // panels (still inside body) would collapse to display:none / 0 height. Copy
  // their current computed display inline while the old page is still active.
  const FREEZE = ".view, .aircraft-subpanel, .aircraft-dashboard-panel, #view-dashboard";
  const srcFreeze = source.querySelectorAll(FREEZE);
  const cloneFreeze = clone.querySelectorAll(FREEZE);
  srcFreeze.forEach((el, index) => {
    if (cloneFreeze[index]) cloneFreeze[index].style.display = getComputedStyle(el).display;
  });
  // Id-keyed visibility (e.g. the topbar #adminNavButton is display:none'd by
  // id in the New UI shell) dies with the id strip below, which made hidden
  // chrome pop into the snapshot mid-slide. Freeze every id-carrying
  // element's computed display inline first, while its selectors still match.
  const srcIdEls = source.querySelectorAll("[id]");
  const cloneIdEls = clone.querySelectorAll("[id]");
  srcIdEls.forEach((el, index) => {
    if (cloneIdEls[index]) cloneIdEls[index].style.display = getComputedStyle(el).display;
  });
  // Strip ids so the snapshot never shadows real elements mid-animation.
  clone.removeAttribute("id");
  clone.querySelectorAll("[id]").forEach((el) => el.removeAttribute("id"));
  // Wrap the (tall) clone in a viewport-sized, clipped container and animate
  // THAT. A 7000px-tall element is too large for the browser to promote to a
  // compositor layer, so its transform animation would fall back to the main
  // thread and stall while the incoming page renders. A viewport-sized layer
  // composites and keeps sliding smoothly through that jank. The clone is
  // positioned at the source's on-screen rect so the same content shows.
  const container = document.createElement("div");
  container.setAttribute("aria-hidden", "true");
  container.style.cssText = `position:fixed; left:0; top:0; width:${rect.width}px; height:${window.innerHeight}px; margin:0; z-index:66; pointer-events:none; overflow:hidden; will-change:transform;`;
  // Explicit width AND height: without a fixed height an absolutely-positioned
  // clone lets height:100%/flex children collapse (the flights page shrank to
  // ~86px), leaving a near-blank snapshot. Inline display too: navigating to Home
  // adds body.mobile-home-active, whose `.workspace { display:none }` rule would
  // otherwise hide this clone (it also carries the .workspace class).
  const sourceDisplay = getComputedStyle(source).display;
  clone.style.cssText = `position:absolute; left:${rect.left}px; top:${rect.top}px; width:${rect.width}px; height:${rect.height}px; margin:0; display:${sourceDisplay === "none" ? "block" : sourceDisplay};`;
  container.appendChild(clone);
  document.body.appendChild(container);
  return container;
}

// Slide the newly-revealed screen in (from the right when moving forward through
// the tab order, from the left when moving back) while the snapshot of the old
// screen slides out the opposite way.
function animateMobileScreen(direction, outgoing, onComplete) {
  const target = mobileHomeActive()
    ? document.querySelector(".fleet-sidebar")
    : document.querySelector(".workspace");
  document.body.classList.add("mobile-anim-active");
  const inClass = direction === "forward" ? "mobile-screen-in-right" : "mobile-screen-in-left";
  const outClass = direction === "forward" ? "mobile-screen-out-left" : "mobile-screen-out-right";
  if (outgoing) outgoing.classList.add(outClass);
  let cleaned = false;
  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    if (target) {
      target.classList.remove("mobile-screen-in-right", "mobile-screen-in-left");
      target.removeEventListener("animationend", onEnd);
    }
    outgoing?.remove();
    document.body.classList.remove("mobile-anim-active");
    // Snap the destination content in only now the slide is done — during the
    // slide the incoming page kept showing the current content, so the heavy
    // render never janks the animation.
    onComplete?.();
  };
  // animationend BUBBLES, so a child's animation (chart / fade-in on the
  // incoming page) would otherwise trigger cleanup early and cut the slide
  // short. Only react to the slide animation on the target element itself.
  const onEnd = (event) => {
    if (event.target !== target) return;
    if (event.animationName !== "mobile-screen-in-right" && event.animationName !== "mobile-screen-in-left") return;
    cleanup();
  };
  if (target) {
    target.classList.remove("mobile-screen-in-right", "mobile-screen-in-left");
    void target.offsetWidth; // restart if mid-flight
    target.classList.add(inClass);
    target.addEventListener("animationend", onEnd);
  }
  // Fallback if animationend never fires (reduced-motion, interrupted).
  setTimeout(cleanup, 420);
}

function activateMobileTab(tab, options = {}) {
  const fromTab = activeMobileTab();
  const fromIdx = MOBILE_TAB_ORDER.indexOf(fromTab);
  const toIdx = MOBILE_TAB_ORDER.indexOf(tab);
  const shouldAnimate = options.animate !== false
    && fromIdx !== -1 && toIdx !== -1 && fromIdx !== toIdx
    && window.matchMedia("(max-width: 900px)").matches;
  const direction = toIdx > fromIdx ? "forward" : "backward";
  // Snapshot the outgoing screen BEFORE the switch overwrites/hides it.
  const outgoing = shouldAnimate ? snapshotMobileScreen() : null;
  // The heavy part of a workspace switch (panel render / dashboard charts).
  const loadWorkspacePanel = () => {
    const aircraft = selectedAircraftWorkspace() || allAircraftOptions()[0] || "";
    if (tab === "dashboard") {
      if (aircraft && aircraft !== selectedAircraftWorkspace()) setAircraftWorkspaceSelection(aircraft, { render: false });
      openFleetSidebarPanel(aircraft, "dashboard");
    } else if (tab === "aircraft") {
      openFleetSidebarPanel(aircraft, "flights");
    } else if (tab === "maintenance") {
      openFleetSidebarPanel(aircraft, "maintenance");
    }
    window.scrollTo({ top: 0 });
    syncMobileTabbar();
  };

  if (!shouldAnimate) {
    if (tab === "home") showMobileHome();
    else { document.body.classList.remove("mobile-home-active"); loadWorkspacePanel(); }
    return;
  }

  // Light up the pressed tab immediately (the content swap is deferred below)
  // and start the oval sliding toward it right away.
  document.querySelectorAll("#mobileTabbar [data-mobile-tab]").forEach((el) => {
    el.classList.toggle("is-active", el.dataset.mobileTab === tab);
  });
  positionMobileTabIndicator();

  if (tab === "home") {
    showMobileHome();
    animateMobileScreen(direction, outgoing);
    return;
  }

  // Workspace tab: load the DESTINATION content into the workspace first (the
  // outgoing snapshot clone covers it, so there's no flash of it appearing in
  // place), THEN slide — the clone (old page) slides out while the workspace
  // (now the destination page) slides in. No duplicate, no end-snap.
  document.body.classList.remove("mobile-home-active");
  loadWorkspacePanel();
  animateMobileScreen(direction, outgoing);
}

function setupMobileTabbar() {
  document.querySelector("#mobileTabbar")?.addEventListener("click", (event) => {
    const button = event.target instanceof HTMLElement ? event.target.closest("[data-mobile-tab]") : null;
    if (!button) return;
    activateMobileTab(button.dataset.mobileTab);
  });
  // The topbar back chevron returns to the full-page Home on small mobile
  // (its drawer-toggle behavior is unused there). Capture phase so this runs
  // before the drawer-toggle handler.
  document.querySelector("#fleetSidebarToggle")?.addEventListener("click", (event) => {
    if (window.matchMedia("(max-width: 900px)").matches) {
      event.stopImmediatePropagation();
      showMobileHome();
    }
  }, true);
  // Admin / My Account navigation from the full-page Home overlay drops
  // mobile-home-active in the fleet-sidebar module; re-sync the highlight so no
  // tab stays lit (neither view owns a tab).
  window.addEventListener("aeroinsight:mobile-home-exit", () => syncMobileTabbar());
  // Re-sync the tab bar on ANY view change (account/admin fade the oval out; the
  // workspace views light their tab) — a MutationObserver catches every route,
  // including hash-only navigations that dispatch no event.
  if (typeof MutationObserver !== "undefined") {
    new MutationObserver(() => syncMobileTabbar())
      .observe(document.body, { attributes: true, attributeFilter: ["data-active-view"] });
  }
  // A fresh sign-in on a small screen defaults to the full-page Home (unless the
  // session was deep-linked to a specific flight/section before signing in).
  window.addEventListener("aeroinsight:signed-in", () => {
    if (!newUiFeatureEnabled() || isPublicShareMode()) return;
    if (!window.matchMedia("(max-width: 900px)").matches) return;
    if (window.location.hash.replace(/^#/, "").trim()) return;
    document.querySelector("#mobileTabbar")?.removeAttribute("hidden");
    showMobileHome();
  });
  window.addEventListener("resize", () => positionMobileTabIndicator());
  setupMobileSwipeNav();
  setupTableDragScroll();
  pinMobileTabbarOnFirefox();
  syncMobileTabbar();
}

// Firefox for Android is the one engine that keeps `position: fixed` anchored to
// the (taller) layout viewport while its URL toolbar animates during a fast
// scroll, so the bottom tab bar visibly lags/jitters for a moment. Every other
// engine — including Android Chrome and all desktop browsers — holds it still
// natively, so we pin the bar to the visual viewport ONLY on Firefox and leave
// the rest completely untouched. On Firefox desktop (no dynamic toolbar) the
// offset is always 0, so this is a no-op there too.
function pinMobileTabbarOnFirefox() {
  const bar = document.querySelector("#mobileTabbar");
  const vv = window.visualViewport;
  if (!bar || !vv || !/firefox/i.test(navigator.userAgent || "")) return;
  const apply = () => {
    // How far the visual viewport's bottom sits above the layout viewport's
    // bottom (the space the browser toolbar is currently taking). Glue the bar
    // there so it tracks the toolbar smoothly instead of lagging behind it.
    const offset = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    bar.style.transform = offset ? `translateY(${-offset}px)` : "";
  };
  vv.addEventListener("resize", apply);
  vv.addEventListener("scroll", apply);
  apply();
}

// Desktop: click-and-drag on a wide table pans it horizontally (grab scroll),
// so operators can move dense tables without reaching for the scrollbar or a
// trackpad gesture. Mouse pointers only — touch is handled above.
function setupTableDragScroll() {
  const WRAP_SELECTOR = "#aircraftFlightsPanel .table-wrap, #aircraftUploadsPanel .table-wrap";
  const INTERACTIVE = "button, a, input, select, textarea, label, [role='button'], [data-aircraft-flight-route-edit]";
  let wrap = null;
  let startX = 0;
  let startScroll = 0;
  let moved = false;
  document.addEventListener("pointerdown", (event) => {
    if (event.pointerType !== "mouse" || event.button !== 0) return;
    const target = event.target instanceof Element ? event.target : null;
    const found = target?.closest(WRAP_SELECTOR);
    if (!found || found.scrollWidth <= found.clientWidth + 1) return;
    if (target?.closest(INTERACTIVE)) return; // don't hijack real controls
    wrap = found;
    startX = event.clientX;
    startScroll = found.scrollLeft;
    moved = false;
  });
  document.addEventListener("pointermove", (event) => {
    if (!wrap) return;
    const dx = event.clientX - startX;
    if (!moved && Math.abs(dx) < 4) return;
    moved = true;
    wrap.scrollLeft = startScroll - dx;
    wrap.style.cursor = "grabbing";
    wrap.style.userSelect = "none";
    event.preventDefault();
  });
  const endDrag = () => {
    if (wrap) {
      wrap.style.cursor = "";
      wrap.style.userSelect = "";
    }
    wrap = null;
  };
  document.addEventListener("pointerup", endDrag);
  document.addEventListener("pointercancel", endDrag);
  // A drag that moved should not also fire a click (e.g. open a flight row).
  document.addEventListener("click", (event) => {
    if (moved) {
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }
  }, true);
}

// Horizontal swipe anywhere on the page switches tabs in bar order. Swipes that
// start inside a horizontally-scrollable or drag-driven region (wide tables,
// ANY chart canvas, the playback scrubber and its strips, the AI summary phase
// rail, the segmented trend control) are left alone so their own panning and
// scrubbing still work.
function setupMobileSwipeNav() {
  const SWIPE_MIN = 60; // px of horizontal travel to count as a swipe
  const NO_SWIPE = ".table-wrap, canvas, .playback-timeline, .playback-status-strip, .playback-advisory-chips, .fb-phase-rail, .aircraft-flights-segmented, .scope-switch, [data-no-swipe-nav]";
  let startX = 0;
  let startY = 0;
  let tracking = false;
  let startInScroller = false;
  document.addEventListener("touchstart", (event) => {
    if (!window.matchMedia("(max-width: 900px)").matches || event.touches.length !== 1) {
      tracking = false;
      return;
    }
    const touch = event.touches[0];
    startX = touch.clientX;
    startY = touch.clientY;
    const target = event.target instanceof Element ? event.target : null;
    startInScroller = Boolean(target?.closest(NO_SWIPE));
    tracking = true;
  }, { passive: true });
  document.addEventListener("touchend", (event) => {
    if (!tracking) return;
    tracking = false;
    if (startInScroller) return;
    const touch = event.changedTouches[0];
    const dx = touch.clientX - startX;
    const dy = touch.clientY - startY;
    // Horizontal intent only: enough travel, and clearly more sideways than
    // vertical (so a diagonal page-scroll never flips tabs).
    if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    const current = MOBILE_TAB_ORDER.indexOf(activeMobileTab());
    if (current === -1) return;
    const nextIndex = dx < 0 ? current + 1 : current - 1; // swipe left => forward
    if (nextIndex < 0 || nextIndex >= MOBILE_TAB_ORDER.length) return;
    activateMobileTab(MOBILE_TAB_ORDER[nextIndex]);
  }, { passive: true });
}

// First-visit-on-a-phone nudge: the app is desktop-first, so the first time a
// small-screen visitor lands we show a friendly full-screen "best on desktop"
// overlay. One-shot: a localStorage flag suppresses it on later visits.
const MOBILE_WELCOME_SEEN_KEY = "aeroinsight:mobile-welcome-seen";
function maybeShowMobileWelcome() {
  const overlay = document.querySelector("#mobileWelcomeOverlay");
  if (!overlay) return;
  if (!window.matchMedia("(max-width: 900px)").matches) return;
  let seen = false;
  try { seen = localStorage.getItem(MOBILE_WELCOME_SEEN_KEY) === "1"; } catch { seen = false; }
  if (seen) return;
  overlay.removeAttribute("hidden");
  const dismiss = () => {
    overlay.setAttribute("hidden", "");
    try { localStorage.setItem(MOBILE_WELCOME_SEEN_KEY, "1"); } catch { /* private mode: show once per session */ }
  };
  document.querySelector("#mobileWelcomeContinue")?.addEventListener("click", dismiss, { once: true });
}

function aircraftFlightDateRangeLabel(flights = []) {
  return aircraftFlightDateRangeLabelModel(flights, { trendDateValue });
}

function aircraftTrendRowsForActivity(aircraft) {
  if (!aircraft) return null;
  const key = trendCacheKey(aircraft);
  const rows = trendCache.get(key) ?? readStoredTrendRows(key);
  if (rows && !trendCache.has(key)) trendCache.set(key, rows);
  return rows ? trendRowsIncludedByPreference(rows) : null;
}

function cachedAircraftAverageFlightDurationSeconds(aircraft, flights = []) {
  const directAverage = aircraftAverageFlightDurationSeconds(flights);
  if (Number.isFinite(directAverage)) return directAverage;
  if (!aircraft) return null;
  // Derive the fallback average from the trend-row cache, which the trend
  // pipeline keeps current. A previous second-level per-aircraft cache here was
  // never invalidated, so a re-analyze or trend-inclusion change could leave the
  // "Average duration" card showing a stale value.
  const key = trendCacheKey(aircraft);
  const rows = trendCache.get(key) ?? readStoredTrendRows(key);
  const trendAverage = aircraftAverageFlightDurationFromTrendRows(trendRowsIncludedByPreference(rows ?? []));
  return Number.isFinite(trendAverage) ? trendAverage : null;
}

function aircraftRecentFlightCount(flights = [], days = 90) {
  return aircraftRecentFlightCountModel(flights, days, { trendDateValue });
}

function aircraftActivityCardsForPanel({
  aircraft,
  flights,
  latestFlight,
  flightDateText,
  recentFlightCount,
  averageFlightDuration,
  setupStatus,
  makeModelText,
}) {
  const cards = aircraftActivityCardsForPanelModel({
    selectedAircraftPanel,
    aircraft,
    flights,
    latestFlight,
    flightDateText,
    recentFlightCount,
    averageFlightDuration,
    setupStatus,
    makeModelText,
    uploadHistory: aircraftUploadHistoryCache.get(aircraft) ?? [],
    rows: aircraftTrendRowsForActivity(aircraft),
    selectedFlight,
    isSupportedFlight,
    flightFlagSummary: (entry) => flightFlagSummary(entry),
    buildTrendSignalSummaries,
    flightDateLabel,
    flightDisplayTitle,
    trendDateValue,
    // Unit-bearing label (e.g. "25m 25s") so the activity cards' durations are
    // unambiguous; the shared clock format is reserved for fixed-width layouts.
    formatCompactElapsedTime: formatCompactDurationLabel,
  });
  const summaryFlightCount = !aircraftFlightManifestReady ? databaseAircraftSummaryFlightCount(aircraft) : null;
  if (selectedAircraftPanel === "profile" && summaryFlightCount && !flights.length) {
    const flightCard = cards.find((card) => card.label === "Flights");
    if (flightCard) {
      flightCard.value = String(summaryFlightCount);
      flightCard.detail = "Imported logs in the database";
    }
  }
  return cards;
}

// Server-computed remaining plan room (same math as the POST /api/uploads
// gate). aircraftId narrows per-aircraft plans; an empty id asks about the
// member's account as a whole.
async function fetchUploadCapacityForAircraft(aircraftId) {
  try {
    const query = aircraftId ? `?aircraftId=${encodeURIComponent(aircraftId)}` : "";
    const response = await fetch(`/api/uploads/capacity${query}`, { cache: "no-store" });
    if (!response.ok) return null;
    return await response.json();
  } catch {
    return null;
  }
}

function databaseAircraftIdForLabel(aircraft) {
  const profile = aircraftProfiles?.[aircraft] ?? null;
  if (profile?.databaseId) return profile.databaseId;
  return databaseAircraftRecords.find((record) => databaseAircraftLabel(record) === aircraft)?.id ?? "";
}

function databaseAircraftRecordsForLabel(aircraft) {
  if (!aircraft) return [];
  const records = databaseAircraftRecords.filter((record) => databaseAircraftLabel(record) === aircraft);
  const profileId = aircraftProfiles?.[aircraft]?.databaseId;
  if (profileId && !records.some((record) => record.id === profileId)) {
    const profileRecord = databaseAircraftRecords.find((record) => record.id === profileId);
    if (profileRecord) records.unshift(profileRecord);
  }
  return records;
}

function databaseAircraftRecordForLabel(aircraft) {
  if (!aircraft) return null;
  return databaseAircraftRecords.find((record) => databaseAircraftLabel(record) === aircraft) ?? null;
}

function databaseAircraftSummaryFlightCount(aircraft) {
  const count = Number(databaseAircraftRecordForLabel(aircraft)?.flight_count);
  return Number.isFinite(count) && count >= 0 ? count : null;
}

function manifestUploadRowsForAircraft(aircraft) {
  const rows = new Map();
  visibleFlightEntries()
    .filter((entry) => entry.aircraft === aircraft && entry.path)
    .forEach((entry) => {
      const existing = rows.get(entry.path) ?? {
        path: entry.path,
        original_filename: entry.path.split("/").pop() || entry.path,
        upload_status: isSupportedFlight(entry) ? "available" : "unsupported",
        flight_count: 0,
        supported_flight_count: 0,
        byte_size: null,
        uploaded_at: null,
        sha256: "",
        flights: [],
      };
      existing.flights.push(entry);
      existing.flight_count += 1;
      if (isSupportedFlight(entry)) existing.supported_flight_count += 1;
      if (existing.supported_flight_count > 0) existing.upload_status = "available";
      rows.set(entry.path, existing);
    });
  return [...rows.values()].sort((a, b) => {
    const dateCompare = String(b.original_filename).localeCompare(String(a.original_filename));
    return dateCompare || String(b.path).localeCompare(String(a.path));
  });
}

async function loadAircraftUploadHistory(aircraft, { force = false } = {}) {
  if (!aircraft) return [];
  if (!force && aircraftUploadHistoryCache.has(aircraft)) return aircraftUploadHistoryCache.get(aircraft);
  const pending = aircraftUploadHistoryPending.get(aircraft);
  if (pending) {
    if (!force) return pending;
    await pending.catch(() => []);
  }
  const aircraftIds = [...new Set(databaseAircraftRecordsForLabel(aircraft).map((record) => record.id).filter(Boolean))];
  if (!aircraftIds.length) return [];
  const task = (async () => {
    const payloads = await Promise.all(aircraftIds.map(async (aircraftId) => {
      const response = await fetch(databaseAircraftUploadsEndpoint(aircraftId), { cache: "no-store" });
      const payload = await response.json().catch(() => null);
      if (!response.ok) throw new Error(payload?.error ?? `Upload history API HTTP ${response.status}`);
      return payload;
    }));
    const byId = new Map();
    payloads.forEach((payload) => {
      (Array.isArray(payload?.uploads) ? payload.uploads : []).forEach((upload) => {
        if (upload?.id && !byId.has(upload.id)) byId.set(upload.id, upload);
      });
    });
    const uploads = [...byId.values()].sort((left, right) => {
      const leftTime = Date.parse(left.uploaded_at ?? left.created_at ?? "") || 0;
      const rightTime = Date.parse(right.uploaded_at ?? right.created_at ?? "") || 0;
      return rightTime - leftTime || String(right.original_filename ?? "").localeCompare(String(left.original_filename ?? ""));
    });
    aircraftUploadHistoryCache.set(aircraft, uploads);
    aircraftUploadHistoryErrors.delete(aircraft);
    return uploads;
  })().catch((error) => {
    aircraftUploadHistoryErrors.set(aircraft, error.message);
    throw error;
  }).finally(() => {
    aircraftUploadHistoryPending.delete(aircraft);
  });
  aircraftUploadHistoryPending.set(aircraft, task);
  return task;
}

// --- Unreviewed flights ("New" tag on the Flights tab) ----------------------
// Server holds the truth (flight_seen_marks); the manifest carries is_new so
// rows can render it. Clearing is optimistic: drop the local flag and repaint
// immediately, then persist. A failed write just means the tag returns on the
// next manifest load, which is the harmless direction to fail.
async function markFlightsReviewed(flightIds = []) {
  const ids = [...new Set(flightIds.map((id) => String(id ?? "").trim()).filter(Boolean))];
  if (!ids.length) return;
  const idSet = new Set(ids);
  let changed = false;
  flightManifest.forEach((entry) => {
    if (entry?.is_new === true && idSet.has(entry.id)) {
      delete entry.is_new;
      changed = true;
    }
  });
  if (changed) {
    renderAircraftFlightsPanel(selectedAircraftWorkspace());
    // The rail lists the same flights, so clear its pill/dot in the same pass.
    renderFleetSidebar();
  }
  try {
    await fetch("/api/flights/seen", {
      method: "POST",
      credentials: "same-origin",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ flightIds: ids }),
    });
  } catch {
    /* offline or transient: the tag reappears on the next manifest load */
  }
}

function markFlightReviewed(entry) {
  if (entry?.is_new !== true) return;
  void markFlightsReviewed([entry.id]);
}

/**
 * Awaitable variant for the fleet rail. The rail repaints immediately after
 * navigating, so the mark has to have landed before that render or the NEW pill
 * would linger until the next repaint. Also re-reads the flight from the live
 * manifest: `entry` is the object the rail was rendered with, which can predate
 * the panel switch.
 */
async function markFlightsReviewedForEntry(entry) {
  const id = entry?.id;
  if (!id) return;
  const live = aircraftFlights(entry?.aircraft ?? selectedAircraftWorkspace())
    .find((candidate) => candidate?.id === id) ?? entry;
  if (live?.is_new !== true) return;
  await markFlightsReviewed([id]);
}

// Bulk action on the Flights table: clear the New tag for every selected
// flight that still carries one.
async function markSelectedAircraftFlightsSeen(aircraft = selectedAircraftWorkspace()) {
  const ids = aircraftFlights(aircraft)
    .filter((entry) => entry?.is_new === true && aircraftFlightBulkDeleteSelected.has(entry.id))
    .map((entry) => entry.id);
  if (!ids.length) return;
  await markFlightsReviewed(ids);
  showAppToast(`Marked ${ids.length} flight${ids.length === 1 ? "" : "s"} as not new.`, "info");
}

function setAircraftFlightBulkDeleteSelection(flightId, selected, { render = true } = {}) {
  const id = String(flightId ?? "").trim();
  if (!id) return;
  if (selected) aircraftFlightBulkDeleteSelected.add(id);
  else aircraftFlightBulkDeleteSelected.delete(id);
  if (render) renderAircraftFlightsPanel(selectedAircraftWorkspace());
}

function setAircraftFlightBulkDeleteSelectionForIds(flightIds = [], selected = true) {
  flightIds.forEach((flightId) => {
    setAircraftFlightBulkDeleteSelection(flightId, selected, { render: false });
  });
  renderAircraftFlightsPanel(selectedAircraftWorkspace());
}

function selectedAircraftFlightBulkDeleteEntries(aircraft = selectedAircraftWorkspace()) {
  if (!aircraft) return [];
  return visibleFlightEntries().filter((entry) => (
    entry?.aircraft === aircraft
    && entry?.database?.flightId
    && aircraftFlightBulkDeleteSelected.has(entry.id)
  ));
}

function selectedAircraftFlightReanalyzeEntries(aircraft = selectedAircraftWorkspace()) {
  if (!aircraft) return [];
  return selectedAircraftFlightBulkDeleteEntries(aircraft)
    .filter((entry) => (
      isSupportedFlight(entry)
      && flightCanReanalyze(entry)
      && entry?.database?.planAccess?.locked !== true
      && !aircraftFlightDeletePending.has(entry.id)
    ));
}

function selectedAircraftFlightReprocessEntries(aircraft = selectedAircraftWorkspace()) {
  if (!aircraft || appReadOnlyMode()) return [];
  return selectedAircraftFlightBulkDeleteEntries(aircraft)
    .filter((entry) => (
      isSupportedFlight(entry)
      && entry?.database?.planAccess?.locked !== true
      && flightUpdateAction(entry)?.kind === "reprocess"
      && entry?.database?.uploadId
      && !aircraftFlightDeletePending.has(entry.id)
      && !aircraftUploadReprocessPending.has(entry.database.uploadId)
    ));
}

async function updateSelectedAircraftFlights(aircraft = selectedAircraftWorkspace()) {
  if (appReadOnlyMode()) {
    showAppToast(readOnlyActionMessage("Updating flights"), "info");
    syncReadOnlyUi();
    return { started: false, reason: "read-only" };
  }
  if (aircraftFlightUpdateSelectedBusy || reanalyzeAllFlightsStatus().active) {
    return { started: false, reason: "busy" };
  }
  const reprocessEntries = selectedAircraftFlightReprocessEntries(aircraft);
  const reanalyzeEntries = selectedAircraftFlightReanalyzeEntries(aircraft);
  const count = reprocessEntries.length + reanalyzeEntries.length;
  if (!count) {
    renderAircraftFlightsPanel(aircraft);
    return { started: false, reason: "no-selection" };
  }
  const confirmed = await confirmFlightsUpdateDialog({
    count,
    reprocessCount: reprocessEntries.length,
    reanalyzeCount: reanalyzeEntries.length,
  });
  if (!confirmed) return { started: false, reason: "cancelled" };
  if (aircraftFlightUpdateSelectedBusy || reanalyzeAllFlightsStatus().active) {
    return { started: false, reason: "busy" };
  }

  aircraftFlightUpdateSelectedBusy = true;
  renderAircraftFlightsPanel(aircraft);
  try {
    const uploadIds = [...new Set(reprocessEntries.map((entry) => entry.database.uploadId))];
    const reprocessTasks = uploadIds
      .map((uploadId) => reprocessDatabaseUpload(uploadId, aircraft))
      .filter(Boolean);
    if (reprocessTasks.length) {
      showAppToast(
        `Queued updates from ${uploadIds.length} original upload${uploadIds.length === 1 ? "" : "s"}.`,
      );
      renderAircraftFlightsPanel(aircraft);
      await Promise.allSettled(reprocessTasks);
    }
    const analysisResult = reanalyzeEntries.length
      ? await reanalyzeAllFlights(aircraft, reanalyzeEntries, { scope: "selected", skipConfirmation: true })
      : { started: false, reason: "no-analysis-updates" };
    return {
      started: true,
      reprocessedUploads: uploadIds.length,
      reprocessedFlights: reprocessEntries.length,
      analysisResult,
    };
  } finally {
    aircraftFlightUpdateSelectedBusy = false;
    renderAircraftFlightsPanel(aircraft);
  }
}

async function reanalyzeAvailableAircraftFlights(aircraft = selectedAircraftWorkspace()) {
  if (!aircraft) return { started: false, reason: "no-aircraft" };
  const entries = visibleFlightEntries().filter((entry) => (
    entry?.aircraft === aircraft
    && entry?.database?.flightId
    && entry.database.planAccess?.locked !== true
    && isSupportedFlight(entry)
    && flightCanReanalyze(entry)
    && !aircraftFlightDeletePending.has(entry.id)
  ));
  if (!entries.length) {
    renderAircraftFlightsPanel(aircraft);
    return { started: false, reason: "no-updates" };
  }
  return reanalyzeAllFlights(aircraft, entries, { scope: "aircraft" });
}

async function archiveSelectedAircraftFlights(aircraft = selectedAircraftWorkspace()) {
  if (appReadOnlyMode()) {
    showAppToast(readOnlyActionMessage("Archiving flights"), "info");
    syncReadOnlyUi();
    return;
  }
  const entries = selectedAircraftFlightBulkDeleteEntries(aircraft)
    .filter((entry) => !aircraftFlightDeletePending.has(entry.id));
  if (!entries.length) {
    renderAircraftFlightsPanel(aircraft);
    return;
  }
  const selectedIds = new Set(entries.map((entry) => entry.id));
  const removesSelectedFlight = Boolean(selectedFlight?.id && selectedIds.has(selectedFlight.id));
  const confirmed = await confirmFlightDeleteDialog({
    // Bulk archive deletes nothing, so the deleted-flight retention
    // disclosure (issue #405) does NOT apply; it lives on the Archive
    // tab's permanent-delete confirmation instead.
    title: `Archive ${entries.length} selected flight${entries.length === 1 ? "" : "s"}?`,
    eyebrow: "Archive Flights",
    copy: `${entries.length} selected flight${entries.length === 1 ? " moves" : "s move"} to the Archive tab in My Account and disappear${entries.length === 1 ? "s" : ""} from this list.`,
    details: "Nothing is deleted. Archived flights stop counting toward your plan limit and can be restored from the Archive tab whenever your plan has room.",
    warningTitle: "You can restore them anytime.",
    confirmLabel: entries.length === 1 ? "Archive Flight" : "Archive Flights",
    destructive: false,
  });
  if (!confirmed) return;

  entries.forEach((entry) => aircraftFlightDeletePending.add(entry.id));
  renderAircraftFlightsPanel(aircraft);

  const deletedEntries = [];
  let deleteError = null;
  try {
    for (const entry of entries) {
      revokeCachedFlightReport(entry.id);
      await archiveFlightLogSource(entry);
      deletedEntries.push(entry);
      aircraftFlightBulkDeleteSelected.delete(entry.id);
      hiddenFlightIds.delete(entry.id);
      trendExcludedFlightIds.delete(entry.id);
      trendIncludedFlightIds.delete(entry.id);
    }
  } catch (error) {
    deleteError = error;
  } finally {
    entries.forEach((entry) => aircraftFlightDeletePending.delete(entry.id));
  }

  if (deletedEntries.length) {
    saveHiddenFlightIds(hiddenFlightIds);
    saveTrendExcludedFlightIds(trendExcludedFlightIds);
    saveTrendIncludedFlightIds(trendIncludedFlightIds);
    clearStoredTrendRowsForAircraft(aircraft);
    trendCache = new Map();
    invalidateAircraftFlightFlagSummaries(aircraft, deletedEntries);
    const replacement = await refreshFlightManifestState(removesSelectedFlight ? "" : selectedFlight?.id ?? "");
    setupFlightLogSelector();
    renderAircraftWorkspace();
    if (removesSelectedFlight) {
      populateTrendAircraftSelect(replacement?.aircraft);
      if (replacement) {
        await loadFlightLog(replacement, { markSeen: false });
      } else {
        clearLoadedFlight(new Error("No visible supported flight logs"));
      }
    } else {
      populateTrendAircraftSelect(selectedFlight?.aircraft ?? replacement?.aircraft);
      updateFlightHeader();
    }
    showAppToast(
      `Archived ${deletedEntries.length} flight${deletedEntries.length === 1 ? "" : "s"}.`,
      deleteError ? "error" : "success",
    );
    notifyWorkspaceArchiveChanged();
  }

  if (deleteError) {
    const message = deletedEntries.length
      ? `Archived ${deletedEntries.length} of ${entries.length} selected flights. ${deleteError.message}`
      : deleteError.message;
    window.alert(message);
  }
  renderAircraftWorkspace();
}

function setAircraftUploadBulkDeleteSelection(uploadId, selected, { render = true } = {}) {
  const id = String(uploadId ?? "").trim();
  if (!id) return;
  if (selected) aircraftUploadBulkDeleteSelected.add(id);
  else aircraftUploadBulkDeleteSelected.delete(id);
  if (render) renderAircraftUploadsPanel(selectedAircraftWorkspace());
}

function setAircraftUploadBulkDeleteSelectionForIds(uploadIds = [], selected = true) {
  uploadIds.forEach((uploadId) => {
    setAircraftUploadBulkDeleteSelection(uploadId, selected, { render: false });
  });
  renderAircraftUploadsPanel(selectedAircraftWorkspace());
}

function selectedAircraftUploadBulkDeleteEntries(aircraft = selectedAircraftWorkspace()) {
  if (!aircraft) return [];
  return (aircraftUploadHistoryCache.get(aircraft) ?? []).filter((upload) => (
    upload?.id
    && aircraftUploadBulkDeleteSelected.has(upload.id)
  ));
}

async function requestDatabaseUploadDelete(uploadId) {
  const response = await fetch(databaseUploadDeleteEndpoint(uploadId), {
    method: "DELETE",
    headers: { Accept: "application/json" },
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(payload?.error ?? `Upload delete API HTTP ${response.status}`);
  }
  return payload;
}

async function refreshAfterDatabaseUploadDeletes(aircraft, uploadIds, uploadFlights, removesSelectedFlight) {
  uploadFlights.forEach((entry) => {
    revokeCachedFlightReport(entry.id);
    hiddenFlightIds.delete(entry.id);
    trendExcludedFlightIds.delete(entry.id);
    trendIncludedFlightIds.delete(entry.id);
  });
  saveHiddenFlightIds(hiddenFlightIds);
  saveTrendExcludedFlightIds(trendExcludedFlightIds);
  saveTrendIncludedFlightIds(trendIncludedFlightIds);
  clearStoredTrendRowsForAircraft(aircraft);
  trendCache = new Map();
  aircraftUploadHistoryCache.delete(aircraft);
  invalidateAircraftFlightFlagSummaries(aircraft, uploadFlights);
  uploadIds.forEach((uploadId) => aircraftUploadBulkDeleteSelected.delete(uploadId));
  const replacement = await refreshFlightManifestState(removesSelectedFlight ? "" : selectedFlight?.id ?? "");
  await loadAircraftUploadHistory(aircraft, { force: true }).catch(() => []);
  renderAircraftWorkspace();
  if (removesSelectedFlight) {
    if (replacement) {
      await loadFlightLog(replacement, { markSeen: false });
    } else {
      clearLoadedFlight(new Error("No visible supported flight logs"));
    }
  }
}

async function deleteDatabaseUpload(uploadId, aircraft = selectedAircraftWorkspace()) {
  if (appReadOnlyMode()) {
    aircraftUploadHistoryErrors.set(aircraft, readOnlyActionMessage("Deleting uploads"));
    renderAircraftUploadsPanel(aircraft);
    return;
  }
  if (!uploadId || aircraftUploadDeletePending.has(uploadId)) return;
  const upload = (aircraftUploadHistoryCache.get(aircraft) ?? []).find((item) => item.id === uploadId) ?? null;
  const rawFilename = upload?.original_filename ?? "this upload";
  const storageKey = upload?.storage_key ?? rawFilename;
  const uploadFlights = flightManifest.filter((entry) => entry.database?.uploadId === uploadId);
  const flightCount = uploadFlights.length || Number(upload?.supported_flight_count ?? upload?.flight_count ?? 0);
  const flightsText = `${flightCount} flight${flightCount === 1 ? "" : "s"}`;
  const confirmed = await confirmFlightDeleteDialog({
    title: `Delete ${rawFilename}?`,
    eyebrow: "Permanent Delete",
    copy: "This will permanently delete the upload job and every record created from it.",
    details: `Source file: ${storageKey}. This removes ${flightsText}, ingest jobs, generated reports, analysis artifacts, trend snapshots, and the locally stored raw upload file. This cannot be undone.`,
    confirmLabel: "Delete Upload",
    destructive: true,
  });
  if (!confirmed) return;
  const removesSelectedFlight = Boolean(selectedFlight?.database?.uploadId === uploadId);
  aircraftUploadDeletePending.add(uploadId);
  aircraftUploadHistoryErrors.delete(aircraft);
  renderAircraftUploadsPanel(aircraft);
  try {
    await requestDatabaseUploadDelete(uploadId);
    await refreshAfterDatabaseUploadDeletes(aircraft, [uploadId], uploadFlights, removesSelectedFlight);
    showAppToast?.("Upload deleted.", "success");
  } catch (error) {
    aircraftUploadHistoryErrors.set(aircraft, error.message);
  } finally {
    aircraftUploadDeletePending.delete(uploadId);
    renderAircraftWorkspace();
  }
}

async function deleteSelectedDatabaseUploads(aircraft = selectedAircraftWorkspace()) {
  if (appReadOnlyMode()) {
    aircraftUploadHistoryErrors.set(aircraft, readOnlyActionMessage("Deleting uploads"));
    renderAircraftUploadsPanel(aircraft);
    syncReadOnlyUi();
    return;
  }
  const uploads = selectedAircraftUploadBulkDeleteEntries(aircraft)
    .filter((upload) => !aircraftUploadDeletePending.has(upload.id));
  if (!uploads.length) {
    renderAircraftUploadsPanel(aircraft);
    return;
  }
  const uploadIds = uploads.map((upload) => upload.id);
  const uploadIdSet = new Set(uploadIds);
  const uploadFlights = flightManifest.filter((entry) => uploadIdSet.has(entry.database?.uploadId));
  const flightCount = uploadFlights.length || uploads.reduce((sum, upload) => (
    sum + Number(upload?.supported_flight_count ?? upload?.flight_count ?? 0)
  ), 0);
  const confirmed = await confirmFlightDeleteDialog({
    title: `Delete ${uploads.length} selected upload${uploads.length === 1 ? "" : "s"}?`,
    eyebrow: "Permanent Delete",
    copy: `This will permanently delete ${uploads.length} upload${uploads.length === 1 ? "" : "s"} and every record created from ${uploads.length === 1 ? "it" : "them"}.`,
    details: `This removes ${flightCount} flight${flightCount === 1 ? "" : "s"}, ingest jobs, generated reports, analysis artifacts, trend snapshots, and locally stored raw upload files. This cannot be undone.`,
    confirmLabel: uploads.length === 1 ? "Delete Upload" : "Delete Uploads",
    destructive: true,
  });
  if (!confirmed) return;

  uploadIds.forEach((uploadId) => aircraftUploadDeletePending.add(uploadId));
  aircraftUploadHistoryErrors.delete(aircraft);
  renderAircraftUploadsPanel(aircraft);

  const deletedUploadIds = [];
  let deleteError = null;
  try {
    for (const uploadId of uploadIds) {
      await requestDatabaseUploadDelete(uploadId);
      deletedUploadIds.push(uploadId);
      aircraftUploadBulkDeleteSelected.delete(uploadId);
    }
  } catch (error) {
    deleteError = error;
  } finally {
    uploadIds.forEach((uploadId) => aircraftUploadDeletePending.delete(uploadId));
  }

  if (deletedUploadIds.length) {
    const deletedIdSet = new Set(deletedUploadIds);
    const deletedUploadFlights = uploadFlights.filter((entry) => deletedIdSet.has(entry.database?.uploadId));
    const removesSelectedFlight = Boolean(selectedFlight?.database?.uploadId && deletedIdSet.has(selectedFlight.database.uploadId));
    await refreshAfterDatabaseUploadDeletes(aircraft, deletedUploadIds, deletedUploadFlights, removesSelectedFlight);
    showAppToast?.(
      `Deleted ${deletedUploadIds.length} upload${deletedUploadIds.length === 1 ? "" : "s"}.`,
      deleteError ? "error" : "success",
    );
  }

  if (deleteError) {
    const message = deletedUploadIds.length
      ? `Deleted ${deletedUploadIds.length} of ${uploadIds.length} selected uploads. ${deleteError.message}`
      : deleteError.message;
    aircraftUploadHistoryErrors.set(aircraft, message);
  }
  renderAircraftWorkspace();
}

function renderQueuedUploadAircraft(aircraft) {
  if (selectedAircraftWorkspace() === aircraft) renderAircraftUploadsPanel(aircraft);
}

function drainAircraftUploadReprocessQueue() {
  while (aircraftUploadReprocessActive.size < aircraftUploadReprocessConcurrency && aircraftUploadReprocessQueue.length) {
    const task = aircraftUploadReprocessQueue.shift();
    aircraftUploadReprocessActive.add(task.uploadId);
    renderQueuedUploadAircraft(task.aircraft);
    runQueuedAircraftUploadReprocess(task);
  }
}

function reprocessDatabaseUpload(uploadId, aircraft = selectedAircraftWorkspace(), { silent = false } = {}) {
  if (appReadOnlyMode()) {
    aircraftUploadHistoryErrors.set(aircraft, readOnlyActionMessage("Reprocessing uploads"));
    renderAircraftUploadsPanel(aircraft);
    return;
  }
  if (!uploadId) return;
  if (aircraftUploadReprocessPending.has(uploadId)) return aircraftUploadReprocessTasks.get(uploadId);
  aircraftUploadReprocessPending.add(uploadId);
  aircraftUploadHistoryErrors.delete(aircraft);
  renderAircraftUploadsPanel(aircraft);
  const taskPromise = new Promise((resolve) => {
    aircraftUploadReprocessQueue.push({ uploadId, aircraft, silent, resolve });
  });
  aircraftUploadReprocessTasks.set(uploadId, taskPromise);
  drainAircraftUploadReprocessQueue();
  return taskPromise;
}

function reprocessableAircraftUploads(aircraft = selectedAircraftWorkspace()) {
  if (!aircraft || appReadOnlyMode()) return [];
  return (aircraftUploadHistoryCache.get(aircraft) ?? []).filter((upload) => uploadCanReprocess(upload, {
    reprocessPending: aircraftUploadReprocessPending.has(upload.id),
    deletePending: aircraftUploadDeletePending.has(upload.id),
  }));
}

function selectedAircraftUploadReprocessEntries(aircraft = selectedAircraftWorkspace()) {
  if (!aircraft || appReadOnlyMode()) return [];
  return (aircraftUploadHistoryCache.get(aircraft) ?? []).filter((upload) => (
    upload?.id
    && aircraftUploadBulkDeleteSelected.has(upload.id)
    && uploadCanReprocess(upload, {
      reprocessPending: aircraftUploadReprocessPending.has(upload.id),
      deletePending: aircraftUploadDeletePending.has(upload.id),
    })
  ));
}

async function reprocessSelectedDatabaseUploads(aircraft = selectedAircraftWorkspace()) {
  if (appReadOnlyMode()) {
    aircraftUploadHistoryErrors.set(aircraft, readOnlyActionMessage("Reprocessing uploads"));
    renderAircraftUploadsPanel(aircraft);
    return [];
  }
  const uploads = selectedAircraftUploadReprocessEntries(aircraft);
  if (!uploads.length) {
    renderAircraftUploadsPanel(aircraft);
    return [];
  }
  const tasks = uploads.map((upload) => reprocessDatabaseUpload(upload.id, aircraft)).filter(Boolean);
  showAppToast?.(`Queued ${uploads.length} selected upload${uploads.length === 1 ? "" : "s"} for reprocessing.`);
  await Promise.allSettled(tasks);
  return tasks;
}

async function reprocessAllDatabaseUploads(aircraft = selectedAircraftWorkspace()) {
  if (appReadOnlyMode()) {
    aircraftUploadHistoryErrors.set(aircraft, readOnlyActionMessage("Reprocessing uploads"));
    renderAircraftUploadsPanel(aircraft);
    return [];
  }
  const uploads = reprocessableAircraftUploads(aircraft);
  if (!uploads.length) {
    renderAircraftUploadsPanel(aircraft);
    return [];
  }
  const tasks = uploads.map((upload) => reprocessDatabaseUpload(upload.id, aircraft)).filter(Boolean);
  showAppToast?.(`Queued ${uploads.length} upload${uploads.length === 1 ? "" : "s"} for reprocessing.`);
  await Promise.allSettled(tasks);
  return tasks;
}

async function runQueuedAircraftUploadReprocess(task) {
  const { uploadId, aircraft, silent, resolve } = task;
  let outcome = { status: "failed" };
  try {
    const response = await fetch(databaseUploadReprocessEndpoint(uploadId), { method: "POST" });
    const payload = await response.json().catch(() => null);
    if (!response.ok) {
      if (response.status === 503 && payload?.integrity) {
        console.warn("Reprocess refused — database integrity check failed:", payload.integrity);
      }
      throw new Error(payload?.error ?? `Upload reprocess API HTTP ${response.status}`);
    }
    await loadAircraftUploadHistory(aircraft, { force: true }).catch(() => []);
    renderAircraftUploadsPanel(aircraft);
    const jobId = payload?.ingestJob?.id;
    if (jobId) {
      await waitForDatabaseUploadIngest(jobId, {
        onStatus: () => {
          loadAircraftUploadHistory(aircraft, { force: true })
            .then(() => {
              if (selectedAircraftWorkspace() === aircraft) renderAircraftUploadsPanel(aircraft);
            })
            .catch(() => {
              if (selectedAircraftWorkspace() === aircraft) renderAircraftUploadsPanel(aircraft);
            });
        },
      });
    }
    await loadAircraftUploadHistory(aircraft, { force: true });
    await refreshFlightManifestState(selectedFlight?.id ?? "");
    outcome = { status: "completed", uploadId };
  } catch (error) {
    outcome = { status: "failed", uploadId, error: error.message };
    if (silent) {
      console.warn("Background upload reprocess failed", error);
    } else {
      aircraftUploadHistoryErrors.set(aircraft, error.message);
      showAppToast(error.message, "error");
    }
  } finally {
    aircraftUploadReprocessActive.delete(uploadId);
    aircraftUploadReprocessPending.delete(uploadId);
    aircraftUploadReprocessTasks.delete(uploadId);
    renderAircraftWorkspace();
    resolve?.(outcome);
    drainAircraftUploadReprocessQueue();
  }
}

async function syncFlightAfterBackgroundUpgrade(entry) {
  if (!entry?.id) return;
  const selectedEntryId = selectedFlight?.id ?? "";
  const refreshed = await refreshFlightManifestState(
    selectedEntryId === entry.id ? entry.id : selectedEntryId,
    selectedEntryId === entry.id ? entry.path : "",
  ).catch((error) => {
    console.warn("Could not refresh flight state after a background upgrade", error);
    return null;
  });
  const refreshedEntry = flightManifest.find((candidate) => candidate.id === entry.id) ?? refreshed;
  if (selectedEntryId === entry.id && refreshedEntry?.id === entry.id) {
    selectedFlight = refreshedEntry;
    selectedFlightStorageId = refreshedEntry.id;
    updateFlightHeader();
    if (healthSummary) renderHealthSummary(healthSummary);
  }
  renderAircraftWorkspace();
  if (document.querySelector("#view-trends")?.classList.contains("is-active")) {
    populateTrendAircraftSelect(entry.aircraft);
    renderTrendsForSelection({ force: true });
  }
}

async function processShortFlightsForDatabaseUpload(uploadId, aircraft = selectedAircraftWorkspace()) {
  if (appReadOnlyMode()) {
    aircraftUploadHistoryErrors.set(aircraft, readOnlyActionMessage("Processing short flights"));
    renderAircraftUploadsPanel(aircraft);
    return;
  }
  if (!uploadId || aircraftUploadProcessShortPending.has(uploadId)) return;
  aircraftUploadProcessShortPending.add(uploadId);
  aircraftUploadHistoryErrors.delete(aircraft);
  renderAircraftUploadsPanel(aircraft);
  try {
    const response = await fetch(databaseUploadProcessShortFlightsEndpoint(uploadId), { method: "POST" });
    const payload = await response.json().catch(() => null);
    if (!response.ok) {
      if (response.status === 503 && payload?.integrity) {
        console.warn("Process short flights refused — database integrity check failed:", payload.integrity);
      }
      throw new Error(payload?.error ?? `Process short flights API HTTP ${response.status}`);
    }
    await loadAircraftUploadHistory(aircraft, { force: true }).catch(() => []);
    renderAircraftUploadsPanel(aircraft);
    const jobId = payload?.ingestJob?.id;
    if (jobId) {
      await waitForDatabaseUploadIngest(jobId, {
        onStatus: () => {
          loadAircraftUploadHistory(aircraft, { force: true })
            .then(() => {
              if (selectedAircraftWorkspace() === aircraft) renderAircraftUploadsPanel(aircraft);
            })
            .catch(() => {
              if (selectedAircraftWorkspace() === aircraft) renderAircraftUploadsPanel(aircraft);
            });
        },
      });
    }
    await loadAircraftUploadHistory(aircraft, { force: true });
    await refreshFlightManifestState(selectedFlight?.id ?? "");
  } catch (error) {
    aircraftUploadHistoryErrors.set(aircraft, error.message);
  } finally {
    aircraftUploadProcessShortPending.delete(uploadId);
    renderAircraftWorkspace();
  }
}


function flightMetadataHydrationTargets(entries = []) {
  const storeTargets = [];
  return { storeTargets, databaseTargets: [] };
  for (const entry of entries) {
    const key = entry?.id ?? "";
    if (key
      && !entry?.database?.reportId
      && !flightReportCache.has(key)
      && !flightReportStoredMetadata.has(key)
      && !flightReportMetadataChecked.has(`store:${key}`)
      && !flightReportMetadataPending.has(`store:${key}`)) {
      storeTargets.push(entry);
    }
  }
  return { storeTargets, databaseTargets: [] };
}

function updateDataSourceLabel(loaded, error) {
  const label = document.querySelector("#dataSourceLabel");
  if (!label) return;
  const trimNote = endpointTrimInfo.total
    ? ` · ${endpointTrimInfo.total.toLocaleString()} endpoint sample${endpointTrimInfo.total === 1 ? "" : "s"} trimmed`
    : "";
  const resampleNote = sourceRawRows > sourceRows
    ? ` from ${sourceRawRows.toLocaleString()} raw rows`
    : "";
  label.textContent = loaded
    ? `Data Source: ${sourceName} · ${sourceRows.toLocaleString()} samples${resampleNote}${trimNote}`
    : `Data Source: generated fallback${error ? ` · ${error.message}` : ""}`;
  const rate = document.querySelector("#dataSourceRate");
  if (rate) rate.textContent = loaded ? sampleRateSummary() : "Generated sample";
}

// Flights with an AI summary generation in flight. Keyed by flight id so a
// second click on the same button navigates to the panel instead of kicking off
// a duplicate generation.
const aiSummaryGenerationInFlight = new Set();

async function openOrGenerateFlightAiSummary(entry, button = null) {
  if (!entry?.id) return;
  if (aiSummaryGenerationInFlight.has(entry.id)) {
    activateView("dashboard");
    if (!reportPanelIsActive("ai-review")) activateDashboardAiReviewPanel();
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    return;
  }
  if (!flightAiSummaryAvailable(entry) && !aiSummaryAvailableForEntry(entry)) {
    window.alert("AI summaries require a persisted flight with a completed analysis run.");
    return;
  }
  const originalText = button?.textContent ?? "";
  const originalMarkup = button?.innerHTML ?? "";
  const originalAriaLabel = button?.getAttribute("aria-label") ?? "";
  const hadSummary = flightAiSummaryAvailable(entry);
  const iconOnlyButton = button?.classList?.contains("is-icon-only");
  if (appReadOnlyMode() && !hadSummary) {
    window.alert(readOnlyActionMessage("Generating AI summaries"));
    syncReadOnlyUi();
    renderAircraftFlightsPanel(entry.aircraft);
    return;
  }
  aiSummaryGenerationInFlight.add(entry.id);
  let aiSummarySucceeded = false;
  try {
    if (button) {
      // Deliberately NOT disabled. Clicking the AI button is how you GET to the
      // summary, so it has to stay clickable while one is generating — a
      // disabled button stranded the user away from the panel they were
      // waiting on. aria-busy carries the state for assistive tech, and the
      // re-entry guard above stops a second click starting a second run.
      button.setAttribute("aria-busy", "true");
      // Emphasize immediately: the button takes its "summary exists" styling
      // the moment generation starts, not only after it completes.
      button.classList.add("is-generating", "has-summary");
      button.setAttribute("aria-label", hadSummary ? "Opening AI summary" : "Generating AI summary");
      if (!iconOnlyButton) button.textContent = hadSummary ? "Opening" : "Summarizing";
    }
    activateView("dashboard");
    if (!reportPanelIsActive("ai-review")) activateDashboardAiReviewPanel();
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    if (hadSummary) {
      // Reading a cached summary: show it immediately without the heavy flight
      // overlay. Select the flight for context, fetch the cached summary (its own
      // light loader), then hydrate the flight in the background so the inline
      // charts and finding links light up a moment later.
      const alreadyLoaded = selectedFlight?.id === entry.id && Array.isArray(flightData) && flightData.length > 0;
      selectedFlight = entry;
      await loadAiSummaryForSelectedFlight({ force: false, scrollIntoView: true });
      if (!alreadyLoaded) {
        void loadFlightLog(entry, { background: true, activateTrial: true }).catch((bgError) => {
          console.error("Background flight hydrate for AI summary failed", bgError);
        });
      }
    } else {
      // Generating: the flight's analysis backs the summary, so load it first.
      await loadFlightLog(entry, { activateTrial: true });
      await loadAiSummaryForSelectedFlight({ force: true, scrollIntoView: true });
    }
    aiSummarySucceeded = true;
    // Stamp the FLIGHTS-TABLE entry, not just whatever object the summary
    // loader held. renderAircraftFlightsPanel below rebuilds the row from the
    // manifest, so without this the freshly generated summary is invisible to
    // the row and the button reverts to its pre-generation state until a full
    // page refresh.
    const generatedSummary = aiSummaryState?.payload?.aiSummary ?? null;
    if (generatedSummary?.id && !entry?.database?.aiSummaryId) {
      updateManifestAiSummaryMetadata(entry, generatedSummary);
    }
  } catch (error) {
    console.error("Flight history AI summary failed", error);
    window.alert(`Could not open AI summary: ${error.message}`);
  } finally {
    aiSummaryGenerationInFlight.delete(entry.id);
    if (button) {
      button.removeAttribute("aria-busy");
      button.classList.remove("is-generating");
      // Judge by whether generation SUCCEEDED, not by re-reading the entry:
      // flightAiSummaryAvailable() reads entry.database.aiSummaryId off the
      // manifest object, which the generate path does not always stamp (the
      // summary loader may hold a different object). Re-reading it here stripped
      // the green "has-summary" state off a button whose summary had just been
      // created, and it only came back on a full page refresh.
      const summaryNowExists = aiSummarySucceeded || flightAiSummaryAvailable(entry);
      if (!summaryNowExists) button.classList.remove("has-summary");
      if (summaryNowExists) {
        button.innerHTML = aircraftFlightAiSummaryIconMarkup();
        button.setAttribute("aria-label", "Open AI summary");
      } else if (iconOnlyButton) {
        button.innerHTML = originalMarkup || aircraftFlightAiSummaryIconMarkup();
        button.setAttribute("aria-label", originalAriaLabel || "Generate AI summary");
      } else {
        button.textContent = originalText || "Generate Summary";
        if (originalAriaLabel) button.setAttribute("aria-label", originalAriaLabel);
      }
    }
    renderAircraftFlightsPanel(entry.aircraft);
  }
}

function rawChannelKeys() {
  const cache = currentFlightDerivedCache();
  if (!cache.rawChannelKeys) cache.rawChannelKeys = rawChannelKeysForData(flightData);
  return cache.rawChannelKeys;
}

function rawChannelStats(key) {
  const cache = currentFlightDerivedCache();
  if (cache.rawChannelStats.has(key)) return cache.rawChannelStats.get(key);
  const values = flightData.map((point) => point[key]).filter(Number.isFinite);
  const extent = extentFromValues(values);
  const total = values.reduce((sum, value) => sum + value, 0);
  const stats = {
    count: values.length,
    missing: Math.max(0, flightData.length - values.length),
    min: extent?.min ?? null,
    max: extent?.max ?? null,
    avg: values.length ? total / values.length : null,
  };
  cache.rawChannelStats.set(key, stats);
  return stats;
}

function flightDurationSeconds() {
  const cache = currentFlightDerivedCache();
  if (Number.isFinite(cache.durationSeconds)) return cache.durationSeconds;
  const values = flightData.map((point) => point.elapsedSeconds).filter(Number.isFinite);
  const extent = extentFromValues(values);
  const duration = extent ? Math.max(0, extent.max - extent.min) : Math.max(0, flightData.length - 1);
  cache.durationSeconds = duration;
  return duration;
}

function sampleRateSummary() {
  const duration = flightDurationSeconds();
  if (!duration || flightData.length < 2) return "n/a";
  const rate = (flightData.length - 1) / duration;
  const interval = duration / (flightData.length - 1);
  return `${rate >= 10 ? rate.toFixed(1) : rate.toFixed(2)} Hz · ${interval.toFixed(2)} s/sample`;
}

function maxFiniteForKeys(keys, minimum = -Infinity) {
  let max = -Infinity;
  keys.forEach((key) => {
    const value = maxFiniteForKey(key, minimum);
    if (Number.isFinite(value) && value > max) max = value;
  });
  return max === -Infinity ? null : max;
}

function maxFiniteForKey(key, minimum = -Infinity) {
  const cache = currentFlightDerivedCache();
  const cacheKey = `${key}|${minimum}`;
  if (cache.maxFiniteByKey.has(cacheKey)) return cache.maxFiniteByKey.get(cacheKey);
  let max = -Infinity;
  flightData.forEach((point) => {
    const value = point[key];
    if (Number.isFinite(value) && value > minimum) max = Math.max(max, value);
  });
  const result = max === -Infinity ? null : max;
  cache.maxFiniteByKey.set(cacheKey, result);
  return result;
}

function fuelUsedMetric() {
  const cache = currentFlightDerivedCache();
  if (cache.fuelUsedMetric) return cache.fuelUsedMetric;
  cache.fuelUsedMetric = fuelUsedMetricModel(flightData);
  return cache.fuelUsedMetric;
}

function estimatePower(point) {
  return estimatePowerModel(point);
}

function powerEstimateRows(data = flightData, scope = "work") {
  return powerEstimateRowsModel(data, scope, { engineWorkPoint, estimatePower });
}

function powerEstimateSummary(data = flightData, scope = "work") {
  if (data === flightData) {
    const cache = currentFlightDerivedCache();
    if (cache.powerEstimateSummary.has(scope)) return cache.powerEstimateSummary.get(scope);
    const summary = powerEstimateSummaryUncached(data, scope);
    cache.powerEstimateSummary.set(scope, summary);
    return summary;
  }
  return powerEstimateSummaryUncached(data, scope);
}

function powerEstimateSummaryUncached(data = flightData, scope = "work") {
  return powerEstimateSummaryModel(data, scope, { engineWorkPoint, estimatePower });
}

function preferredPowerEstimateSummary(data = flightData) {
  return preferredPowerEstimateSummaryModel(data, { powerEstimateSummary });
}

function estimatedHpMetric(scope = "work") {
  return estimatedHpMetricModel(flightData, scope, { powerEstimateSummary });
}

function estimatedTorqueMetric(scope = "work") {
  return estimatedTorqueMetricModel(flightData, scope, { powerEstimateSummary });
}

function setText(selector, value) {
  const element = document.querySelector(selector);
  if (element) element.textContent = value;
}

// Build the fully-resolved options computeRawAnalysisMetrics / finalizeAnalysisSummary
// expect. Extracted from calculateHealthSummary so the off-main-thread trend
// analyzer (calculateTrendFlightSummaryOffThread) lands on the identical option
// shape -- and therefore the identical rawAnalysisSignature and bundle -- as this
// synchronous path.
function resolveHealthSummaryOptions(options = {}) {
  const aircraftProfile = options.aircraftProfile ?? aircraftProfileForEntry(options.selectedEntry);
  const parserMetadata = options.parserMetadata ?? currentParserMetadata;
  const aircraft = options.selectedEntry?.aircraft ?? selectedFlight?.aircraft ?? selectedAircraftWorkspace();
  const disabledMetricKeys = Array.isArray(options.disabledMetricKeys)
    ? options.disabledMetricKeys
    : disabledReviewMonitorKeyList(aircraft);
  const coolingRateThresholdFpm = Number.isFinite(Number(options.coolingRateThresholdFpm))
    ? Number(options.coolingRateThresholdFpm)
    : coolingRateTriggerFpm(aircraft);
  return {
    skipContextDetectors: true,
    ...options,
    aircraftProfile,
    parserMetadata,
    parserId: parserMetadata?.parserId ?? options.selectedEntry?.parser,
    disabledMetricKeys,
    coolingRateThresholdFpm,
    buildFinding,
    staticValveRowsForAircraft,
    trendDateValue,
    formatPointTime,
    phaseForWindow: candidateMagPhase,
    perfMark: DASHBOARD_PERF_LOG ? perfMark : undefined,
  };
}

function calculateHealthSummary(data, options = {}) {
  const resolvedOptions = resolveHealthSummaryOptions(options);
  const parserMetadata = resolvedOptions.parserMetadata;
  const aircraft = resolvedOptions.selectedEntry?.aircraft ?? selectedFlight?.aircraft ?? selectedAircraftWorkspace();
  if (data !== flightData || options.metricScoreScope === "engine") {
    return calculateAnalysisSummary(data, resolvedOptions);
  }
  const signature = rawAnalysisSignature(aircraft, parserMetadata, resolvedOptions);
  let cached = rawAnalysisCache.get(signature);
  if (!cached || cached.data !== data) {
    cached = {
      data,
      bundle: perfTimeSync("analysis(miss)", () => computeRawAnalysisMetrics(data, resolvedOptions)),
    };
    rawAnalysisCache.set(signature, cached);
    // Persist the freshly computed bundle so a later page reload / relaunch can
    // skip the expensive recompute. Fire-and-forget: never blocks render and
    // never throws (caching is a pure optimization).
    const persistEntry = options.selectedEntry ?? selectedFlight;
    const persistKey = persistentRawAnalysisCacheKey(persistEntry, signature);
    const persistBundle = cached.bundle;
    Promise.resolve()
      .then(() => writeCachedRawAnalysisBundle(persistKey, rawAnalysisCacheFlightId(persistEntry), persistBundle))
      .catch(() => {});
  } else {
    perfMark("analysis(hit)", 0);
  }
  return perfTimeSync("finalizeAnalysis", () =>
    finalizeAnalysisSummary(cached.bundle, resolvedOptions),
  );
}

function rawAnalysisSignature(aircraft, parserMetadata, options) {
  const profile = options.aircraftProfile ?? aircraftProfiles?.[aircraft] ?? null;
  const profileHash = trendHashString(JSON.stringify(profile ?? null));
  return [
    aircraft ?? "",
    parserMetadata?.parserId ?? options.parserId ?? options.selectedEntry?.parser ?? "",
    options.selectedEntry?.id ?? "",
    options.selectedEntry?.database?.analysisRunId ?? "",
    profileHash,
    reviewSettingsSignature(aircraft),
    options.skipContextDetectors === true
      ? "context:skip"
      : options.contextCardsOnly === true ? "context:cards" : "context:full",
  ].join("|");
}

// Compose the persistent (IndexedDB) cache key from the in-memory signature
// plus the flight's content identity, so a source-file change, re-normalization,
// or ANALYSIS_VERSION bump naturally lands on a different key.
function persistentRawAnalysisCacheKey(entry, signature) {
  return rawAnalysisCacheKey({
    analysisVersion: ANALYSIS_VERSION,
    sourceHash: entry?.sourceHash ?? null,
    normalizedArtifactId: entry?.database?.normalizedArtifactId ?? null,
    analysisRunId: entry?.database?.analysisRunId ?? null,
    signature,
  });
}

// Before the synchronous health-summary render runs, try to hydrate tier-1
// (rawAnalysisCache) from the persistent store for the dashboard's analysis
// path. On a hit, calculateHealthSummary later sees a plain in-memory hit and
// skips computeRawAnalysisMetrics entirely. Mirrors the exact signature
// calculateHealthSummary builds for healthSummaryOptions() (skipContextDetectors
// false, contextCardsOnly true). Any failure is swallowed -> normal recompute.
async function primeRawAnalysisCacheFromStore(entry, data, parserMetadata) {
  if (!entry || data !== flightData) return;
  const aircraft = entry.aircraft ?? selectedFlight?.aircraft ?? selectedAircraftWorkspace();
  const signature = rawAnalysisSignature(aircraft, parserMetadata, {
    selectedEntry: entry,
    parserId: parserMetadata?.parserId ?? entry.parser,
    skipContextDetectors: false,
    contextCardsOnly: true,
  });
  if (rawAnalysisCache.has(signature)) return;
  const key = persistentRawAnalysisCacheKey(entry, signature);
  let bundle = null;
  try {
    bundle = await readCachedRawAnalysisBundle(key);
  } catch {
    bundle = null;
  }
  // The flight may have changed during the async read, or another path may have
  // computed the bundle meanwhile.
  if (!bundle || data !== flightData || rawAnalysisCache.has(signature)) return;
  rawAnalysisCache.set(signature, { data, bundle });
  perfMark("analysis(store-hit)", 0);
}

// Off-main-thread companion to primeRawAnalysisCacheFromStore: on a cold load
// (tier-1 + tier-2 both missed) compute the dashboard analysis bundle in a Web
// Worker and seed tier-1 (and persist tier-2) under the exact signature the
// synchronous calculateHealthSummary will look up below. The synchronous render
// then lands a cache hit and only runs the cheap finalize step, so the main
// thread never blocks on the detector pass. Any failure (worker disabled,
// unsupported, clone error, ...) leaves the cache untouched, so the synchronous
// pass runs as the fallback exactly as it did before this optimization.
async function primeRawAnalysisCacheFromWorker(entry, data, parserMetadata) {
  if (!analysisWorkerAvailable() || !entry || data !== flightData) return;
  const aircraft = entry.aircraft ?? selectedFlight?.aircraft ?? selectedAircraftWorkspace();
  // Mirror the resolvedOptions calculateHealthSummary builds for the dashboard
  // path (healthSummaryOptions => skipContextDetectors:false, contextCardsOnly:true)
  // so rawAnalysisSignature() lands on the identical key.
  const resolvedOptions = {
    ...healthSummaryOptions(),
    selectedEntry: entry,
    aircraftProfile: aircraftProfileForEntry(entry),
    parserMetadata,
    parserId: parserMetadata?.parserId ?? entry.parser,
    disabledMetricKeys: disabledReviewMonitorKeyList(aircraft),
    coolingRateThresholdFpm: coolingRateTriggerFpm(aircraft),
  };
  const signature = rawAnalysisSignature(aircraft, parserMetadata, resolvedOptions);
  if (rawAnalysisCache.has(signature)) return;
  let bundle = null;
  try {
    bundle = await computeRawAnalysisBundleInWorker(data, resolvedOptions);
  } catch {
    bundle = null;
  }
  // The flight may have changed during the async compute, or another path may
  // have populated the cache meanwhile.
  if (!bundle || data !== flightData || rawAnalysisCache.has(signature)) return;
  rawAnalysisCache.set(signature, { data, bundle });
  const persistKey = persistentRawAnalysisCacheKey(entry, signature);
  const persistFlightId = rawAnalysisCacheFlightId(entry);
  Promise.resolve()
    .then(() => writeCachedRawAnalysisBundle(persistKey, persistFlightId, bundle))
    .catch(() => {});
  perfMark("analysis(worker-hit)", 0);
}

// Engine-scope companion to primeRawAnalysisCacheFromWorker. The per-engine
// health summary (scopedHealthSummaryForEngine) runs the detector pass
// synchronously on the main thread the first time each engine is selected on a
// twin, freezing the UI for several seconds. Pre-compute each engine's scoped
// bundle in the worker and seed rawScopedAnalysisCache under the exact key and
// signature scopedHealthSummaryForEngine looks up, so the later synchronous
// engine-scope render lands a cache hit and only runs the cheap finalize step.
// Fire-and-forget: selectedEngineScope always resets to "aircraft" on load, so
// engine selection is a later user click that this prime normally beats. Any
// failure (worker unavailable, flight changed mid-compute) leaves the synchronous
// pass as the fallback exactly as before.
async function primeScopedAnalysisCacheFromWorker(entry, data) {
  if (!analysisWorkerAvailable() || !entry || data !== flightData) return;
  const engines = currentEngineDescriptors().filter((engine) => engine && engine.side !== "single");
  if (engines.length < 2) return;
  const aircraft = entry.aircraft;
  // Mirror scopedHealthSummaryForEngine's signature/options exactly so the
  // bundle lands under the key its synchronous lookup builds.
  const scopedSignature = `${aircraft ?? ""}|${entry?.parser ?? ""}|${reviewSettingsSignature(aircraft)}`;
  const scopedOptions = {
    selectedEntry: entry,
    aircraftProfile: aircraftProfileForEntry(entry),
    parserMetadata: currentParserMetadata,
    parserId: currentParserMetadata?.parserId ?? entry?.parser,
    crossFlightRows: [],
    metricScoreScope: "engine",
    sensitivity: detectionSensitivity,
    disabledMetricKeys: disabledReviewMonitorKeyList(aircraft),
    coolingRateThresholdFpm: coolingRateTriggerFpm(aircraft),
  };
  for (const engine of engines) {
    if (data !== flightData) return;
    if (
      rawScopedAnalysisCache.data === flightData
      && rawScopedAnalysisCache.signature === scopedSignature
      && rawScopedAnalysisCache.bundles.has(engine.id)
    ) continue;
    let bundle = null;
    try {
      const scopedData = projectedEngineData(flightData, engine);
      bundle = await computeRawAnalysisBundleInWorker(scopedData, { ...scopedOptions,
        analysisEngine: { id: engine.id, engineKey: engine.engineKey, engineNumber: engine.engineNumber } });
    } catch {
      bundle = null;
    }
    if (!bundle || data !== flightData) return;
    if (rawScopedAnalysisCache.data !== flightData || rawScopedAnalysisCache.signature !== scopedSignature) {
      rawScopedAnalysisCache = { data: flightData, signature: scopedSignature, bundles: new Map() };
    }
    if (!rawScopedAnalysisCache.bundles.has(engine.id)) {
      rawScopedAnalysisCache.bundles.set(engine.id, bundle);
    }
  }
}

// Post the expensive detector pass to the Web Worker and return its bundle.
// Strips function-valued options (the worker reconstructs equivalents from
// serializable data) and pre-resolves on the main thread the two that depend on
// app state the worker can't see: the aircraft's static valve history and the
// current flight's trend date. Worker-side perf marks are replayed into the
// dashboard perf log. Rejects on worker failure so the caller falls back to
// the synchronous pass.
async function computeRawAnalysisBundleInWorker(data, resolvedOptions) {
  const entry = resolvedOptions.selectedEntry ?? selectedFlight;
  const payloadOptions = {
    aircraftProfile: resolvedOptions.aircraftProfile ?? null,
    parserMetadata: resolvedOptions.parserMetadata ?? null,
    parserId: resolvedOptions.parserId ?? resolvedOptions.parserMetadata?.parserId ?? entry?.parser ?? null,
    engineLayout: resolvedOptions.engineLayout ?? resolvedOptions.parserMetadata?.engineLayout ?? null,
    crossFlightRows: Array.isArray(resolvedOptions.crossFlightRows) ? resolvedOptions.crossFlightRows : [],
    skipContextDetectors: resolvedOptions.skipContextDetectors === true,
    contextCardsOnly: resolvedOptions.contextCardsOnly === true,
    metricScoreScope: resolvedOptions.metricScoreScope ?? null,
    analysisEngine: resolvedOptions.analysisEngine ?? null,
    coolingRateThresholdFpm: resolvedOptions.coolingRateThresholdFpm ?? null,
    staticValveRows: staticValveRowsForAircraft(entry) ?? [],
    currentDateValue: trendDateValue(entry ?? {}, []),
  };
  const { bundle, perfMarks } = await runRawAnalysisInWorker({ data, options: payloadOptions });
  for (const mark of perfMarks) perfMark(mark.label, mark.ms);
  return bundle;
}

// Off-main-thread health summary for the client trends loop. Every flight in
// buildAircraftTrends is a historical flight (data !== flightData), so the
// synchronous calculateHealthSummary runs the full detector pass with no caching
// -- ~2s per flight, so a 56-flight aircraft freezes the main thread for ~2
// minutes. This variant (1) reuses the persistent IndexedDB bundle cache so
// repeat builds and reloads skip the detector pass entirely, and (2) computes a
// cold bundle in the Web Worker so the main thread stays responsive. It returns
// the exact same summary as calculateHealthSummary(data, options) for a
// non-current flight, and falls back to the synchronous pass on any worker
// failure, so correctness is unchanged -- only the thread it runs on and whether
// the cache is consulted.
async function calculateTrendFlightSummaryOffThread(data, options = {}) {
  let effectiveOptions = options;
  // Analyze non-current flights with their OWN parser metadata instead of the
  // loaded flight's (resolveHealthSummaryOptions falls back to
  // currentParserMetadata). Per-flight gates — like the unaligned CGR-combo
  // aux-channel strip — depend on it, and the envelope is already cached from
  // the parseFlightEntry call that produced `data`.
  if (!options.parserMetadata && options.selectedEntry) {
    try {
      const envelope = await parseFlightEntryEnvelope(options.selectedEntry);
      effectiveOptions = { ...options, parserMetadata: parserMetadataFromEnvelope(envelope) };
    } catch {
      // Envelope unavailable: keep the currentParserMetadata fallback.
    }
  }
  const resolvedOptions = resolveHealthSummaryOptions(effectiveOptions);
  const entry = resolvedOptions.selectedEntry ?? null;
  const aircraft = entry?.aircraft ?? selectedFlight?.aircraft ?? selectedAircraftWorkspace();
  const signature = rawAnalysisSignature(aircraft, resolvedOptions.parserMetadata, resolvedOptions);
  const persistKey = persistentRawAnalysisCacheKey(entry, signature);
  let bundle = null;
  try {
    bundle = await readCachedRawAnalysisBundle(persistKey);
  } catch {
    bundle = null;
  }
  if (bundle) {
    return finalizeAnalysisSummary(bundle, resolvedOptions);
  }
  if (analysisWorkerAvailable()) {
    try {
      bundle = await computeRawAnalysisBundleInWorker(data, resolvedOptions);
    } catch {
      bundle = null;
    }
    if (bundle) {
      const persistFlightId = rawAnalysisCacheFlightId(entry);
      Promise.resolve()
        .then(() => writeCachedRawAnalysisBundle(persistKey, persistFlightId, bundle))
        .catch(() => {});
      return finalizeAnalysisSummary(bundle, resolvedOptions);
    }
  }
  // Worker disabled/unavailable/failed, or persistent miss with no worker:
  // fall back to the original synchronous detector pass.
  return calculateAnalysisSummary(data, resolvedOptions);
}

// Re-apply a saved review-settings change to the dashboard without freezing the
// main thread. The new disabled-monitor set re-keys rawAnalysisSignature, so a
// bare updateHealthSummary() would miss the cache and run the detector pass
// synchronously (a multi-second stall). Prime the cache off the main thread
// (persistent store, then Web Worker) under the signature the synchronous render
// looks up — exactly like flight load — so updateHealthSummary() lands a cache
// hit and only runs the cheap finalize. Self-guards against a flight switch
// mid-compute. Called fire-and-forget from the review-settings save handler.
async function reapplyDashboardAnalysisForReviewSettings() {
  const entry = selectedFlight;
  const data = flightData;
  if (!entry || !data?.length) return;
  await primeRawAnalysisCacheFromStore(entry, data, currentParserMetadata);
  await primeRawAnalysisCacheFromWorker(entry, data, currentParserMetadata);
  if (selectedFlight !== entry || flightData !== data) return;
  await waitForUiFrame();
  if (selectedFlight !== entry || flightData !== data) return;
  updateHealthSummary();
  renderEnginePanel();
  scheduleDrawAll();
}

function quantile(values, q) {
  const sorted = values.filter(Number.isFinite).sort((a, b) => a - b);
  if (!sorted.length) return null;
  const index = Math.min(sorted.length - 1, Math.max(0, Math.floor((sorted.length - 1) * q)));
  return sorted[index];
}

function clampScore(score) {
  return Math.max(0, Math.min(100, Math.round(score)));
}

function healthMetricScope(key) {
  return healthMetricScopeForKey(key);
}

function reviewSettingsAircraft(defaultAircraft = selectedFlight?.aircraft ?? selectedAircraftWorkspace()) {
  return reviewSettingsAircraftId(defaultAircraft);
}

function disabledReviewMonitorKeys(aircraft = reviewSettingsAircraft()) {
  return disabledReviewMonitorKeysForAircraft(aircraftReviewSettings, aircraft);
}

function disabledReviewMonitorKeyList(aircraft = reviewSettingsAircraft()) {
  return disabledReviewMonitorKeyListForAircraft(aircraftReviewSettings, aircraft);
}

function coolingRateTriggerFpm(aircraft = reviewSettingsAircraft()) {
  return coolingRateTriggerSettingForAircraft(aircraftReviewSettings, aircraft);
}

function reviewMonitorEnabled(key, aircraft = reviewSettingsAircraft()) {
  return reviewMonitorEnabledForAircraft(aircraftReviewSettings, aircraft, key)
    && reviewMonitorCapabilityAvailable(key, aircraft);
}

function reviewMonitorCapabilityAvailable(key, aircraft = reviewSettingsAircraft()) {
  const aircraftId = reviewSettingsAircraftId(aircraft);
  const profile = aircraftProfiles?.[aircraftId] ?? aircraftProfiles?.[aircraft] ?? null;
  const capability = aircraftMonitorCapability([], profile);
  return capability.get(key)?.available !== false;
}

function reviewSettingsSignature(aircraft = reviewSettingsAircraft()) {
  return reviewSettingsSignatureForAircraft(aircraftReviewSettings, aircraft);
}

function scoreMarkup(metric) {
  if (!Number.isFinite(metric.score)) return `--<span>/100</span>`;
  return `${metric.score}<span>/100</span>`;
}

const {
  compactMissingHealthNote,
  compactCylinderLabel,
  compactHealthNote,
  healthCardNoteMarkup,
  detectionWindowsForHealthKey,
  selectedDetectionWindows,
  playbackDetectionWindows,
} = createHealthNoteMarkup({
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  sensorChannelList: (...args) => sensorChannelList(...args),
  sensorPrimarySummaries: (...args) => sensorPrimarySummaries(...args),
  sensorSummaryDisplayLabel: (...args) => sensorSummaryDisplayLabel(...args),
  readableProbeLabel: (...args) => readableProbeLabel(...args),
  findingCylinderReference: (...args) => findingCylinderReference(...args),
  explorerEgtAnnunciationLabel: (...args) => explorerEgtAnnunciationLabel(...args),
  reviewMonitorEnabled: (...args) => reviewMonitorEnabled(...args),
  getHealthSummary: () => healthSummary,
  getRenderedHealthSummary: () => renderedHealthSummary,
  getSelectedHealthKey: () => selectedHealthKey,
  getSelectedCylinderNumber: () => selectedCylinderNumber,
  getSelectedOperatingContextWindows: () => selectedOperatingContextWindows,
  getSelectedFlight: () => selectedFlight,
  getSelectedDetectionWindowCache: () => selectedDetectionWindowCache,
  setSelectedDetectionWindowCache: (value) => { selectedDetectionWindowCache = value; },
  getPlaybackDetectionWindowCache: () => playbackDetectionWindowCache,
  setPlaybackDetectionWindowCache: (value) => { playbackDetectionWindowCache = value; },
});

function healthSummaryOptions() {
  const rows = selectedFlight?.aircraft
    ? (trendCache.get(trendCacheKey(selectedFlight.aircraft)) ?? []).filter((row) => !row.error)
    : [];
  return {
    selectedEntry: selectedFlight,
    aircraftProfile: aircraftProfileForEntry(selectedFlight),
    crossFlightRows: rows,
    sensitivity: detectionSensitivity,
    skipContextDetectors: false,
    contextCardsOnly: true,
    coolingRateThresholdFpm: coolingRateTriggerFpm(selectedFlight?.aircraft),
  };
}

function projectedEngineData(data, engine) {
  return projectFlightDataForEngine(data, engine);
}

function scopedHealthSummaryForEngine(baseSummary, engine) {
  if (!baseSummary || !engine || engine.side === "single") return baseSummary;
  const cacheKey = engine.id;
  const aircraft = selectedFlight?.aircraft;
  const settingsSignature = reviewSettingsSignature(aircraft);
  if (
    scopedHealthSummaryCache.source !== baseSummary
    || scopedHealthSummaryCache.data !== flightData
    || scopedHealthSummaryCache.sensitivity !== detectionSensitivity
    || scopedHealthSummaryCache.reviewSettings !== settingsSignature
  ) {
    scopedHealthSummaryCache = {
      source: baseSummary,
      data: flightData,
      sensitivity: detectionSensitivity,
      reviewSettings: settingsSignature,
      summaries: new Map(),
    };
  }
  if (scopedHealthSummaryCache.summaries.has(cacheKey)) {
    return scopedHealthSummaryCache.summaries.get(cacheKey);
  }
  const scopedSignature = `${aircraft ?? ""}|${selectedFlight?.parser ?? ""}|${settingsSignature}`;
  if (rawScopedAnalysisCache.data !== flightData || rawScopedAnalysisCache.signature !== scopedSignature) {
    rawScopedAnalysisCache = { data: flightData, signature: scopedSignature, bundles: new Map() };
  }
  const scopedOptions = {
    selectedEntry: selectedFlight,
    analysisEngine: { id: engine.id, engineKey: engine.engineKey, engineNumber: engine.engineNumber },
    aircraftProfile: aircraftProfileForEntry(selectedFlight),
    parserMetadata: currentParserMetadata,
    parserId: currentParserMetadata?.parserId ?? selectedFlight?.parser,
    crossFlightRows: [],
    metricScoreScope: "engine",
    sensitivity: detectionSensitivity,
    disabledMetricKeys: disabledReviewMonitorKeyList(aircraft),
    coolingRateThresholdFpm: coolingRateTriggerFpm(aircraft),
    buildFinding,
    staticValveRowsForAircraft,
    trendDateValue,
    formatPointTime,
    phaseForWindow: candidateMagPhase,
  };
  let bundle = rawScopedAnalysisCache.bundles.get(cacheKey);
  if (!bundle) {
    const scopedData = projectedEngineData(flightData, engine);
    bundle = computeRawAnalysisMetrics(scopedData, scopedOptions);
    rawScopedAnalysisCache.bundles.set(cacheKey, bundle);
  }
  const summary = finalizeAnalysisSummary(bundle, scopedOptions);
  summary.scope = {
    type: "engine",
    engineId: engine.id,
    label: engine.label,
    shortLabel: engine.shortLabel,
  };
  scopedHealthSummaryCache.summaries.set(cacheKey, summary);
  return summary;
}

function healthSummaryForCurrentEngineScope(baseSummary = healthSummary) {
  if (!baseSummary) return baseSummary;
  const engines = currentEngineDescriptors();
  const scope = normalizeSelectedEngineScope(engines);
  if (scope !== "left" && scope !== "right") return baseSummary;
  const engine = engines.find((candidate) => candidate.id === scope || candidate.side === scope);
  return scopedHealthSummaryForEngine(baseSummary, engine);
}

function updateHealthSummary() {
  healthSummary = perfTimeSync("calculateHealthSummary", () =>
    calculateHealthSummary(flightData, healthSummaryOptions()),
  );
  perfTimeSync("renderHealthSummary", () => renderHealthSummary(healthSummary));
  void loadReviewNotesForSelectedFlight();
}

// Fallback for render paths that can run before the first updateHealthSummary()
// lands. Must use healthSummaryOptions(): a bare calculateHealthSummary(flightData)
// resolves to a context:full signature that can never match the primed
// context:cards cache entry, so it would rerun the full detector pass
// synchronously on the main thread (and produce a summary without trend
// context on top).
function currentHealthSummary() {
  return healthSummary ?? calculateHealthSummary(flightData, healthSummaryOptions());
}

function renderScopeSwitch() {
  const dashboardSwitch = document.querySelector("#scopeSwitch");
  const containers = [dashboardSwitch].filter(Boolean);
  if (!containers.length) return;
  const engines = currentEngineDescriptors();
  normalizeSelectedEngineScope(engines);
  containers.forEach((container) => {
    if (engines.length > 1) {
      container.classList.add("is-multi-engine");
      const engineButtonLabel = (engine) => engine.label ?? `${engine.shortLabel ?? ""} Engine`.trim();
      const groupHtml = (engine) => `
        <div class="scope-engine-group" data-scope-engine-group="${escapeHtml(engine.id)}">
          <button class="scope-engine-button ${!selectedCylinderNumber && selectedEngineScope === engine.id ? "is-active" : ""}" data-scope-engine-id="${escapeHtml(engine.id)}" type="button">${escapeHtml(engineButtonLabel(engine))}</button>
          ${(engine.cylinders ?? []).map((cylinder) => `
            <button class="${selectedCylinderNumber === cylinder.sourceNumber ? "is-active" : ""}" data-scope-cylinder="${cylinder.sourceNumber}" type="button" title="${escapeHtml(`${engineButtonLabel(engine)} Cyl ${cylinder.number} · ${cylinder.egtKey.toUpperCase()} / ${cylinder.chtKey.toUpperCase()}`)}">Cyl ${cylinder.number}</button>
          `).join("")}
        </div>
      `;
      container.innerHTML = `
        <button class="scope-aircraft-button ${!selectedCylinderNumber && selectedEngineScope === "aircraft" ? "is-active" : ""}" data-scope-aircraft type="button">Aircraft</button>
        ${engines.slice(0, 2).map(groupHtml).join('<span class="scope-engine-divider" aria-hidden="true"></span>')}
        <div class="scope-sensitivity-control">
          ${reviewSensitivityControlMarkup()}
        </div>
      `;
      container.querySelector("[data-scope-aircraft]")?.addEventListener("click", () => clearCylinderFocus());
      container.querySelectorAll("[data-scope-engine-id]").forEach((button) => {
        button.addEventListener("click", () => setEngineScope(button.dataset.scopeEngineId));
      });
    } else {
      container.classList.remove("is-multi-engine");
      const cylinders = availableCylinderNumbers();
      container.innerHTML = `
        <button class="${selectedCylinderNumber ? "" : "is-active"}" data-scope-engine type="button">Engine</button>
        ${cylinders.map((number) => `
          <button class="${selectedCylinderNumber === number ? "is-active" : ""}" data-scope-cylinder="${number}" type="button">Cyl ${number}</button>
        `).join("")}
        <div class="scope-sensitivity-control">
          ${reviewSensitivityControlMarkup()}
        </div>
      `;
      container.querySelector("[data-scope-engine]")?.addEventListener("click", () => clearCylinderFocus());
    }
    container.querySelectorAll("[data-scope-cylinder]").forEach((button) => {
      button.addEventListener("click", () => setCylinderFocus(Number(button.dataset.scopeCylinder)));
    });
    bindSensitivityControlButtons(container);
    renderSensitivityControl();
  });
}


function updateHealthCardSelection() {
  document.querySelectorAll("[data-health-card]").forEach((card) => {
    const key = card.dataset.healthCard;
    if (card.hidden || (key && key !== "overall" && !reviewMonitorEnabled(key, selectedFlight?.aircraft))) {
      card.classList.remove("is-selected");
      card.setAttribute("aria-pressed", "false");
      return;
    }
    const selected = overviewSelectionCleared
      ? false
      : selectedOperatingContextKey
        ? false
        : selectedHealthKey
          ? key === selectedHealthKey
          : key === "overall";
    card.classList.toggle("is-selected", selected);
    card.setAttribute("aria-pressed", selected ? "true" : "false");
  });
}

function clearOverviewTileSelection() {
  if (overviewSelectionCleared && !selectedHealthKey && !selectedOperatingContextKey) return false;
  overviewSelectionCleared = true;
  selectedHealthKey = null;
  selectedOperatingContextKey = null;
  selectedOperatingContextWindows = [];
  selectedDetectionWindowCache = { summary: null, key: "", windows: [] };
  return true;
}

function preserveScrollDuring(callback) {
  const scrollX = window.scrollX;
  const scrollY = window.scrollY;
  const result = callback();
  window.scrollTo({ top: scrollY, left: scrollX, behavior: "auto" });
  requestAnimationFrame(() => window.scrollTo({ top: scrollY, left: scrollX, behavior: "auto" }));
  return result;
}


function fuelFlowSeriesForSensorMetric(metric) {
  const available = new Set(availableSeriesKeys());
  const fuelKeys = sensorReviewSummaries(metric)
    .map((summary) => summary?.key)
    .filter((key) => sensorChannelType(key) === "fuelFlow");
  const candidates = fuelKeys.length ? fuelKeys : [];
  return [...new Set(candidates.flatMap((key) => [key, key === "fuelFlowLeft" ? "fuelFlow1" : null, key === "fuelFlowRight" ? "fuelFlow2" : null, "fuelFlow"].filter(Boolean)))]
    .filter((key) => available.has(key));
}

function reviewSeriesForSensorMetric(metric) {
  const available = new Set(availableSeriesKeys());
  return sensorReviewSummaries(metric)
    .filter((summary) => summary?.suspicion >= 8 || summary?.impossibleJumpCount > 0 || summary?.jumpEvents?.length || summary?.conditionWindows?.length || summary?.flatline)
    .flatMap((summary) => [summary?.key, sensorChannelType(summary?.key) === "rpm" ? "rpm" : null, sensorChannelType(summary?.key) === "map" ? "map" : null])
    .filter((key, index, keys) => key && available.has(key) && keys.indexOf(key) === index);
}

function selectCompanionSeriesForHealthCard(key) {
  selectedOperatingContextKey = null;
  selectedOperatingContextWindows = [];
  const bestSpeedSeriesKey = ["ias", "tas", "groundSpeed"].find((seriesKey) => flightData.some((point) => Number.isFinite(point[seriesKey])));
  const companions = {
    engineDelta: ["rpm", "map", "fuelFlow", "cht", "oilPressure", "oilTemp"],
    abnormalCombustion: ["rpm", "map", "fuelFlow"],
    divergence: ["fuelFlow", "rpm", "map"],
    descentEgtDropout: ["fuelFlow", "map", "rpm", "altitude"],
    inductionLeak: ["rpm", "fuelFlow", "map"],
    carbIce: ["carbTemp", "oat", "rpm", "map", "fuelFlow"],
    turbo: ["tit", "map", "upperDeckPressure", "fuelFlow", "rpm", "altitude"],
    oilSystem: ["oilPressure", "oilPressure1", "oilPressure2", "oilTemp", "oilTemp1", "oilTemp2"],
    coolantMargin: ["coolantTemp", "oilTemp", "rpm", "map", "fuelFlow"],
    takeoffEnrichment: ["fuelFlow", "percentPower", "map", "rpm"],
    coolingRate: ["rpm", "map", "fuelFlow", bestSpeedSeriesKey],
    charging: ["buss", "amps"],
    electrical: ["buss", "amps"],
    mag: ["rpm"],
  }[key]?.filter(Boolean) ?? [];
  if (key === "sensors") companions.push(...reviewSeriesForSensorMetric(healthSummary?.sensors), ...fuelFlowSeriesForSensorMetric(healthSummary?.sensors));
  const available = new Set(availableSeriesKeys());
  // On an unaligned combo, never auto-add 30C companions next to 30P traces —
  // the exclusivity rule would immediately hide whichever group lost.
  const unalignedAux = unalignedAuxSeriesKeys();
  let changed = false;
  companions.forEach((seriesKey) => {
    if (unalignedAux.has(seriesKey)) return;
    if (!available.has(seriesKey) || activeSeries.has(seriesKey)) return;
    activeSeries.add(seriesKey);
    changed = true;
  });
  if (changed) syncSeriesControls();
}

function setupHealthCardInteractions() {
  const activateHealthCard = (card) => {
    const key = card?.dataset?.healthCard;
    if (!key || card.hidden || (key !== "overall" && !reviewMonitorEnabled(key, selectedFlight?.aircraft))) return;
    overviewSelectionCleared = false;
    selectedHealthKey = key === "overall" ? null : key;
    selectedOperatingContextKey = null;
    selectedOperatingContextWindows = [];
    selectCompanionSeriesForHealthCard(selectedHealthKey);
    if (healthSummary) preserveScrollDuring(() => renderHealthSummary(healthSummary));
    scheduleDrawAll();
    syncFlightReviewRoute("overview");
  };
  if (!overviewHealthCardInteractionBound) {
    overviewHealthCardInteractionBound = true;
    document.addEventListener("click", (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const healthCard = target.closest("[data-health-card]");
      if (healthCard) {
        activateHealthCard(healthCard);
        return;
      }
      const clearZone = target.closest(".summary-band.overview-only, #overviewScoreRow, #cylinderSummaryBand");
      if (!clearZone) return;
      if (target.closest("[data-cylinder-health-card], [data-operating-context-card], [data-engine-scope-card], button, a, input, select, textarea, label, summary")) return;
      if (!clearOverviewTileSelection()) return;
      if (healthSummary) preserveScrollDuring(() => renderHealthSummary(healthSummary));
      else updateHealthCardSelection();
      scheduleDrawAll();
      syncFlightReviewRoute("overview");
    });
    document.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      const target = event.target;
      if (!(target instanceof Element)) return;
      const healthCard = target.closest("[data-health-card]");
      if (!healthCard) return;
      event.preventDefault();
      activateHealthCard(healthCard);
    });
  }
  updateHealthCardSelection();
}

function bindSensitivityControlButtons(root = document) {
  root.querySelectorAll("[data-sensitivity]").forEach((button) => {
    if (button.dataset.sensitivityBound === "true") return;
    button.dataset.sensitivityBound = "true";
    button.addEventListener("click", () => setDetectionSensitivity(button.dataset.sensitivity));
    button.addEventListener("keydown", (event) => {
      const currentIndex = sensitivityModeOrder.indexOf(detectionSensitivity);
      const direction = event.key === "ArrowRight" || event.key === "ArrowDown" ? 1 : event.key === "ArrowLeft" || event.key === "ArrowUp" ? -1 : 0;
      if (!direction) return;
      event.preventDefault();
      const next = sensitivityModeOrder[(currentIndex + direction + sensitivityModeOrder.length) % sensitivityModeOrder.length];
      setDetectionSensitivity(next);
      const localGroup = button.closest("[role='radiogroup']");
      (localGroup?.querySelector(`[data-sensitivity="${next}"]`) ?? document.querySelector(`[data-sensitivity="${next}"]`))?.focus();
    });
  });
}

function setupSensitivityControl() {
  const select = document.querySelector("#sensitivityControl");
  if (select) {
    select.addEventListener("change", (event) => setDetectionSensitivity(event.target.value));
  }
  bindSensitivityControlButtons();
  renderSensitivityControl();
}

function scheduleDrawAll() {
  if (!document.querySelector("#view-dashboard")?.classList.contains("is-active")) return;
  if (drawScheduled) return;
  drawScheduled = true;
  requestAnimationFrame(() => {
    drawScheduled = false;
    updateStickyTableHeaderOffset();
    drawAll();
  });
}

function updateStickyTableHeaderOffset() {
  const topbar = document.querySelector(".topbar");
  // Tuck sticky headers 2px UNDER the topbar: the topbar's height is
  // fractional, and rounding up leaves a subpixel slit that scrolling rows
  // shine through. The topbar paints above (higher z-index), so the small
  // overlap is invisible.
  const height = topbar ? Math.max(0, Math.floor(topbar.getBoundingClientRect().height) - 2) : 74;
  document.documentElement.style.setProperty("--sticky-table-header-top", `${height}px`);
}

function drawChartForCanvasId(canvasId) {
  if (canvasId === "flightChart") {
    drawFlightChart();
    return;
  }
  if (canvasId === "explorerChart") {
    drawExplorerChart();
    renderExplorerAskAnnotations();
    return;
  }
  drawAll();
}

function scheduleChartDraw(canvasId) {
  scheduledChartCanvasId = canvasId;
  if (chartDrawScheduled) return;
  chartDrawScheduled = true;
  requestAnimationFrame(() => {
    const targetCanvasId = scheduledChartCanvasId;
    chartDrawScheduled = false;
    scheduledChartCanvasId = null;
    drawChartForCanvasId(targetCanvasId);
  });
}

function scheduleMarkerUpdate(canvasId) {
  scheduledMarkerCanvasId = canvasId;
  if (markerUpdateScheduled) return;
  markerUpdateScheduled = true;
  requestAnimationFrame(() => {
    const targetCanvasId = scheduledMarkerCanvasId;
    markerUpdateScheduled = false;
    scheduledMarkerCanvasId = null;
    updateChartInteractionForCanvasId(targetCanvasId);
  });
}

const {
  activateAircraftWorkspaceShell,
  activateDashboardAiReviewPanel,
  activateHashView,
  activateView,
  aircraftPanelFromLocationHash,
  mountAircraftDashboardPanel,
  setAircraftPanel,
  setReportPanel,
  trackCurrentAnalyticsPageView,
  viewFromLocationHash,
} = createViewNavigationController({
  PUBLIC_VIEWS,
  newUiFeatureEnabled: () => newUiFeatureEnabled(),
  activateAircraftDashboardFlight: (...args) => activateAircraftDashboardFlight(...args),
  applyRouteSensitivity: (...args) => applyRouteSensitivity(...args),
  applyFlightReviewRouteFocus: (...args) => applyFlightReviewRouteFocus(...args),
  activateTrendRoute: (...args) => activateTrendRoute(...args),
  clearFlightLogLoading: (...args) => clearFlightLogLoading(...args),
  displayMonitorLabelForEntry: (...args) => displayMonitorLabelForEntry(...args),
  ensureAircraftFlightManifestLoaded: (...args) => ensureAircraftFlightManifestLoaded(...args),
  ensureDetectionGuideRendered: (...args) => ensureDetectionGuideRendered(...args),
  ensureFlightDataLoaded: (...args) => ensureFlightDataLoaded(...args),
  findFlightReviewEntry: (...args) => findFlightReviewEntry(...args),
  loadFlightLog: (...args) => loadFlightLog(...args),
  maybeLoadCachedAiSummaryForSelectedFlight: (...args) => maybeLoadCachedAiSummaryForSelectedFlight(...args),
  populateTrendAircraftSelect: (...args) => populateTrendAircraftSelect(...args),
  renderAiSummaryPanel: (...args) => renderAiSummaryPanel(...args),
  renderAircraftWorkspace: (...args) => renderAircraftWorkspace(...args),
  renderEnginePanel: (...args) => renderEnginePanel(...args),
  renderFlightProfilePanel: (...args) => renderFlightProfilePanel(...args),
  renderHealthSummary: (...args) => renderHealthSummary(...args),
  renderRawDataPanel: (...args) => renderRawDataPanel(...args),
  renderSensitivityControl: (...args) => renderSensitivityControl(...args),
  renderTrendsForSelection: (...args) => renderTrendsForSelection(...args),
  scheduleDrawAll: (...args) => scheduleDrawAll(...args),
  setFlightLogLoading: (...args) => setFlightLogLoading(...args),
  showFlightReviewRouteError: (...args) => showFlightReviewRouteError(...args),
  titleCase: (...args) => titleCase(...args),
  updateDataSourceLabel: (...args) => updateDataSourceLabel(...args),
  updateFlightHeader: (...args) => updateFlightHeader(...args),
  updateReportButtonState: (...args) => updateReportButtonState(...args),
  viewNeedsFlightData: (...args) => viewNeedsFlightData(...args),
  selectedAircraftWorkspace: (...args) => selectedAircraftWorkspace(...args),
  getSelectedFlight: () => selectedFlight,
  getSourceMonitor: () => sourceMonitor,
  getHealthSummary: () => healthSummary,
  getSelectedAircraftPanel: () => selectedAircraftPanel,
  setSelectedAircraftPanel: (value) => {
    selectedAircraftPanel = value;
    // Leaving the Info / Settings tabs returns their dialogs to modal duty.
    if (value !== "info") unmountAircraftDialogInline("#aircraftEditDialog");
    if (value !== "settings") unmountAircraftDialogInline("#aircraftReviewSettingsDialog");
    // Keep the tail-number URL path current on every workspace navigation
    // (selection changes sync too, but same-aircraft navigation must as well).
    syncAircraftUrlPathTail();
    // The topbar height differs per view; re-measure so sticky table headers
    // pin directly under it (the ResizeObserver covers live resizes, but a
    // deterministic re-measure on navigation costs nothing).
    updateStickyTableHeaderOffset();
    syncMobileTabbar();
    renderFleetSidebar();
  },
  mountAircraftInfoPanel: () => mountAircraftInfoPanelInline(),
  mountAircraftSettingsPanel: () => mountAircraftSettingsPanelInline(),
  syncWorkspaceUrlPath: () => syncAircraftUrlPathTail(),
});

function titleCase(value) {
  return value.replace(/-/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
}

function drawGauge() {
  const canvas = document.querySelector("#healthGauge");
  if (!canvas) return;
  const ctx = canvas.getContext("2d");
  const width = canvas.width;
  const height = canvas.height;
  const summary = renderedHealthSummary ?? healthSummary;
  const score = summary?.overall?.score ?? 0;
  const strokeColor = {
    green: colors.green,
    amber: colors.amber,
    red: colors.red,
  }[summary?.overall?.className] ?? colors.muted;
  ctx.clearRect(0, 0, width, height);
  ctx.lineWidth = 16;
  ctx.lineCap = "round";
  ctx.strokeStyle = "rgba(255,255,255,0.1)";
  ctx.beginPath();
  ctx.arc(width / 2, height / 2, 58, Math.PI * 0.75, Math.PI * 2.25);
  ctx.stroke();
  ctx.strokeStyle = strokeColor;
  ctx.beginPath();
  ctx.arc(width / 2, height / 2, 58, Math.PI * 0.75, Math.PI * (0.75 + 1.5 * score / 100));
  ctx.stroke();
}

function hasGraphableSeriesData(data, key) {
  const extent = cachedRawValueExtent(data, key);
  if (!extent) return false;
  if (isPrimaryTemperatureSeries(key)) return true;
  return !(extent.min === 0 && extent.max === 0);
}

function cachedRawValueExtent(data, key) {
  if (data !== flightData) return rawValueExtent(data, key);
  const cache = currentFlightDerivedCache();
  if (cache.rawValueExtents.has(key)) return cache.rawValueExtents.get(key);
  const extent = rawValueExtent(data, key);
  cache.rawValueExtents.set(key, extent);
  return extent;
}

function activeSeriesKeys(data) {
  return [...activeSeries].filter((key) => seriesMeta[key] && hasGraphableSeriesData(data, key));
}

function isPrimaryTemperatureSeries(key) {
  return /^(egt|cht)\d*$/.test(key);
}

function defaultSeriesPane(key) {
  return isPrimaryTemperatureSeries(key) ? "primary" : "secondary";
}

function currentSeriesPaneAircraft() {
  return selectedFlight?.aircraft || selectedAircraftWorkspace() || "";
}

function currentSeriesPaneOverrides() {
  return seriesPaneOverridesForAircraft(seriesPaneOverridesByAircraft, currentSeriesPaneAircraft());
}

function seriesPaneForKey(key) {
  return currentSeriesPaneOverrides()[key] ?? defaultSeriesPane(key);
}

function isPrimaryPaneSeries(key) {
  return seriesPaneForKey(key) === "primary";
}

function hasSeriesPaneOverrides() {
  // Stored overrides can reference channels the selected flight doesn't log
  // (or that dedup absorbed) — only an override for a channel actually on
  // offer should surface the "Reset graph layout" button.
  const available = availableSeriesKeys();
  return Object.keys(currentSeriesPaneOverrides()).some((key) => available.includes(key));
}

function setSeriesPane(key, pane) {
  // Moving a channel back to its default pane clears the override instead of
  // pinning it, so the stored layout only records deliberate divergence.
  seriesPaneOverridesByAircraft = updateAircraftSeriesPaneOverride(
    seriesPaneOverridesByAircraft,
    currentSeriesPaneAircraft(),
    key,
    pane === defaultSeriesPane(key) ? null : pane,
  );
  saveSeriesPaneOverrides(seriesPaneOverridesByAircraft);
}

function resetSeriesPaneOverrides() {
  seriesPaneOverridesByAircraft = clearAircraftSeriesPaneOverrides(seriesPaneOverridesByAircraft, currentSeriesPaneAircraft());
  saveSeriesPaneOverrides(seriesPaneOverridesByAircraft);
}

// Time-unaligned CGR combo support: the 30C-sourced channel keys for the
// loaded flight. Empty set when the combo aligned (or the flight isn't a
// combo), which turns the exclusivity enforcement into a no-op.
function unalignedAuxSeriesKeys() {
  if (currentParserMetadata?.comboAlignment !== "unaligned") return new Set();
  return new Set(Array.isArray(currentParserMetadata.auxSeriesKeys) ? currentParserMetadata.auxSeriesKeys : []);
}

function notifySeriesExclusion(keptGroup) {
  const kept = keptGroup === "aux" ? "CGR-30C" : "CGR-30P";
  showAppToast(`Showing ${kept} channels only. The 30C's clock isn't aligned with the 30P on this flight, so the two units' traces can't be shown together.`);
}

function moveSeriesToPane(key, pane) {
  // Dropping a channel on the pane it already lives in still turns the
  // channel on, so dragging an unchecked channel onto its own graph shows it.
  // A comma-separated key (a chip-strip EGT/CHT bank) moves every channel.
  const keys = String(key ?? "").split(",").filter(Boolean);
  let changed = false;
  keys.forEach((seriesKey) => {
    if (seriesPaneForKey(seriesKey) !== pane) {
      setSeriesPane(seriesKey, pane);
      changed = true;
    }
    if (!activeSeries.has(seriesKey)) {
      activeSeries.add(seriesKey);
      changed = true;
    }
  });
  if (!changed) return;
  const exclusion = enforceUnalignedSeriesExclusivity(activeSeries, unalignedAuxSeriesKeys(), keys);
  if (exclusion.removedKeys.length && exclusion.keptGroup) notifySeriesExclusion(exclusion.keptGroup);
  setupSeriesControls();
  scheduleDrawAll();
}

function thermalAxisTypeForKey(key) {
  if (/^egt\d*$/.test(key)) return "egt";
  if (/^cht\d*$/.test(key)) return "cht";
  return null;
}

const egtAxisHeadroomF = 50;
const egtAxisDisplayCeilingF = 1700;
const egtAxisDisplayFloorF = 350;
const egtAxisRoundIncrementF = 25;
const egtAxisKeys = ["egt", ...cylinderKeys("egt")];
const thermalAxisLowerHeadroomF = 25;
const thermalAxisLowerIncrementF = 50;
const chtAxisKeys = ["cht", ...cylinderKeys("cht")];

function egtAxisRangeForData(data, options = {}) {
  return axisRangeForData(data, egtAxisKeys, thermalAxisRanges.egt, {
    lowerHeadroom: thermalAxisLowerHeadroomF,
    lowerIncrement: thermalAxisLowerIncrementF,
    lowerFloor: egtAxisDisplayFloorF,
    upperCeiling: egtAxisDisplayCeilingF,
    upperHeadroom: egtAxisHeadroomF,
    upperIncrement: egtAxisRoundIncrementF,
    ...options,
  });
}

function chtAxisRangeForData(data, options = {}) {
  return axisRangeForData(data, chtAxisKeys, thermalAxisRanges.cht, {
    expandUpper: false,
    lowerHeadroom: thermalAxisLowerHeadroomF,
    lowerIncrement: thermalAxisLowerIncrementF,
    lowerFloor: thermalAxisRanges.cht.min,
    ...options,
  });
}

function explorerFitThermalRange(type, data) {
  return type === "egt"
    ? egtAxisRangeForData(data, { fit: true })
    : chtAxisRangeForData(data, { fit: true });
}

function thermalAxisRangeForType(type, data = flightData) {
  if (type !== "egt" && type !== "cht") return thermalAxisRanges[type] ?? null;
  if (data === flightData) {
    const cache = currentFlightDerivedCache().thermalAxisRanges;
    const cached = cache.get(type);
    if (cached) return cached;
    const range = type === "egt" ? egtAxisRangeForData(data) : chtAxisRangeForData(data);
    cache.set(type, range);
    return range;
  }
  return type === "egt" ? egtAxisRangeForData(data) : chtAxisRangeForData(data);
}

function thermalAxisRangeForKey(key, data = flightData) {
  const type = thermalAxisTypeForKey(key);
  return type ? thermalAxisRangeForType(type, data) : null;
}

function thermalAxisTypesForKeys(keys) {
  return [...new Set(keys.map(thermalAxisTypeForKey).filter(Boolean))];
}

function splitSeriesKeys(data) {
  const keys = activeSeriesKeys(data);
  return {
    primary: keys.filter(isPrimaryPaneSeries),
    aux: keys.filter((key) => !isPrimaryPaneSeries(key)),
  };
}

function hasSplitChartLanes(data) {
  const split = splitSeriesKeys(data);
  return Boolean(split.primary.length && split.aux.length);
}

function drawPhaseLabels(ctx, rail, data = visibleFlightData()) {
  if (!data.length || rail.bottom <= rail.top || rail.right <= rail.left) return;
  const segments = phaseRailSegments(data, rail);
  if (!segments.length) return;
  const { bands, microSegments } = phaseRailDisplayPlan(segments, rail);
  const transitionZones = phaseRailTransitionZones(microSegments, rail);
  if (!bands.length) return;

  ctx.save();
  ctx.beginPath();
  roundRect(ctx, rail.left, rail.top, rail.right - rail.left, rail.bottom - rail.top, 5);
  ctx.fillStyle = "rgba(8, 16, 26, 0.86)";
  ctx.fill();
  ctx.strokeStyle = "rgba(255,255,255,0.12)";
  ctx.stroke();
  ctx.beginPath();
  ctx.rect(rail.left, rail.top, rail.right - rail.left, rail.bottom - rail.top);
  ctx.clip();

  bands.forEach((band) => {
    const x = Math.max(rail.left, band.left);
    const right = Math.min(rail.right, band.right);
    const width = Math.max(1, right - x);
    if (width >= 2) {
      ctx.fillStyle = phaseRailColor(band.phase.name, width < 7 ? 0.24 : 0.17);
      ctx.fillRect(x, rail.top + 1, width, rail.bottom - rail.top - 2);
    }
    if (width >= 7) {
      ctx.fillStyle = phaseRailColor(band.phase.name, 0.72);
      ctx.fillRect(x, rail.top + 1, width, 2);
    }
  });

  transitionZones.forEach((zone) => {
    const gradient = ctx.createLinearGradient(zone.left, 0, zone.right, 0);
    gradient.addColorStop(0, "rgba(255,255,255,0)");
    gradient.addColorStop(0.5, "rgba(255,255,255,0.11)");
    gradient.addColorStop(1, "rgba(255,255,255,0)");
    ctx.fillStyle = gradient;
    ctx.fillRect(zone.left, rail.top + 1, zone.right - zone.left, rail.bottom - rail.top - 2);
  });

  ctx.strokeStyle = "rgba(255,255,255,0.16)";
  ctx.lineWidth = 1;
  bands.slice(1).forEach((band) => {
    const x = Math.round(band.left) + 0.5;
    ctx.beginPath();
    ctx.moveTo(x, rail.top + 2);
    ctx.lineTo(x, rail.bottom - 2);
    ctx.stroke();
  });

  ctx.font = "700 11px Inter, sans-serif";
  const labelY = rail.top + Math.round((rail.bottom - rail.top) / 2) + 4;
  const placed = [];
  bands.map((segment) => {
    const label = phaseRailLabelForSegment(ctx, segment);
    if (!label) return null;
    const width = ctx.measureText(label).width;
    const x = Math.max(segment.left + 6, Math.min(segment.right - width - 6, (segment.left + segment.right - width) / 2));
    return {
      ...segment,
      label,
      x,
      textWidth: width,
      priority: phaseRailPriority(segment.phase, segment.width),
    };
  }).filter(Boolean)
    .sort((a, b) => b.priority - a.priority)
    .forEach((candidate) => {
      const rect = {
        left: candidate.x - 5,
        right: candidate.x + candidate.textWidth + 5,
        top: rail.top + 2,
        bottom: rail.bottom - 2,
      };
      if (placed.some((item) => rectsOverlap(rect, item.rect))) return;
      placed.push({ ...candidate, rect });
    });

  placed
    .sort((a, b) => a.index - b.index)
    .forEach(({ phase, label, x }) => {
      ctx.fillStyle = ["Takeoff", "Runup", "Ground Run", "Landing"].includes(phase.name)
        ? "rgba(255,255,255,0.92)"
        : colors.text;
      ctx.fillText(label, x, labelY);
    });

  ctx.restore();
}

function phaseFilteredData() {
  return visibleFlightData("#phaseFilter");
}

function explorerPhaseFilteredData() {
  return visibleFlightData("#explorerPhaseFilter");
}

function visibleFlightData(phaseSelect = null) {
  if (visibleFlightDataCacheSource !== flightData) {
    visibleFlightDataCacheSource = flightData;
    visibleFlightDataCache.clear();
    explorerTimelineMarkerCache = { data: null, summary: null, markers: [] };
  }
  const maxIndex = Math.max(flightData.length - 1, 1);
  const startIndex = Math.floor(zoomRange.start * maxIndex);
  const endIndex = Math.ceil(zoomRange.end * maxIndex);
  const selectedPhase = phaseSelect ? document.querySelector(phaseSelect)?.value : "all";
  const cacheKey = `${phaseSelect ?? "all"}|${selectedPhase ?? "all"}|${startIndex}|${endIndex}|${flightData.length}`;
  if (visibleFlightDataCache.has(cacheKey)) return visibleFlightDataCache.get(cacheKey);
  const zoomed = zoomRange.start <= 0 && zoomRange.end >= 1
    ? flightData
    : flightData.slice(startIndex, endIndex + 1);
  const data = !selectedPhase || selectedPhase === "all"
    ? zoomed
    : zoomed.filter((point) => point.phase === selectedPhase);
  if (visibleFlightDataCache.size > 24) visibleFlightDataCache.clear();
  visibleFlightDataCache.set(cacheKey, data);
  return data;
}

function dismissExplorerGamiPanel({ render = true } = {}) {
  const changed = gamiSpecialTestsState.open || gamiSpecialTestsState.selecting;
  gamiSpecialTestsState.open = false;
  gamiSpecialTestsState.selecting = false;
  hideExplorerGamiCursorTime();
  if (render && changed) {
    renderGamiSpecialTestsPanel({ syncInputs: false });
    scheduleChartDraw("explorerChart");
  }
}

const {
  syncAskGraphFeatureUi,
  resetExplorerAskState,
  dismissExplorerAskAnnotations,
  renderExplorerAskAnnotations,
  renderExplorerAskPanel,
  loadSavedExplorerAskAnswers,
  explorerAskGraphImageDataUrl,
  setupExplorerAskAboutPart,
} = createExplorerAskController({
  activeSeriesKeys: (...args) => activeSeriesKeys(...args),
  aiRequestLimitInfoFromPayload: (...args) => aiRequestLimitInfoFromPayload(...args),
  appReadOnlyMode: (...args) => appReadOnlyMode(...args),
  availableSeriesKeys: (...args) => availableSeriesKeys(...args),
  chartZoomedIn: (...args) => chartZoomedIn(...args),
  dismissExplorerGamiPanel: (...args) => {
    dismissExplorerGamiPanel(...args);
    dismissPilotObservationPanel({ clear: false });
  },
  drawAll: (...args) => drawAll(...args),
  explorerPhaseFilteredData: (...args) => explorerPhaseFilteredData(...args),
  readOnlyActionMessage: (...args) => readOnlyActionMessage(...args),
  scheduleDrawAll: (...args) => scheduleDrawAll(...args),
  selectedDatabaseFlightId: (...args) => selectedDatabaseFlightId(...args),
  syncReadOnlyUi: (...args) => syncReadOnlyUi(...args),
  syncSeriesControls: (...args) => syncSeriesControls(...args),
  getAppConfig: () => appConfig,
  getFlightData: () => flightData,
  getSelectedFlight: () => selectedFlight,
  getLastRequestedFlightId: () => lastRequestedFlightId,
  getDetectionSensitivity: () => detectionSensitivity,
  getDisabledReviewMonitorKeys: () => disabledReviewMonitorKeyList(selectedFlight?.aircraft),
  getCoolingRateTriggerFpm: () => coolingRateTriggerFpm(selectedFlight?.aircraft),
  getActiveSeries: () => activeSeries,
  getZoomRange: () => zoomRange,
  setZoomRange: (value) => {
    zoomRange = value;
    syncFlightReviewRoute(activeReportPanel());
  },
  setScrubRatio: (value) => { scrubRatio = value; },
});

function visibleScrubRatio() {
  const width = zoomRange.end - zoomRange.start;
  if (width <= 0) return 0;
  return clamp01((scrubRatio - zoomRange.start) / width);
}

function clearChartInteractionCaches() {
  document.querySelectorAll("canvas").forEach((canvas) => {
    delete canvas._aeroInteractionBounds;
    delete canvas._aeroPointerGeometry;
  });
}

function chartOverlayElements(canvas) {
  const parent = canvas?.parentElement;
  if (!parent) return {};
  if (canvas._aeroChartOverlays?.parent === parent) return canvas._aeroChartOverlays;
  let marker = parent.querySelector(":scope > .chart-marker-overlay");
  if (!marker) {
    marker = document.createElement("div");
    marker.className = "chart-marker-overlay";
    marker.setAttribute("aria-hidden", "true");
    parent.appendChild(marker);
  }
  let zoom = parent.querySelector(":scope > .chart-zoom-overlay");
  if (!zoom) {
    zoom = document.createElement("div");
    zoom.className = "chart-zoom-overlay";
    zoom.setAttribute("aria-hidden", "true");
    parent.appendChild(zoom);
  }
  let timeTooltip = parent.querySelector(":scope > .chart-cursor-time-tooltip");
  if (!timeTooltip) {
    timeTooltip = document.createElement("div");
    timeTooltip.className = "chart-cursor-time-tooltip";
    timeTooltip.setAttribute("aria-hidden", "true");
    parent.appendChild(timeTooltip);
  }
  canvas._aeroChartOverlays = { parent, marker, zoom, timeTooltip };
  return canvas._aeroChartOverlays;
}

// Layout READS for the cursor tooltip, taken at the top of updateChartOverlays
// BEFORE any overlay style writes dirty the layout. Measuring here (and reusing
// the tooltip's previous-frame rect) means the per-scrub-frame clamping math
// below never forces a synchronous reflow; the tooltip's own size is stale by
// one frame only when its text width changes (a digit-count rollover).
function measureChartTooltipLayout(timeTooltip, canvas) {
  if (!timeTooltip || canvas.id !== "explorerChart") return null;
  return {
    parentRect: canvas.parentElement?.getBoundingClientRect?.(),
    parentWidth: canvas.parentElement?.clientWidth ?? canvas.getBoundingClientRect().width,
    parentHeight: canvas.parentElement?.clientHeight ?? canvas.getBoundingClientRect().height,
    rect: timeTooltip.getBoundingClientRect(),
  };
}

function updateChartCursorTimeTooltip(timeTooltip, canvas, overlay, bounds, point, layout) {
  if (!timeTooltip) return;
  if (
    canvas.id !== "explorerChart"
    || !point
    || !layout
    || (
      dragSelection?.canvasId === canvas.id
      && ["gami-sweep", "pilot-observation"].includes(dragSelection.mode)
    )
  ) {
    timeTooltip.classList.remove("is-visible");
    return;
  }
  const system = document.createElement("strong");
  system.textContent = formatPointTime(point);
  const elapsed = document.createElement("span");
  elapsed.textContent = `Elapsed ${formatElapsedTime(point.elapsedSeconds)}`;
  timeTooltip.replaceChildren(system, elapsed);
  timeTooltip.classList.add("is-visible");

  const { parentRect, parentWidth, parentHeight, rect } = layout;
  const offset = 10;
  let left = overlay.marker.x + offset;
  if (left + rect.width > parentWidth - offset) left = overlay.marker.x - rect.width - offset;
  const cursorY = chartCursorPosition?.canvasId === canvas.id && Number.isFinite(chartCursorPosition.clientY) && parentRect
    ? chartCursorPosition.clientY - parentRect.top
    : bounds.top + rect.height + offset;
  let top = cursorY - rect.height - offset;
  if (top < bounds.top) top = cursorY + offset;
  if (top + rect.height > parentHeight - offset) top = Math.max(offset, parentHeight - rect.height - offset);
  timeTooltip.style.left = `${Math.round(Math.max(offset, left))}px`;
  timeTooltip.style.top = `${Math.round(Math.max(offset, top))}px`;
}

function updateChartOverlays(canvas, bounds, markerRatio, point = null) {
  const { marker, zoom, timeTooltip } = chartOverlayElements(canvas);
  if (!marker || !zoom) return;
  const overlay = chartOverlayPlan(bounds, markerRatio, dragSelection, canvas.id);
  // All layout reads happen before the style writes below; see
  // measureChartTooltipLayout.
  const tooltipLayout = measureChartTooltipLayout(timeTooltip, canvas);
  marker.style.display = "block";
  marker.style.transform = `translateX(${overlay.marker.x}px)`;
  marker.style.top = `${overlay.marker.top}px`;
  marker.style.height = `${overlay.marker.height}px`;

  if (overlay.zoom) {
    zoom.style.display = "block";
    zoom.style.left = `${overlay.zoom.x}px`;
    zoom.style.top = `${overlay.zoom.y}px`;
    zoom.style.width = `${overlay.zoom.width}px`;
    zoom.style.height = `${overlay.zoom.height}px`;
  } else {
    zoom.style.display = "none";
  }
  updateChartCursorTimeTooltip(timeTooltip, canvas, overlay, bounds, point, tooltipLayout);
}

function hideChartOverlays(canvas) {
  const { marker, zoom, timeTooltip } = chartOverlayElements(canvas);
  if (marker) marker.style.display = "none";
  if (zoom) zoom.style.display = "none";
  if (timeTooltip) timeTooltip.classList.remove("is-visible");
}

function gamiCursorTimeTooltipElement() {
  if (gamiCursorTimeTooltip?.isConnected) return gamiCursorTimeTooltip;
  gamiCursorTimeTooltip = document.createElement("div");
  gamiCursorTimeTooltip.className = "gami-cursor-time-tooltip";
  gamiCursorTimeTooltip.setAttribute("aria-hidden", "true");
  document.body.appendChild(gamiCursorTimeTooltip);
  return gamiCursorTimeTooltip;
}

function hideExplorerGamiCursorTime() {
  if (!gamiCursorTimeTooltip) return;
  gamiCursorTimeTooltip.classList.remove("is-visible");
}

function showExplorerGamiCursorTime({ clientX, clientY, ratio } = {}) {
  if (
    (!gamiSpecialTestsState.open && !pilotObservationState.open)
    || !Number.isFinite(clientX)
    || !Number.isFinite(clientY)
    || !Number.isFinite(ratio)
  ) {
    hideExplorerGamiCursorTime();
    return;
  }
  const data = explorerPhaseFilteredData();
  const point = nearestPoint(data, clamp01(ratio));
  if (!point) {
    hideExplorerGamiCursorTime();
    return;
  }

  const tooltip = gamiCursorTimeTooltipElement();
  const time = document.createElement("strong");
  time.textContent = formatPointTime(point);
  const elapsed = document.createElement("span");
  elapsed.textContent = `Elapsed ${formatElapsedTime(point.elapsedSeconds)}`;
  tooltip.replaceChildren(time, elapsed);
  tooltip.classList.add("is-visible");

  const viewportPadding = 10;
  const pointerOffset = 14;
  const rect = tooltip.getBoundingClientRect();
  const maxLeft = Math.max(viewportPadding, window.innerWidth - rect.width - viewportPadding);
  const maxTop = Math.max(viewportPadding, window.innerHeight - rect.height - viewportPadding);
  let left = clientX + pointerOffset;
  let top = clientY - rect.height - pointerOffset;
  if (top < viewportPadding) top = clientY + pointerOffset;
  tooltip.style.left = `${Math.round(Math.min(Math.max(left, viewportPadding), maxLeft))}px`;
  tooltip.style.top = `${Math.round(Math.min(Math.max(top, viewportPadding), maxTop))}px`;
}

function updateChartInteractionForCanvasId(canvasId) {
  if (canvasId === "flightChart") {
    updateFlightChartInteraction();
    return;
  }
  if (canvasId === "explorerChart") {
    updateExplorerChartInteraction({ renderContext: false });
  }
}

function updateFlightChartInteraction() {
  const canvas = document.querySelector("#flightChart");
  if (!canvas) return;
  const data = phaseFilteredData();
  const markerRatio = visibleScrubRatio();
  const point = nearestPoint(data, markerRatio);
  if (point) updateScrubReadout(point, { scope: "flight", live: true });
  updateChartOverlays(canvas, cachedInteractionBounds(canvas, flightChartPadding, flightChartLayoutOptions), markerRatio, point);
}

function updateExplorerChartInteraction(options = {}) {
  const canvas = document.querySelector("#explorerChart");
  const data = explorerPhaseFilteredData();
  const markerRatio = visibleScrubRatio();
  const point = nearestPoint(data, markerRatio);
  if (point) updateScrubReadout(point, { scope: "explorer", live: true });
  if (point) updateExplorerChannelReadout(data, point);
  if (canvas) updateChartOverlays(canvas, cachedInteractionBounds(canvas, explorerChartPadding, explorerChartLayoutOptions), markerRatio, point);
  if (options.renderContext === false) {
    updateExplorerTimelineCursor(data, point, markerRatio);
    updateExplorerAnnunciationHeader(point);
    return;
  }
  renderExplorerContext(data, point);
}

// The explorer channel readout draws as an overlay inside the plot only
// while the pointer is over the graph: enter paints it on top of the
// current frame, leave needs a full redraw to restore the chart pixels
// beneath the opaque panel.
function setupExplorerReadoutHover() {
  const canvas = document.querySelector("#explorerChart");
  if (!canvas) return;
  canvas.addEventListener("pointerenter", () => {
    setExplorerReadoutHover(true);
    updateExplorerChartInteraction({ renderContext: false });
  });
  canvas.addEventListener("pointerleave", () => {
    // Pointer capture can carry the pointer outside the canvas mid-drag;
    // keep the readout up until the drag finishes.
    if (dragSelection?.canvasId === "explorerChart") return;
    setExplorerReadoutHover(false);
    drawExplorerChart();
  });
}

function nearestPoint(data, ratio) {
  if (!data.length) return undefined;
  const index = Math.round(clamp01(ratio) * (data.length - 1));
  return data[index];
}

// formatPointTime is imported from ./src/core/format-point-time.js so the main
// thread and the analysis Web Worker share one implementation.

function formatMarkerPointTime(point) {
  return point?.utcDisplayTime ? `${point.utcDisplayTime} UTC` : formatPointTime(point);
}

const {
  clearPilotObservationPersistenceState,
  commitExplorerPilotObservationSelection,
  dismissPilotObservationPanel,
  loadSavedPilotObservations,
  pilotObservationDetectionWindows,
  renderPilotObservationPanel,
  resetPilotObservationSelectionState,
  setupPilotObservations,
} = createPilotObservationController({
  aircraftProfileForEntry: (...args) => aircraftProfileForEntry(...args),
  appReadOnlyMode: (...args) => appReadOnlyMode(...args),
  readOnlyActionMessage: (...args) => readOnlyActionMessage(...args),
  renderAiSummaryPanel: (...args) => renderAiSummaryPanel(...args),
  resetGeneratedReport: (...args) => resetGeneratedReport(...args),
  revokeCachedFlightReport: (...args) => revokeCachedFlightReport(...args),
  scheduleChartDraw: (...args) => scheduleChartDraw(...args),
  selectedDatabaseFlightId: (...args) => selectedDatabaseFlightId(...args),
  syncReadOnlyUi: (...args) => syncReadOnlyUi(...args),
  getFlightData: () => flightData,
  getSelectedFlight: () => selectedFlight,
  getFlightManifest: () => flightManifest,
  getCurrentParserMetadata: () => currentParserMetadata,
  getLastRequestedFlightId: () => lastRequestedFlightId,
  getPilotObservationState: () => pilotObservationState,
  getFlightReportMetadataChecked: () => flightReportMetadataChecked,
  getFlightReportMetadataPending: () => flightReportMetadataPending,
  getFlightReportStoredMetadata: () => flightReportStoredMetadata,
  flightReportMetadataKey: (...args) => flightReportMetadataKey(...args),
  chartGestureHintBaseText: () => chartGestureHintBaseText(),
  onOpenPilotObservation: () => {
    dismissExplorerAskAnnotations({ closePanel: true, render: false });
    renderExplorerAskPanel();
    dismissExplorerGamiPanel();
  },
});

const {
  clearGamiSpecialTestPersistenceState,
  commitExplorerGamiSweepSelection,
  loadSavedGamiSpecialTests,
  renderGamiSpecialTestsPanel,
  resetGamiSpecialTestSelectionState,
  savedGamiSpecialTestResultById,
  selectGamiSweepGraphSeries,
  selectSavedGamiSpecialTestResult,
  setGamiQuestionState,
  setupGamiSpecialTests,
  specialTestDetectionWindows,
  getSavedGamiSpecialTestResults,
  getSelectedSavedGamiSpecialTestResultId,
} = createGamiSpecialTestsController({
  aircraftProfileForEntry: (...args) => aircraftProfileForEntry(...args),
  appReadOnlyMode: (...args) => appReadOnlyMode(...args),
  availableSeriesKeys: (...args) => availableSeriesKeys(...args),
  hideExplorerGamiCursorTime: (...args) => hideExplorerGamiCursorTime(...args),
  readOnlyActionMessage: (...args) => readOnlyActionMessage(...args),
  renderAiSummaryPanel: (...args) => renderAiSummaryPanel(...args),
  renderAircraftFlightsPanel: (...args) => renderAircraftFlightsPanel(...args),
  resetGeneratedReport: (...args) => resetGeneratedReport(...args),
  revokeCachedFlightReport: (...args) => revokeCachedFlightReport(...args),
  scheduleChartDraw: (...args) => scheduleChartDraw(...args),
  scheduleDrawAll: (...args) => scheduleDrawAll(...args),
  selectReportPanel: (...args) => selectReportPanel(...args),
  selectedDatabaseFlightId: (...args) => selectedDatabaseFlightId(...args),
  syncReadOnlyUi: (...args) => syncReadOnlyUi(...args),
  syncSeriesControls: (...args) => syncSeriesControls(...args),
  trendCacheKey: (...args) => trendCacheKey(...args),
  flightReportMetadataKey: (...args) => flightReportMetadataKey(...args),
  getFlightData: () => flightData,
  getSelectedFlight: () => selectedFlight,
  getFlightManifest: () => flightManifest,
  getAircraftProfiles: () => aircraftProfiles,
  getCurrentParserMetadata: () => currentParserMetadata,
  getLastRequestedFlightId: () => lastRequestedFlightId,
  getTrendCache: () => trendCache,
  getGamiSpecialTestsState: () => gamiSpecialTestsState,
  getActiveSeries: () => activeSeries,
  getFlightReportMetadataChecked: () => flightReportMetadataChecked,
  getFlightReportMetadataPending: () => flightReportMetadataPending,
  getFlightReportStoredMetadata: () => flightReportStoredMetadata,
  getExplorerPilotObservationSelectionActive: () => pilotObservationState.open && pilotObservationState.selecting,
  chartGestureHintBaseText: () => chartGestureHintBaseText(),
  onOpenGamiPanel: () => {
    dismissExplorerAskAnnotations({ closePanel: true, render: false });
    renderExplorerAskPanel();
    dismissPilotObservationPanel({ clear: false });
  },
});

function explorerSpecialTestDetectionWindows() {
  return [
    ...specialTestDetectionWindows(),
    ...pilotObservationDetectionWindows(),
  ];
}

const {
  updateScrubReadout,
} = createMarkerReadoutRenderer({
  currentEngineDescriptors: (...args) => currentEngineDescriptors(...args),
  formatMarkerPointTime: (...args) => formatMarkerPointTime(...args),
  selectedDetectionWindows: (...args) => selectedDetectionWindows(...args),
  setText: (...args) => setText(...args),
  titleCase: (...args) => titleCase(...args),
  getActiveSeries: () => activeSeries,
  getSelectedCylinderNumber: () => selectedCylinderNumber,
  getSelectedFlight: () => selectedFlight,
  getSourceName: () => sourceName,
  getDetectionSensitivity: () => detectionSensitivity,
  getSelectedHealthKey: () => selectedHealthKey,
  getSelectedOperatingContextKey: () => selectedOperatingContextKey,
});

function availableCylinderNumbers(data = flightData) {
  return cylinderKeys("egt").map(cylinderNumberFromKey).filter((number) => {
    return data.some((point) => Number.isFinite(point[`cht${number}`]) || Number.isFinite(point[`egt${number}`]));
  });
}

function normalizeSelectedEngineScope(engines = currentEngineDescriptors()) {
  const allowed = engines.length > 1
    ? new Set(["aircraft", "left", "right", "compare"])
    : new Set(["aircraft"]);
  if (!allowed.has(selectedEngineScope)) selectedEngineScope = "aircraft";
  return selectedEngineScope;
}

function engineScopeVisibleEngines(engines = currentEngineDescriptors()) {
  const scope = normalizeSelectedEngineScope(engines);
  if (engines.length <= 1) return engines;
  if (scope === "left" || scope === "right") {
    return engines.filter((engine) => engine.id === scope || engine.side === scope);
  }
  return engines.slice(0, 2);
}

function engineSourceNumbers(engine) {
  return (engine?.cylinders ?? []).map((cylinder) => cylinder.sourceNumber).filter(Number.isFinite);
}

function cylinderHasLoggedData(number, data = flightData) {
  return data.some((point) => Number.isFinite(point[`cht${number}`]) || Number.isFinite(point[`egt${number}`]));
}

function engineScopeCylinderNumbers(data = flightData, engines = currentEngineDescriptors(data)) {
  if (engines.length <= 1) return availableCylinderNumbers(data);
  const scopedNumbers = engineScopeVisibleEngines(engines)
    .flatMap(engineSourceNumbers)
    .filter((number) => cylinderHasLoggedData(number, data));
  return scopedNumbers.length ? scopedNumbers : availableCylinderNumbers(data);
}

function engineInfoForCylinderNumber(number, engines = currentEngineDescriptors()) {
  for (const engine of engines) {
    const cylinder = (engine.cylinders ?? []).find((candidate) => candidate.sourceNumber === number);
    if (cylinder) {
      const label = engines.length > 1
        ? `${engine.shortLabel} Cyl ${cylinder.number}`
        : `Cyl ${cylinder.number}`;
      return { engine, cylinder, label };
    }
  }
  return { engine: null, cylinder: null, label: `Cyl ${number}` };
}

function enginePeerKeysForCylinderNumber(number, engines, prefix) {
  const info = engineInfoForCylinderNumber(number, engines);
  const keys = (info.engine?.cylinders ?? [])
    .map((cylinder) => cylinder[`${prefix}Key`])
    .filter(Boolean);
  return keys.length > 1 ? keys : cylinderKeys(prefix);
}

function engineScopeSeriesKeys(engines = currentEngineDescriptors()) {
  const cylinders = engineScopeVisibleEngines(engines).flatMap((engine) => engine.cylinders ?? []);
  return [
    ...cylinders.map((cylinder) => cylinder.egtKey),
    ...cylinders.map((cylinder) => cylinder.chtKey),
  ].filter((key) => key && seriesMeta[key] && flightData.some((point) => Number.isFinite(point[key])));
}

function setEngineScope(scope) {
  selectedEngineScope = scope;
  selectedCylinderNumber = null;
  const engines = currentEngineDescriptors();
  normalizeSelectedEngineScope(engines);
  const scopedSeries = engineScopeSeriesKeys(engines);
  if (scopedSeries.length) {
    activeSeries.clear();
    scopedSeries.forEach((key) => activeSeries.add(key));
    syncSeriesControls();
  }
  renderHealthSummary(currentHealthSummary());
  renderEnginePanelIfActive();
  scheduleDrawAll();
}

function renderEngineScopeSwitch(engines) {
  const container = document.querySelector("#engineScopeSwitch");
  if (!container) return;
  if (engines.length <= 1) {
    container.hidden = true;
    container.innerHTML = "";
    return;
  }
  const [left, right] = engines;
  const scope = normalizeSelectedEngineScope(engines);
  const controls = [
    ["aircraft", "Aircraft", "All engines"],
    ["left", left.shortLabel, left.label],
    ["right", right.shortLabel, right.label],
    ["compare", "Compare", `${engineDeltaLabel(left, right)} delta`],
  ];
  container.hidden = false;
  container.innerHTML = controls.map(([id, label, detail]) => `
    <button class="${scope === id ? "is-active" : ""}" data-engine-scope="${escapeHtml(id)}" aria-pressed="${scope === id ? "true" : "false"}" type="button">
      <span>${escapeHtml(label)}</span>
      <small>${escapeHtml(detail)}</small>
    </button>
  `).join("");
  container.querySelectorAll("[data-engine-scope]").forEach((button) => {
    button.addEventListener("click", () => setEngineScope(button.dataset.engineScope));
  });
}

function renderEngineMultiSummary(summary, engines) {
  renderEngineScopeSwitch(engines);
  const container = document.querySelector("#engineMultiSummary");
  if (!container) return;
  if (engines.length <= 1) {
    container.hidden = true;
    container.innerHTML = "";
    return;
  }
  const scope = normalizeSelectedEngineScope(engines);
  const [left, right] = engines;
  container.hidden = false;
  container.innerHTML = `
    ${aircraftSnapshotCard(summary, { active: scope === "aircraft" })}
    ${engineSnapshotCard(left, { active: scope === "left" })}
    ${engineSnapshotCard(right, { active: scope === "right" })}
    ${engineDeltaOverviewCard(left, right)}
  `;
  bindEngineScopeCards(container, summary);
}

function cylinderSensorSummary(summary, key) {
  return summary.sensors?.details?.summaries?.find((item) => item.key === key) ?? null;
}

function cylinderProbeNote(sensor) {
  if (!sensor) return "not logged";
  const symptoms = [];
  if (sensor.conditionWindow) symptoms.push(`${formatElapsedTime(sensor.conditionWindow.duration)} ${sensor.conditionWindow.reason}`);
  if (sensor.impossibleJumpCount) symptoms.push(`${sensor.impossibleJumpCount.toLocaleString()} jumps`);
  if (sensor.zeroCount) symptoms.push(`${sensor.zeroCount.toLocaleString()} dropouts`);
  if (sensor.outOfRangeCount) symptoms.push(`${sensor.outOfRangeCount.toLocaleString()} range`);
  const peerMismatch = (sensor.coldMismatchCount ?? 0) + (sensor.hotMismatchCount ?? 0);
  if (peerMismatch) symptoms.push(`${peerMismatch.toLocaleString()} peer mismatches`);
  if (sensor.flatline) symptoms.push("flatline");
  if (!symptoms.length) return "stable";
  return symptoms.slice(0, 2).join(" · ");
}

function cylinderFocusSeries(number) {
  return [`egt${number}`, `cht${number}`].filter((key) => seriesMeta[key] && flightData.some((point) => Number.isFinite(point[key])));
}

function selectReportPanel(panel) {
  if (reportPanelIsActive(panel)) return;
  if (panel !== "explorer") dismissExplorerAskAnnotations({ closePanel: true, removeOverlay: true, render: false });
  document.querySelectorAll(".tab").forEach((item) => item.classList.toggle("is-active", item.dataset.panel === panel));
  setReportPanel(panel);
  trackCurrentAnalyticsPageView();
  syncFlightReviewRoute(panel);
}

function centerFlightChartInViewport() {
  const chartPanel = document.querySelector("#flightChart")?.closest(".chart-panel");
  if (!chartPanel) return;
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      chartPanel.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
      });
    });
  });
}

function chartZoomRangeForElapsedWindow(startTime, endTime, { padRatio = 0.18, minPaddingSeconds = 20 } = {}) {
  const start = Number(startTime);
  const end = Number(endTime);
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start || flightData.length < 2) return null;
  const elapsedValues = flightData.map((point) => Number(point?.elapsedSeconds)).filter(Number.isFinite);
  if (elapsedValues.length < 2) return null;
  const minElapsed = Math.min(...elapsedValues);
  const maxElapsed = Math.max(...elapsedValues);
  if (maxElapsed <= minElapsed) return null;
  const padding = Math.max(minPaddingSeconds, (end - start) * padRatio);
  const paddedStart = Math.max(minElapsed, start - padding);
  const paddedEnd = Math.min(maxElapsed, end + padding);
  const maxIndex = flightData.length - 1;
  const startIndex = flightData.findIndex((point) => Number(point?.elapsedSeconds) >= paddedStart);
  let endIndex = -1;
  for (let index = flightData.length - 1; index >= 0; index -= 1) {
    if (Number(flightData[index]?.elapsedSeconds) <= paddedEnd) {
      endIndex = index;
      break;
    }
  }
  if (startIndex < 0 || endIndex < startIndex) return null;
  return {
    start: startIndex <= 0 ? 0 : clamp01(startIndex / maxIndex),
    end: endIndex >= maxIndex ? 1 : clamp01(endIndex / maxIndex),
  };
}

function selectChtEgtPairingCardWindow({ cylinder, startTime, endTime } = {}) {
  if (!Number.isFinite(Number(cylinder))) return;
  overviewSelectionCleared = false;
  selectedHealthKey = "combustion";
  setCylinderFocus(Number(cylinder), { centerChart: false });
  const nextRange = chartZoomRangeForElapsedWindow(startTime, endTime);
  if (nextRange) {
    zoomRange = nextRange;
    scrubRatio = clamp01((nextRange.start + nextRange.end) / 2);
  } else {
    zoomRange = { start: 0, end: 1 };
    scrubRatio = 0.62;
  }
  syncFlightReviewRoute("overview");
  scrollFlightChartPanelIntoView();
  scheduleDrawAll();
}

function scrollFlightChartPanelIntoView() {
  const chartPanel = document.querySelector("#flightChart")?.closest(".chart-panel");
  if (!chartPanel) return;
  const scroll = () => {
    const topbarHeight = Math.ceil(document.querySelector(".topbar")?.getBoundingClientRect().height ?? 0);
    const targetTop = window.scrollY + chartPanel.getBoundingClientRect().top - topbarHeight - 10;
    window.scrollTo({ top: Math.max(0, targetTop), left: window.scrollX, behavior: "auto" });
  };
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      scroll();
      window.setTimeout(scroll, 120);
    });
  });
}

function setCylinderFocus(number, options = {}) {
  selectedCylinderNumber = number;
  const engines = currentEngineDescriptors();
  const info = engineInfoForCylinderNumber(number, engines);
  if (engines.length > 1 && info.engine?.id) selectedEngineScope = info.engine.id;
  const focusKeys = cylinderFocusSeries(number);
  if (focusKeys.length) {
    activeSeries.clear();
    focusKeys.forEach((key) => activeSeries.add(key));
    syncSeriesControls();
  }
  if (options.openOverview !== false && !reportPanelIsActive("overview")) selectReportPanel("overview");
  renderHealthSummary(currentHealthSummary());
  renderEnginePanelIfActive();
  scheduleDrawAll();
  syncFlightReviewRoute(activeReportPanel());
  if (options.centerChart) centerFlightChartInViewport();
}

function clearCylinderFocus() {
  selectedCylinderNumber = null;
  selectedEngineScope = "aircraft";
  setDefaultActiveSeries([...cylinderKeys("egt"), ...cylinderKeys("cht")]);
  syncSeriesControls();
  renderHealthSummary(currentHealthSummary());
  renderEnginePanelIfActive();
  scheduleDrawAll();
  syncFlightReviewRoute(activeReportPanel());
}

function renderEnginePanel() {
  const cylinders = document.querySelector("#engineCylinderGrid");
  if (!cylinders) return;
  const baseSummary = currentHealthSummary();
  const summary = healthSummaryForCurrentEngineScope(baseSummary);
  const engines = currentEngineDescriptors();
  normalizeSelectedEngineScope(engines);
  const metricRows = engineMetricRows(summary);
  const reviewItems = engineReviewItems(summary);
  renderEngineMultiSummary(baseSummary, engines);
  renderEngineTriageSummary(summary, reviewItems);
  renderEngineReviewList(reviewItems, summary);
  renderEngineEvidencePanel(reviewItems);
  renderEngineSupportingChecks(metricRows, reviewItems);

  document.querySelectorAll("[data-engine-event-key]").forEach((button) => {
    button.addEventListener("click", () => selectEngineTimelineEvidence(button));
  });

  renderCylinderDetailSection(cylinders, summary, engines);
}

function chartZoomedIn() {
  return !(zoomRange.start <= 0 && zoomRange.end >= 1);
}

// The overview flight-chart gesture hint follows the input mode (mouse vs
// touch) and the scrubber's Select Region state. (The explorer chart's hint is
// owned by the GAMI controller, which also factors in its sweep-selection
// state and falls back to the same base copy.)
function updateFlightChartGestureHint() {
  const hint = document.querySelector(".chart-wrap:not(.explorer-chart-wrap) .chart-gesture-hint");
  if (!hint) return;
  hint.textContent = chartGestureHintBaseText();
}

function drawAll() {
  const dashboardActive = document.querySelector("#view-dashboard")?.classList.contains("is-active");
  const engineActive = document.querySelector("#enginePanel")?.classList.contains("is-active");
  const explorerActive = document.querySelector("#graphExplorerPanel")?.classList.contains("is-active");
  const profileActive = document.querySelector("#flightProfilePanel")?.classList.contains("is-active");
  const rawActive = document.querySelector("#rawDataPanel")?.classList.contains("is-active");
  const playbackActive = document.querySelector("#playbackPanel")?.classList.contains("is-active");
  const comparisonsActive = document.querySelector("#view-comparisons")?.classList.contains("is-active");
  const trendsActive = document.querySelector("#view-trends")?.classList.contains("is-active");

  if (!dashboardActive || !explorerActive) {
    dismissExplorerAskAnnotations({ closePanel: !explorerActive, removeOverlay: true, render: false });
  }

  if (dashboardActive) {
    updateFlightHeader();
    if (explorerActive) {
      drawExplorerChart();
      renderGamiSpecialTestsPanel({ syncInputs: false });
      renderExplorerAskPanel();
    } else if (engineActive) {
      renderEnginePanel();
    } else if (profileActive) {
      renderFlightProfilePanel();
    } else if (rawActive) {
      renderRawDataPanel();
    } else if (playbackActive) {
      window.AeroInsightPlayback?.render?.();
    } else {
      drawGauge();
      drawFlightChart();
      updateFlightChartGestureHint();
    }
  }

  if (comparisonsActive) {
    drawCompareChart();
    drawCylinderCompareChart();
  }

  if (trendsActive) {
    renderCachedTrendView();
  }
}

function elapsedRatioForPlayback(elapsedSeconds) {
  const values = flightData.map((point) => point.elapsedSeconds).filter(Number.isFinite);
  const extent = extentFromValues(values);
  if (!extent || extent.max <= extent.min || !Number.isFinite(elapsedSeconds)) return 0;
  return clamp01((elapsedSeconds - extent.min) / (extent.max - extent.min));
}

function setPlaybackScrubRatio(ratio, options = {}) {
  scrubRatio = clamp01(ratio);
  if (options.resetZoom) zoomRange = { start: 0, end: 1 };
  const point = nearestPoint(flightData, scrubRatio);
  if (point) updateScrubReadout(point);
  if (options.draw !== false) scheduleDrawAll();
}

function setPlaybackScrubElapsed(elapsedSeconds, options = {}) {
  setPlaybackScrubRatio(elapsedRatioForPlayback(elapsedSeconds), options);
}

function notifyPlaybackDataChanged() {
  explorerSelectedAlertId = null;
  window.AeroInsightPlayback?.onDataChanged?.();
}

function installAeroInsightAppBridge() {
  window.AeroInsightApp = {
    getState() {
      return {
        flightData,
        selectedFlight,
        healthSummary,
        sourceName,
        sourceMonitor,
        parserMetadata: cloneParserMetadata(currentParserMetadata),
        aircraftProfile: aircraftProfileForEntry(selectedFlight),
        sourceRows,
        sourceRawRows,
        endpointTrimInfo,
        scrubRatio,
        zoomRange,
        selectedHealthKey,
        selectedCylinderNumber,
      };
    },
    colors,
    seriesMeta,
    engineDescriptorsForData: (points = flightData) => engineDescriptorsForData(points, aircraftProfileForEntry(selectedFlight), {
      parserId: currentParserMetadata?.parserId ?? selectedFlight?.parser,
      parserMetadata: currentParserMetadata,
    }),
    engineLayoutAmbiguityForData: (points = flightData) => engineLayoutAmbiguityForData(points, aircraftProfileForEntry(selectedFlight), {
      parserId: currentParserMetadata?.parserId ?? selectedFlight?.parser,
      parserMetadata: currentParserMetadata,
    }),
    engineMetricValue,
    engineDelta,
    engineScopedChannelLabel: (key, points = flightData) => engineScopedChannelLabel(key, engineDescriptorsForData(points, aircraftProfileForEntry(selectedFlight), {
      parserId: currentParserMetadata?.parserId ?? selectedFlight?.parser,
      parserMetadata: currentParserMetadata,
    })),
    engineScopedProbeLabel: (key, points = flightData) => engineScopedProbeLabel(key, engineDescriptorsForData(points, aircraftProfileForEntry(selectedFlight), {
      parserId: currentParserMetadata?.parserId ?? selectedFlight?.parser,
      parserMetadata: currentParserMetadata,
    })),
    getDetectionWindows: () => playbackDetectionWindows(),
    getSelectedDetectionWindows: () => selectedDetectionWindows(),
    pointInDetectionWindow,
    findingForMetric: (key) => findingForMetric(key, currentHealthSummary()),
    formatPointTime,
    formatMarkerPointTime,
    formatElapsedTime,
    formatCompactElapsedTime,
    rawMetricDescriptor,
    estimatePower,
    accountAircraftRows,
    openAccountAircraftEditor,
    openAccountAircraftReviewSettings,
    setScrubRatio: setPlaybackScrubRatio,
    setScrubElapsed: setPlaybackScrubElapsed,
    setExplorerZoomRange(start, end) {
      const nextStart = clamp01(Number(start));
      const nextEnd = clamp01(Number(end));
      if (!Number.isFinite(nextStart) || !Number.isFinite(nextEnd) || nextEnd <= nextStart) return null;
      zoomRange = { start: nextStart, end: nextEnd };
      explorerSelectedAlertId = null;
      syncFlightReviewRoute(activeReportPanel());
      drawAll();
      return { ...zoomRange };
    },
    captureExplorerAskGraphImageDataUrl: explorerAskGraphImageDataUrl,
    // Aircraft edit dialog bridge — used by the approval-gate aircraft wizard
    // (src/app/aircraft-wizard.ts) and any other external module that needs
    // to drive the shared #aircraftEditDialog without re-implementing the
    // form orchestration. Keep these exposed even though the in-page UI calls
    // the underlying functions directly.
    openAircraftEditDialog: (...args) => openAircraftEditDialog(...args),
    closeAircraftEditDialog: (...args) => closeAircraftEditDialog(...args),
    saveAircraftEditDialogForm: (...args) => saveAircraftEditDialogForm(...args),
    // Editing an aircraft from the onboarding gate happens before the app
    // shell has necessarily loaded the fleet, and opening the edit dialog
    // without a profile in hand would present an empty form that overwrites
    // the stored aircraft on save. Callers await this first and only open the
    // editor when it reports the profile is in memory.
    async ensureAircraftProfileLoaded(tailNumber) {
      const tail = String(tailNumber ?? "").trim();
      if (!tail) return false;
      if (!aircraftProfiles?.[tail]) await loadAircraftProfiles({ force: true });
      return Boolean(aircraftProfiles?.[tail]);
    },
  };
}

// --- Public read-only share view (issue #100) --------------------------------
// Boots ONE flight read-only from a pre-loaded /bundle. The fetch shim (installed
// first) serves the app's normal data endpoints from that bundle, so the existing
// manifest + flight-render path runs unchanged; here we only strip the auth
// gates, drive the boot, lock sensitivity, and add the read-only banner.
async function bootPublicShareView() {
  installPublicShareFetchShim();
  const body = document.body;
  body?.removeAttribute("data-auth-gate");
  body?.removeAttribute("data-approval-gate");
  body?.setAttribute("data-public-share", "1");

  const session = await initPublicShareSession();
  if (!session.ok) { renderPublicShareError(session.error); return; }

  let bundle;
  try {
    bundle = await loadPublicShareBundle();
  } catch (error) {
    renderPublicShareError(error?.message || "This shared flight is unavailable.");
    return;
  }

  await perfTime("loadAppConfig", () => loadAppConfig()).catch(() => {});
  setupNavigation();
  wireFleetSidebar();
  setupHealthCardInteractions();
  setupSensitivityControl();
  setupChartScrubber();
  setupExplorerReadoutHover();
  setupExplorerContextInteractions();
  setupPilotObservations();
  setupGamiSpecialTests();
  setupOverviewReviewPanelHeightSync();

  renderPublicShareBanner(bundle);
  await ensureFlightDataLoaded();
  // The single shared flight loads into the dashboard DOM; switch to it so the
  // viewer lands on the flight analysis, not the aircraft workspace.
  activateView("dashboard");
  applyPublicShareAvailability(bundle);
  // Lock detector sensitivity to the owner's shared value (no-persist setter),
  // then make the control inert so a viewer can't change what produced the findings.
  applyRouteSensitivity({ sensitivity: bundle?.sensitivity });
  lockPublicShareSensitivity();
  syncReadOnlyUi();
}

function renderPublicShareBanner(bundle) {
  if (document.getElementById("publicShareBanner")) return;
  const aircraft = bundle?.aircraft ?? {};
  const flight = bundle?.flight ?? {};
  const tail = aircraft.tail_number || aircraft.tail_number_normalized || "";
  const type = [aircraft.make, aircraft.model].filter(Boolean).join(" ");
  const rawDate = flight.flight_date || flight.flight_start_at || "";
  const dateLabel = String(rawDate).slice(0, 10);
  const context = [tail, type, dateLabel].filter(Boolean).join(" · ");
  const banner = document.createElement("div");
  banner.id = "publicShareBanner";
  banner.className = "public-share-banner";
  banner.innerHTML = `
    <span class="public-share-banner__icon" aria-hidden="true">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1"/><path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1"/></svg>
    </span>
    <span class="public-share-banner__text">
      <strong>Read-only shared flight</strong>
      <span class="public-share-banner__context"></span>
    </span>
    <span class="public-share-banner__badge">Read-only · link expires in 30 days</span>`;
  banner.querySelector(".public-share-banner__context").textContent =
    context ? `${context} · shared by the aircraft owner` : "shared by the aircraft owner";
  document.body?.prepend(banner);
  document.body?.classList.add("has-public-share-banner");
}

// Reflect what the bundle actually carries: no saved PDF → hide the download
// action; no cached AI summary → hide the AI Summary tab (its generate control
// is already hidden, so an empty "ready to build" state would only mislead).
function applyPublicShareAvailability(bundle) {
  if (!bundle?.reportAvailable) {
    const reportButton = document.getElementById("action-report");
    if (reportButton) reportButton.hidden = true;
  }
  if (!bundle?.aiSummary) {
    const aiTab = document.querySelector('.tab[data-panel="ai-review"]');
    if (aiTab) {
      aiTab.hidden = true;
      if (aiTab.classList.contains("is-active")) selectReportPanel("overview");
    }
  }
}

function lockPublicShareSensitivity() {
  document.querySelectorAll("[data-sensitivity]").forEach((element) => {
    element.setAttribute("disabled", "");
    element.setAttribute("aria-disabled", "true");
    element.classList.add("is-locked");
  });
  const control = document.getElementById("sensitivityControl");
  if (control) control.setAttribute("disabled", "");
}

function renderPublicShareError(message) {
  document.body?.removeAttribute("data-auth-gate");
  document.body?.removeAttribute("data-approval-gate");
  document.body?.setAttribute("data-public-share-error", "1");
  let el = document.getElementById("publicShareError");
  if (!el) {
    el = document.createElement("div");
    el.id = "publicShareError";
    el.className = "public-share-error";
    document.body?.appendChild(el);
  }
  el.innerHTML = `<div class="public-share-error__card">
      <h1>Shared flight unavailable</h1>
      <p class="public-share-error__message"></p>
      <p class="public-share-error__hint">Ask the aircraft owner for a new share link.</p>
    </div>`;
  el.querySelector(".public-share-error__message").textContent =
    message || "This share link is invalid or has expired.";
}

// --- Owner-side "Share this flight" dialog (issue #100) ----------------------
// Creates / shows / revokes the read-only share link for the selected flight.
// Only a hash of the secret is stored, so the full capability URL is shown once
// at creation; reopening an active link offers "Create new link" (rotate).
let shareLinkDialogActiveId = "";

function shareLinkDialogElements() {
  const dialog = document.getElementById("shareLinkDialog");
  return {
    dialog,
    flight: document.getElementById("shareLinkDialogFlight"),
    error: document.getElementById("shareLinkDialogError"),
    createState: document.getElementById("shareLinkDialogCreateState"),
    activeState: document.getElementById("shareLinkDialogActiveState"),
    createBtn: document.getElementById("shareLinkDialogCreate"),
    cancelBtn: document.getElementById("shareLinkDialogCancel"),
    closeBtn: document.getElementById("shareLinkDialogClose"),
    urlRow: dialog?.querySelector(".share-link-url-row") ?? null,
    urlDisplay: document.getElementById("shareLinkDialogUrl"),
    copyBtn: document.getElementById("shareLinkDialogCopy"),
    meta: document.getElementById("shareLinkDialogMeta"),
    warning: document.getElementById("shareLinkDialogWarning"),
    revokeBtn: document.getElementById("shareLinkDialogRevoke"),
    replaceBtn: document.getElementById("shareLinkDialogReplace"),
    doneBtn: document.getElementById("shareLinkDialogDone"),
  };
}

function setShareLinkDialogError(message) {
  const { error } = shareLinkDialogElements();
  if (!error) return;
  error.textContent = message || "";
  error.hidden = !message;
}

function shareLinkExpiryLabel(link) {
  if (!link?.expiresAt) return "";
  try {
    return new Date(link.expiresAt).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch { return ""; }
}

function showShareLinkCreateState() {
  const els = shareLinkDialogElements();
  if (els.createState) els.createState.hidden = false;
  if (els.activeState) els.activeState.hidden = true;
}

function showExistingShareLink(link) {
  const els = shareLinkDialogElements();
  shareLinkDialogActiveId = link.id;
  if (els.createState) els.createState.hidden = true;
  if (els.activeState) els.activeState.hidden = false;
  if (els.urlRow) els.urlRow.hidden = true;
  if (els.urlDisplay) {
    els.urlDisplay.textContent = "";
    els.urlDisplay.removeAttribute("title");
  }
  if (els.warning) els.warning.hidden = true;
  if (els.replaceBtn) els.replaceBtn.hidden = false;
  const expires = shareLinkExpiryLabel(link);
  if (els.meta) {
    els.meta.textContent = `A read-only link is active${expires ? ` (expires ${expires})` : ""}. The full link is shown only once — create a new link to get a fresh URL.`;
  }
}

function showFreshShareLink(link) {
  const els = shareLinkDialogElements();
  shareLinkDialogActiveId = link.id;
  if (els.createState) els.createState.hidden = true;
  if (els.activeState) els.activeState.hidden = false;
  if (els.urlRow) els.urlRow.hidden = false;
  if (els.urlDisplay) {
    els.urlDisplay.textContent = link.url || "";
    if (link.url) els.urlDisplay.setAttribute("title", link.url);
    else els.urlDisplay.removeAttribute("title");
  }
  if (els.warning) els.warning.hidden = false;
  if (els.replaceBtn) els.replaceBtn.hidden = true;
  const expires = shareLinkExpiryLabel(link);
  if (els.meta) els.meta.textContent = expires ? `Active. Expires ${expires}.` : "Active.";
  els.copyBtn?.focus();
}

async function openShareLinkDialog() {
  const els = shareLinkDialogElements();
  const flight = selectedFlight;
  if (!els.dialog || !flight?.id) return;
  shareLinkDialogActiveId = "";
  if (els.flight) els.flight.textContent = flightDisplayTitle(flight);
  setShareLinkDialogError("");
  if (els.createState) els.createState.hidden = true;
  if (els.activeState) els.activeState.hidden = true;
  if (!els.dialog.open) els.dialog.showModal();
  try {
    const res = await fetch(`/api/share-links?flightId=${encodeURIComponent(flight.id)}`, { cache: "no-store" });
    if (res.ok) {
      const payload = await res.json();
      const active = (payload.links || [])[0];
      if (active) { showExistingShareLink(active); return; }
    }
  } catch { /* fall through to the create state */ }
  showShareLinkCreateState();
}

async function createShareLink() {
  const els = shareLinkDialogElements();
  if (!shareLinkDialogFlightIdForCreate()) return;
  setShareLinkDialogError("");
  if (els.createBtn) els.createBtn.disabled = true;
  if (els.replaceBtn) els.replaceBtn.disabled = true;
  try {
    const res = await fetch("/api/share-links", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        flightId: selectedFlight.id,
        sensitivity: detectionSensitivity,
        replaceShareId: shareLinkDialogActiveId || null,
        previewImage: await createSharePreview(document),
      }),
    });
    const payload = await res.json().catch(() => ({}));
    if (res.status === 409 && payload.link) {
      showExistingShareLink(payload.link);
      setShareLinkDialogError("The active link changed in another request. Review it before replacing it.");
      return;
    }
    if (!res.ok) throw new Error(payload?.error || `HTTP ${res.status}`);
    const { link } = payload;
    showFreshShareLink(link);
  } catch (error) {
    setShareLinkDialogError(`Could not create the share link: ${error.message}`);
  } finally {
    if (els.createBtn) els.createBtn.disabled = false;
    if (els.replaceBtn) els.replaceBtn.disabled = false;
  }
}

function shareLinkDialogFlightIdForCreate() {
  return selectedFlight?.id || "";
}

async function revokeShareLink() {
  const els = shareLinkDialogElements();
  if (!shareLinkDialogActiveId) { showShareLinkCreateState(); return; }
  setShareLinkDialogError("");
  if (els.revokeBtn) els.revokeBtn.disabled = true;
  try {
    const res = await fetch(`/api/share-links/${encodeURIComponent(shareLinkDialogActiveId)}`, { method: "DELETE" });
    if (!res.ok && res.status !== 404) throw new Error(`HTTP ${res.status}`);
    shareLinkDialogActiveId = "";
    showShareLinkCreateState();
  } catch (error) {
    setShareLinkDialogError(`Could not revoke the link: ${error.message}`);
  } finally {
    if (els.revokeBtn) els.revokeBtn.disabled = false;
  }
}

async function copyShareLink() {
  const els = shareLinkDialogElements();
  if (!els.urlDisplay) return;
  const url = els.urlDisplay.textContent || "";
  if (!url) return;
  try {
    await navigator.clipboard.writeText(url);
    if (els.copyBtn) {
      const original = els.copyBtn.textContent;
      els.copyBtn.textContent = "Copied!";
      window.setTimeout(() => { if (els.copyBtn) els.copyBtn.textContent = original; }, 1500);
    }
  } catch {
    selectShareLinkUrl(els.urlDisplay);
  }
}

function selectShareLinkUrl(urlDisplay) {
  if (!urlDisplay || !document.createRange || !window.getSelection) return;
  const range = document.createRange();
  range.selectNodeContents(urlDisplay);
  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(range);
  urlDisplay.focus?.();
}

function setupShareLinkDialog() {
  const els = shareLinkDialogElements();
  if (!els.dialog) return;
  const open = () => { void openShareLinkDialog(); };
  document.getElementById("action-share-flight")?.addEventListener("click", open);
  document.getElementById("action-share-flight-compact")?.addEventListener("click", open);
  els.closeBtn?.addEventListener("click", () => els.dialog.close());
  els.cancelBtn?.addEventListener("click", () => els.dialog.close());
  els.doneBtn?.addEventListener("click", () => els.dialog.close());
  els.createBtn?.addEventListener("click", () => { void createShareLink(); });
  els.replaceBtn?.addEventListener("click", () => { void createShareLink(); });
  els.revokeBtn?.addEventListener("click", () => { void revokeShareLink(); });
  els.copyBtn?.addEventListener("click", () => { void copyShareLink(); });
}

installAeroInsightAppBridge();
window.dispatchEvent(new CustomEvent("aeroinsight:app-bridge-ready"));

// The account Archive tab restores/deletes records outside the workspace's
// own flows; refresh the aircraft + flight state so the fleet and flight
// lists reflect it without a reload. Workspace-sourced events are skipped:
// those flows already refreshed the workspace themselves.
window.addEventListener("aeroinsight:archive-changed", (event) => {
  if (event?.detail?.source === "workspace") return;
  void (async () => {
    try {
      await refreshFlightManifestState(selectedFlight?.id ?? "");
      populateUploadAircraftSelect(selectedAircraftWorkspace());
      populateTrendAircraftSelect(selectedAircraftWorkspace());
      setupFlightLogSelector();
      renderAircraftWorkspace();
      updateFlightHeader();
    } catch {
      /* transient refresh failure; the next navigation reloads state */
    }
  })();
});
mountAircraftDashboardPanel();
const startupT0 = performance.now();
(async () => {
  // Analytics chrome runs on every page, including public share views: the
  // consent banner until a choice is stored, delegated event instrumentation,
  // and the (flag-gated) debug overlay.
  mountConsentBanner();
  wireAnalyticsInstrumentation();
  mountAnalyticsOverlay();
  setupMobileTabbar();
  // On small mobile the fleet sidebar is a full "Home" page; land there when
  // not deep-linked to a specific flight/section, and reveal the tab bar.
  if (newUiFeatureEnabled() && !isPublicShareMode()) {
    document.querySelector("#mobileTabbar")?.removeAttribute("hidden");
    const rawHash = window.location.hash.replace(/^#/, "").trim();
    if (!rawHash && window.matchMedia("(max-width: 900px)").matches) {
      document.body.classList.add("mobile-home-active");
      syncAircraftUrlPathTail(); // land on /home
      syncMobileTabbar();
    }
    maybeShowMobileWelcome();
  }
  // Sticky table headers pin right under the topbar. The old hook only
  // re-measured during dashboard draws, so on Flights/Uploads the offset kept
  // a stale (taller) topbar height and the headers floated a row too low.
  // Measure now and on every topbar size change (view switches included).
  updateStickyTableHeaderOffset();
  if (typeof ResizeObserver !== "undefined") {
    const topbarElement = document.querySelector(".topbar");
    if (topbarElement) new ResizeObserver(() => updateStickyTableHeaderOffset()).observe(topbarElement);
  }
  // Info tab: every field change autosaves while the form is inline.
  document.querySelector("#aircraftEditDialogForm")?.addEventListener("change", () => scheduleAircraftInfoAutosave());
  // Public read-only share links (issue #100): /share/<id> boots a single
  // read-only flight from a pre-loaded bundle, no fleet, no auth.
  if (isPublicShareMode()) {
    await bootPublicShareView().catch((error) => {
      console.error("[public-share] boot failed:", error);
      renderPublicShareError("Could not open this shared flight.");
    });
    return;
  }
  await perfTime("loadAppConfig", () => loadAppConfig()).catch(() => {});
  setupNavigation();
  wireFleetSidebar();
  setupShareLinkDialog();
  activateHashView();
  setupHealthCardInteractions();
  setupSensitivityControl();
  setupTrendControls();
  setupTrendVisualWorkspace();
  setupChartScrubber();
  setupExplorerReadoutHover();
  setupExplorerContextInteractions();
  setupExplorerAskAboutPart();
  setupPilotObservations();
  setupGamiSpecialTests();
  setupOverviewReviewPanelHeightSync();
  // Only block startup on the (heavy, synchronous) flight load when the landing view actually
  // shows flight data: a deep link into a data view / aircraft panel, or the file-manifest mode
  // where no lazy loader exists. On a public landing (e.g. Home) keep the page interactive and
  // preload the data during browser idle time instead.
  // Bare URL (no hash) lands on the aircraft workspace (see
  // view-navigation-controller.activateHashView), so we need the aircraft
  // manifest/flights loaded eagerly for that case too — otherwise an approved
  // user reloading at `/` sees an empty fleet until the 2s idle bootstrap.
  const rawHash = window.location.hash.replace(/^#/, "").trim();
  const landingNeedsFlightData =
    Boolean(aircraftPanelFromLocationHash())
    || viewNeedsFlightData(viewFromLocationHash())
    || !rawHash;
  if (landingNeedsFlightData) {
    await perfTime("loadSampleFlightData", () => ensureFlightDataLoaded()).catch(() => {});
    if (DASHBOARD_PERF_LOG) perfMark("startup-total", performance.now() - startupT0);
    perfFlush("startup");
  } else {
    if (DASHBOARD_PERF_LOG) perfMark("startup-total", performance.now() - startupT0);
    perfFlush("startup");
    waitForBrowserIdle(2000)
      .then(() => perfTime("loadSampleFlightData", () => ensureFlightDataLoaded()))
      .then(() => perfFlush("startup-deferred"))
      .catch(() => {});
  }
})();
window.addEventListener("hashchange", activateHashView);
// Back/forward across entries whose HASH did not change. hashchange alone is
// not enough: the aircraft tail lives in the path (/N12345/), so moving between
// two aircraft — or between an aircraft and the root — is a path-only
// navigation that fires popstate and never hashchange, leaving the UI showing
// the previous aircraft. popstate does not fire when the app assigns
// location.hash itself, so this cannot re-enter its own navigation.
window.addEventListener("popstate", () => {
  if (isPublicShareMode()) return;
  const tail = aircraftTailFromUrlPath();
  if (tail && tail !== selectedAircraftWorkspaceId) {
    if (setAircraftWorkspaceSelection(tail, { render: false }) === false) {
      const restored = new URL(window.location.href);
      restored.pathname = selectedAircraftWorkspaceId ? `/${encodeURIComponent(selectedAircraftWorkspaceId)}/` : "/";
      restored.hash = selectedAircraftPanel === "profile" ? "aircraft" : selectedAircraftPanel;
      window.history.replaceState(window.history.state, "", restored.href);
      return;
    }
  }
  activateHashView();
});
let windowResizeDispatchScheduled = false;
window.addEventListener("resize", () => {
  clearChartInteractionCaches();
  if (windowResizeDispatchScheduled) return;
  windowResizeDispatchScheduled = true;
  requestAnimationFrame(() => {
    windowResizeDispatchScheduled = false;
    scheduleDrawAll();
    scheduleCylinderSummaryLayout();
    scheduleOverviewReviewPanelHeight();
  });
});
